/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "search/service/service.proto" (package "rd.search.service", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UnitOfMeasure } from "../../company/models_pb";
import { Spiff } from "../../spiff/models_pb";
import { GiftCardBalance } from "../../giftcard/models_pb";
import { GiftCard_Status } from "../../giftcard/models_pb";
import { Conversation_Status } from "../../llm/models_pb";
import { Conversation_Type } from "../../llm/models_pb";
import { Routine } from "../../llm/models_pb";
import { Routine_Type } from "../../llm/models_pb";
import { Message } from "../../chat/models_pb";
import { Thread } from "../../chat/models_pb";
import { ComputedSKUInfo } from "../../catalog/models_pb";
import { SKU } from "../../catalog/models_pb";
import { SKU_Origin } from "../../catalog/models_pb";
import { InventoryCount } from "../../product/models_pb";
import { PriceChange } from "../../integrations/db/models_pb";
import { IntegrationVendor } from "../../proto/integration_vendor/models_pb";
import { Method } from "../../company/tender/models_pb";
import { TransactionType } from "../../accounting/models_pb";
import { GeneralLedgerSortBy } from "../../accounting/models_pb";
import { JournalEntries } from "../../accounting/models_pb";
import { IncomeStatement } from "../../accounting/models_pb";
import { BalanceSheet } from "../../accounting/models_pb";
import { PayoutTxnSortBy } from "../../analyticsv2/models_pb";
import { Delivery as Delivery$ } from "../../notif/models_pb";
import { Sink } from "../../notif/models_pb";
import { ProductCategory_Type } from "../../company/models_pb";
import { TaxRate } from "../../company/models_pb";
import { DeliveryStop_Status } from "../../txn/models_pb";
import { Delivery } from "../../txn/models_pb";
import { Delivery_Status } from "../../txn/models_pb";
import { ColumnOption } from "../../analyticsv2/reportbuilder/models_pb";
import { Filter_Attribute } from "../../analyticsv2/reportbuilder/models_pb";
import { Report as Report$ } from "../../analyticsv2/reportbuilder/models_pb";
import { ReportParamsV2 } from "../../analyticsv2/reportbuilder/models_pb";
import { ReportParams } from "../../analyticsv2/reportbuilder/models_pb";
import { PurchaseJournalSortBy } from "../../analyticsv2/models_pb";
import { ProfitAndLoss } from "../../analyticsv2/models_pb";
import { Report } from "../../analytics/models_pb";
import { SortOrder as SortOrder$ } from "../../analyticsv2/models_pb";
import { SoldProductsSortBy } from "../../analyticsv2/models_pb";
import { Filters } from "../../analyticsv2/models_pb";
import { Receivable_Type } from "../../txn/models_pb";
import { SavedReport } from "../../analyticsv2/reportbuilder/models_pb";
import { BaseData } from "../../analyticsv2/reportbuilder/models_pb";
import { ManualJournalEntry } from "../../manualjournalentry/models_pb";
import { JournalEntry } from "../../accounting/models_pb";
import { JournalEntry_Type } from "../../accounting/models_pb";
import { InternalAccount } from "../../coa/models_pb";
import { Mapping } from "../../coa/models_pb";
import { Account_Type } from "../../coa/models_pb";
import { Receivable } from "../../txn/models_pb";
import { Receivable_Transaction_Type } from "../../txn/models_pb";
import { CreditAllocationStatus } from "../../txn/models_pb";
import { StatementRun } from "../../statement/models_pb";
import { StatementRun_RunType } from "../../statement/models_pb";
import { Statement } from "../../statement/models_pb";
import { Statement_AutopayStatus } from "../../statement/models_pb";
import { Statement_Status } from "../../statement/models_pb";
import { OrderProductFilter } from "../../txn/models_pb";
import { SaleForm_CustomField } from "../../company/models_pb";
import { Tag_Color } from "../../tag/models_pb";
import { Tag_Type } from "../../tag/models_pb";
import { PricingRegion } from "../../company/models_pb";
import { TierRule } from "../../price/models_pb";
import { Rule_PriceStrategy } from "../../price/models_pb";
import { Custom } from "../../price/models_pb";
import { ExternalAccount } from "../../accounting/models_pb";
import { ExternalTransaction } from "../../accounting/models_pb";
import { ExternalTransaction_PaymentMethod } from "../../accounting/models_pb";
import { ExternalTransaction_Type } from "../../accounting/models_pb";
import { FractionalMoney } from "../../proto/money/models_pb";
import { InventoryCountProduct_Status } from "../../product/models_pb";
import { Account } from "../../coa/models_pb";
import { FinancialTransaction } from "../../payments/models_pb";
import { FinancialTransaction_Status } from "../../payments/models_pb";
import { FinancialTransaction_Type } from "../../payments/models_pb";
import { CloseOut } from "../../txn/models_pb";
import { PettyCash } from "../../txn/models_pb";
import { Update } from "../cache/models_pb";
import { Transfer } from "../../txn/models_pb";
import { Transfer_Status } from "../../txn/models_pb";
import { DeliveryStop } from "../../txn/models_pb";
import { GiftCard } from "../../giftcard/models_pb";
import { SaleProduct } from "../../txn/models_pb";
import { TintColor } from "../../tintcolor/models_pb";
import { Sale_Source } from "../../txn/models_pb";
import { Sale_CloseOutStatus } from "../../txn/models_pb";
import { Sale_Type } from "../../txn/models_pb";
import { Sale_Status } from "../../txn/models_pb";
import { CustomPrintSettings } from "../../product/models_pb";
import { LabelTemplate } from "../../product/models_pb";
import { ProductLabel } from "../../product/models_pb";
import { RegionTierPrices } from "../../price/models_pb";
import { AdditionalFees_Fee } from "../../company/models_pb";
import { SaleForm } from "../../company/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { VendorSKU } from "../../product/models_pb";
import { Tier } from "../../price/models_pb";
import { ProductCategory } from "../../company/models_pb";
import { Product as Product$ } from "../../catalog/models_pb";
import { ProductSalesAnalytics } from "../../txn/models_pb";
import { Inventories } from "../../product/models_pb";
import { PricingTiers } from "../../company/models_pb";
import { Product_KitType } from "../../product/models_pb";
import { GiftCard_Type } from "../../giftcard/models_pb";
import { Product_TaxStatus } from "../../product/models_pb";
import { OrderShipment_Status } from "../../txn/models_pb";
import { OrderShipment } from "../../txn/models_pb";
import { Product } from "../../product/models_pb";
import { Vendor } from "../../vendors/models_pb";
import { Order } from "../../txn/models_pb";
import { Order_Status } from "../../txn/models_pb";
import { Contacts_Contact } from "../../customer/models_pb";
import { Tag } from "../../tag/models_pb";
import { FinanceChargeSetting } from "../../company/models_pb";
import { CustomerSalesAnalytics } from "../../txn/models_pb";
import { Staff } from "../../company/models_pb";
import { Interaction } from "../../customer/models_pb";
import { CustomerBalance } from "../../txn/models_pb";
import { PricingTiers_Tier } from "../../company/models_pb";
import { FinancingTerms_Term } from "../../company/models_pb";
import { Contacts } from "../../customer/models_pb";
import { Customer_Origin } from "../../customer/models_pb";
import { AllocatedReceivable } from "../../txn/models_pb";
import { LedgerMethods } from "../../ledger/models_pb";
import { Method_Type } from "../../company/tender/models_pb";
import { LedgerEntry } from "../../ledger/models_pb";
import { Card } from "../../payments/models_pb";
import { Customer } from "../../customer/models_pb";
import { Location } from "../../company/models_pb";
import { PurchaseOrder } from "../../customer/models_pb";
import { Sale } from "../../txn/models_pb";
import { BillPayment } from "../../txn/models_pb";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { User } from "../../user/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Money } from "../../proto/money/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.search.service.SearchBillPaymentsAllocatedFinanceCharge
 */
export interface SearchBillPaymentsAllocatedFinanceCharge {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money allocated_amount = 3
     */
    allocatedAmount?: Money;
    /**
     * @generated from protobuf field: string location_prefix = 4
     */
    locationPrefix: string;
    /**
     * @generated from protobuf field: string location_name = 5
     */
    locationName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp assessed_at = 6
     */
    assessedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 7
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 8
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string customer_identifier = 9
     */
    customerIdentifier: string;
    /**
     * @generated from protobuf field: string customer_name = 10
     */
    customerName: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID job_id = 11
     */
    jobId?: UUID;
    /**
     * @generated from protobuf field: string job_identifier = 12
     */
    jobIdentifier: string;
    /**
     * @generated from protobuf field: string job_name = 13
     */
    jobName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 14
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchBillPaymentsReq
 */
export interface SearchBillPaymentsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 3
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 4
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 5
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 6
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 7
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchBillPaymentsReq.CreditFilter credit_filters = 11
     */
    creditFilters: SearchBillPaymentsReq_CreditFilter[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 12
     */
    methodIds: UUID[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchBillPaymentsReq.CreditFilter
 */
export enum SearchBillPaymentsReq_CreditFilter {
    /**
     * @generated from protobuf enum value: NO_CREDIT = 0;
     */
    NO_CREDIT = 0,
    /**
     * @generated from protobuf enum value: ADDS_CREDIT = 1;
     */
    ADDS_CREDIT = 1,
    /**
     * @generated from protobuf enum value: USES_CREDIT = 2;
     */
    USES_CREDIT = 2
}
/**
 * @generated from protobuf message rd.search.service.SearchBillPaymentsRes
 */
export interface SearchBillPaymentsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchBillPaymentsRes.Result results = 1
     */
    results: SearchBillPaymentsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchBillPaymentsRes.Result
 */
export interface SearchBillPaymentsRes_Result {
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 1
     */
    billPayment?: BillPayment;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale> sales_by_id = 4
     */
    salesById: {
        [key: string]: Sale;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_sale_id = 5
     */
    allocationsBySaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> totals_by_sale_id = 6
     */
    totalsBySaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id = 7
     */
    purchaseOrdersBySaleId: {
        [key: string]: PurchaseOrder;
    };
    /**
     * @generated from protobuf field: map<string, rd.company.Location> locations_by_sale_id = 9
     */
    locationsBySaleId: {
        [key: string]: Location;
    };
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 10
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.payments.Card payment_card = 11
     */
    paymentCard?: Card;
    /**
     * TODO: (CUSTOM_METHODS_OF_TENDER) Reserve
     *
     * @generated from protobuf field: string payment_method = 12
     */
    paymentMethod: string;
    /**
     * @generated from protobuf field: map<string, rd.customer.Customer> customers_by_sale_id = 13
     */
    customersBySaleId: {
        [key: string]: Customer;
    };
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges = 21
     */
    allocatedFinanceCharges: SearchBillPaymentsAllocatedFinanceCharge[];
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> credits_used_by_id = 22
     */
    creditsUsedById: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry ledger_entry = 23
     */
    ledgerEntry?: LedgerEntry; // payment ledger entry
    /**
     * TODO: (CUSTOM_METHODS_OF_TENDER) Reserve
     *
     * @generated from protobuf field: rd.company.tender.Method.Type tender_method_type = 24
     */
    tenderMethodType: Method_Type;
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 25
     */
    ledgerMethods?: LedgerMethods;
    /**
     * @generated from protobuf field: repeated rd.txn.AllocatedReceivable allocated_receivables = 26
     */
    allocatedReceivables: AllocatedReceivable[];
}
/**
 * @generated from protobuf message rd.search.service.SearchRefundedBillPaymentsReq
 */
export interface SearchRefundedBillPaymentsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 3
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 4
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 5
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 6
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 7
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 10
     */
    methodIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchRefundedBillPaymentsRes
 */
export interface SearchRefundedBillPaymentsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchRefundedBillPaymentsRes.Result results = 1
     */
    results: SearchRefundedBillPaymentsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchRefundedBillPaymentsRes.Result
 */
export interface SearchRefundedBillPaymentsRes_Result {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID payment_ledger_entry_id = 1
     */
    paymentLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 2
     */
    billPayment?: BillPayment;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry payment_ledger_entry = 3
     */
    paymentLedgerEntry?: LedgerEntry;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale> sales_by_id = 4
     */
    salesById: {
        [key: string]: Sale;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_sale_id = 5
     */
    allocationsBySaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> totals_by_sale_id = 6
     */
    totalsBySaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id = 7
     */
    purchaseOrdersBySaleId: {
        [key: string]: PurchaseOrder;
    };
    /**
     * @generated from protobuf field: map<string, rd.company.Location> locations_by_sale_id = 9
     */
    locationsBySaleId: {
        [key: string]: Location;
    };
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 10
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.payments.Card payment_card = 11
     */
    paymentCard?: Card;
    /**
     * TODO: (CUSTOM_METHODS_OF_TENDER) Reserve
     *
     * @generated from protobuf field: string payment_method = 12
     */
    paymentMethod: string;
    /**
     * @generated from protobuf field: map<string, rd.customer.Customer> customers_by_sale_id = 13
     */
    customersBySaleId: {
        [key: string]: Customer;
    };
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges = 14
     */
    allocatedFinanceCharges: SearchBillPaymentsAllocatedFinanceCharge[];
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> credits_used_by_id = 15
     */
    creditsUsedById: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 16
     */
    ledgerMethods?: LedgerMethods;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID refund_ledger_entry_id = 17
     */
    refundLedgerEntryId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.txn.AllocatedReceivable allocated_receivables = 18
     */
    allocatedReceivables: AllocatedReceivable[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomersV2Req
 */
export interface SearchCustomersV2Req {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 3
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 4
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_on_credit_hold_filter = 5
     */
    isOnCreditHoldFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 6
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 7
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 9
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: string cursor = 10
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 11
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 12
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.OrderCustomersBy order_by = 13
     */
    orderBy: OrderCustomersBy;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_settings_ids = 14
     */
    financeChargeSettingsIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 15
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID primary_location_ids = 16
     */
    primaryLocationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 17
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.customer.Customer.Origin origins = 18
     */
    origins: Customer_Origin[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomersV2Res
 */
export interface SearchCustomersV2Res {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCustomersV2Res.Result results = 1
     */
    results: SearchCustomersV2Res_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomersV2Res.Result
 */
export interface SearchCustomersV2Res_Result {
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 1
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.Contacts contacts = 2
     */
    contacts?: Contacts;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms.Term financing_term = 4
     */
    financingTerm?: FinancingTerms_Term;
    /**
     * @generated from protobuf field: rd.company.PricingTiers.Tier pricing_tier = 5
     */
    pricingTier?: PricingTiers_Tier;
    /**
     * @generated from protobuf field: rd.txn.CustomerBalance balance = 6
     */
    balance?: CustomerBalance;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 7
     */
    totalBalance?: Money;
    /**
     * @generated from protobuf field: string financing_term_name = 8
     */
    financingTermName: string;
    /**
     * @generated from protobuf field: rd.customer.Interaction last_interaction = 10
     */
    lastInteraction?: Interaction;
    /**
     * @generated from protobuf field: rd.company.Staff rep_staff = 11
     */
    repStaff?: Staff;
    /**
     * @generated from protobuf field: rd.txn.CustomerSalesAnalytics analytics = 13
     */
    analytics?: CustomerSalesAnalytics;
    /**
     * @generated from protobuf field: rd.company.FinanceChargeSetting finance_charge_setting = 14
     */
    financeChargeSetting?: FinanceChargeSetting;
    /**
     * @generated from protobuf field: repeated rd.tag.Tag tags = 15
     */
    tags: Tag[];
    /**
     * @generated from protobuf field: rd.company.Location primary_location = 16
     */
    primaryLocation?: Location;
    /**
     * @generated from protobuf field: float margin_ytd = 17
     */
    marginYtd: number;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange last_statement_period = 18
     */
    lastStatementPeriod?: TimestampRange;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomersReq
 */
export interface BulkExportCustomersReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 3
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 4
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_on_credit_hold_filter = 5
     */
    isOnCreditHoldFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 6
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 7
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.OrderCustomersBy order_by = 8
     */
    orderBy: OrderCustomersBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 9
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: bool is_template = 10
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_setting_ids = 11
     */
    financeChargeSettingIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 12
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID primary_location_ids = 13
     */
    primaryLocationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.customer.Customer.Origin origins = 14
     */
    origins: Customer_Origin[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomersRes
 */
export interface BulkExportCustomersRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerContactsReq
 */
export interface SearchCustomerContactsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 2
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter should_email_invoices_filter = 3
     */
    shouldEmailInvoicesFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter should_email_statements_filter = 4
     */
    shouldEmailStatementsFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.OrderCustomerContactsBy order_by = 5
     */
    orderBy: OrderCustomerContactsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: string cursor = 7
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 8
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 9
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter sms_consent_filter = 10
     */
    smsConsentFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_tag_ids = 11
     */
    customerTagIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerContactsRes
 */
export interface SearchCustomerContactsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCustomerContactsRes.Result results = 1
     */
    results: SearchCustomerContactsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerContactsRes.Result
 */
export interface SearchCustomerContactsRes_Result {
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 1
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact contact = 2
     */
    contact?: Contacts_Contact;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomerContactsReq
 */
export interface BulkExportCustomerContactsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 2
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter should_email_invoices_filter = 3
     */
    shouldEmailInvoicesFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter should_email_statements_filter = 4
     */
    shouldEmailStatementsFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.OrderCustomerContactsBy order_by = 5
     */
    orderBy: OrderCustomerContactsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: bool is_template = 7
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter sms_consent_filter = 8
     */
    smsConsentFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_tag_ids = 9
     */
    customerTagIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomerContactsRes
 */
export interface BulkExportCustomerContactsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchOrdersReq
 */
export interface SearchOrdersReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange ordered_at_range = 3
     */
    orderedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange received_at_range = 4
     */
    receivedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange voided_at_range = 5
     */
    voidedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 6
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Order.Status statuses = 7
     */
    statuses: Order_Status[];
    /**
     * @generated from protobuf field: string cursor = 8
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 9
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 10
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 11
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 12
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 13
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID ordered_by_ids = 14
     */
    orderedByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID voided_by_ids = 16
     */
    voidedByIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchOrdersRes
 */
export interface SearchOrdersRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchOrdersRes.Result results = 1
     */
    results: SearchOrdersRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchOrdersRes.Result
 */
export interface SearchOrdersRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Order order = 1
     */
    order?: Order;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.Location location = 3
     */
    location?: Location;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 4
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: map<string, rd.product.Product> matched_products_by_id = 5
     */
    matchedProductsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 6
     */
    total?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.OrderShipment order_shipments = 7
     */
    orderShipments: OrderShipment[];
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsReq
 */
export interface SearchOrderShipmentsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 3
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 4
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 5
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 6
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange timestamp_range = 11
     */
    timestampRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.txn.OrderShipment.Status status = 12
     */
    status: OrderShipment_Status;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 13
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 14
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID received_by_ids = 16
     */
    receivedByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID marked_paid_by_ids = 17
     */
    markedPaidByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vouchered_by_ids = 18
     */
    voucheredByIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsRes
 */
export interface SearchOrderShipmentsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchOrderShipmentsRes.Result results = 1
     */
    results: SearchOrderShipmentsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsRes.Result
 */
export interface SearchOrderShipmentsRes_Result {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.Location location = 3
     */
    location?: Location;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 4
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: map<string, rd.product.Product> matched_products_by_id = 5
     */
    matchedProductsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 6
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchProductsV2Req
 */
export interface SearchProductsV2Req {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inv_sort_location_id = 2
     */
    invSortLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID current_location_id = 3
     */
    currentLocationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 5
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_id_strings = 6
     */
    additionalFeeIdStrings: string[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 7
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_tintable_filter = 9
     */
    isTintableFilter: BoolFilter;
    /**
     * @generated from protobuf field: string cursor = 10
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 11
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 12
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchProductsV2Req.OrderBy order_by = 13
     */
    orderBy: SearchProductsV2Req_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 14
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.product.Product.TaxStatus tax_statuses = 15
     */
    taxStatuses: Product_TaxStatus[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 16
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 17
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 18
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 19
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 20
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID integrated_vendor_ids = 21
     */
    integratedVendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.giftcard.GiftCard.Type gift_card_types = 22
     */
    giftCardTypes: GiftCard_Type[];
    /**
     * @generated from protobuf field: bool filter_no_department = 23
     */
    filterNoDepartment: boolean;
    /**
     * @generated from protobuf field: bool filter_no_class = 24
     */
    filterNoClass: boolean;
    /**
     * @generated from protobuf field: bool filter_no_fineline = 25
     */
    filterNoFineline: boolean;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_ecomm_enabled_filter = 26
     */
    isEcommEnabledFilter: BoolFilter; // Filter products by their e-commerce eligibility
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_in_stock_filter = 27
     */
    isInStockFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_non_stock_filter = 28
     */
    isNonStockFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_special_orderable_filter = 29
     */
    isSpecialOrderableFilter: BoolFilter;
    /**
     * has_price_change_since_print_filter restricts to products whose label price
     * was updated after the label was last printed (at current_location_id).
     *
     * @generated from protobuf field: rd.search.service.BoolFilter has_price_change_since_print_filter = 30
     */
    hasPriceChangeSincePrintFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_bub_export_filter = 31
     */
    isBubExportFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.product.Product.KitType kit_types = 32
     */
    kitTypes: Product_KitType[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchProductsV2Req.OrderBy
 */
export enum SearchProductsV2Req_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_INVENTORY_LOCATION_ID = 2;
     */
    INVENTORY_LOCATION_ID = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_TARGET = 3;
     */
    TARGET = 3,
    /**
     * @generated from protobuf enum value: ORDER_BY_CURRENT = 4;
     */
    CURRENT = 4,
    /**
     * @generated from protobuf enum value: ORDER_BY_REORDER = 5;
     */
    REORDER = 5,
    /**
     * @generated from protobuf enum value: ORDER_BY_DELTA = 6;
     */
    DELTA = 6,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_SOLD_YTD = 7;
     */
    UNITS_SOLD_YTD = 7,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_VS_LAST_YEAR = 8;
     */
    UNITS_VS_LAST_YEAR = 8,
    /**
     * @generated from protobuf enum value: ORDER_BY_MARGIN = 9;
     */
    MARGIN = 9,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_12MO = 10;
     */
    UNITS_LAST_12MO = 10,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_3MO = 11;
     */
    UNITS_LAST_3MO = 11,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_1MO = 12;
     */
    UNITS_LAST_1MO = 12,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_SALE = 13;
     */
    LAST_SALE = 13,
    /**
     * @generated from protobuf enum value: ORDER_BY_TURNS = 14;
     */
    TURNS = 14,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 15;
     */
    UPDATED_AT = 15,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_PRINTED_AT = 16;
     */
    LAST_PRINTED_AT = 16,
    /**
     * @generated from protobuf enum value: ORDER_BY_PRICE_UPDATED_AT = 17;
     */
    PRICE_UPDATED_AT = 17
}
/**
 * @generated from protobuf message rd.search.service.SearchProductsV2Res
 */
export interface SearchProductsV2Res {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchProductsV2Res.Result results = 1
     */
    results: SearchProductsV2Res_Result[];
    /**
     * @generated from protobuf field: map<string, rd.company.Location> locations_by_id = 2
     */
    locationsById: {
        [key: string]: Location;
    };
    /**
     * @generated from protobuf field: rd.company.PricingTiers pricing_tiers = 3
     */
    pricingTiers?: PricingTiers;
    /**
     * @generated from protobuf field: string cursor = 4
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchProductsV2Res.Result
 */
export interface SearchProductsV2Res_Result {
    /**
     * @generated from protobuf field: rd.product.Product product = 1
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.product.Product matched_price_product = 2
     */
    matchedPriceProduct?: Product;
    /**
     * @generated from protobuf field: rd.product.Product matched_cost_product = 3
     */
    matchedCostProduct?: Product;
    /**
     * @generated from protobuf field: rd.product.Inventories inventories = 4
     */
    inventories?: Inventories;
    /**
     * @generated from protobuf field: rd.vendors.Vendor primary_cost_vendor = 5
     */
    primaryCostVendor?: Vendor;
    /**
     * @generated from protobuf field: rd.txn.ProductSalesAnalytics analytics = 10
     */
    analytics?: ProductSalesAnalytics;
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 11
     */
    catalogProduct?: Product$;
    /**
     * @generated from protobuf field: rd.company.ProductCategory department = 12
     */
    department?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory class = 13
     */
    class?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory fineline = 14
     */
    fineline?: ProductCategory;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 15
     */
    tierPrices: Tier[];
    /**
     * @generated from protobuf field: repeated rd.tag.Tag tags = 16
     */
    tags: Tag[];
    /**
     * @generated from protobuf field: float margin_ytd = 17
     */
    marginYtd: number;
    /**
     * TODO: remove this field
     *
     * @generated from protobuf field: repeated rd.product.VendorSKU vendor_skus = 18
     */
    vendorSkus: VendorSKU[];
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal delta_v2 = 19
     */
    deltaV2?: Decimal;
    /**
     * @generated from protobuf field: string image_url = 20
     */
    imageUrl: string;
    /**
     * @generated from protobuf field: rd.company.SaleForm sale_form = 21
     */
    saleForm?: SaleForm;
    /**
     * @generated from protobuf field: repeated string upcs = 22
     */
    upcs: string[];
    /**
     * @generated from protobuf field: repeated rd.company.AdditionalFees.Fee additional_fees = 23
     */
    additionalFees: AdditionalFees_Fee[];
    /**
     * @generated from protobuf field: repeated rd.price.RegionTierPrices tier_prices_by_region = 24
     */
    tierPricesByRegion: RegionTierPrices[]; // bub only, exludes inherited
    /**
     * @generated from protobuf field: rd.product.ProductLabel product_label = 25
     */
    productLabel?: ProductLabel; // label at current_location_id
}
/**
 * @generated from protobuf message rd.search.service.BulkExportProductsReq
 */
export interface BulkExportProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inv_sort_location_id = 2
     */
    invSortLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID current_location_id = 3
     */
    currentLocationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 5
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_id_strings = 6
     */
    additionalFeeIdStrings: string[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 7
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_tintable_filter = 8
     */
    isTintableFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.SearchProductOrderBy order_by = 9
     */
    orderBy: SearchProductOrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 10
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.product.Product.TaxStatus tax_statuses = 11
     */
    taxStatuses: Product_TaxStatus[];
    /**
     * @generated from protobuf field: bool is_template = 16
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 17
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 18
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 19
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 20
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 21
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: bool output_to_gcs = 22
     */
    outputToGcs: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportProductsRes
 */
export interface BulkExportProductsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
    /**
     * @generated from protobuf field: string gcs_url = 2
     */
    gcsUrl: string;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportProductLabelsReq
 */
export interface BulkExportProductLabelsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inv_sort_location_id = 2
     */
    invSortLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID current_location_id = 3
     */
    currentLocationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 4
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_id_strings = 5
     */
    additionalFeeIdStrings: string[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 6
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_tintable_filter = 7
     */
    isTintableFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.SearchProductOrderBy order_by = 8
     */
    orderBy: SearchProductOrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 9
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.product.Product.TaxStatus tax_statuses = 10
     */
    taxStatuses: Product_TaxStatus[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 11
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 12
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 13
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 14
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.product.LabelTemplate template = 15
     */
    template: LabelTemplate;
    /**
     * @generated from protobuf field: int32 rotation_degrees = 16
     */
    rotationDegrees: number;
    /**
     * @generated from protobuf field: int32 quantity = 17
     */
    quantity: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID label_design_id = 18
     */
    labelDesignId?: UUID;
    /**
     * @generated from protobuf field: rd.product.CustomPrintSettings print_settings = 21
     */
    printSettings?: CustomPrintSettings;
    /**
     * @generated from protobuf field: int32 start_position = 22
     */
    startPosition: number;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportProductLabelsRes
 */
export interface BulkExportProductLabelsRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchSalesV2Req
 */
export interface SearchSalesV2Req {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange quoted_at_range = 3
     */
    quotedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange will_called_at_range = 4
     */
    willCalledAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sold_at_range = 5
     */
    soldAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange voided_at_range = 6
     */
    voidedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 7
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID quoted_by_ids = 8
     */
    quotedByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID will_called_by_ids = 9
     */
    willCalledByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sold_by_ids = 10
     */
    soldByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID voided_by_ids = 11
     */
    voidedByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 12
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 13
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Status statuses = 14
     */
    statuses: Sale_Status[];
    /**
     * @generated from protobuf field: string cursor = 15
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 16
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 17
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 18
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tint_color_ids = 19
     */
    tintColorIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter contains_non_taxable_products_filter = 20
     */
    containsNonTaxableProductsFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 22
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Type types = 23
     */
    types: Sale_Type[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 25
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 26
     */
    methodIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange special_ordered_at_range = 27
     */
    specialOrderedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID special_ordered_by_ids = 28
     */
    specialOrderedByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fulfillment_location_ids = 29
     */
    fulfillmentLocationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.CloseOutStatus close_out_statuses = 31
     */
    closeOutStatuses: Sale_CloseOutStatus[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Source sources = 32
     */
    sources: Sale_Source[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID designated_clerk_ids = 33
     */
    designatedClerkIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Status exclude_statuses = 34
     */
    excludeStatuses: Sale_Status[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_staged_for_delivery = 35
     */
    isStagedForDelivery: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.SearchSalesV2Res
 */
export interface SearchSalesV2Res {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchSalesV2Res.Result results = 1
     */
    results: SearchSalesV2Res_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchSalesV2Res.Result
 */
export interface SearchSalesV2Res_Result {
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 1
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 3
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.PurchaseOrder purchase_order = 4
     */
    purchaseOrder?: PurchaseOrder;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 6
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: map<string, rd.tintcolor.TintColor> tint_colors_by_id = 8
     */
    tintColorsById: {
        [key: string]: TintColor;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 9
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact customer_contact = 10
     */
    customerContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct sale_products = 12
     */
    saleProducts: SaleProduct[];
    /**
     * @generated from protobuf field: rd.customer.Customer job = 15
     */
    job?: Customer;
    /**
     * @generated from protobuf field: repeated rd.txn.Sale returns = 16
     */
    returns: Sale[];
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale> returned_from_sales_by_id = 17
     */
    returnedFromSalesById: {
        [key: string]: Sale;
    };
    /**
     * @generated from protobuf field: map<string, rd.search.service.SearchSalesV2Res.Result.ReturnedInSales> returned_in_sales_by_sale_product_id = 18
     */
    returnedInSalesBySaleProductId: {
        [key: string]: SearchSalesV2Res_Result_ReturnedInSales;
    };
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 19
     */
    ledgerMethods?: LedgerMethods;
    /**
     * @generated from protobuf field: rd.company.Location fulfillment_location = 20
     */
    fulfillmentLocation?: Location;
    /**
     * @generated from protobuf field: map<string, rd.giftcard.GiftCard> gift_cards_by_id = 21
     */
    giftCardsById: {
        [key: string]: GiftCard;
    };
    /**
     * @generated from protobuf field: repeated rd.txn.DeliveryStop delivery_stops = 22
     */
    deliveryStops: DeliveryStop[]; // for now only staged stops; read by the delivery stops cart
}
/**
 * @generated from protobuf message rd.search.service.SearchSalesV2Res.Result.ReturnedInSales
 */
export interface SearchSalesV2Res_Result_ReturnedInSales {
    /**
     * @generated from protobuf field: repeated rd.txn.Sale sales = 1
     */
    sales: Sale[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnsReq
 */
export interface SearchReturnsReq {
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnsRes
 */
export interface SearchReturnsRes {
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnsRes.Result
 */
export interface SearchReturnsRes_Result {
}
/**
 * @generated from protobuf message rd.search.service.SearchOutstandingSalesReq
 */
export interface SearchOutstandingSalesReq {
}
/**
 * @generated from protobuf message rd.search.service.SearchOutstandingSalesRes
 */
export interface SearchOutstandingSalesRes {
}
/**
 * @generated from protobuf message rd.search.service.SearchOutstandingSalesRes.Result
 */
export interface SearchOutstandingSalesRes_Result {
}
/**
 * @generated from protobuf message rd.search.service.SearchTintColorsReq
 */
export interface SearchTintColorsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchTintColorsRes
 */
export interface SearchTintColorsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchTintColorsRes.Result results = 2
     */
    results: SearchTintColorsRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchTintColorsRes.Result
 */
export interface SearchTintColorsRes_Result {
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 1
     */
    tintColor?: TintColor;
}
/**
 * @generated from protobuf message rd.search.service.SearchTransfersReq
 */
export interface SearchTransfersReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sent_at_range = 3
     */
    sentAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange received_at_range = 4
     */
    receivedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange voided_at_range = 5
     */
    voidedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID from_location_ids = 6
     */
    fromLocationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID to_location_ids = 7
     */
    toLocationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Transfer.Status statuses = 8
     */
    statuses: Transfer_Status[];
    /**
     * @generated from protobuf field: string cursor = 9
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 10
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 11
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange requested_at_range = 12
     */
    requestedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 13
     */
    productIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchTransfersRes
 */
export interface SearchTransfersRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchTransfersRes.Result results = 1
     */
    results: SearchTransfersRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchTransfersRes.Result
 */
export interface SearchTransfersRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Transfer transfer = 1
     */
    transfer?: Transfer;
    /**
     * @generated from protobuf field: rd.company.Location from_location = 2
     */
    fromLocation?: Location;
    /**
     * @generated from protobuf field: rd.company.Location to_location = 3
     */
    toLocation?: Location;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 4
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 6
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchVendorsReq
 */
export interface SearchVendorsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 2
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: string cursor = 3
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 4
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 5
     */
    limit: number;
}
/**
 * @generated from protobuf message rd.search.service.SearchVendorsRes
 */
export interface SearchVendorsRes {
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchVendorsRes.Result results = 3
     */
    results: SearchVendorsRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchVendorsRes.Result
 */
export interface SearchVendorsRes_Result {
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 1
     */
    vendor?: Vendor;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportVendorsReq
 */
export interface BulkExportVendorsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 2
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: bool is_template = 3
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportVendorsRes
 */
export interface BulkExportVendorsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportUnitsOfMeasureReq
 */
export interface BulkExportUnitsOfMeasureReq {
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 1
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: bool is_template = 2
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportUnitsOfMeasureRes
 */
export interface BulkExportUnitsOfMeasureRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.UpdateRecordReq
 */
export interface UpdateRecordReq {
    /**
     * @generated from protobuf field: rd.search.cache.Update update = 6
     */
    update?: Update;
}
/**
 * @generated from protobuf message rd.search.service.UpdateRecordRes
 */
export interface UpdateRecordRes {
}
/**
 * @generated from protobuf message rd.search.service.ReloadReq
 */
export interface ReloadReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 1
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: bool full_reload = 2
     */
    fullReload: boolean;
    /**
     * @generated from protobuf field: repeated string table_names = 3
     */
    tableNames: string[];
    /**
     * @generated from protobuf field: bool clear_aux_tables = 4
     */
    clearAuxTables: boolean;
    /**
     * @generated from protobuf field: bool from_disk = 5
     */
    fromDisk: boolean;
}
/**
 * @generated from protobuf message rd.search.service.ReloadRes
 */
export interface ReloadRes {
}
/**
 * @generated from protobuf message rd.search.service.SearchCashTransactionsReq
 */
export interface SearchCashTransactionsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 2
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 3
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCashTransactionsReq.Type types = 4
     */
    types: SearchCashTransactionsReq_Type[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 5
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 6
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 7
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID cash_register_ids = 9
     */
    cashRegisterIds: UUID[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchCashTransactionsReq.Type
 */
export enum SearchCashTransactionsReq_Type {
    /**
     * @generated from protobuf enum value: TYPE_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: TYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * @generated from protobuf enum value: TYPE_BILL_PAYMENT = 2;
     */
    BILL_PAYMENT = 2,
    /**
     * @generated from protobuf enum value: TYPE_REFUND = 3;
     */
    REFUND = 3,
    /**
     * @generated from protobuf enum value: TYPE_PETTY_CASH = 4;
     */
    PETTY_CASH = 4,
    /**
     * @generated from protobuf enum value: TYPE_CLOSE_OUT = 5;
     */
    CLOSE_OUT = 5
}
/**
 * @generated from protobuf message rd.search.service.SearchCashTransactionsRes
 */
export interface SearchCashTransactionsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCashTransactionsRes.Result results = 1
     */
    results: SearchCashTransactionsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCashTransactionsRes.Result
 */
export interface SearchCashTransactionsRes_Result {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry ledger_entry = 1
     */
    ledgerEntry?: LedgerEntry;
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 2
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 3
     */
    billPayment?: BillPayment;
    /**
     * @generated from protobuf field: rd.txn.PettyCash petty_cash = 4
     */
    pettyCash?: PettyCash;
    /**
     * @generated from protobuf field: rd.txn.CloseOut close_out = 5
     */
    closeOut?: CloseOut;
    /**
     * @generated from protobuf field: rd.txn.Sale sale_return = 7
     */
    saleReturn?: Sale;
}
/**
 * @generated from protobuf message rd.search.service.SearchFinancialTransactionsReq
 */
export interface SearchFinancialTransactionsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 2
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.payments.FinancialTransaction.Type types = 3
     */
    types: FinancialTransaction_Type[];
    /**
     * @generated from protobuf field: repeated rd.payments.FinancialTransaction.Status statuses = 4
     */
    statuses: FinancialTransaction_Status[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange range = 5
     */
    range?: TimestampRange;
    /**
     * @generated from protobuf field: string cursor = 6
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 7
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID chart_of_account_ids = 9
     */
    chartOfAccountIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchFinancialTransactionsRes
 */
export interface SearchFinancialTransactionsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchFinancialTransactionsRes.Result results = 1
     */
    results: SearchFinancialTransactionsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchFinancialTransactionsRes.Result
 */
export interface SearchFinancialTransactionsRes_Result {
    /**
     * @generated from protobuf field: rd.payments.FinancialTransaction financial_transaction = 1
     */
    financialTransaction?: FinancialTransaction;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: map<string, rd.coa.Account> accounts_by_id = 5
     */
    accountsById: {
        [key: string]: Account;
    };
    /**
     * @generated from protobuf field: map<string, rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id = 6
     */
    orderShipmentDataById: {
        [key: string]: SearchFinancialTransactionsRes_Result_OrderShipmentData;
    };
    /**
     * @generated from protobuf field: rd.company.Location location = 7
     */
    location?: Location;
}
/**
 * @generated from protobuf message rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData
 */
export interface SearchFinancialTransactionsRes_Result_OrderShipmentData {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryCountProductsReq
 */
export interface SearchInventoryCountProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_location_id = 2
     */
    inventoryLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 3
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: rd.product.InventoryCountProduct.Status product_status = 4
     */
    productStatus: InventoryCountProduct_Status;
    /**
     * @generated from protobuf field: string cursor = 5
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 6
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 7
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchInventoryCountProductsReq.OrderBy order_by = 13
     */
    orderBy: SearchInventoryCountProductsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 14
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf enum rd.search.service.SearchInventoryCountProductsReq.OrderBy
 */
export enum SearchInventoryCountProductsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_ON_HAND = 2;
     */
    ON_HAND = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_VARIANCE = 3;
     */
    VARIANCE = 3,
    /**
     * @generated from protobuf enum value: ORDER_BY_DOLLAR_VARIANCE = 4;
     */
    DOLLAR_VARIANCE = 4
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryCountProductsRes
 */
export interface SearchInventoryCountProductsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchInventoryCountProductsRes.Result results = 1
     */
    results: SearchInventoryCountProductsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryCountProductsRes.Result
 */
export interface SearchInventoryCountProductsRes_Result {
    /**
     * @generated from protobuf field: rd.product.Product product = 1
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.proto.money.Money dollar_variance = 5
     */
    dollarVariance?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal on_hand_v2 = 6
     */
    onHandV2?: Decimal; // stock: on hand + committed
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal counted_v2 = 7
     */
    countedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal variance_v2 = 8
     */
    varianceV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_product_id = 9
     */
    inventoryCountProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 10
     */
    cost?: FractionalMoney;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportInventoryCountProductsReq
 */
export interface BulkExportInventoryCountProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_location_id = 2
     */
    inventoryLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 3
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: rd.product.InventoryCountProduct.Status product_status = 4
     */
    productStatus: InventoryCountProduct_Status;
    /**
     * @generated from protobuf field: string cursor = 5
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 6
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 7
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.BulkExportInventoryCountProductsReq.OrderBy order_by = 13
     */
    orderBy: BulkExportInventoryCountProductsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 14
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf enum rd.search.service.BulkExportInventoryCountProductsReq.OrderBy
 */
export enum BulkExportInventoryCountProductsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_ON_HAND = 2;
     */
    ON_HAND = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_VARIANCE = 3;
     */
    VARIANCE = 3,
    /**
     * @generated from protobuf enum value: ORDER_BY_DOLLAR_VARIANCE = 4;
     */
    DOLLAR_VARIANCE = 4
}
/**
 * @generated from protobuf message rd.search.service.BulkExportInventoryCountProductsRes
 */
export interface BulkExportInventoryCountProductsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchExcludedInventoryCountProductsReq
 */
export interface SearchExcludedInventoryCountProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID inventory_count_id = 3
     */
    inventoryCountId?: UUID;
    /**
     * @generated from protobuf field: string cursor = 4
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 5
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 6
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 7
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 8
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID class_id = 9
     */
    classId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID fineline_id = 10
     */
    finelineId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.SearchExcludedInventoryCountProductsRes
 */
export interface SearchExcludedInventoryCountProductsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchExcludedInventoryCountProductsRes.Result results = 1
     */
    results: SearchExcludedInventoryCountProductsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchExcludedInventoryCountProductsRes.Result
 */
export interface SearchExcludedInventoryCountProductsRes_Result {
    /**
     * @generated from protobuf field: rd.product.Product product = 1
     */
    product?: Product;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 2
     */
    tierPrices: Tier[];
}
/**
 * @generated from protobuf message rd.search.service.SearchExternalTransactionsReq
 */
export interface SearchExternalTransactionsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange transacted_at_range = 2
     */
    transactedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 3
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 4
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 5
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID chart_of_account_ids = 6
     */
    chartOfAccountIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.accounting.ExternalTransaction.Type types = 7
     */
    types: ExternalTransaction_Type[];
    /**
     * @generated from protobuf field: repeated rd.accounting.ExternalTransaction.PaymentMethod payment_methods = 8
     */
    paymentMethods: ExternalTransaction_PaymentMethod[];
    /**
     * @generated from protobuf field: string cursor = 9
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 10
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 11
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 12
     */
    externalAccountId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.SearchExternalTransactionsRes
 */
export interface SearchExternalTransactionsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchExternalTransactionsRes.Result results = 1
     */
    results: SearchExternalTransactionsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchExternalTransactionsRes.Result
 */
export interface SearchExternalTransactionsRes_Result {
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction external_transaction = 1
     */
    externalTransaction?: ExternalTransaction;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 3
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 4
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: map<string, rd.coa.Account> accounts_by_id = 7
     */
    accountsById: {
        [key: string]: Account;
    };
    /**
     * @generated from protobuf field: map<string, rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id = 8
     */
    orderShipmentDataById: {
        [key: string]: SearchExternalTransactionsRes_Result_OrderShipmentData;
    };
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount external_account = 9
     */
    externalAccount?: ExternalAccount;
}
/**
 * @generated from protobuf message rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData
 */
export interface SearchExternalTransactionsRes_Result_OrderShipmentData {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsForReconciliationReq
 */
export interface SearchOrderShipmentsForReconciliationReq {
    /**
     * @generated from protobuf field: string cursor = 1
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 2
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 3
     */
    limit: number;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID transaction_id = 5
     */
    transactionId?: UUID;
    /**
     * @generated from protobuf field: string stripe_transaction_id = 6
     */
    stripeTransactionId: string; // if present, will be used to generate a transaction id uuid
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsForReconciliationRes
 */
export interface SearchOrderShipmentsForReconciliationRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchOrderShipmentsForReconciliationRes.Result results = 1
     */
    results: SearchOrderShipmentsForReconciliationRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchOrderShipmentsForReconciliationRes.Result
 */
export interface SearchOrderShipmentsForReconciliationRes_Result {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 2
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryChangesReq
 */
export interface SearchInventoryChangesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID staff_ids = 4
     */
    staffIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange range = 6
     */
    range?: TimestampRange;
    /**
     * @generated from protobuf field: string cursor = 7
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 8
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 9
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 10
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.search.service.InventoryChangeType inventory_change_types = 11
     */
    inventoryChangeTypes: InventoryChangeType[];
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryChangesRes
 */
export interface SearchInventoryChangesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchInventoryChangesRes.Result results = 1
     */
    results: SearchInventoryChangesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchInventoryChangesRes.Result
 */
export interface SearchInventoryChangesRes_Result {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID txn_id = 3
     */
    txnId?: UUID;
    /**
     * @generated from protobuf field: string txn_identifier = 4
     */
    txnIdentifier: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 7
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User staff = 8
     */
    staff?: User;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_cost = 9
     */
    unitCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney average_cost = 10
     */
    averageCost?: FractionalMoney;
    /**
     * @deprecated
     * @generated from protobuf field: map<int32, int32> status_quantities = 11 [deprecated = true]
     */
    statusQuantities: {
        [key: number]: number;
    };
    /**
     * @deprecated
     * @generated from protobuf field: map<int32, int32> status_deltas = 12 [deprecated = true]
     */
    statusDeltas: {
        [key: number]: number;
    };
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney valuation = 13
     */
    valuation?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry ledger_entry = 14
     */
    ledgerEntry?: LedgerEntry;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_cost_delta = 15
     */
    unitCostDelta?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 16
     */
    returnedFromSaleId?: UUID;
    /**
     * @generated from protobuf field: rd.search.service.SearchInventoryChangesRes.TransactionTag tag = 17
     */
    tag: SearchInventoryChangesRes_TransactionTag;
    /**
     * @generated from protobuf field: map<int32, rd.proto.decimal.Decimal> status_quantities_v2 = 18
     */
    statusQuantitiesV2: {
        [key: number]: Decimal;
    };
    /**
     * @generated from protobuf field: map<int32, rd.proto.decimal.Decimal> status_deltas_v2 = 19
     */
    statusDeltasV2: {
        [key: number]: Decimal;
    };
    /**
     * @generated from protobuf field: rd.search.service.InventoryChangeType inventory_change_type = 20
     */
    inventoryChangeType: InventoryChangeType;
    /**
     * @generated from protobuf field: bool is_reversal = 21
     */
    isReversal: boolean;
    /**
     * @generated from protobuf field: rd.company.Location location = 22
     */
    location?: Location;
}
/**
 * TransactionTag used to explain logical inconsistencies
 *
 * @generated from protobuf enum rd.search.service.SearchInventoryChangesRes.TransactionTag
 */
export enum SearchInventoryChangesRes_TransactionTag {
    /**
     * @generated from protobuf enum value: TRANSACTION_TAG_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: TRANSACTION_TAG_VOIDED = 1;
     */
    VOIDED = 1,
    /**
     * @generated from protobuf enum value: TRANSACTION_TAG_EDITED = 2;
     */
    EDITED = 2,
    /**
     * @generated from protobuf enum value: TRANSACTION_TAG_EDIT = 3;
     */
    EDIT = 3
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomPriceRulesReq
 */
export interface SearchCustomPriceRulesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 5
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 6
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 7
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 8
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 9
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.CustomPriceRuleSortBy sort_by = 10
     */
    sortBy: CustomPriceRuleSortBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 11
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.CustomPriceRuleType type = 12
     */
    type: CustomPriceRuleType;
    /**
     * @generated from protobuf field: repeated rd.search.service.CustomPriceRuleValidityFilter statuses = 13
     */
    statuses: CustomPriceRuleValidityFilter[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 14
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 15
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 16
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_tag_ids = 17
     */
    productTagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_tag_ids = 18
     */
    customerTagIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomPriceRulesRes
 */
export interface SearchCustomPriceRulesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCustomPriceRulesRes.Result results = 1
     */
    results: SearchCustomPriceRulesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomPriceRulesRes.Result
 */
export interface SearchCustomPriceRulesRes_Result {
    /**
     * @generated from protobuf field: rd.price.Custom custom = 1
     */
    custom?: Custom;
    /**
     * @generated from protobuf field: int32 product_count = 10
     */
    productCount: number;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 11
     */
    customer?: Customer; // for jobs, this is the parent customer
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 12
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.ProductCategory department = 13
     */
    department?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory class = 14
     */
    class?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory fineline = 15
     */
    fineline?: ProductCategory;
    /**
     * @generated from protobuf field: rd.product.Product product = 16
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.vendors.Vendor product_vendor = 18
     */
    productVendor?: Vendor;
    /**
     * @generated from protobuf field: rd.customer.Customer job = 19
     */
    job?: Customer;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_department = 20
     */
    productDepartment?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_class = 21
     */
    productClass?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_fineline = 22
     */
    productFineline?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.Location location = 23
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.tag.Tag product_tag = 24
     */
    productTag?: Tag;
    /**
     * @generated from protobuf field: rd.company.PricingTiers.Tier reference_tier = 25
     */
    referenceTier?: PricingTiers_Tier;
    /**
     * @generated from protobuf field: rd.tag.Tag customer_tag = 26
     */
    customerTag?: Tag;
    /**
     * @generated from protobuf field: rd.proto.money.Money computed_price = 27
     */
    computedPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal computed_margin_percent = 28
     */
    computedMarginPercent?: Decimal;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 29
     */
    tierPrices: Tier[]; // only for rule with single product
    /**
     * @generated from protobuf field: rd.product.Product matched_cost_product = 30
     */
    matchedCostProduct?: Product; // only for rule with single product
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomPriceRulesReq
 */
export interface BulkExportCustomPriceRulesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 2
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 3
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 4
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 5
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 6
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.CustomPriceRuleSortBy sort_by = 7
     */
    sortBy: CustomPriceRuleSortBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 8
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.CustomPriceRuleType type = 9
     */
    type: CustomPriceRuleType;
    /**
     * @generated from protobuf field: repeated rd.search.service.CustomPriceRuleValidityFilter statuses = 10
     */
    statuses: CustomPriceRuleValidityFilter[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 11
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: bool is_template = 12
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 13
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 14
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_tag_ids = 15
     */
    productTagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_tag_ids = 16
     */
    customerTagIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportCustomPriceRulesRes
 */
export interface BulkExportCustomPriceRulesRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceTierRulesReq
 */
export interface SearchPriceTierRulesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: string pricing_tier_id_string = 5
     */
    pricingTierIdString: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 6
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 7
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 8
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 9
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_tag_ids = 10
     */
    productTagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 11
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.price.Rule.PriceStrategy price_strategies = 12
     */
    priceStrategies: Rule_PriceStrategy[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID pricing_region_ids = 13
     */
    pricingRegionIds: UUID[];
    /**
     * The pricing region id for the current signed in location
     *
     * @generated from protobuf field: rd.proto.uuid.UUID current_pricing_region_id = 14
     */
    currentPricingRegionId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceTierRulesRes
 */
export interface SearchPriceTierRulesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchPriceTierRulesRes.Result results = 1
     */
    results: SearchPriceTierRulesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceTierRulesRes.Result
 */
export interface SearchPriceTierRulesRes_Result {
    /**
     * @generated from protobuf field: rd.price.TierRule tier_rule = 1
     */
    tierRule?: TierRule;
    /**
     * @generated from protobuf field: int32 product_count = 2
     */
    productCount: number;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 3
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.ProductCategory department = 4
     */
    department?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory class = 5
     */
    class?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory fineline = 6
     */
    fineline?: ProductCategory;
    /**
     * @generated from protobuf field: rd.product.Product product = 7
     */
    product?: Product;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 17
     */
    tierPrices: Tier[];
    /**
     * @generated from protobuf field: rd.tag.Tag product_tag = 8
     */
    productTag?: Tag;
    /**
     * @generated from protobuf field: rd.company.PricingRegion pricing_region = 9
     */
    pricingRegion?: PricingRegion;
}
/**
 * @generated from protobuf message rd.search.service.SearchJobsReq
 */
export interface SearchJobsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.OrderJobsBy order_by = 6
     */
    orderBy: OrderJobsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 8
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 9
     */
    customerIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchJobsRes
 */
export interface SearchJobsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchJobsRes.Result results = 1
     */
    results: SearchJobsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchJobsRes.Result
 */
export interface SearchJobsRes_Result {
    /**
     * @generated from protobuf field: rd.customer.Customer job = 1
     */
    job?: Customer;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 7
     */
    totalBalance?: Money;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 8
     */
    customer?: Customer;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportJobsReq
 */
export interface BulkExportJobsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 2
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.OrderJobsBy order_by = 3
     */
    orderBy: OrderJobsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 4
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 5
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: bool is_template = 6
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportJobsRes
 */
export interface BulkExportJobsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchTagsReq
 */
export interface SearchTagsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchTagsReq.OrderBy order_by = 5
     */
    orderBy: SearchTagsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.tag.Tag.Type types = 7
     */
    types: Tag_Type[];
    /**
     * @generated from protobuf field: repeated rd.tag.Tag.Color colors = 8
     */
    colors: Tag_Color[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchTagsReq.OrderBy
 */
export enum SearchTagsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1
}
/**
 * @generated from protobuf message rd.search.service.SearchTagsRes
 */
export interface SearchTagsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchTagsRes.Result results = 1
     */
    results: SearchTagsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchTagsRes.Result
 */
export interface SearchTagsRes_Result {
    /**
     * @generated from protobuf field: rd.tag.Tag tag = 1
     */
    tag?: Tag;
    /**
     * @generated from protobuf field: int32 tagged_count = 2
     */
    taggedCount: number;
}
/**
 * @generated from protobuf message rd.search.service.SearchStagedProductsToOrderReq
 */
export interface SearchStagedProductsToOrderReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 5
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 6
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 7
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 8
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 9
     */
    saleIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 10
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 11
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.SearchStagedProductsToOrderReq.OrderBy order_by = 12
     */
    orderBy: SearchStagedProductsToOrderReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_in_buyers_list_filter = 13
     */
    isActiveInBuyersListFilter: BoolFilter;
}
/**
 * @generated from protobuf enum rd.search.service.SearchStagedProductsToOrderReq.OrderBy
 */
export enum SearchStagedProductsToOrderReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 1;
     */
    CREATED_AT = 1
}
/**
 * @generated from protobuf message rd.search.service.SearchStagedProductsToOrderRes
 */
export interface SearchStagedProductsToOrderRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStagedProductsToOrderRes.Result results = 1
     */
    results: SearchStagedProductsToOrderRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder
 */
export interface SearchStagedProductsToOrderRes_LinkedOrder {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment
 */
export interface SearchStagedProductsToOrderRes_LinkedShipment {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchStagedProductsToOrderRes.Result
 */
export interface SearchStagedProductsToOrderRes_Result {
    /**
     * @generated from protobuf field: rd.product.Product product = 4
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.product.Product matched_price_product = 8
     */
    matchedPriceProduct?: Product;
    /**
     * @generated from protobuf field: rd.product.Product matched_cost_product = 9
     */
    matchedCostProduct?: Product;
    /**
     * @generated from protobuf field: rd.product.Inventories inventories = 10
     */
    inventories?: Inventories;
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 12
     */
    catalogProduct?: Product$;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 13
     */
    tierPrices: Tier[];
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal required_quantity = 14
     */
    requiredQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_on_draft_order = 15
     */
    quantityOnDraftOrder?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_on_order = 16
     */
    quantityOnOrder?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received = 17
     */
    quantityReceived?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal remaining_quantity = 18
     */
    remainingQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 19
     */
    cost?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_active_in_buyers_list = 20
     */
    isActiveInBuyersList: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 21
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: string product_identifier = 22
     */
    productIdentifier: string;
    /**
     * @generated from protobuf field: string product_name = 23
     */
    productName: string;
    /**
     * @generated from protobuf field: string vendor_name = 24
     */
    vendorName: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 25
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: string sale_identifier = 26
     */
    saleIdentifier: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 27
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 28
     */
    price?: Money;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder linked_orders = 29
     */
    linkedOrders: SearchStagedProductsToOrderRes_LinkedOrder[];
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment linked_shipments = 30
     */
    linkedShipments: SearchStagedProductsToOrderRes_LinkedShipment[];
    /**
     * @generated from protobuf field: string customer_name = 31
     */
    customerName: string;
    /**
     * @generated from protobuf field: string job_name = 32
     */
    jobName: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 33
     */
    saleProductId?: UUID;
    /**
     * @generated from protobuf field: string notes = 34
     */
    notes: string;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 35
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney price_fractional = 36
     */
    priceFractional?: FractionalMoney;
}
/**
 * PreviewGeneratedOrderProductsReq carries everything OrderService needs to
 * generate the order this previews, minus the fields only a write needs. The two
 * must stay in step: this endpoint previews the products the order service would
 * generate for the same request, so any divergence in the request shape becomes
 * a divergence between the preview and the order.
 *
 * @generated from protobuf message rd.search.service.PreviewGeneratedOrderProductsReq
 */
export interface PreviewGeneratedOrderProductsReq {
    /**
     * @generated from protobuf field: rd.search.service.PreviewGeneratedOrderProductsReq.Mode mode = 1
     */
    mode: PreviewGeneratedOrderProductsReq_Mode;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 2
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: int32 weeks = 4
     */
    weeks: number; // required for MODE_PREDICTIVE and MODE_REPLENISHMENT
    /**
     * @generated from protobuf field: bool match_vendor_on_all_costs = 5
     */
    matchVendorOnAllCosts: boolean;
    /**
     * @generated from protobuf field: rd.txn.OrderProductFilter filters = 6
     */
    filters?: OrderProductFilter;
}
/**
 * @generated from protobuf enum rd.search.service.PreviewGeneratedOrderProductsReq.Mode
 */
export enum PreviewGeneratedOrderProductsReq_Mode {
    /**
     * @generated from protobuf enum value: MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * GenerateOrder
     *
     * @generated from protobuf enum value: MODE_MIN_MAX = 1;
     */
    MIN_MAX = 1,
    /**
     * GeneratePredictiveOrder
     *
     * @generated from protobuf enum value: MODE_PREDICTIVE = 2;
     */
    PREDICTIVE = 2,
    /**
     * GenerateReplenishmentOrder
     *
     * @generated from protobuf enum value: MODE_REPLENISHMENT = 3;
     */
    REPLENISHMENT = 3
}
/**
 * @generated from protobuf message rd.search.service.PreviewGeneratedOrderProductsRes
 */
export interface PreviewGeneratedOrderProductsRes {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 1
     */
    productIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchFinanceChargesReq
 */
export interface SearchFinanceChargesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 2
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 3
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 4
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 5
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 6
     */
    limit: number;
}
/**
 * @generated from protobuf message rd.search.service.SearchFinanceChargesRes
 */
export interface SearchFinanceChargesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchFinanceChargesRes.Result results = 1
     */
    results: SearchFinanceChargesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchFinanceChargesRes.OutstandingTransaction
 */
export interface SearchFinanceChargesRes_OutstandingTransaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.search.service.SearchFinanceChargesRes.OutstandingTransaction.Type type = 2
     */
    type: SearchFinanceChargesRes_OutstandingTransaction_Type;
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 3
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry finance_charge = 4
     */
    financeCharge?: LedgerEntry;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 5
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.company.Location location = 6
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.proto.money.Money outstanding_balance = 7
     */
    outstandingBalance?: Money;
}
/**
 * @generated from protobuf enum rd.search.service.SearchFinanceChargesRes.OutstandingTransaction.Type
 */
export enum SearchFinanceChargesRes_OutstandingTransaction_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * @generated from protobuf enum value: TYPE_FINANCE_CHARGE = 2;
     */
    FINANCE_CHARGE = 2
}
/**
 * @generated from protobuf message rd.search.service.SearchFinanceChargesRes.Result
 */
export interface SearchFinanceChargesRes_Result {
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry finance_charge_ledger_entry = 1
     */
    financeChargeLedgerEntry?: LedgerEntry;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 2
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: map<string, rd.search.service.SearchFinanceChargesRes.OutstandingTransaction> outstanding_transactions_by_id = 3
     */
    outstandingTransactionsById: {
        [key: string]: SearchFinanceChargesRes_OutstandingTransaction;
    };
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementsReq
 */
export interface SearchStatementsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID finance_charge_settings_ids = 5
     */
    financeChargeSettingsIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_on_credit_hold_filter = 6
     */
    isOnCreditHoldFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated string financing_term_id_strings = 7
     */
    financingTermIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string pricing_tier_id_strings = 8
     */
    pricingTierIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID rep_staff_ids = 9
     */
    repStaffIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 10
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 11
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 12
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: rd.search.service.OrderStatementsBy order_by = 13
     */
    orderBy: OrderStatementsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 14
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.statement.Statement.Status statuses = 15
     */
    statuses: Statement_Status[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter isMailed = 16
     */
    isMailed: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.statement.Statement.AutopayStatus autopay_statuses = 17
     */
    autopayStatuses: Statement_AutopayStatus[];
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementsRes
 */
export interface SearchStatementsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStatementsRes.Result results = 1
     */
    results: SearchStatementsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementsRes.Result
 */
export interface SearchStatementsRes_Result {
    /**
     * @generated from protobuf field: rd.statement.Statement statement = 1
     */
    statement?: Statement;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 2
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange statement_period = 3
     */
    statementPeriod?: TimestampRange;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 4
     */
    sentAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 5
     */
    totalBalance?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementRunsReq
 */
export interface SearchStatementRunsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.statement.StatementRun.RunType run_types = 5
     */
    runTypes: StatementRun_RunType[];
    /**
     * @generated from protobuf field: rd.search.service.OrderStatementRunsBy order_by = 6
     */
    orderBy: OrderStatementRunsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementRunsRes
 */
export interface SearchStatementRunsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStatementRunsRes.Result results = 1
     */
    results: SearchStatementRunsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchStatementRunsRes.Result
 */
export interface SearchStatementRunsRes_Result {
    /**
     * @generated from protobuf field: rd.statement.StatementRun statement_run = 1
     */
    statementRun?: StatementRun;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 2
     */
    sentAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 generated_count = 3
     */
    generatedCount: number;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange statement_period = 4
     */
    statementPeriod?: TimestampRange;
    /**
     * @generated from protobuf field: int32 error_count = 5
     */
    errorCount: number;
    /**
     * @generated from protobuf field: int32 initiated_count = 6
     */
    initiatedCount: number;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerStatementsReq
 */
export interface SearchCustomerStatementsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.statement.StatementRun.RunType run_types = 6
     */
    runTypes: StatementRun_RunType[];
    /**
     * @generated from protobuf field: rd.search.service.OrderCustomerStatementsBy order_by = 7
     */
    orderBy: OrderCustomerStatementsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 8
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerStatementsRes
 */
export interface SearchCustomerStatementsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCustomerStatementsRes.Result results = 1
     */
    results: SearchCustomerStatementsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCustomerStatementsRes.Result
 */
export interface SearchCustomerStatementsRes_Result {
    /**
     * @generated from protobuf field: rd.statement.Statement statement = 1
     */
    statement?: Statement;
    /**
     * @generated from protobuf field: rd.statement.StatementRun statement_run = 2
     */
    statementRun?: StatementRun;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange statement_period = 3
     */
    statementPeriod?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 4
     */
    totalBalance?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 5
     */
    sentAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnableSaleProductsReq
 */
export interface SearchReturnableSaleProductsReq {
    /**
     * @generated from protobuf field: string cursor = 1
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 2
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 3
     */
    limit: number;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 5
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 6
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sold_at_range = 7
     */
    soldAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 8
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_purchase_order_ids = 9
     */
    customerPurchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID clerk_ids = 10
     */
    clerkIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tint_color_ids = 12
     */
    tintColorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 13
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID current_selected_sale_product_id = 14
     */
    currentSelectedSaleProductId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID selected_sale_product_ids_in_cart = 15
     */
    selectedSaleProductIdsInCart: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 16
     */
    methodIds: UUID[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnableSaleProductsRes
 */
export interface SearchReturnableSaleProductsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchReturnableSaleProductsRes.Result results = 1
     */
    results: SearchReturnableSaleProductsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchReturnableSaleProductsRes.Result
 */
export interface SearchReturnableSaleProductsRes_Result {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 1
     */
    saleProductId?: UUID; // required
    /**
     * @generated from protobuf field: string sale_identifier = 2
     */
    saleIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 3
     */
    saleId?: UUID; // required
    /**
     * @generated from protobuf field: rd.txn.Sale.Type sale_type = 4
     */
    saleType: Sale_Type;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 5
     */
    soldAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money unit_price = 7
     */
    unitPrice?: Money;
    /**
     * @generated from protobuf field: string clerk_name = 8
     */
    clerkName: string;
    /**
     * @generated from protobuf field: string sale_notes = 10
     */
    saleNotes: string;
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 11
     */
    tintColor?: TintColor;
    /**
     * @generated from protobuf field: string custom_tint_color = 12
     */
    customTintColor: string;
    /**
     * @generated from protobuf field: string customer_name = 13
     */
    customerName: string;
    /**
     * @generated from protobuf field: string customer_identifier = 14
     */
    customerIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 15
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string job_name = 16
     */
    jobName: string;
    /**
     * @generated from protobuf field: string job_identifier = 17
     */
    jobIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID job_id = 18
     */
    jobId?: UUID;
    /**
     * @generated from protobuf field: string location_prefix = 19
     */
    locationPrefix: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 20
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string customer_purchase_order = 21
     */
    customerPurchaseOrder: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_remaining_v2 = 22
     */
    quantityRemainingV2?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 23
     */
    ledgerMethods?: LedgerMethods;
    /**
     * Original transaction UOM context (optional).
     *
     * @generated from protobuf field: rd.proto.uuid.UUID original_uom_id = 24
     */
    originalUomId?: UUID;
    /**
     * @generated from protobuf field: string original_uom_code = 25
     */
    originalUomCode: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal original_conversion_factor = 26
     */
    originalConversionFactor?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_remaining_uom = 27
     */
    quantityRemainingUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_price_fractional = 28
     */
    unitPriceFractional?: FractionalMoney;
}
/**
 * @generated from protobuf message rd.search.service.SearchCreditsReq
 */
export interface SearchCreditsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange date_range_filter = 5
     */
    dateRangeFilter?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 6
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.OrderCreditsBy order_by = 7
     */
    orderBy: OrderCreditsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 8
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.txn.CreditAllocationStatus allocation_statuses = 9
     */
    allocationStatuses: CreditAllocationStatus[];
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Transaction.Type transaction_types = 10
     */
    transactionTypes: Receivable_Transaction_Type[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCreditsRes
 */
export interface SearchCreditsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCreditsRes.Result results = 1
     */
    results: SearchCreditsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCreditsRes.Result
 */
export interface SearchCreditsRes_Result {
    /**
     * @generated from protobuf field: rd.txn.CreditAllocationStatus allocation_status = 5
     */
    allocationStatus: CreditAllocationStatus;
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 10
     */
    receivable?: Receivable;
}
/**
 * @generated from protobuf message rd.search.service.SearchAccountsReq
 */
export interface SearchAccountsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SortAccountsBy sort_by = 5
     */
    sortBy: SortAccountsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.coa.Account.Type types = 7
     */
    types: Account_Type[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 8
     */
    isActiveFilter: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.SearchAccountsRes
 */
export interface SearchAccountsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchAccountsRes.Result results = 1
     */
    results: SearchAccountsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchAccountsRes.Result
 */
export interface SearchAccountsRes_Result {
    /**
     * @generated from protobuf field: rd.coa.Account account = 1
     */
    account?: Account;
    /**
     * @generated from protobuf field: repeated rd.coa.Mapping mappings = 2
     */
    mappings: Mapping[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportAccountsReq
 */
export interface BulkExportAccountsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: bool is_template = 2
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: rd.search.service.SortAccountsBy sort_by = 3
     */
    sortBy: SortAccountsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 4
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.coa.Account.Type types = 5
     */
    types: Account_Type[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 6
     */
    isActiveFilter: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportAccountsRes
 */
export interface BulkExportAccountsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchMappingsReq
 */
export interface SearchMappingsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SortMappingsBy sort_by = 5
     */
    sortBy: SortMappingsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.coa.Account.Type types = 7
     */
    types: Account_Type[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 8
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 9
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID account_ids = 10
     */
    accountIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount control_accounts = 11
     */
    controlAccounts: InternalAccount[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tender_method_ids = 12
     */
    tenderMethodIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_ids = 13
     */
    additionalFeeIds: string[];
}
/**
 * @generated from protobuf message rd.search.service.SearchMappingsRes
 */
export interface SearchMappingsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchMappingsRes.Result results = 1
     */
    results: SearchMappingsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchMappingsRes.Result
 */
export interface SearchMappingsRes_Result {
    /**
     * @generated from protobuf field: rd.coa.Mapping mapping = 1
     */
    mapping?: Mapping;
    /**
     * @generated from protobuf field: rd.coa.Account account = 2
     */
    account?: Account;
    /**
     * @generated from protobuf field: rd.company.Location location = 3
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.coa.Account.Type account_type = 5
     */
    accountType: Account_Type;
    /**
     * @generated from protobuf field: string breakdown_name = 6
     */
    breakdownName: string;
    /**
     * @generated from protobuf field: string control_account_description = 7
     */
    controlAccountDescription: string;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportMappingsReq
 */
export interface BulkExportMappingsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: bool is_template = 2
     */
    isTemplate: boolean;
    /**
     * @generated from protobuf field: rd.search.service.SortMappingsBy sort_by = 3
     */
    sortBy: SortMappingsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 4
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.coa.Account.Type types = 5
     */
    types: Account_Type[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 6
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 7
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID account_ids = 8
     */
    accountIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount control_accounts = 9
     */
    controlAccounts: InternalAccount[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportMappingsRes
 */
export interface BulkExportMappingsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchJournalEntriesReq
 */
export interface SearchJournalEntriesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SortJournalEntriesBy sort_by = 5
     */
    sortBy: SortJournalEntriesBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.accounting.JournalEntry.Type types = 7
     */
    types: JournalEntry_Type[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_auto_generated_filter = 8
     */
    isAutoGeneratedFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_archived_filter = 9
     */
    isArchivedFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange date_range_filter = 10
     */
    dateRangeFilter?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange exported_at_range_filter = 11
     */
    exportedAtRangeFilter?: TimestampRange;
    /**
     * @generated from protobuf field: string client_time_zone = 12
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchJournalEntriesRes
 */
export interface SearchJournalEntriesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchJournalEntriesRes.Result results = 1
     */
    results: SearchJournalEntriesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchJournalEntriesRes.Result
 */
export interface SearchJournalEntriesRes_Result {
    /**
     * @generated from protobuf field: rd.accounting.JournalEntry journal_entry = 1
     */
    journalEntry?: JournalEntry;
}
/**
 * @generated from protobuf message rd.search.service.SearchManualJournalEntriesReq
 */
export interface SearchManualJournalEntriesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SortManualJournalEntriesBy sort_by = 5
     */
    sortBy: SortManualJournalEntriesBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange accounted_at_range_filter = 7
     */
    accountedAtRangeFilter?: TimestampRange;
    /**
     * @generated from protobuf field: string client_time_zone = 8
     */
    clientTimeZone: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 9
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 10
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 11
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 12
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 13
     */
    isActiveFilter: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.SearchManualJournalEntriesRes
 */
export interface SearchManualJournalEntriesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchManualJournalEntriesRes.Result results = 1
     */
    results: SearchManualJournalEntriesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchManualJournalEntriesRes.Result
 */
export interface SearchManualJournalEntriesRes_Result {
    /**
     * @generated from protobuf field: rd.manualjournalentry.ManualJournalEntry manual_journal_entry = 1
     */
    manualJournalEntry?: ManualJournalEntry;
    /**
     * @generated from protobuf field: map<string, string> line_entity_names_by_id = 2
     */
    lineEntityNamesById: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message rd.search.service.SearchSavedReportsReq
 */
export interface SearchSavedReportsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SortSavedReportsBy sort_by = 5
     */
    sortBy: SortSavedReportsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.SearchSavedReportsReq.Filter filter = 7
     */
    filter?: SearchSavedReportsReq_Filter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_global_filter = 8
     */
    isGlobalFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_accounting_filter = 9
     */
    isAccountingFilter: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.SearchSavedReportsReq.Filter
 */
export interface SearchSavedReportsReq_Filter {
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.BaseData base_data_types = 1
     */
    baseDataTypes: BaseData[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID created_by_ids = 2
     */
    createdByIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID updated_by_ids = 3
     */
    updatedByIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange created_at_range = 4
     */
    createdAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange updated_at_range = 5
     */
    updatedAtRange?: TimestampRange;
}
/**
 * @generated from protobuf message rd.search.service.SearchSavedReportsRes
 */
export interface SearchSavedReportsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchSavedReportsRes.Result results = 1
     */
    results: SearchSavedReportsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchSavedReportsRes.Result
 */
export interface SearchSavedReportsRes_Result {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.SavedReport saved_report = 1
     */
    savedReport?: SavedReport;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchSalesReq
 */
export interface CxaSearchSalesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 3
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Status statuses = 4
     */
    statuses: Sale_Status[];
    /**
     * @generated from protobuf field: string cursor = 5
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 6
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 7
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Type types = 8
     */
    types: Sale_Type[];
    /**
     * @generated from protobuf field: repeated rd.txn.Sale.Source sources = 9
     */
    sources: Sale_Source[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange sold_at_range = 10
     */
    soldAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tint_color_ids = 11
     */
    tintColorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 12
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 13
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 14
     */
    methodIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange will_called_at_range = 15
     */
    willCalledAtRange?: TimestampRange;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchSalesRes
 */
export interface CxaSearchSalesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.CxaSearchSalesRes.Result results = 1
     */
    results: CxaSearchSalesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchSalesRes.Result
 */
export interface CxaSearchSalesRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 1
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.PurchaseOrder purchase_order = 3
     */
    purchaseOrder?: PurchaseOrder;
    /**
     * @generated from protobuf field: map<string, rd.product.Product> products_by_id = 5
     */
    productsById: {
        [key: string]: Product;
    };
    /**
     * @generated from protobuf field: map<string, rd.tintcolor.TintColor> tint_colors_by_id = 7
     */
    tintColorsById: {
        [key: string]: TintColor;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 8
     */
    total?: Money;
    /**
     * @generated from protobuf field: string customer_contact_name = 10
     */
    customerContactName: string;
    /**
     * @generated from protobuf field: string customer_identifier = 11
     */
    customerIdentifier: string;
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 12
     */
    ledgerMethods?: LedgerMethods;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchOutstandingSalesReq
 */
export interface CxaSearchOutstandingSalesReq {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchOutstandingSalesRes
 */
export interface CxaSearchOutstandingSalesRes {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchOutstandingSalesRes.Result
 */
export interface CxaSearchOutstandingSalesRes_Result {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReceivablesAgingReq
 */
export interface CxaSearchReceivablesAgingReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Type receivable_types = 2
     */
    receivableTypes: Receivable_Type[];
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReceivablesAgingRes
 */
export interface CxaSearchReceivablesAgingRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.CxaSearchReceivablesAgingRes.Result results = 1
     */
    results: CxaSearchReceivablesAgingRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReceivablesAgingRes.Result
 */
export interface CxaSearchReceivablesAgingRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 1
     */
    receivable?: Receivable;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReturnsReq
 */
export interface CxaSearchReturnsReq {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReturnsRes
 */
export interface CxaSearchReturnsRes {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchReturnsRes.Result
 */
export interface CxaSearchReturnsRes_Result {
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchJobsReq
 */
export interface CxaSearchJobsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchJobsRes
 */
export interface CxaSearchJobsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.CxaSearchJobsRes.Result results = 1
     */
    results: CxaSearchJobsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchJobsRes.Result
 */
export interface CxaSearchJobsRes_Result {
    /**
     * @generated from protobuf field: rd.customer.Customer job = 1
     */
    job?: Customer;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 2
     */
    totalBalance?: Money;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchProductsReq
 */
export interface CxaSearchProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 6
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 7
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 8
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.CxaSearchProductsReq.OrderBy order_by = 9
     */
    orderBy: CxaSearchProductsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 10
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_in_stock_filter = 11
     */
    isInStockFilter: BoolFilter;
}
/**
 * @generated from protobuf enum rd.search.service.CxaSearchProductsReq.OrderBy
 */
export enum CxaSearchProductsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_INVENTORY = 2;
     */
    INVENTORY = 2
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchProductsRes
 */
export interface CxaSearchProductsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.CxaSearchProductsRes.Result results = 1
     */
    results: CxaSearchProductsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchProductsRes.Result
 */
export interface CxaSearchProductsRes_Result {
    /**
     * @generated from protobuf field: rd.product.Product product = 1
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.proto.money.Money customer_price = 2
     */
    customerPrice?: Money;
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 3
     */
    catalogProduct?: Product$;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal on_hand_quantity = 4
     */
    onHandQuantity?: Decimal;
    /**
     * @generated from protobuf field: rd.company.ProductCategory department = 5
     */
    department?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory class = 6
     */
    class?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory fineline = 7
     */
    fineline?: ProductCategory;
    /**
     * @generated from protobuf field: string image_url = 8
     */
    imageUrl: string;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchTintColorsReq
 */
export interface CxaSearchTintColorsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchTintColorsRes
 */
export interface CxaSearchTintColorsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.CxaSearchTintColorsRes.Result results = 1
     */
    results: CxaSearchTintColorsRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.CxaSearchTintColorsRes.Result
 */
export interface CxaSearchTintColorsRes_Result {
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 1
     */
    tintColor?: TintColor;
}
/**
 * Cash Register Report
 *
 * @generated from protobuf message rd.search.service.GetCashRegisterReq
 */
export interface GetCashRegisterReq {
}
/**
 * @generated from protobuf message rd.search.service.GetCashRegisterRes
 */
export interface GetCashRegisterRes {
}
/**
 * @generated from protobuf message rd.search.service.GetCashRegisterPDFReq
 */
export interface GetCashRegisterPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetCashRegisterPDFRes
 */
export interface GetCashRegisterPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetCashRegisterCSVReq
 */
export interface GetCashRegisterCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetCashRegisterCSVRes
 */
export interface GetCashRegisterCSVRes {
}
/**
 * Sales
 *
 * @generated from protobuf message rd.search.service.GetSalesReq
 */
export interface GetSalesReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesRes
 */
export interface GetSalesRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesPDFReq
 */
export interface GetSalesPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesPDFRes
 */
export interface GetSalesPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesCSVReq
 */
export interface GetSalesCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesCSVRes
 */
export interface GetSalesCSVRes {
}
/**
 * Payments
 *
 * @generated from protobuf message rd.search.service.GetPaymentsReq
 */
export interface GetPaymentsReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPaymentsRes
 */
export interface GetPaymentsRes {
}
/**
 * @generated from protobuf message rd.search.service.GetPaymentsPDFReq
 */
export interface GetPaymentsPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPaymentsPDFRes
 */
export interface GetPaymentsPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetPaymentsCSVReq
 */
export interface GetPaymentsCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPaymentsCSVRes
 */
export interface GetPaymentsCSVRes {
}
/**
 * Sold Products
 *
 * @generated from protobuf message rd.search.service.GetSoldProductsReq
 */
export interface GetSoldProductsReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.SoldProductsSortBy sort_by = 2
     */
    sortBy: SoldProductsSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetSoldProductsRes
 */
export interface GetSoldProductsRes {
    /**
     * @generated from protobuf field: rd.analytics.Report report = 1
     */
    report?: Report;
}
/**
 * @generated from protobuf message rd.search.service.GetSoldProductsPDFReq
 */
export interface GetSoldProductsPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSoldProductsPDFRes
 */
export interface GetSoldProductsPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSoldProductsCSVReq
 */
export interface GetSoldProductsCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSoldProductsCSVRes
 */
export interface GetSoldProductsCSVRes {
}
/**
 * Sales by Customer
 *
 * @generated from protobuf message rd.search.service.GetSalesByCustomerReq
 */
export interface GetSalesByCustomerReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByCustomerRes
 */
export interface GetSalesByCustomerRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByCustomerPDFReq
 */
export interface GetSalesByCustomerPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByCustomerPDFRes
 */
export interface GetSalesByCustomerPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByCustomerCSVReq
 */
export interface GetSalesByCustomerCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByCustomerCSVRes
 */
export interface GetSalesByCustomerCSVRes {
}
/**
 * Sales by Job
 *
 * @generated from protobuf message rd.search.service.GetSalesByJobReq
 */
export interface GetSalesByJobReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByJobRes
 */
export interface GetSalesByJobRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByJobPDFReq
 */
export interface GetSalesByJobPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByJobPDFRes
 */
export interface GetSalesByJobPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByJobCSVReq
 */
export interface GetSalesByJobCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByJobCSVRes
 */
export interface GetSalesByJobCSVRes {
}
/**
 * Sales by Product
 *
 * @generated from protobuf message rd.search.service.GetSalesByProductReq
 */
export interface GetSalesByProductReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByProductRes
 */
export interface GetSalesByProductRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByProductPDFReq
 */
export interface GetSalesByProductPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByProductPDFRes
 */
export interface GetSalesByProductPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByProductCSVReq
 */
export interface GetSalesByProductCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByProductCSVRes
 */
export interface GetSalesByProductCSVRes {
}
/**
 * Sales by Location
 *
 * @generated from protobuf message rd.search.service.GetSalesByLocationReq
 */
export interface GetSalesByLocationReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByLocationRes
 */
export interface GetSalesByLocationRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByLocationPDFReq
 */
export interface GetSalesByLocationPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByLocationPDFRes
 */
export interface GetSalesByLocationPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByLocationCSVReq
 */
export interface GetSalesByLocationCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByLocationCSVRes
 */
export interface GetSalesByLocationCSVRes {
}
/**
 * Sales by Rep
 *
 * @generated from protobuf message rd.search.service.GetSalesByRepReq
 */
export interface GetSalesByRepReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByRepRes
 */
export interface GetSalesByRepRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByRepPDFReq
 */
export interface GetSalesByRepPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByRepPDFRes
 */
export interface GetSalesByRepPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByRepCSVReq
 */
export interface GetSalesByRepCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetSalesByRepCSVRes
 */
export interface GetSalesByRepCSVRes {
}
/**
 * Price Edits
 *
 * @generated from protobuf message rd.search.service.GetPriceEditsReq
 */
export interface GetPriceEditsReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPriceEditsRes
 */
export interface GetPriceEditsRes {
}
/**
 * @generated from protobuf message rd.search.service.GetPriceEditsPDFReq
 */
export interface GetPriceEditsPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPriceEditsPDFRes
 */
export interface GetPriceEditsPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetPriceEditsCSVReq
 */
export interface GetPriceEditsCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetPriceEditsCSVRes
 */
export interface GetPriceEditsCSVRes {
}
/**
 * @generated from protobuf message rd.search.service.GetProfitAndLossReq
 */
export interface GetProfitAndLossReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
}
/**
 * @generated from protobuf message rd.search.service.GetProfitAndLossRes
 */
export interface GetProfitAndLossRes {
    /**
     * @generated from protobuf field: rd.analyticsv2.ProfitAndLoss profit_and_loss = 1
     */
    profitAndLoss?: ProfitAndLoss;
}
/**
 * @generated from protobuf message rd.search.service.GetProfitAndLossPDFReq
 */
export interface GetProfitAndLossPDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: bool hide_product_categories = 2
     */
    hideProductCategories: boolean;
}
/**
 * @generated from protobuf message rd.search.service.GetProfitAndLossPDFRes
 */
export interface GetProfitAndLossPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * New Accounts Opened
 *
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedReq
 */
export interface GetNewAccountsOpenedReq {
}
/**
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedRes
 */
export interface GetNewAccountsOpenedRes {
}
/**
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedPDFReq
 */
export interface GetNewAccountsOpenedPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedPDFRes
 */
export interface GetNewAccountsOpenedPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedCSVReq
 */
export interface GetNewAccountsOpenedCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetNewAccountsOpenedCSVRes
 */
export interface GetNewAccountsOpenedCSVRes {
}
/**
 * Aging Detail
 *
 * @generated from protobuf message rd.search.service.GetAgingDetailReq
 */
export interface GetAgingDetailReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingDetailRes
 */
export interface GetAgingDetailRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingDetailPDFReq
 */
export interface GetAgingDetailPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingDetailPDFRes
 */
export interface GetAgingDetailPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingDetailCSVReq
 */
export interface GetAgingDetailCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingDetailCSVRes
 */
export interface GetAgingDetailCSVRes {
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalReq
 */
export interface GetPurchaseJournalReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PurchaseJournalSortBy sort_by = 2
     */
    sortBy: PurchaseJournalSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalRes
 */
export interface GetPurchaseJournalRes {
    /**
     * @generated from protobuf field: rd.analytics.Report report = 1
     */
    report?: Report;
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalPDFReq
 */
export interface GetPurchaseJournalPDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PurchaseJournalSortBy sort_by = 2
     */
    sortBy: PurchaseJournalSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalPDFRes
 */
export interface GetPurchaseJournalPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalCSVReq
 */
export interface GetPurchaseJournalCSVReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PurchaseJournalSortBy sort_by = 2
     */
    sortBy: PurchaseJournalSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPurchaseJournalCSVRes
 */
export interface GetPurchaseJournalCSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsReq
 */
export interface GetAccountPaymentAdjustmentsReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsRes
 */
export interface GetAccountPaymentAdjustmentsRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsPDFReq
 */
export interface GetAccountPaymentAdjustmentsPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsPDFRes
 */
export interface GetAccountPaymentAdjustmentsPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsCSVReq
 */
export interface GetAccountPaymentAdjustmentsCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAccountPaymentAdjustmentsCSVRes
 */
export interface GetAccountPaymentAdjustmentsCSVRes {
}
// Additional Fees 

/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesReq
 */
export interface GetAdditionalFeesReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesRes
 */
export interface GetAdditionalFeesRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesPDFReq
 */
export interface GetAdditionalFeesPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesPDFRes
 */
export interface GetAdditionalFeesPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesCSVReq
 */
export interface GetAdditionalFeesCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAdditionalFeesCSVRes
 */
export interface GetAdditionalFeesCSVRes {
}
/**
 * Aging by Job
 *
 * @generated from protobuf message rd.search.service.GetAgingByJobReq
 */
export interface GetAgingByJobReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingByJobRes
 */
export interface GetAgingByJobRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingByJobPDFReq
 */
export interface GetAgingByJobPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingByJobPDFRes
 */
export interface GetAgingByJobPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingByJobCSVReq
 */
export interface GetAgingByJobCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetAgingByJobCSVRes
 */
export interface GetAgingByJobCSVRes {
}
/**
 * Inventory By Department
 *
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentReq
 */
export interface GetInventoryByDepartmentReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentRes
 */
export interface GetInventoryByDepartmentRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentPDFReq
 */
export interface GetInventoryByDepartmentPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentPDFRes
 */
export interface GetInventoryByDepartmentPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentCSVReq
 */
export interface GetInventoryByDepartmentCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByDepartmentCSVRes
 */
export interface GetInventoryByDepartmentCSVRes {
}
/**
 * Inventory By Product
 *
 * @generated from protobuf message rd.search.service.GetInventoryByProductReq
 */
export interface GetInventoryByProductReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByProductRes
 */
export interface GetInventoryByProductRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByProductPDFReq
 */
export interface GetInventoryByProductPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByProductPDFRes
 */
export interface GetInventoryByProductPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByProductCSVReq
 */
export interface GetInventoryByProductCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInventoryByProductCSVRes
 */
export interface GetInventoryByProductCSVRes {
}
/**
 * Transfer Discrepancies
 *
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesReq
 */
export interface GetTransferDiscrepanciesReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesRes
 */
export interface GetTransferDiscrepanciesRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesPDFReq
 */
export interface GetTransferDiscrepanciesPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesPDFRes
 */
export interface GetTransferDiscrepanciesPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesCSVReq
 */
export interface GetTransferDiscrepanciesCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTransferDiscrepanciesCSVRes
 */
export interface GetTransferDiscrepanciesCSVRes {
}
/**
 * Interactions By Staff
 *
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffReq
 */
export interface GetInteractionsByStaffReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffRes
 */
export interface GetInteractionsByStaffRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffPDFReq
 */
export interface GetInteractionsByStaffPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffPDFRes
 */
export interface GetInteractionsByStaffPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffCSVReq
 */
export interface GetInteractionsByStaffCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsByStaffCSVRes
 */
export interface GetInteractionsByStaffCSVRes {
}
/**
 * Interactions
 *
 * @generated from protobuf message rd.search.service.GetInteractionsReq
 */
export interface GetInteractionsReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsRes
 */
export interface GetInteractionsRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsPDFReq
 */
export interface GetInteractionsPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsPDFRes
 */
export interface GetInteractionsPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsCSVReq
 */
export interface GetInteractionsCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetInteractionsCSVRes
 */
export interface GetInteractionsCSVRes {
}
/**
 * Finance Charges
 *
 * @generated from protobuf message rd.search.service.GetFinanceChargesReq
 */
export interface GetFinanceChargesReq {
}
/**
 * @generated from protobuf message rd.search.service.GetFinanceChargesRes
 */
export interface GetFinanceChargesRes {
}
/**
 * @generated from protobuf message rd.search.service.GetFinanceChargesPDFReq
 */
export interface GetFinanceChargesPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetFinanceChargesPDFRes
 */
export interface GetFinanceChargesPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetFinanceChargesCSVReq
 */
export interface GetFinanceChargesCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetFinanceChargesCSVRes
 */
export interface GetFinanceChargesCSVRes {
}
/**
 * Report Builder
 *
 * @generated from protobuf message rd.search.service.GetReportBuilderReq
 */
export interface GetReportBuilderReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParams params = 1
     */
    params?: ReportParams;
    /**
     * @generated from protobuf field: bool to_csv = 2
     */
    toCsv: boolean;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2 params_v2 = 3
     */
    paramsV2?: ReportParamsV2;
    /**
     * @generated from protobuf field: bool to_pdf = 4
     */
    toPdf: boolean;
    /**
     * @generated from protobuf field: string saved_report_name = 5
     */
    savedReportName: string;
}
/**
 * @generated from protobuf message rd.search.service.GetReportBuilderRes
 */
export interface GetReportBuilderRes {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report report = 1
     */
    report?: Report$;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report compare_report = 2
     */
    compareReport?: Report$;
    /**
     * @generated from protobuf field: string csv_url = 3
     */
    csvUrl: string;
    /**
     * @generated from protobuf field: bytes pdf_bytes = 4
     */
    pdfBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetReportBuilderConfigReq
 */
export interface GetReportBuilderConfigReq {
    /**
     * @generated from protobuf field: bool show_admin_base_datas = 1
     */
    showAdminBaseDatas: boolean;
}
/**
 * @generated from protobuf message rd.search.service.GetReportBuilderConfigRes
 */
export interface GetReportBuilderConfigRes {
    /**
     * @generated from protobuf field: map<int32, rd.search.service.GetReportBuilderConfigRes.Mapping> mappings_by_base_data = 1
     */
    mappingsByBaseData: {
        [key: number]: GetReportBuilderConfigRes_Mapping;
    };
    /**
     * @generated from protobuf field: map<int32, string> group_names = 2
     */
    groupNames: {
        [key: number]: string;
    };
    /**
     * @generated from protobuf field: map<int32, string> base_data_names = 3
     */
    baseDataNames: {
        [key: number]: string;
    };
}
/**
 * @generated from protobuf message rd.search.service.GetReportBuilderConfigRes.Mapping
 */
export interface GetReportBuilderConfigRes_Mapping {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.BaseData base_data = 1
     */
    baseData: BaseData;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Filter.Attribute filters = 3
     */
    filters: Filter_Attribute[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2 default_params = 7
     */
    defaultParams?: ReportParamsV2;
    /**
     * @generated from protobuf field: bool is_single_date = 8
     */
    isSingleDate: boolean;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ColumnOption all_columns = 9
     */
    allColumns: ColumnOption[];
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ColumnOption label_columns = 10
     */
    labelColumns: ColumnOption[];
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ColumnOption metric_columns = 11
     */
    metricColumns: ColumnOption[];
}
/**
 * @generated from protobuf message rd.search.service.RefreshSearchalyticsCacheReq
 */
export interface RefreshSearchalyticsCacheReq {
}
/**
 * @generated from protobuf message rd.search.service.RefreshSearchalyticsCacheRes
 */
export interface RefreshSearchalyticsCacheRes {
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveriesReq
 */
export interface SearchDeliveriesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.txn.Delivery.Status statuses = 2
     */
    statuses: Delivery_Status[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 3
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange departure_time_range = 4
     */
    departureTimeRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID assigned_to_staff_ids = 5
     */
    assignedToStaffIds: UUID[];
    /**
     * @generated from protobuf field: string cursor = 6
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 7
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 8
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 9
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 10
     */
    saleIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 11
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.SearchDeliveriesReq.OrderBy order_by = 12
     */
    orderBy: SearchDeliveriesReq_OrderBy;
}
/**
 * @generated from protobuf enum rd.search.service.SearchDeliveriesReq.OrderBy
 */
export enum SearchDeliveriesReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_DEPARTURE_TIME = 1;
     */
    DEPARTURE_TIME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveriesRes
 */
export interface SearchDeliveriesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchDeliveriesRes.Result results = 1
     */
    results: SearchDeliveriesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveriesRes.Result
 */
export interface SearchDeliveriesRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Delivery delivery = 1
     */
    delivery?: Delivery;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * Drive order comes from stop.position.
     *
     * @generated from protobuf field: map<string, rd.search.service.SearchDeliveriesRes.Result.StopTransactions> transactions_by_stop_id = 3
     */
    transactionsByStopId: {
        [key: string]: SearchDeliveriesRes_Result_StopTransactions;
    };
    /**
     * @generated from protobuf field: rd.company.Staff assigned_to = 4
     */
    assignedTo?: Staff;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveriesRes.Result.StopTransaction
 */
export interface SearchDeliveriesRes_Result_StopTransaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: int32 item_count = 3
     */
    itemCount: number;
    /**
     * @generated from protobuf field: rd.txn.Sale.Status status = 4
     */
    status: Sale_Status;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 5
     */
    total?: Money;
    /**
     * @generated from protobuf field: string customer_name = 6
     */
    customerName: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveriesRes.Result.StopTransactions
 */
export interface SearchDeliveriesRes_Result_StopTransactions {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchDeliveriesRes.Result.StopTransaction transactions = 1
     */
    transactions: SearchDeliveriesRes_Result_StopTransaction[];
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop stop = 2
     */
    stop?: DeliveryStop;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveryStopsReq
 */
export interface SearchDeliveryStopsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.txn.DeliveryStop.Status statuses = 2
     */
    statuses: DeliveryStop_Status[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 3
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 4
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 5
     */
    saleIds: UUID[];
    /**
     * Filters on the stop's deliver-by date, DeliveryDetails.requested_date.
     *
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange requested_date_range = 6
     */
    requestedDateRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.SearchDeliveryStopsReq.OrderBy order_by = 8
     */
    orderBy: SearchDeliveryStopsReq_OrderBy;
    /**
     * @generated from protobuf field: string cursor = 9
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 10
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 11
     */
    limit: number;
}
/**
 * @generated from protobuf enum rd.search.service.SearchDeliveryStopsReq.OrderBy
 */
export enum SearchDeliveryStopsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_REQUESTED_DATE = 1;
     */
    REQUESTED_DATE = 1
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveryStopsRes
 */
export interface SearchDeliveryStopsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchDeliveryStopsRes.Result results = 1
     */
    results: SearchDeliveryStopsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveryStopsRes.Result
 */
export interface SearchDeliveryStopsRes_Result {
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop stop = 1
     */
    stop?: DeliveryStop;
    /**
     * @generated from protobuf field: rd.company.Location dispatch_location = 2
     */
    dispatchLocation?: Location;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchDeliveryStopsRes.Result.Transaction transactions = 3
     */
    transactions: SearchDeliveryStopsRes_Result_Transaction[];
    /**
     * @generated from protobuf field: rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery linked_delivery = 4
     */
    linkedDelivery?: SearchDeliveryStopsRes_Result_LinkedDelivery;
}
/**
 * @generated from protobuf message rd.search.service.SearchDeliveryStopsRes.Result.Transaction
 */
export interface SearchDeliveryStopsRes_Result_Transaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: int32 item_count = 3
     */
    itemCount: number;
    /**
     * @generated from protobuf field: rd.txn.Sale.Status status = 4
     */
    status: Sale_Status;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 5
     */
    total?: Money;
    /**
     * @generated from protobuf field: string customer_name = 6
     */
    customerName: string;
}
/**
 * Set only once the stop has been routed onto a delivery.
 *
 * @generated from protobuf message rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery
 */
export interface SearchDeliveryStopsRes_Result_LinkedDelivery {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Delivery.Status status = 3
     */
    status: Delivery_Status;
}
/**
 * @generated from protobuf message rd.search.service.SearchLocationsReq
 */
export interface SearchLocationsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 5
     */
    isActiveFilter: BoolFilter;
}
/**
 * @generated from protobuf message rd.search.service.SearchLocationsRes
 */
export interface SearchLocationsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchLocationsRes.Result results = 1
     */
    results: SearchLocationsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchLocationsRes.Result
 */
export interface SearchLocationsRes_Result {
    /**
     * @generated from protobuf field: rd.company.Location location = 1
     */
    location?: Location;
    /**
     * @generated from protobuf field: repeated rd.company.TaxRate tax_rates = 3
     */
    taxRates: TaxRate[];
    /**
     * @generated from protobuf field: rd.company.PricingRegion pricing_region = 4
     */
    pricingRegion?: PricingRegion;
}
/**
 * @generated from protobuf message rd.search.service.SearchProductCategoriesReq
 */
export interface SearchProductCategoriesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.company.ProductCategory.Type types = 5
     */
    types: ProductCategory_Type[];
}
/**
 * @generated from protobuf message rd.search.service.SearchProductCategoriesRes
 */
export interface SearchProductCategoriesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchProductCategoriesRes.Result results = 1
     */
    results: SearchProductCategoriesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchProductCategoriesRes.Result
 */
export interface SearchProductCategoriesRes_Result {
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_category = 1
     */
    productCategory?: ProductCategory;
}
/**
 * @generated from protobuf message rd.search.service.SearchStaffsReq
 */
export interface SearchStaffsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 5
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.SearchStaffsReq.OrderBy order_by = 6
     */
    orderBy: SearchStaffsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf enum rd.search.service.SearchStaffsReq.OrderBy
 */
export enum SearchStaffsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_PHONE = 2;
     */
    PHONE = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_EMAIL = 3;
     */
    EMAIL = 3
}
/**
 * @generated from protobuf message rd.search.service.SearchStaffsRes
 */
export interface SearchStaffsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchStaffsRes.Result results = 1
     */
    results: SearchStaffsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: repeated string permissionIds = 3
     */
    permissionIds: string[];
}
/**
 * @generated from protobuf message rd.search.service.SearchStaffsRes.Result
 */
export interface SearchStaffsRes_Result {
    /**
     * @generated from protobuf field: rd.company.Staff staff = 1
     */
    staff?: Staff;
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesReq
 */
export interface GetTaxesReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesRes
 */
export interface GetTaxesRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesPDFReq
 */
export interface GetTaxesPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesPDFRes
 */
export interface GetTaxesPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesCSVReq
 */
export interface GetTaxesCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesCSVRes
 */
export interface GetTaxesCSVRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRateReq
 */
export interface GetTaxesByTaxRateReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRateRes
 */
export interface GetTaxesByTaxRateRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRatePDFReq
 */
export interface GetTaxesByTaxRatePDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRatePDFRes
 */
export interface GetTaxesByTaxRatePDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRateCSVReq
 */
export interface GetTaxesByTaxRateCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByTaxRateCSVRes
 */
export interface GetTaxesByTaxRateCSVRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationReq
 */
export interface GetTaxesByAccountingLocationReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationRes
 */
export interface GetTaxesByAccountingLocationRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationPDFReq
 */
export interface GetTaxesByAccountingLocationPDFReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationPDFRes
 */
export interface GetTaxesByAccountingLocationPDFRes {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationCSVReq
 */
export interface GetTaxesByAccountingLocationCSVReq {
}
/**
 * @generated from protobuf message rd.search.service.GetTaxesByAccountingLocationCSVRes
 */
export interface GetTaxesByAccountingLocationCSVRes {
}
/**
 * @generated from protobuf message rd.search.service.SearchNotifDeliveriesReq
 */
export interface SearchNotifDeliveriesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_read_filter = 5
     */
    isReadFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_archived_filter = 6
     */
    isArchivedFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.OrderNotificationsBy order_by = 7
     */
    orderBy: OrderNotificationsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 8
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.notif.Sink sink_filter = 9
     */
    sinkFilter: Sink[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 10
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.SearchNotifDeliveriesRes
 */
export interface SearchNotifDeliveriesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchNotifDeliveriesRes.Result results = 1
     */
    results: SearchNotifDeliveriesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchNotifDeliveriesRes.Result
 */
export interface SearchNotifDeliveriesRes_Result {
    /**
     * @generated from protobuf field: rd.notif.Delivery delivery = 1
     */
    delivery?: Delivery$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDateReq
 */
export interface GetPayoutsByPayoutDateReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDateRes
 */
export interface GetPayoutsByPayoutDateRes {
    /**
     * @generated from protobuf field: rd.analytics.Report report = 1
     */
    report?: Report;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDatePDFReq
 */
export interface GetPayoutsByPayoutDatePDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDatePDFRes
 */
export interface GetPayoutsByPayoutDatePDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDateCSVReq
 */
export interface GetPayoutsByPayoutDateCSVReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByPayoutDateCSVRes
 */
export interface GetPayoutsByPayoutDateCSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDateReq
 */
export interface GetPayoutsByTransactionDateReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDateRes
 */
export interface GetPayoutsByTransactionDateRes {
    /**
     * @generated from protobuf field: rd.analytics.Report report = 1
     */
    report?: Report;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDatePDFReq
 */
export interface GetPayoutsByTransactionDatePDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDatePDFRes
 */
export interface GetPayoutsByTransactionDatePDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDateCSVReq
 */
export interface GetPayoutsByTransactionDateCSVReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.analyticsv2.PayoutTxnSortBy sort_by = 2
     */
    sortBy: PayoutTxnSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
}
/**
 * @generated from protobuf message rd.search.service.GetBalanceSheetReq
 */
export interface GetBalanceSheetReq {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp asOf = 1
     */
    asOf?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 2
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.search.service.GetBalanceSheetRes
 */
export interface GetBalanceSheetRes {
    /**
     * @generated from protobuf field: rd.accounting.BalanceSheet balance_sheet = 1
     */
    balanceSheet?: BalanceSheet;
}
/**
 * @generated from protobuf message rd.search.service.GetIncomeStatementReq
 */
export interface GetIncomeStatementReq {
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange timestamp_range = 1
     */
    timestampRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.search.service.GetIncomeStatementRes
 */
export interface GetIncomeStatementRes {
    /**
     * @generated from protobuf field: rd.accounting.IncomeStatement income_statement = 1
     */
    incomeStatement?: IncomeStatement;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesReq
 */
export interface GetJournalEntriesReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: bool is_internal_transactions_only = 2
     */
    isInternalTransactionsOnly: boolean;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesRes
 */
export interface GetJournalEntriesRes {
    /**
     * @generated from protobuf field: rd.accounting.JournalEntries journal_entries = 1
     */
    journalEntries?: JournalEntries;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesPDFReq
 */
export interface GetJournalEntriesPDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: bool is_internal_transactions_only = 2
     */
    isInternalTransactionsOnly: boolean;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesPDFRes
 */
export interface GetJournalEntriesPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesIIFReq
 */
export interface GetJournalEntriesIIFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: bool is_internal_transactions_only = 2
     */
    isInternalTransactionsOnly: boolean;
}
/**
 * @generated from protobuf message rd.search.service.GetJournalEntriesIIFRes
 */
export interface GetJournalEntriesIIFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetPayoutsByTransactionDateCSVRes
 */
export interface GetPayoutsByTransactionDateCSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerReq
 */
export interface GetGeneralLedgerReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.accounting.GeneralLedgerSortBy sort_by = 2
     */
    sortBy: GeneralLedgerSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
    /**
     * @generated from protobuf field: repeated rd.accounting.TransactionType transaction_types = 4
     */
    transactionTypes: TransactionType[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount control_accounts = 5
     */
    controlAccounts: InternalAccount[];
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerRes
 */
export interface GetGeneralLedgerRes {
    /**
     * @generated from protobuf field: rd.analytics.Report report = 1
     */
    report?: Report;
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerPDFReq
 */
export interface GetGeneralLedgerPDFReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.accounting.GeneralLedgerSortBy sort_by = 2
     */
    sortBy: GeneralLedgerSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
    /**
     * @generated from protobuf field: repeated rd.accounting.TransactionType transaction_types = 4
     */
    transactionTypes: TransactionType[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount control_accounts = 5
     */
    controlAccounts: InternalAccount[];
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerPDFRes
 */
export interface GetGeneralLedgerPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerCSVReq
 */
export interface GetGeneralLedgerCSVReq {
    /**
     * @generated from protobuf field: rd.analyticsv2.Filters filters = 1
     */
    filters?: Filters;
    /**
     * @generated from protobuf field: rd.accounting.GeneralLedgerSortBy sort_by = 2
     */
    sortBy: GeneralLedgerSortBy;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder sort_order = 3
     */
    sortOrder: SortOrder$;
    /**
     * @generated from protobuf field: repeated rd.accounting.TransactionType transaction_types = 4
     */
    transactionTypes: TransactionType[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount control_accounts = 5
     */
    controlAccounts: InternalAccount[];
}
/**
 * @generated from protobuf message rd.search.service.GetGeneralLedgerCSVRes
 */
export interface GetGeneralLedgerCSVRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchTenderMethodsReq
 */
export interface SearchTenderMethodsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method.Type exclude_types = 5
     */
    excludeTypes: Method_Type[];
    /**
     * @generated from protobuf field: repeated rd.company.tender.Method.Type include_types = 6
     */
    includeTypes: Method_Type[];
}
/**
 * @generated from protobuf message rd.search.service.SearchTenderMethodsRes
 */
export interface SearchTenderMethodsRes {
    /**
     * @generated from protobuf field: string cursor = 1
     */
    cursor: string;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchTenderMethodsRes.Result results = 2
     */
    results: SearchTenderMethodsRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchTenderMethodsRes.Result
 */
export interface SearchTenderMethodsRes_Result {
    /**
     * @generated from protobuf field: rd.company.tender.Method method = 1
     */
    method?: Method;
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesHistoryReq
 */
export interface SearchReceivablesHistoryReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 7
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Transaction.Type transaction_types = 8
     */
    transactionTypes: Receivable_Transaction_Type[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesHistoryRes
 */
export interface SearchReceivablesHistoryRes {
    /**
     * @generated from protobuf field: string cursor = 1
     */
    cursor: string;
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchReceivablesHistoryRes.Result results = 2
     */
    results: SearchReceivablesHistoryRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesHistoryRes.Result
 */
export interface SearchReceivablesHistoryRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 14
     */
    receivable?: Receivable;
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceChangesReq
 */
export interface SearchPriceChangesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchPriceChangesReq.OrderBy order_by = 5
     */
    orderBy: SearchPriceChangesReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 7
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_id_strings = 8
     */
    additionalFeeIdStrings: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 11
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 12
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 13
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 14
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 15
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 17
     */
    integrationVendors: IntegrationVendor[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_promotional = 18
     */
    isPromotional: BoolFilter;
    /**
     * @generated from protobuf field: repeated string sale_codes = 19
     */
    saleCodes: string[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 20
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 21
     */
    orderShipmentId?: UUID;
}
/**
 * @generated from protobuf enum rd.search.service.SearchPriceChangesReq.OrderBy
 */
export enum SearchPriceChangesReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_EFFECTIVE_DATE = 1;
     */
    EFFECTIVE_DATE = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 2;
     */
    UPDATED_AT = 2
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceChangesRes
 */
export interface SearchPriceChangesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchPriceChangesRes.Result results = 1
     */
    results: SearchPriceChangesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchPriceChangesRes.Result
 */
export interface SearchPriceChangesRes_Result {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.product.Product product = 2
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.proto.money.Money old_price = 3
     */
    oldPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money new_price = 4
     */
    newPrice?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney old_cost = 5
     */
    oldCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney new_cost = 6
     */
    newCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 7
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp effective_date = 8
     */
    effectiveDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost = 9
     */
    standardCost?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.integrations.PriceChange price_change = 10
     */
    priceChange?: PriceChange;
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 11
     */
    catalogProduct?: Product$;
    /**
     * @generated from protobuf field: string base_uom_label = 12
     */
    baseUomLabel: string;
}
/**
 * @generated from protobuf message rd.search.service.PrintReceivablesHistoryReq
 */
export interface PrintReceivablesHistoryReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 7
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Transaction.Type transaction_types = 8
     */
    transactionTypes: Receivable_Transaction_Type[];
}
/**
 * @generated from protobuf message rd.search.service.PrintReceivablesHistoryRes
 */
export interface PrintReceivablesHistoryRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesAgingReq
 */
export interface SearchReceivablesAgingReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 4
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 5
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.SearchReceivablesAgingReq.OrderBy order_by = 6
     */
    orderBy: SearchReceivablesAgingReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Type receivable_types = 8
     */
    receivableTypes: Receivable_Type[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchReceivablesAgingReq.Type
 */
export enum SearchReceivablesAgingReq_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0
}
/**
 * @generated from protobuf enum rd.search.service.SearchReceivablesAgingReq.OrderBy
 */
export enum SearchReceivablesAgingReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_RECEIVABLES_AGING_BY_NONE = 0;
     */
    ORDER_RECEIVABLES_AGING_BY_NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_RECEIVABLES_AGING_BY_OUTSTANDING_BALANCE = 1;
     */
    ORDER_RECEIVABLES_AGING_BY_OUTSTANDING_BALANCE = 1,
    /**
     * @generated from protobuf enum value: ORDER_RECEIVABLES_AGING_BY_ACCOUNTED_AT = 2;
     */
    ORDER_RECEIVABLES_AGING_BY_ACCOUNTED_AT = 2,
    /**
     * @generated from protobuf enum value: ORDER_RECEIVABLES_AGING_BY_DAYS_OVERDUE = 3;
     */
    ORDER_RECEIVABLES_AGING_BY_DAYS_OVERDUE = 3
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesAgingRes
 */
export interface SearchReceivablesAgingRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchReceivablesAgingRes.Result results = 1
     */
    results: SearchReceivablesAgingRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReceivablesAgingRes.Result
 */
export interface SearchReceivablesAgingRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 13
     */
    receivable?: Receivable;
    /**
     * @generated from protobuf field: rd.proto.money.Money statement_balance = 14
     */
    statementBalance?: Money;
}
/**
 * @generated from protobuf message rd.search.service.PrintReceivablesAgingReq
 */
export interface PrintReceivablesAgingReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID purchase_order_ids = 4
     */
    purchaseOrderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID job_ids = 5
     */
    jobIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Type receivable_types = 6
     */
    receivableTypes: Receivable_Type[];
}
/**
 * @generated from protobuf message rd.search.service.PrintReceivablesAgingRes
 */
export interface PrintReceivablesAgingRes {
    /**
     * @generated from protobuf field: bytes pdf_bytes = 1
     */
    pdfBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.SearchReallocationReceivablesReq
 */
export interface SearchReallocationReceivablesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 2
     */
    billPaymentId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.txn.Receivable.Type receivable_types = 3
     */
    receivableTypes: Receivable_Type[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReallocationReceivablesRes
 */
export interface SearchReallocationReceivablesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchReallocationReceivablesRes.Result results = 1
     */
    results: SearchReallocationReceivablesRes_Result[];
}
/**
 * @generated from protobuf message rd.search.service.SearchReallocationReceivablesRes.Result
 */
export interface SearchReallocationReceivablesRes_Result {
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 1
     */
    receivable?: Receivable;
    /**
     * @generated from protobuf field: rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation original_allocation = 2
     */
    originalAllocation?: SearchReallocationReceivablesRes_Result_OriginalAllocation;
    /**
     * @generated from protobuf field: rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance adjusted_balance = 3
     */
    adjustedBalance?: SearchReallocationReceivablesRes_Result_AdjustedBalance;
}
/**
 * @generated from protobuf message rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation
 */
export interface SearchReallocationReceivablesRes_Result_OriginalAllocation {
    /**
     * @generated from protobuf field: rd.proto.money.Money allocation = 1
     */
    allocation?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount = 2
     */
    discount?: Money;
}
/**
 * @generated from protobuf message rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance
 */
export interface SearchReallocationReceivablesRes_Result_AdjustedBalance {
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 1
     */
    balance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money potential_discount = 2
     */
    potentialDiscount?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp potential_discount_expires_at = 3
     */
    potentialDiscountExpiresAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.search.service.OmniSearchReq
 */
export interface OmniSearchReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * If non-empty, restricts results to the given types; empty means all
     * types. Lets callers (e.g. the transaction picker) request only the
     * subset they care about so the first page isn't dominated by unrelated
     * types like customers and products.
     *
     * @generated from protobuf field: repeated rd.search.service.OmniSearchRes.Result.Type include_types = 5
     */
    includeTypes: OmniSearchRes_Result_Type[];
}
/**
 * @generated from protobuf message rd.search.service.OmniSearchRes
 */
export interface OmniSearchRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.OmniSearchRes.Result results = 1
     */
    results: OmniSearchRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.OmniSearchRes.Result
 */
export interface OmniSearchRes_Result {
    /**
     * @generated from protobuf field: rd.search.service.OmniSearchRes.Result.Type type = 1
     */
    type: OmniSearchRes_Result_Type;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 2
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.product.Product product = 3
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 4
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 5
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.txn.Order order = 6
     */
    order?: Order;
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 7
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.txn.Transfer transfer = 8
     */
    transfer?: Transfer;
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 9
     */
    billPayment?: BillPayment;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.SavedReport saved_report = 10
     */
    savedReport?: SavedReport;
    /**
     * @generated from protobuf field: rd.company.Staff staff = 11
     */
    staff?: Staff;
    /**
     * @generated from protobuf field: rd.company.Location location = 12
     */
    location?: Location;
    /**
     * Finance charge results carry the underlying ledger entry; the
     * human-readable identifier lives on the nested FinancingCharge.
     *
     * @generated from protobuf field: rd.ledger.LedgerEntry finance_charge = 13
     */
    financeCharge?: LedgerEntry;
    /**
     * @generated from protobuf field: rd.txn.CloseOut close_out = 14
     */
    closeOut?: CloseOut;
    /**
     * @generated from protobuf field: rd.txn.PettyCash petty_cash = 15
     */
    pettyCash?: PettyCash;
    /**
     * @generated from protobuf field: rd.product.InventoryCount inventory_count = 16
     */
    inventoryCount?: InventoryCount;
    /**
     * @generated from protobuf field: rd.txn.Delivery delivery = 17
     */
    delivery?: Delivery;
}
/**
 * @generated from protobuf enum rd.search.service.OmniSearchRes.Result.Type
 */
export enum OmniSearchRes_Result_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOMER = 1;
     */
    CUSTOMER = 1,
    /**
     * @generated from protobuf enum value: TYPE_PRODUCT = 2;
     */
    PRODUCT = 2,
    /**
     * @generated from protobuf enum value: TYPE_SALE = 3;
     */
    SALE = 3,
    /**
     * @generated from protobuf enum value: TYPE_VENDOR = 4;
     */
    VENDOR = 4,
    /**
     * @generated from protobuf enum value: TYPE_ORDER = 5;
     */
    ORDER = 5,
    /**
     * @generated from protobuf enum value: TYPE_ORDER_SHIPMENT = 6;
     */
    ORDER_SHIPMENT = 6,
    /**
     * @generated from protobuf enum value: TYPE_TRANSFER = 7;
     */
    TRANSFER = 7,
    /**
     * @generated from protobuf enum value: TYPE_BILL_PAYMENT = 8;
     */
    BILL_PAYMENT = 8,
    /**
     * @generated from protobuf enum value: TYPE_SAVED_REPORT = 9;
     */
    SAVED_REPORT = 9,
    /**
     * @generated from protobuf enum value: TYPE_STAFF = 10;
     */
    STAFF = 10,
    /**
     * @generated from protobuf enum value: TYPE_LOCATION = 11;
     */
    LOCATION = 11,
    /**
     * @generated from protobuf enum value: TYPE_FINANCE_CHARGE = 12;
     */
    FINANCE_CHARGE = 12,
    /**
     * @generated from protobuf enum value: TYPE_CLOSE_OUT = 13;
     */
    CLOSE_OUT = 13,
    /**
     * @generated from protobuf enum value: TYPE_PETTY_CASH = 14;
     */
    PETTY_CASH = 14,
    /**
     * @generated from protobuf enum value: TYPE_INVENTORY_COUNT = 15;
     */
    INVENTORY_COUNT = 15,
    /**
     * @generated from protobuf enum value: TYPE_DELIVERY = 16;
     */
    DELIVERY = 16
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogSKUsReq
 */
export interface SearchCatalogSKUsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.OrderCatalogSKUsBy order_by = 6
     */
    orderBy: OrderCatalogSKUsBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 7
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 8
     */
    integrationVendors: IntegrationVendor[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 9
     */
    locationIds: UUID[]; // Public catalog SKUs are always included.
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID current_location_id = 10
     */
    currentLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter discontinued_filter = 11
     */
    discontinuedFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.catalog.SKU.Origin origins = 13
     */
    origins: SKU_Origin[];
    /**
     * @generated from protobuf field: repeated string identifiers = 14
     */
    identifiers: string[];
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogSKUsRes
 */
export interface SearchCatalogSKUsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCatalogSKUsRes.Result results = 1
     */
    results: SearchCatalogSKUsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogSKUsRes.Result
 */
export interface SearchCatalogSKUsRes_Result {
    /**
     * @generated from protobuf field: rd.catalog.SKU sku = 1
     */
    sku?: SKU;
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 2
     */
    catalogProduct?: Product$;
    /**
     * If this catalog SKU matches an existing company product (by UPC or SKU),
     * this will be set to the company product ID
     *
     * @generated from protobuf field: rd.proto.uuid.UUID linked_product_id = 3
     */
    linkedProductId?: UUID;
    /**
     * Vendor-agnostic computed information (discontinued status, etc.)
     *
     * @generated from protobuf field: rd.catalog.ComputedSKUInfo computed_info = 4
     */
    computedInfo?: ComputedSKUInfo;
    /**
     * The vendor that maps to this SKU's integration vendor
     *
     * @generated from protobuf field: rd.vendors.Vendor vendor = 5
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: string linked_product_identifier = 6
     */
    linkedProductIdentifier: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogProductsReq
 */
export interface SearchCatalogProductsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: string upc = 5
     */
    upc: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogProductsRes
 */
export interface SearchCatalogProductsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchCatalogProductsRes.Result results = 1
     */
    results: SearchCatalogProductsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchCatalogProductsRes.Result
 */
export interface SearchCatalogProductsRes_Result {
    /**
     * @generated from protobuf field: rd.catalog.Product catalog_product = 1
     */
    catalogProduct?: Product$;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID linked_product_id = 2
     */
    linkedProductId?: UUID;
    /**
     * @generated from protobuf field: string linked_product_identifier = 3
     */
    linkedProductIdentifier: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchChatThreadsReq
 */
export interface SearchChatThreadsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchChatThreadsReq.OrderBy order_by = 5
     */
    orderBy: SearchChatThreadsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 7
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 8
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: repeated string attached_to_ids = 9
     */
    attachedToIds: string[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_tag_ids = 10
     */
    customerTagIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_read_filter = 11
     */
    isReadFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_unknown_contact_filter = 12
     */
    isUnknownContactFilter: BoolFilter;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange last_activity_at_range = 13
     */
    lastActivityAtRange?: TimestampRange;
}
/**
 * @generated from protobuf enum rd.search.service.SearchChatThreadsReq.OrderBy
 */
export enum SearchChatThreadsReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_ACTIVITY_AT = 1;
     */
    LAST_ACTIVITY_AT = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2
}
/**
 * @generated from protobuf message rd.search.service.SearchChatThreadsRes
 */
export interface SearchChatThreadsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchChatThreadsRes.Result results = 1
     */
    results: SearchChatThreadsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchChatThreadsRes.Result
 */
export interface SearchChatThreadsRes_Result {
    /**
     * @generated from protobuf field: rd.chat.Thread thread = 1
     */
    thread?: Thread;
    /**
     * @generated from protobuf field: rd.chat.Message latest_message = 2
     */
    latestMessage?: Message;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact customer_contact = 3
     */
    customerContact?: Contacts_Contact;
}
/**
 * @generated from protobuf message rd.search.service.SearchChatMessagesReq
 */
export interface SearchChatMessagesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchChatMessagesReq.OrderBy order_by = 5
     */
    orderBy: SearchChatMessagesReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID thread_ids = 7
     */
    threadIds: UUID[];
}
/**
 * @generated from protobuf enum rd.search.service.SearchChatMessagesReq.OrderBy
 */
export enum SearchChatMessagesReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 1;
     */
    UPDATED_AT = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_SENT_AT = 3;
     */
    SENT_AT = 3
}
/**
 * @generated from protobuf message rd.search.service.SearchChatMessagesRes
 */
export interface SearchChatMessagesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchChatMessagesRes.Result results = 1
     */
    results: SearchChatMessagesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: map<string, rd.chat.Thread> threads_by_id = 3
     */
    threadsById: {
        [key: string]: Thread;
    };
    /**
     * @generated from protobuf field: map<string, rd.customer.Contacts.Contact> customer_contacts_by_id = 4
     */
    customerContactsById: {
        [key: string]: Contacts_Contact;
    };
}
/**
 * @generated from protobuf message rd.search.service.SearchChatMessagesRes.Result
 */
export interface SearchChatMessagesRes_Result {
    /**
     * @generated from protobuf field: rd.chat.Message message = 1
     */
    message?: Message;
}
/**
 * @generated from protobuf message rd.search.service.SearchRoutinesReq
 */
export interface SearchRoutinesReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchRoutinesReq.OrderBy order_by = 5
     */
    orderBy: SearchRoutinesReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 7
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: repeated rd.llm.Routine.Type types = 8
     */
    types: Routine_Type[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange scheduled_run_time_range = 9
     */
    scheduledRunTimeRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange last_run_at_range = 10
     */
    lastRunAtRange?: TimestampRange;
}
/**
 * @generated from protobuf enum rd.search.service.SearchRoutinesReq.OrderBy
 */
export enum SearchRoutinesReq_OrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 1;
     */
    UPDATED_AT = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_RUN_AT = 3;
     */
    LAST_RUN_AT = 3,
    /**
     * @generated from protobuf enum value: ORDER_BY_SCHEDULED_RUN_TIME = 4;
     */
    SCHEDULED_RUN_TIME = 4,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 5;
     */
    NAME = 5
}
/**
 * @generated from protobuf message rd.search.service.SearchRoutinesRes
 */
export interface SearchRoutinesRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchRoutinesRes.Result results = 1
     */
    results: SearchRoutinesRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchRoutinesRes.Result
 */
export interface SearchRoutinesRes_Result {
    /**
     * @generated from protobuf field: rd.llm.Routine routine = 1
     */
    routine?: Routine;
}
/**
 * @generated from protobuf message rd.search.service.SearchConversationsReq
 */
export interface SearchConversationsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: rd.search.service.SearchConversationsReq.OrderBy order_by = 5
     */
    orderBy: SearchConversationsReq_OrderBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 6
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: repeated rd.llm.Conversation.Type types = 7
     */
    types: Conversation_Type[];
    /**
     * Limits results to the runs of a single routine
     *
     * @generated from protobuf field: rd.proto.uuid.UUID routine_id = 8
     */
    routineId?: UUID;
    /**
     * Ignored for staff, who only ever see their own conversations
     *
     * @generated from protobuf field: repeated rd.proto.uuid.UUID user_ids = 9
     */
    userIds: UUID[];
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_read_filter = 10
     */
    isReadFilter: BoolFilter;
}
/**
 * @generated from protobuf enum rd.search.service.SearchConversationsReq.OrderBy
 */
export enum SearchConversationsReq_OrderBy {
    /**
     * default: newest human message first
     *
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 1;
     */
    UPDATED_AT = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_HUMAN_MESSAGE_AT = 3;
     */
    LAST_HUMAN_MESSAGE_AT = 3
}
/**
 * @generated from protobuf message rd.search.service.SearchConversationsRes
 */
export interface SearchConversationsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchConversationsRes.Result results = 1
     */
    results: SearchConversationsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchConversationsRes.Result
 */
export interface SearchConversationsRes_Result {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * short plain text snippet of the most recent message with text content
     *
     * @generated from protobuf field: string last_message_preview = 4
     */
    lastMessagePreview: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * Only populated for dooers, who can see other users' conversations
     * Empty when the conversation was started by a dooer rather than a staff member
     *
     * @generated from protobuf field: string staff_name = 6
     */
    staffName: string;
    /**
     * @generated from protobuf field: rd.llm.Conversation.Status status = 7
     */
    status: Conversation_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_human_message_at = 8
     */
    lastHumanMessageAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.search.service.PollForNewChatMessagesReq
 */
export interface PollForNewChatMessagesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID thread_id = 1
     */
    threadId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID latest_message_id = 2
     */
    latestMessageId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.PollForNewChatMessagesRes
 */
export interface PollForNewChatMessagesRes {
    /**
     * @generated from protobuf field: bool has_new_messages = 1
     */
    hasNewMessages: boolean;
}
/**
 * @generated from protobuf message rd.search.service.PollForUnreadChatThreadsReq
 */
export interface PollForUnreadChatThreadsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.PollForUnreadChatThreadsRes
 */
export interface PollForUnreadChatThreadsRes {
    /**
     * @generated from protobuf field: int32 num_unread_threads = 1
     */
    numUnreadThreads: number;
}
/**
 * @generated from protobuf message rd.search.service.SearchGiftCardsReq
 */
export interface SearchGiftCardsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID product_ids = 5
     */
    productIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange activated_at_range = 6
     */
    activatedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange deactivated_at_range = 7
     */
    deactivatedAtRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.giftcard.GiftCard.Status statuses = 8
     */
    statuses: GiftCard_Status[];
    /**
     * @generated from protobuf field: rd.search.service.SearchGiftCardsReq.GiftCardSortBy sort_by = 9
     */
    sortBy: SearchGiftCardsReq_GiftCardSortBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 10
     */
    sortOrder: SortOrder;
}
/**
 * @generated from protobuf enum rd.search.service.SearchGiftCardsReq.GiftCardSortBy
 */
export enum SearchGiftCardsReq_GiftCardSortBy {
    /**
     * @generated from protobuf enum value: GIFT_CARD_SORT_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: GIFT_CARD_SORT_BY_CREATED_AT = 1;
     */
    CREATED_AT = 1,
    /**
     * @generated from protobuf enum value: GIFT_CARD_SORT_BY_ACTIVATED_AT = 2;
     */
    ACTIVATED_AT = 2,
    /**
     * @generated from protobuf enum value: GIFT_CARD_SORT_BY_DEACTIVATED_AT = 3;
     */
    DEACTIVATED_AT = 3,
    /**
     * @generated from protobuf enum value: GIFT_CARD_SORT_BY_BALANCE = 4;
     */
    BALANCE = 4
}
/**
 * @generated from protobuf message rd.search.service.SearchGiftCardsRes
 */
export interface SearchGiftCardsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchGiftCardsRes.Result results = 1
     */
    results: SearchGiftCardsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchGiftCardsRes.Result
 */
export interface SearchGiftCardsRes_Result {
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard gift_card = 1
     */
    giftCard?: GiftCard;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCardBalance gift_card_balance = 2
     */
    giftCardBalance?: GiftCardBalance;
    /**
     * @generated from protobuf field: rd.product.Product product = 3
     */
    product?: Product;
}
/**
 * @generated from protobuf message rd.search.service.SearchSpiffsReq
 */
export interface SearchSpiffsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
    /**
     * @generated from protobuf field: int32 offset = 3
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 limit = 4
     */
    limit: number;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 5
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 6
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 7
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 8
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 9
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.search.service.SpiffValidityFilter statuses = 10
     */
    statuses: SpiffValidityFilter[];
    /**
     * @generated from protobuf field: rd.search.service.SpiffSortBy sort_by = 11
     */
    sortBy: SpiffSortBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 12
     */
    sortOrder: SortOrder;
    /**
     * The pricing region id for the current signed in location
     *
     * @generated from protobuf field: rd.proto.uuid.UUID current_pricing_region_id = 13
     */
    currentPricingRegionId?: UUID;
}
/**
 * @generated from protobuf message rd.search.service.SearchSpiffsRes
 */
export interface SearchSpiffsRes {
    /**
     * @generated from protobuf field: repeated rd.search.service.SearchSpiffsRes.Result results = 1
     */
    results: SearchSpiffsRes_Result[];
    /**
     * @generated from protobuf field: string cursor = 2
     */
    cursor: string;
}
/**
 * @generated from protobuf message rd.search.service.SearchSpiffsRes.Result
 */
export interface SearchSpiffsRes_Result {
    /**
     * @generated from protobuf field: rd.spiff.Spiff spiff = 1
     */
    spiff?: Spiff;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 3
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.ProductCategory department = 4
     */
    department?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory class = 5
     */
    class?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory fineline = 6
     */
    fineline?: ProductCategory;
    /**
     * @generated from protobuf field: rd.product.Product product = 7
     */
    product?: Product;
    /**
     * @generated from protobuf field: int32 product_count = 8
     */
    productCount: number;
    /**
     * @generated from protobuf field: rd.vendors.Vendor product_vendor = 9
     */
    productVendor?: Vendor;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_department = 10
     */
    productDepartment?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_class = 11
     */
    productClass?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.ProductCategory product_fineline = 12
     */
    productFineline?: ProductCategory;
    /**
     * @generated from protobuf field: rd.company.UnitOfMeasure uom = 13
     */
    uom?: UnitOfMeasure;
    /**
     * @generated from protobuf field: repeated rd.price.Tier tier_prices = 14
     */
    tierPrices: Tier[];
}
/**
 * @generated from protobuf message rd.search.service.BulkExportSpiffsReq
 */
export interface BulkExportSpiffsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 2
     */
    locationIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID vendor_ids = 3
     */
    vendorIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 4
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 5
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 6
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.search.service.SpiffValidityFilter statuses = 7
     */
    statuses: SpiffValidityFilter[];
    /**
     * @generated from protobuf field: rd.search.service.SpiffSortBy sort_by = 8
     */
    sortBy: SpiffSortBy;
    /**
     * @generated from protobuf field: rd.search.service.SortOrder sort_order = 9
     */
    sortOrder: SortOrder;
    /**
     * @generated from protobuf field: bool is_template = 10
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportSpiffsRes
 */
export interface BulkExportSpiffsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportStaffReq
 */
export interface BulkExportStaffReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: rd.search.service.BoolFilter is_active_filter = 2
     */
    isActiveFilter: BoolFilter;
    /**
     * @generated from protobuf field: bool is_template = 3
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportStaffRes
 */
export interface BulkExportStaffRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportDepartmentsReq
 */
export interface BulkExportDepartmentsReq {
    /**
     * @generated from protobuf field: bool is_template = 1
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportDepartmentsRes
 */
export interface BulkExportDepartmentsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportClassesReq
 */
export interface BulkExportClassesReq {
    /**
     * @generated from protobuf field: bool is_template = 1
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportClassesRes
 */
export interface BulkExportClassesRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportFinelineReq
 */
export interface BulkExportFinelineReq {
    /**
     * @generated from protobuf field: bool is_template = 1
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportFinelineRes
 */
export interface BulkExportFinelineRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportTagsReq
 */
export interface BulkExportTagsReq {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated rd.tag.Tag.Type types = 2
     */
    types: Tag_Type[];
    /**
     * @generated from protobuf field: repeated rd.tag.Tag.Color colors = 3
     */
    colors: Tag_Color[];
    /**
     * @generated from protobuf field: bool is_template = 4
     */
    isTemplate: boolean;
}
/**
 * @generated from protobuf message rd.search.service.BulkExportTagsRes
 */
export interface BulkExportTagsRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.search.service.ListIntegrationVendorsWithCatalogsReq
 */
export interface ListIntegrationVendorsWithCatalogsReq {
}
/**
 * @generated from protobuf message rd.search.service.ListIntegrationVendorsWithCatalogsRes
 */
export interface ListIntegrationVendorsWithCatalogsRes {
    /**
     * @generated from protobuf field: repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 1
     */
    integrationVendors: IntegrationVendor[];
}
/**
 * @generated from protobuf message rd.search.service.SearchListPromotionalSaleCodesReq
 */
export interface SearchListPromotionalSaleCodesReq {
}
/**
 * @generated from protobuf message rd.search.service.SearchListPromotionalSaleCodesRes
 */
export interface SearchListPromotionalSaleCodesRes {
    /**
     * @generated from protobuf field: repeated string sale_codes = 1
     */
    saleCodes: string[];
}
/**
 * @generated from protobuf enum rd.search.service.SortOrder
 */
export enum SortOrder {
    /**
     * @generated from protobuf enum value: SORT_ORDER_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_ORDER_DESC = 1;
     */
    DESC = 1,
    /**
     * @generated from protobuf enum value: SORT_ORDER_ASC = 2;
     */
    ASC = 2
}
/**
 * @generated from protobuf enum rd.search.service.BoolFilter
 */
export enum BoolFilter {
    /**
     * @generated from protobuf enum value: BOOL_FILTER_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: BOOL_FILTER_FALSE = 1;
     */
    FALSE = 1,
    /**
     * @generated from protobuf enum value: BOOL_FILTER_TRUE = 2;
     */
    TRUE = 2
}
/**
 * @generated from protobuf enum rd.search.service.CustomPriceRuleValidityFilter
 */
export enum CustomPriceRuleValidityFilter {
    /**
     * @generated from protobuf enum value: CPRVF_NONE = 0;
     */
    CPRVF_NONE = 0,
    /**
     * ExpiresAt is in the past
     *
     * @generated from protobuf enum value: CPRVF_EXPIRED = 1;
     */
    CPRVF_EXPIRED = 1,
    /**
     * ExpiresAt is in the future & StartsAt is in the past
     *
     * @generated from protobuf enum value: CPRVF_ACTIVE = 2;
     */
    CPRVF_ACTIVE = 2,
    /**
     * StartsAt is in the future
     *
     * @generated from protobuf enum value: CPRVF_SCHEDULED = 3;
     */
    CPRVF_SCHEDULED = 3
}
/**
 * @generated from protobuf enum rd.search.service.OrderCustomersBy
 */
export enum OrderCustomersBy {
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_CREDIT_LIMIT = 2;
     */
    CREDIT_LIMIT = 2,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_TOTAL_BALANCE = 3;
     */
    TOTAL_BALANCE = 3,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_CURRENT_BALANCE = 4;
     */
    CURRENT_BALANCE = 4,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LATE_1_TO_30_BALANCE = 5;
     */
    LATE_1_TO_30_BALANCE = 5,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LATE_31_TO_60_BALANCE = 6;
     */
    LATE_31_TO_60_BALANCE = 6,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LATE_61_PLUS_BALANCE = 7;
     */
    LATE_61_PLUS_BALANCE = 7,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_CREDITS_BALANCE = 8;
     */
    CREDITS_BALANCE = 8,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_FINANCING_CHARGES_BALANCE = 9;
     */
    FINANCING_CHARGES_BALANCE = 9,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_SALES_YTD = 10;
     */
    SALES_YTD = 10,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_SALES_VS_LAST_YEAR = 11;
     */
    SALES_VS_LAST_YEAR = 11,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_MARGIN_YTD = 12;
     */
    MARGIN_YTD = 12,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_SALES_LAST_12MO = 13;
     */
    SALES_LAST_12MO = 13,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_SALES_LAST_3MO = 14;
     */
    SALES_LAST_3MO = 14,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_SALES_LAST_1MO = 15;
     */
    SALES_LAST_1MO = 15,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LAST_SALE = 16;
     */
    LAST_SALE = 16,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LAST_INTERACTION_DATE = 17;
     */
    LAST_INTERACTION_DATE = 17,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_CREATED_AT = 18;
     */
    CREATED_AT = 18,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMERS_BY_LAST_UPDATED_AT = 19;
     */
    LAST_UPDATED_AT = 19
}
/**
 * @generated from protobuf enum rd.search.service.OrderCustomerContactsBy
 */
export enum OrderCustomerContactsBy {
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_CONTACTS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_CONTACTS_BY_CUSTOMER_IDENTIFIER = 1;
     */
    CUSTOMER_IDENTIFIER = 1,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_CONTACTS_BY_CUSTOMER_NAME = 2;
     */
    CUSTOMER_NAME = 2,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_CONTACTS_BY_CONTACT_NAME = 3;
     */
    CONTACT_NAME = 3
}
/**
 * @generated from protobuf enum rd.search.service.SearchProductOrderBy
 */
export enum SearchProductOrderBy {
    /**
     * @generated from protobuf enum value: ORDER_BY_NONE = 0;
     */
    ORDER_BY_NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_BY_NAME = 1;
     */
    ORDER_BY_NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_BY_INVENTORY_LOCATION_ID = 2;
     */
    ORDER_BY_INVENTORY_LOCATION_ID = 2,
    /**
     * @generated from protobuf enum value: ORDER_BY_TARGET = 3;
     */
    ORDER_BY_TARGET = 3,
    /**
     * @generated from protobuf enum value: ORDER_BY_CURRENT = 4;
     */
    ORDER_BY_CURRENT = 4,
    /**
     * @generated from protobuf enum value: ORDER_BY_REORDER = 5;
     */
    ORDER_BY_REORDER = 5,
    /**
     * @generated from protobuf enum value: ORDER_BY_DELTA = 6;
     */
    ORDER_BY_DELTA = 6,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_SOLD_YTD = 7;
     */
    ORDER_BY_UNITS_SOLD_YTD = 7,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_VS_LAST_YEAR = 8;
     */
    ORDER_BY_UNITS_VS_LAST_YEAR = 8,
    /**
     * @generated from protobuf enum value: ORDER_BY_MARGIN = 9;
     */
    ORDER_BY_MARGIN = 9,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_12MO = 10;
     */
    ORDER_BY_UNITS_LAST_12MO = 10,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_3MO = 11;
     */
    ORDER_BY_UNITS_LAST_3MO = 11,
    /**
     * @generated from protobuf enum value: ORDER_BY_UNITS_LAST_1MO = 12;
     */
    ORDER_BY_UNITS_LAST_1MO = 12,
    /**
     * @generated from protobuf enum value: ORDER_BY_LAST_SALE = 13;
     */
    ORDER_BY_LAST_SALE = 13,
    /**
     * @generated from protobuf enum value: ORDER_BY_TURNS = 14;
     */
    ORDER_BY_TURNS = 14,
    /**
     * @generated from protobuf enum value: ORDER_BY_UPDATED_AT = 15;
     */
    ORDER_BY_UPDATED_AT = 15
}
/**
 * InventoryChangeType represents all leaf-node transaction types for inventory changes.
 *
 * @generated from protobuf enum rd.search.service.InventoryChangeType
 */
export enum InventoryChangeType {
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_NONE = 0;
     */
    NONE = 0,
    /**
     * Sale transactions (customer)
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_RETURN = 2;
     */
    RETURN = 2,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_WILL_CALL = 3;
     */
    WILL_CALL = 3,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_WILL_CALL_RETURN = 4;
     */
    WILL_CALL_RETURN = 4,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SPECIAL_ORDER = 5;
     */
    SPECIAL_ORDER = 5,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SALE_COST_EDIT = 6;
     */
    SALE_COST_EDIT = 6,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_RETURN_COST_EDIT = 7;
     */
    RETURN_COST_EDIT = 7,
    /**
     * Transfer transactions (between locations)
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_RECEIVE = 8;
     */
    TRANSFER_RECEIVE = 8,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_SEND = 9;
     */
    TRANSFER_SEND = 9,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_REQUEST_INCOMING = 10;
     */
    TRANSFER_REQUEST_INCOMING = 10,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_REQUEST_OUTGOING = 11;
     */
    TRANSFER_REQUEST_OUTGOING = 11,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_DISPATCH_INCOMING = 12;
     */
    TRANSFER_DISPATCH_INCOMING = 12,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_TRANSFER_DISPATCH_OUTGOING = 13;
     */
    TRANSFER_DISPATCH_OUTGOING = 13,
    /**
     * Order transactions (from vendor)
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_ORDER = 14;
     */
    ORDER = 14,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_ORDER_RETURN = 15;
     */
    ORDER_RETURN = 15,
    /**
     * Shipment transactions (from vendor)
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SHIPMENT = 16;
     */
    SHIPMENT = 16,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SHIPMENT_RETURN = 17;
     */
    SHIPMENT_RETURN = 17,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SHIPMENT_COST_EDIT = 18;
     */
    SHIPMENT_COST_EDIT = 18,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SHIPMENT_RETURN_COST_EDIT = 19;
     */
    SHIPMENT_RETURN_COST_EDIT = 19,
    /**
     * Count transactions
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_COUNT = 20;
     */
    COUNT = 20,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_MANUAL_EDIT = 21;
     */
    MANUAL_EDIT = 21,
    /**
     * Void reversals
     *
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_VOIDED_SALE_REVERSAL = 22;
     */
    VOIDED_SALE_REVERSAL = 22,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_VOIDED_RETURN_REVERSAL = 23;
     */
    VOIDED_RETURN_REVERSAL = 23,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SPECIAL_ORDER_RETURN = 24;
     */
    SPECIAL_ORDER_RETURN = 24,
    /**
     * @generated from protobuf enum value: INVENTORY_CHANGE_TYPE_SHIPMENT_EDIT = 25;
     */
    SHIPMENT_EDIT = 25
}
/**
 * @generated from protobuf enum rd.search.service.CustomPriceRuleSortBy
 */
export enum CustomPriceRuleSortBy {
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_SORT_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_SORT_BY_EXPIRES = 1;
     */
    EXPIRES = 1,
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_SORT_BY_NAME = 2;
     */
    NAME = 2,
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_SORT_BY_STARTS = 3;
     */
    STARTS = 3
}
/**
 * @generated from protobuf enum rd.search.service.CustomPriceRuleType
 */
export enum CustomPriceRuleType {
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_TYPE_CUSTOM = 1;
     */
    CUSTOM = 1,
    /**
     * @generated from protobuf enum value: CUSTOM_PRICE_RULE_TYPE_PROMOTION = 2;
     */
    PROMOTION = 2
}
/**
 * @generated from protobuf enum rd.search.service.OrderJobsBy
 */
export enum OrderJobsBy {
    /**
     * @generated from protobuf enum value: ORDER_JOBS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_JOBS_BY_IDENTIFIER = 1;
     */
    IDENTIFIER = 1,
    /**
     * @generated from protobuf enum value: ORDER_JOBS_BY_NAME = 2;
     */
    NAME = 2,
    /**
     * @generated from protobuf enum value: ORDER_JOBS_BY_TOTAL_BALANCE = 3;
     */
    TOTAL_BALANCE = 3
}
/**
 * @generated from protobuf enum rd.search.service.OrderStatementsBy
 */
export enum OrderStatementsBy {
    /**
     * @generated from protobuf enum value: ORDER_STATEMENTS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENTS_BY_CUSTOMER_NAME = 1;
     */
    CUSTOMER_NAME = 1,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENTS_BY_TOTAL_BALANCE = 2;
     */
    TOTAL_BALANCE = 2,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENTS_BY_SEND_DATE = 4;
     */
    SEND_DATE = 4
}
/**
 * @generated from protobuf enum rd.search.service.OrderStatementRunsBy
 */
export enum OrderStatementRunsBy {
    /**
     * @generated from protobuf enum value: ORDER_STATEMENT_RUNS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENT_RUNS_BY_END_DATE = 1;
     */
    END_DATE = 1,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENT_RUNS_BY_START_DATE = 2;
     */
    START_DATE = 2,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENT_RUNS_BY_RUN_TYPE = 3;
     */
    RUN_TYPE = 3,
    /**
     * @generated from protobuf enum value: ORDER_STATEMENT_RUNS_BY_CREATED_AT = 5;
     */
    CREATED_AT = 5
}
/**
 * @generated from protobuf enum rd.search.service.OrderCustomerStatementsBy
 */
export enum OrderCustomerStatementsBy {
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_STATEMENTS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_STATEMENTS_BY_END_DATE = 3;
     */
    END_DATE = 3,
    /**
     * @generated from protobuf enum value: ORDER_CUSTOMER_STATEMENTS_BY_DATE_GENERATED = 5;
     */
    DATE_GENERATED = 5
}
/**
 * @generated from protobuf enum rd.search.service.OrderCreditsBy
 */
export enum OrderCreditsBy {
    /**
     * @generated from protobuf enum value: ORDER_CREDITS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_CREDITS_BY_TOTAL_BALANCE = 1;
     */
    TOTAL_BALANCE = 1,
    /**
     * @generated from protobuf enum value: ORDER_CREDITS_BY_CREATED_AT = 2;
     */
    CREATED_AT = 2
}
/**
 * @generated from protobuf enum rd.search.service.SortAccountsBy
 */
export enum SortAccountsBy {
    /**
     * @generated from protobuf enum value: SORT_ACCOUNTS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_ACCOUNTS_BY_NUMBER = 1;
     */
    NUMBER = 1,
    /**
     * @generated from protobuf enum value: SORT_ACCOUNTS_BY_NAME = 2;
     */
    NAME = 2,
    /**
     * @generated from protobuf enum value: SORT_ACCOUNTS_BY_TYPE_NAME = 3;
     */
    TYPE_NAME = 3
}
/**
 * @generated from protobuf enum rd.search.service.SortMappingsBy
 */
export enum SortMappingsBy {
    /**
     * @generated from protobuf enum value: SORT_MAPPINGS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_MAPPINGS_BY_ACCOUNT_NUMBER = 1;
     */
    ACCOUNT_NUMBER = 1,
    /**
     * @generated from protobuf enum value: SORT_MAPPINGS_BY_TYPE_NAME = 2;
     */
    TYPE_NAME = 2
}
/**
 * @generated from protobuf enum rd.search.service.SortJournalEntriesBy
 */
export enum SortJournalEntriesBy {
    /**
     * @generated from protobuf enum value: SORT_JOURNAL_ENTRIES_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_JOURNAL_ENTRIES_BY_CREATED_AT = 1;
     */
    CREATED_AT = 1,
    /**
     * @generated from protobuf enum value: SORT_JOURNAL_ENTRIES_BY_DATE = 2;
     */
    DATE = 2,
    /**
     * @generated from protobuf enum value: SORT_JOURNAL_ENTRIES_BY_EXPORTED_AT = 3;
     */
    EXPORTED_AT = 3
}
/**
 * @generated from protobuf enum rd.search.service.SortManualJournalEntriesBy
 */
export enum SortManualJournalEntriesBy {
    /**
     * @generated from protobuf enum value: SORT_MANUAL_JOURNAL_ENTRIES_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_MANUAL_JOURNAL_ENTRIES_BY_CREATED_AT = 1;
     */
    CREATED_AT = 1,
    /**
     * @generated from protobuf enum value: SORT_MANUAL_JOURNAL_ENTRIES_BY_UPDATED_AT = 2;
     */
    UPDATED_AT = 2,
    /**
     * @generated from protobuf enum value: SORT_MANUAL_JOURNAL_ENTRIES_BY_ACCOUNTED_AT = 3;
     */
    ACCOUNTED_AT = 3,
    /**
     * @generated from protobuf enum value: SORT_MANUAL_JOURNAL_ENTRIES_BY_IDENTIFIER = 5;
     */
    IDENTIFIER = 5
}
/**
 * @generated from protobuf enum rd.search.service.SortSavedReportsBy
 */
export enum SortSavedReportsBy {
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_BASE_DATA = 2;
     */
    BASE_DATA = 2,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_CREATED_BY = 3;
     */
    CREATED_BY = 3,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_UPDATED_BY = 4;
     */
    UPDATED_BY = 4,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_CREATED_AT = 5;
     */
    CREATED_AT = 5,
    /**
     * @generated from protobuf enum value: SORT_SAVED_REPORTS_BY_UPDATED_AT = 6;
     */
    UPDATED_AT = 6
}
/**
 * Notifications
 *
 * @generated from protobuf enum rd.search.service.OrderNotificationsBy
 */
export enum OrderNotificationsBy {
    /**
     * @generated from protobuf enum value: ORDER_NOTIFICATIONS_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: ORDER_NOTIFICATIONS_BY_READ_AT = 2;
     */
    READ_AT = 2,
    /**
     * @generated from protobuf enum value: ORDER_NOTIFICATIONS_BY_ARCHIVED_AT = 3;
     */
    ARCHIVED_AT = 3,
    /**
     * @generated from protobuf enum value: ORDER_NOTIFICATIONS_BY_NOTIFIED_AT = 4;
     */
    NOTIFIED_AT = 4
}
/**
 * @generated from protobuf enum rd.search.service.OrderCatalogSKUsBy
 */
export enum OrderCatalogSKUsBy {
    /**
     * @generated from protobuf enum value: ORDER_CATALOG_SKUS_BY_NONE = 0;
     */
    ORDER_CATALOG_SKUS_BY_NONE = 0
}
/**
 * @generated from protobuf enum rd.search.service.SpiffSortBy
 */
export enum SpiffSortBy {
    /**
     * @generated from protobuf enum value: SPIFF_SORT_BY_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SPIFF_SORT_BY_NAME = 1;
     */
    NAME = 1,
    /**
     * @generated from protobuf enum value: SPIFF_SORT_BY_STARTS_AT = 2;
     */
    STARTS_AT = 2,
    /**
     * @generated from protobuf enum value: SPIFF_SORT_BY_EXPIRES_AT = 3;
     */
    EXPIRES_AT = 3
}
/**
 * @generated from protobuf enum rd.search.service.SpiffValidityFilter
 */
export enum SpiffValidityFilter {
    /**
     * @generated from protobuf enum value: SPIFF_VALIDITY_FILTER_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SPIFF_VALIDITY_FILTER_EXPIRED = 1;
     */
    EXPIRED = 1,
    /**
     * @generated from protobuf enum value: SPIFF_VALIDITY_FILTER_ACTIVE = 2;
     */
    ACTIVE = 2,
    /**
     * @generated from protobuf enum value: SPIFF_VALIDITY_FILTER_SCHEDULED = 3;
     */
    SCHEDULED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchBillPaymentsAllocatedFinanceCharge$Type extends MessageType<SearchBillPaymentsAllocatedFinanceCharge> {
    constructor() {
        super("rd.search.service.SearchBillPaymentsAllocatedFinanceCharge", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "allocated_amount", kind: "message", T: () => Money },
            { no: 4, name: "location_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "assessed_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "created_by", kind: "message", T: () => User },
            { no: 8, name: "customer_id", kind: "message", T: () => UUID },
            { no: 9, name: "customer_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "job_id", kind: "message", T: () => UUID },
            { no: 12, name: "job_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchBillPaymentsAllocatedFinanceCharge>): SearchBillPaymentsAllocatedFinanceCharge {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.locationPrefix = "";
        message.locationName = "";
        message.customerIdentifier = "";
        message.customerName = "";
        message.jobIdentifier = "";
        message.jobName = "";
        if (value !== undefined)
            reflectionMergePartial<SearchBillPaymentsAllocatedFinanceCharge>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchBillPaymentsAllocatedFinanceCharge): SearchBillPaymentsAllocatedFinanceCharge {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.money.Money allocated_amount */ 3:
                    message.allocatedAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocatedAmount);
                    break;
                case /* string location_prefix */ 4:
                    message.locationPrefix = reader.string();
                    break;
                case /* string location_name */ 5:
                    message.locationName = reader.string();
                    break;
                case /* google.protobuf.Timestamp assessed_at */ 6:
                    message.assessedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.assessedAt);
                    break;
                case /* rd.user.User created_by */ 7:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 8:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string customer_identifier */ 9:
                    message.customerIdentifier = reader.string();
                    break;
                case /* string customer_name */ 10:
                    message.customerName = reader.string();
                    break;
                case /* rd.proto.uuid.UUID job_id */ 11:
                    message.jobId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.jobId);
                    break;
                case /* string job_identifier */ 12:
                    message.jobIdentifier = reader.string();
                    break;
                case /* string job_name */ 13:
                    message.jobName = reader.string();
                    break;
                case /* rd.proto.money.Money total */ 14:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchBillPaymentsAllocatedFinanceCharge, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.money.Money allocated_amount = 3; */
        if (message.allocatedAmount)
            Money.internalBinaryWrite(message.allocatedAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string location_prefix = 4; */
        if (message.locationPrefix !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.locationPrefix);
        /* string location_name = 5; */
        if (message.locationName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locationName);
        /* google.protobuf.Timestamp assessed_at = 6; */
        if (message.assessedAt)
            Timestamp.internalBinaryWrite(message.assessedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 7; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 8; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string customer_identifier = 9; */
        if (message.customerIdentifier !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customerIdentifier);
        /* string customer_name = 10; */
        if (message.customerName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.customerName);
        /* rd.proto.uuid.UUID job_id = 11; */
        if (message.jobId)
            UUID.internalBinaryWrite(message.jobId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string job_identifier = 12; */
        if (message.jobIdentifier !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.jobIdentifier);
        /* string job_name = 13; */
        if (message.jobName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.jobName);
        /* rd.proto.money.Money total = 14; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchBillPaymentsAllocatedFinanceCharge
 */
export const SearchBillPaymentsAllocatedFinanceCharge = new SearchBillPaymentsAllocatedFinanceCharge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchBillPaymentsReq$Type extends MessageType<SearchBillPaymentsReq> {
    constructor() {
        super("rd.search.service.SearchBillPaymentsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "credit_filters", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.SearchBillPaymentsReq.CreditFilter", SearchBillPaymentsReq_CreditFilter] },
            { no: 12, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchBillPaymentsReq>): SearchBillPaymentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.createdByIds = [];
        message.locationIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.creditFilters = [];
        message.methodIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchBillPaymentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchBillPaymentsReq): SearchBillPaymentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 3:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 4:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 5:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 6:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 7:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.search.service.SearchBillPaymentsReq.CreditFilter credit_filters */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.creditFilters.push(reader.int32());
                    else
                        message.creditFilters.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 12:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchBillPaymentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 3; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID created_by_ids = 4; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 5; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 6; */
        if (message.cursor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 7; */
        if (message.offset !== 0)
            writer.tag(7, WireType.Varint).int32(message.offset);
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* repeated rd.search.service.SearchBillPaymentsReq.CreditFilter credit_filters = 11; */
        if (message.creditFilters.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.creditFilters.length; i++)
                writer.int32(message.creditFilters[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID method_ids = 12; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchBillPaymentsReq
 */
export const SearchBillPaymentsReq = new SearchBillPaymentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchBillPaymentsRes$Type extends MessageType<SearchBillPaymentsRes> {
    constructor() {
        super("rd.search.service.SearchBillPaymentsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchBillPaymentsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchBillPaymentsRes>): SearchBillPaymentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchBillPaymentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchBillPaymentsRes): SearchBillPaymentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchBillPaymentsRes.Result results */ 1:
                    message.results.push(SearchBillPaymentsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchBillPaymentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchBillPaymentsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchBillPaymentsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchBillPaymentsRes
 */
export const SearchBillPaymentsRes = new SearchBillPaymentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchBillPaymentsRes_Result$Type extends MessageType<SearchBillPaymentsRes_Result> {
    constructor() {
        super("rd.search.service.SearchBillPaymentsRes.Result", [
            { no: 1, name: "bill_payment", kind: "message", T: () => BillPayment },
            { no: 4, name: "sales_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale } },
            { no: 5, name: "allocations_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 6, name: "totals_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 7, name: "purchase_orders_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PurchaseOrder } },
            { no: 9, name: "locations_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Location } },
            { no: 10, name: "customer", kind: "message", T: () => Customer },
            { no: 11, name: "payment_card", kind: "message", T: () => Card },
            { no: 12, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "customers_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Customer } },
            { no: 21, name: "allocated_finance_charges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchBillPaymentsAllocatedFinanceCharge },
            { no: 22, name: "credits_used_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 23, name: "ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 24, name: "tender_method_type", kind: "enum", T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] },
            { no: 25, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 26, name: "allocated_receivables", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AllocatedReceivable }
        ]);
    }
    create(value?: PartialMessage<SearchBillPaymentsRes_Result>): SearchBillPaymentsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salesById = {};
        message.allocationsBySaleId = {};
        message.totalsBySaleId = {};
        message.purchaseOrdersBySaleId = {};
        message.locationsBySaleId = {};
        message.paymentMethod = "";
        message.customersBySaleId = {};
        message.allocatedFinanceCharges = [];
        message.creditsUsedById = {};
        message.tenderMethodType = 0;
        message.allocatedReceivables = [];
        if (value !== undefined)
            reflectionMergePartial<SearchBillPaymentsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchBillPaymentsRes_Result): SearchBillPaymentsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.BillPayment bill_payment */ 1:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                case /* map<string, rd.txn.Sale> sales_by_id */ 4:
                    this.binaryReadMap4(message.salesById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_sale_id */ 5:
                    this.binaryReadMap5(message.allocationsBySaleId, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> totals_by_sale_id */ 6:
                    this.binaryReadMap6(message.totalsBySaleId, reader, options);
                    break;
                case /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id */ 7:
                    this.binaryReadMap7(message.purchaseOrdersBySaleId, reader, options);
                    break;
                case /* map<string, rd.company.Location> locations_by_sale_id */ 9:
                    this.binaryReadMap9(message.locationsBySaleId, reader, options);
                    break;
                case /* rd.customer.Customer customer */ 10:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.payments.Card payment_card */ 11:
                    message.paymentCard = Card.internalBinaryRead(reader, reader.uint32(), options, message.paymentCard);
                    break;
                case /* string payment_method */ 12:
                    message.paymentMethod = reader.string();
                    break;
                case /* map<string, rd.customer.Customer> customers_by_sale_id */ 13:
                    this.binaryReadMap13(message.customersBySaleId, reader, options);
                    break;
                case /* repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges */ 21:
                    message.allocatedFinanceCharges.push(SearchBillPaymentsAllocatedFinanceCharge.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.money.Money> credits_used_by_id */ 22:
                    this.binaryReadMap22(message.creditsUsedById, reader, options);
                    break;
                case /* rd.ledger.LedgerEntry ledger_entry */ 23:
                    message.ledgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntry);
                    break;
                case /* rd.company.tender.Method.Type tender_method_type */ 24:
                    message.tenderMethodType = reader.int32();
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 25:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* repeated rd.txn.AllocatedReceivable allocated_receivables */ 26:
                    message.allocatedReceivables.push(AllocatedReceivable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SearchBillPaymentsRes_Result["salesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["salesById"] | undefined, val: SearchBillPaymentsRes_Result["salesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.sales_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale.create();
    }
    private binaryReadMap5(map: SearchBillPaymentsRes_Result["allocationsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["allocationsBySaleId"] | undefined, val: SearchBillPaymentsRes_Result["allocationsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.allocations_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap6(map: SearchBillPaymentsRes_Result["totalsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["totalsBySaleId"] | undefined, val: SearchBillPaymentsRes_Result["totalsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.totals_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap7(map: SearchBillPaymentsRes_Result["purchaseOrdersBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["purchaseOrdersBySaleId"] | undefined, val: SearchBillPaymentsRes_Result["purchaseOrdersBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.purchase_orders_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? PurchaseOrder.create();
    }
    private binaryReadMap9(map: SearchBillPaymentsRes_Result["locationsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["locationsBySaleId"] | undefined, val: SearchBillPaymentsRes_Result["locationsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Location.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.locations_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Location.create();
    }
    private binaryReadMap13(map: SearchBillPaymentsRes_Result["customersBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["customersBySaleId"] | undefined, val: SearchBillPaymentsRes_Result["customersBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Customer.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.customers_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Customer.create();
    }
    private binaryReadMap22(map: SearchBillPaymentsRes_Result["creditsUsedById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchBillPaymentsRes_Result["creditsUsedById"] | undefined, val: SearchBillPaymentsRes_Result["creditsUsedById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchBillPaymentsRes.Result.credits_used_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: SearchBillPaymentsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.BillPayment bill_payment = 1; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale> sales_by_id = 4; */
        for (let k of globalThis.Object.keys(message.salesById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale.internalBinaryWrite(message.salesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> allocations_by_sale_id = 5; */
        for (let k of globalThis.Object.keys(message.allocationsBySaleId)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> totals_by_sale_id = 6; */
        for (let k of globalThis.Object.keys(message.totalsBySaleId)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.totalsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id = 7; */
        for (let k of globalThis.Object.keys(message.purchaseOrdersBySaleId)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            PurchaseOrder.internalBinaryWrite(message.purchaseOrdersBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.company.Location> locations_by_sale_id = 9; */
        for (let k of globalThis.Object.keys(message.locationsBySaleId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Location.internalBinaryWrite(message.locationsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.customer.Customer customer = 10; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.Card payment_card = 11; */
        if (message.paymentCard)
            Card.internalBinaryWrite(message.paymentCard, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string payment_method = 12; */
        if (message.paymentMethod !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.paymentMethod);
        /* map<string, rd.customer.Customer> customers_by_sale_id = 13; */
        for (let k of globalThis.Object.keys(message.customersBySaleId)) {
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Customer.internalBinaryWrite(message.customersBySaleId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges = 21; */
        for (let i = 0; i < message.allocatedFinanceCharges.length; i++)
            SearchBillPaymentsAllocatedFinanceCharge.internalBinaryWrite(message.allocatedFinanceCharges[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> credits_used_by_id = 22; */
        for (let k of globalThis.Object.keys(message.creditsUsedById)) {
            writer.tag(22, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.creditsUsedById[k], writer, options);
            writer.join().join();
        }
        /* rd.ledger.LedgerEntry ledger_entry = 23; */
        if (message.ledgerEntry)
            LedgerEntry.internalBinaryWrite(message.ledgerEntry, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.Type tender_method_type = 24; */
        if (message.tenderMethodType !== 0)
            writer.tag(24, WireType.Varint).int32(message.tenderMethodType);
        /* rd.ledger.LedgerMethods ledger_methods = 25; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.AllocatedReceivable allocated_receivables = 26; */
        for (let i = 0; i < message.allocatedReceivables.length; i++)
            AllocatedReceivable.internalBinaryWrite(message.allocatedReceivables[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchBillPaymentsRes.Result
 */
export const SearchBillPaymentsRes_Result = new SearchBillPaymentsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRefundedBillPaymentsReq$Type extends MessageType<SearchRefundedBillPaymentsReq> {
    constructor() {
        super("rd.search.service.SearchRefundedBillPaymentsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchRefundedBillPaymentsReq>): SearchRefundedBillPaymentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.createdByIds = [];
        message.locationIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.methodIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRefundedBillPaymentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRefundedBillPaymentsReq): SearchRefundedBillPaymentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 3:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 4:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 5:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 6:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 7:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 10:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRefundedBillPaymentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 3; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID created_by_ids = 4; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 5; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 6; */
        if (message.cursor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 7; */
        if (message.offset !== 0)
            writer.tag(7, WireType.Varint).int32(message.offset);
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID method_ids = 10; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRefundedBillPaymentsReq
 */
export const SearchRefundedBillPaymentsReq = new SearchRefundedBillPaymentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRefundedBillPaymentsRes$Type extends MessageType<SearchRefundedBillPaymentsRes> {
    constructor() {
        super("rd.search.service.SearchRefundedBillPaymentsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchRefundedBillPaymentsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRefundedBillPaymentsRes>): SearchRefundedBillPaymentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRefundedBillPaymentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRefundedBillPaymentsRes): SearchRefundedBillPaymentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchRefundedBillPaymentsRes.Result results */ 1:
                    message.results.push(SearchRefundedBillPaymentsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRefundedBillPaymentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchRefundedBillPaymentsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchRefundedBillPaymentsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRefundedBillPaymentsRes
 */
export const SearchRefundedBillPaymentsRes = new SearchRefundedBillPaymentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRefundedBillPaymentsRes_Result$Type extends MessageType<SearchRefundedBillPaymentsRes_Result> {
    constructor() {
        super("rd.search.service.SearchRefundedBillPaymentsRes.Result", [
            { no: 1, name: "payment_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "bill_payment", kind: "message", T: () => BillPayment },
            { no: 3, name: "payment_ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 4, name: "sales_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale } },
            { no: 5, name: "allocations_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 6, name: "totals_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 7, name: "purchase_orders_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PurchaseOrder } },
            { no: 9, name: "locations_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Location } },
            { no: 10, name: "customer", kind: "message", T: () => Customer },
            { no: 11, name: "payment_card", kind: "message", T: () => Card },
            { no: 12, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "customers_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Customer } },
            { no: 14, name: "allocated_finance_charges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchBillPaymentsAllocatedFinanceCharge },
            { no: 15, name: "credits_used_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 16, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 17, name: "refund_ledger_entry_id", kind: "message", T: () => UUID },
            { no: 18, name: "allocated_receivables", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AllocatedReceivable }
        ]);
    }
    create(value?: PartialMessage<SearchRefundedBillPaymentsRes_Result>): SearchRefundedBillPaymentsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salesById = {};
        message.allocationsBySaleId = {};
        message.totalsBySaleId = {};
        message.purchaseOrdersBySaleId = {};
        message.locationsBySaleId = {};
        message.paymentMethod = "";
        message.customersBySaleId = {};
        message.allocatedFinanceCharges = [];
        message.creditsUsedById = {};
        message.allocatedReceivables = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRefundedBillPaymentsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRefundedBillPaymentsRes_Result): SearchRefundedBillPaymentsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID payment_ledger_entry_id */ 1:
                    message.paymentLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.paymentLedgerEntryId);
                    break;
                case /* rd.txn.BillPayment bill_payment */ 2:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                case /* rd.ledger.LedgerEntry payment_ledger_entry */ 3:
                    message.paymentLedgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.paymentLedgerEntry);
                    break;
                case /* map<string, rd.txn.Sale> sales_by_id */ 4:
                    this.binaryReadMap4(message.salesById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_sale_id */ 5:
                    this.binaryReadMap5(message.allocationsBySaleId, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> totals_by_sale_id */ 6:
                    this.binaryReadMap6(message.totalsBySaleId, reader, options);
                    break;
                case /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id */ 7:
                    this.binaryReadMap7(message.purchaseOrdersBySaleId, reader, options);
                    break;
                case /* map<string, rd.company.Location> locations_by_sale_id */ 9:
                    this.binaryReadMap9(message.locationsBySaleId, reader, options);
                    break;
                case /* rd.customer.Customer customer */ 10:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.payments.Card payment_card */ 11:
                    message.paymentCard = Card.internalBinaryRead(reader, reader.uint32(), options, message.paymentCard);
                    break;
                case /* string payment_method */ 12:
                    message.paymentMethod = reader.string();
                    break;
                case /* map<string, rd.customer.Customer> customers_by_sale_id */ 13:
                    this.binaryReadMap13(message.customersBySaleId, reader, options);
                    break;
                case /* repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges */ 14:
                    message.allocatedFinanceCharges.push(SearchBillPaymentsAllocatedFinanceCharge.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.money.Money> credits_used_by_id */ 15:
                    this.binaryReadMap15(message.creditsUsedById, reader, options);
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 16:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* rd.proto.uuid.UUID refund_ledger_entry_id */ 17:
                    message.refundLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.refundLedgerEntryId);
                    break;
                case /* repeated rd.txn.AllocatedReceivable allocated_receivables */ 18:
                    message.allocatedReceivables.push(AllocatedReceivable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SearchRefundedBillPaymentsRes_Result["salesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["salesById"] | undefined, val: SearchRefundedBillPaymentsRes_Result["salesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.sales_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale.create();
    }
    private binaryReadMap5(map: SearchRefundedBillPaymentsRes_Result["allocationsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["allocationsBySaleId"] | undefined, val: SearchRefundedBillPaymentsRes_Result["allocationsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.allocations_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap6(map: SearchRefundedBillPaymentsRes_Result["totalsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["totalsBySaleId"] | undefined, val: SearchRefundedBillPaymentsRes_Result["totalsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.totals_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap7(map: SearchRefundedBillPaymentsRes_Result["purchaseOrdersBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["purchaseOrdersBySaleId"] | undefined, val: SearchRefundedBillPaymentsRes_Result["purchaseOrdersBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.purchase_orders_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? PurchaseOrder.create();
    }
    private binaryReadMap9(map: SearchRefundedBillPaymentsRes_Result["locationsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["locationsBySaleId"] | undefined, val: SearchRefundedBillPaymentsRes_Result["locationsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Location.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.locations_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Location.create();
    }
    private binaryReadMap13(map: SearchRefundedBillPaymentsRes_Result["customersBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["customersBySaleId"] | undefined, val: SearchRefundedBillPaymentsRes_Result["customersBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Customer.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.customers_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Customer.create();
    }
    private binaryReadMap15(map: SearchRefundedBillPaymentsRes_Result["creditsUsedById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchRefundedBillPaymentsRes_Result["creditsUsedById"] | undefined, val: SearchRefundedBillPaymentsRes_Result["creditsUsedById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchRefundedBillPaymentsRes.Result.credits_used_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: SearchRefundedBillPaymentsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID payment_ledger_entry_id = 1; */
        if (message.paymentLedgerEntryId)
            UUID.internalBinaryWrite(message.paymentLedgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.BillPayment bill_payment = 2; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry payment_ledger_entry = 3; */
        if (message.paymentLedgerEntry)
            LedgerEntry.internalBinaryWrite(message.paymentLedgerEntry, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale> sales_by_id = 4; */
        for (let k of globalThis.Object.keys(message.salesById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale.internalBinaryWrite(message.salesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> allocations_by_sale_id = 5; */
        for (let k of globalThis.Object.keys(message.allocationsBySaleId)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> totals_by_sale_id = 6; */
        for (let k of globalThis.Object.keys(message.totalsBySaleId)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.totalsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_sale_id = 7; */
        for (let k of globalThis.Object.keys(message.purchaseOrdersBySaleId)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            PurchaseOrder.internalBinaryWrite(message.purchaseOrdersBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.company.Location> locations_by_sale_id = 9; */
        for (let k of globalThis.Object.keys(message.locationsBySaleId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Location.internalBinaryWrite(message.locationsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.customer.Customer customer = 10; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.Card payment_card = 11; */
        if (message.paymentCard)
            Card.internalBinaryWrite(message.paymentCard, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string payment_method = 12; */
        if (message.paymentMethod !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.paymentMethod);
        /* map<string, rd.customer.Customer> customers_by_sale_id = 13; */
        for (let k of globalThis.Object.keys(message.customersBySaleId)) {
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Customer.internalBinaryWrite(message.customersBySaleId[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.search.service.SearchBillPaymentsAllocatedFinanceCharge allocated_finance_charges = 14; */
        for (let i = 0; i < message.allocatedFinanceCharges.length; i++)
            SearchBillPaymentsAllocatedFinanceCharge.internalBinaryWrite(message.allocatedFinanceCharges[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> credits_used_by_id = 15; */
        for (let k of globalThis.Object.keys(message.creditsUsedById)) {
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.creditsUsedById[k], writer, options);
            writer.join().join();
        }
        /* rd.ledger.LedgerMethods ledger_methods = 16; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID refund_ledger_entry_id = 17; */
        if (message.refundLedgerEntryId)
            UUID.internalBinaryWrite(message.refundLedgerEntryId, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.AllocatedReceivable allocated_receivables = 18; */
        for (let i = 0; i < message.allocatedReceivables.length; i++)
            AllocatedReceivable.internalBinaryWrite(message.allocatedReceivables[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRefundedBillPaymentsRes.Result
 */
export const SearchRefundedBillPaymentsRes_Result = new SearchRefundedBillPaymentsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomersV2Req$Type extends MessageType<SearchCustomersV2Req> {
    constructor() {
        super("rd.search.service.SearchCustomersV2Req", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_on_credit_hold_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 6, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 10, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCustomersBy", OrderCustomersBy, "ORDER_CUSTOMERS_BY_"] },
            { no: 14, name: "finance_charge_settings_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "primary_location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 17, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "origins", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.customer.Customer.Origin", Customer_Origin, "ORIGIN_"] }
        ]);
    }
    create(value?: PartialMessage<SearchCustomersV2Req>): SearchCustomersV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.isOnCreditHoldFilter = 0;
        message.repStaffIds = [];
        message.isActiveFilter = 0;
        message.sortOrder = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.financeChargeSettingsIds = [];
        message.tagIds = [];
        message.primaryLocationIds = [];
        message.customerIds = [];
        message.origins = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCustomersV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomersV2Req): SearchCustomersV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string financing_term_id_strings */ 3:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 4:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* rd.search.service.BoolFilter is_on_credit_hold_filter */ 5:
                    message.isOnCreditHoldFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 6:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 7:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 9:
                    message.sortOrder = reader.int32();
                    break;
                case /* string cursor */ 10:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 11:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 12:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.OrderCustomersBy order_by */ 13:
                    message.orderBy = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_settings_ids */ 14:
                    message.financeChargeSettingsIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 15:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID primary_location_ids */ 16:
                    message.primaryLocationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 17:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.customer.Customer.Origin origins */ 18:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.origins.push(reader.int32());
                    else
                        message.origins.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomersV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string financing_term_id_strings = 3; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 4; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* rd.search.service.BoolFilter is_on_credit_hold_filter = 5; */
        if (message.isOnCreditHoldFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isOnCreditHoldFilter);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 6; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_active_filter = 7; */
        if (message.isActiveFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.SortOrder sort_order = 9; */
        if (message.sortOrder !== 0)
            writer.tag(9, WireType.Varint).int32(message.sortOrder);
        /* string cursor = 10; */
        if (message.cursor !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 11; */
        if (message.offset !== 0)
            writer.tag(11, WireType.Varint).int32(message.offset);
        /* int32 limit = 12; */
        if (message.limit !== 0)
            writer.tag(12, WireType.Varint).int32(message.limit);
        /* rd.search.service.OrderCustomersBy order_by = 13; */
        if (message.orderBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.orderBy);
        /* repeated rd.proto.uuid.UUID finance_charge_settings_ids = 14; */
        for (let i = 0; i < message.financeChargeSettingsIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingsIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 15; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID primary_location_ids = 16; */
        for (let i = 0; i < message.primaryLocationIds.length; i++)
            UUID.internalBinaryWrite(message.primaryLocationIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 17; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.customer.Customer.Origin origins = 18; */
        if (message.origins.length) {
            writer.tag(18, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.origins.length; i++)
                writer.int32(message.origins[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomersV2Req
 */
export const SearchCustomersV2Req = new SearchCustomersV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomersV2Res$Type extends MessageType<SearchCustomersV2Res> {
    constructor() {
        super("rd.search.service.SearchCustomersV2Res", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCustomersV2Res_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCustomersV2Res>): SearchCustomersV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCustomersV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomersV2Res): SearchCustomersV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCustomersV2Res.Result results */ 1:
                    message.results.push(SearchCustomersV2Res_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomersV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCustomersV2Res.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCustomersV2Res_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomersV2Res
 */
export const SearchCustomersV2Res = new SearchCustomersV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomersV2Res_Result$Type extends MessageType<SearchCustomersV2Res_Result> {
    constructor() {
        super("rd.search.service.SearchCustomersV2Res.Result", [
            { no: 1, name: "customer", kind: "message", T: () => Customer },
            { no: 2, name: "contacts", kind: "message", T: () => Contacts },
            { no: 4, name: "financing_term", kind: "message", T: () => FinancingTerms_Term },
            { no: 5, name: "pricing_tier", kind: "message", T: () => PricingTiers_Tier },
            { no: 6, name: "balance", kind: "message", T: () => CustomerBalance },
            { no: 7, name: "total_balance", kind: "message", T: () => Money },
            { no: 8, name: "financing_term_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "last_interaction", kind: "message", T: () => Interaction },
            { no: 11, name: "rep_staff", kind: "message", T: () => Staff },
            { no: 13, name: "analytics", kind: "message", T: () => CustomerSalesAnalytics },
            { no: 14, name: "finance_charge_setting", kind: "message", T: () => FinanceChargeSetting },
            { no: 15, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tag },
            { no: 16, name: "primary_location", kind: "message", T: () => Location },
            { no: 17, name: "margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 18, name: "last_statement_period", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<SearchCustomersV2Res_Result>): SearchCustomersV2Res_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.financingTermName = "";
        message.tags = [];
        message.marginYtd = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchCustomersV2Res_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomersV2Res_Result): SearchCustomersV2Res_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.customer.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.Contacts contacts */ 2:
                    message.contacts = Contacts.internalBinaryRead(reader, reader.uint32(), options, message.contacts);
                    break;
                case /* rd.company.FinancingTerms.Term financing_term */ 4:
                    message.financingTerm = FinancingTerms_Term.internalBinaryRead(reader, reader.uint32(), options, message.financingTerm);
                    break;
                case /* rd.company.PricingTiers.Tier pricing_tier */ 5:
                    message.pricingTier = PricingTiers_Tier.internalBinaryRead(reader, reader.uint32(), options, message.pricingTier);
                    break;
                case /* rd.txn.CustomerBalance balance */ 6:
                    message.balance = CustomerBalance.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                case /* rd.proto.money.Money total_balance */ 7:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                case /* string financing_term_name */ 8:
                    message.financingTermName = reader.string();
                    break;
                case /* rd.customer.Interaction last_interaction */ 10:
                    message.lastInteraction = Interaction.internalBinaryRead(reader, reader.uint32(), options, message.lastInteraction);
                    break;
                case /* rd.company.Staff rep_staff */ 11:
                    message.repStaff = Staff.internalBinaryRead(reader, reader.uint32(), options, message.repStaff);
                    break;
                case /* rd.txn.CustomerSalesAnalytics analytics */ 13:
                    message.analytics = CustomerSalesAnalytics.internalBinaryRead(reader, reader.uint32(), options, message.analytics);
                    break;
                case /* rd.company.FinanceChargeSetting finance_charge_setting */ 14:
                    message.financeChargeSetting = FinanceChargeSetting.internalBinaryRead(reader, reader.uint32(), options, message.financeChargeSetting);
                    break;
                case /* repeated rd.tag.Tag tags */ 15:
                    message.tags.push(Tag.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.company.Location primary_location */ 16:
                    message.primaryLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.primaryLocation);
                    break;
                case /* float margin_ytd */ 17:
                    message.marginYtd = reader.float();
                    break;
                case /* rd.proto.timestamprange.TimestampRange last_statement_period */ 18:
                    message.lastStatementPeriod = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.lastStatementPeriod);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomersV2Res_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.customer.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts contacts = 2; */
        if (message.contacts)
            Contacts.internalBinaryWrite(message.contacts, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.FinancingTerms.Term financing_term = 4; */
        if (message.financingTerm)
            FinancingTerms_Term.internalBinaryWrite(message.financingTerm, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingTiers.Tier pricing_tier = 5; */
        if (message.pricingTier)
            PricingTiers_Tier.internalBinaryWrite(message.pricingTier, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerBalance balance = 6; */
        if (message.balance)
            CustomerBalance.internalBinaryWrite(message.balance, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 7; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string financing_term_name = 8; */
        if (message.financingTermName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.financingTermName);
        /* rd.customer.Interaction last_interaction = 10; */
        if (message.lastInteraction)
            Interaction.internalBinaryWrite(message.lastInteraction, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Staff rep_staff = 11; */
        if (message.repStaff)
            Staff.internalBinaryWrite(message.repStaff, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerSalesAnalytics analytics = 13; */
        if (message.analytics)
            CustomerSalesAnalytics.internalBinaryWrite(message.analytics, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.FinanceChargeSetting finance_charge_setting = 14; */
        if (message.financeChargeSetting)
            FinanceChargeSetting.internalBinaryWrite(message.financeChargeSetting, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.tag.Tag tags = 15; */
        for (let i = 0; i < message.tags.length; i++)
            Tag.internalBinaryWrite(message.tags[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location primary_location = 16; */
        if (message.primaryLocation)
            Location.internalBinaryWrite(message.primaryLocation, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* float margin_ytd = 17; */
        if (message.marginYtd !== 0)
            writer.tag(17, WireType.Bit32).float(message.marginYtd);
        /* rd.proto.timestamprange.TimestampRange last_statement_period = 18; */
        if (message.lastStatementPeriod)
            TimestampRange.internalBinaryWrite(message.lastStatementPeriod, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomersV2Res.Result
 */
export const SearchCustomersV2Res_Result = new SearchCustomersV2Res_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomersReq$Type extends MessageType<BulkExportCustomersReq> {
    constructor() {
        super("rd.search.service.BulkExportCustomersReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_on_credit_hold_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 6, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 8, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCustomersBy", OrderCustomersBy, "ORDER_CUSTOMERS_BY_"] },
            { no: 9, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 10, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "finance_charge_setting_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "primary_location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "origins", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.customer.Customer.Origin", Customer_Origin, "ORIGIN_"] }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomersReq>): BulkExportCustomersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.isOnCreditHoldFilter = 0;
        message.repStaffIds = [];
        message.isActiveFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isTemplate = false;
        message.financeChargeSettingIds = [];
        message.tagIds = [];
        message.primaryLocationIds = [];
        message.origins = [];
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomersReq): BulkExportCustomersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string financing_term_id_strings */ 3:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 4:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* rd.search.service.BoolFilter is_on_credit_hold_filter */ 5:
                    message.isOnCreditHoldFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 6:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 7:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.OrderCustomersBy order_by */ 8:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 9:
                    message.sortOrder = reader.int32();
                    break;
                case /* bool is_template */ 10:
                    message.isTemplate = reader.bool();
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_setting_ids */ 11:
                    message.financeChargeSettingIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 12:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID primary_location_ids */ 13:
                    message.primaryLocationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.customer.Customer.Origin origins */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.origins.push(reader.int32());
                    else
                        message.origins.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string financing_term_id_strings = 3; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 4; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* rd.search.service.BoolFilter is_on_credit_hold_filter = 5; */
        if (message.isOnCreditHoldFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isOnCreditHoldFilter);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 6; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_active_filter = 7; */
        if (message.isActiveFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.OrderCustomersBy order_by = 8; */
        if (message.orderBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 9; */
        if (message.sortOrder !== 0)
            writer.tag(9, WireType.Varint).int32(message.sortOrder);
        /* bool is_template = 10; */
        if (message.isTemplate !== false)
            writer.tag(10, WireType.Varint).bool(message.isTemplate);
        /* repeated rd.proto.uuid.UUID finance_charge_setting_ids = 11; */
        for (let i = 0; i < message.financeChargeSettingIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 12; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID primary_location_ids = 13; */
        for (let i = 0; i < message.primaryLocationIds.length; i++)
            UUID.internalBinaryWrite(message.primaryLocationIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.customer.Customer.Origin origins = 14; */
        if (message.origins.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.origins.length; i++)
                writer.int32(message.origins[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomersReq
 */
export const BulkExportCustomersReq = new BulkExportCustomersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomersRes$Type extends MessageType<BulkExportCustomersRes> {
    constructor() {
        super("rd.search.service.BulkExportCustomersRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomersRes>): BulkExportCustomersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomersRes): BulkExportCustomersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomersRes
 */
export const BulkExportCustomersRes = new BulkExportCustomersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerContactsReq$Type extends MessageType<SearchCustomerContactsReq> {
    constructor() {
        super("rd.search.service.SearchCustomerContactsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "should_email_invoices_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 4, name: "should_email_statements_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCustomerContactsBy", OrderCustomerContactsBy, "ORDER_CUSTOMER_CONTACTS_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "sms_consent_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 11, name: "customer_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerContactsReq>): SearchCustomerContactsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.shouldEmailInvoicesFilter = 0;
        message.shouldEmailStatementsFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.smsConsentFilter = 0;
        message.customerTagIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerContactsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerContactsReq): SearchCustomerContactsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 2:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter should_email_invoices_filter */ 3:
                    message.shouldEmailInvoicesFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter should_email_statements_filter */ 4:
                    message.shouldEmailStatementsFilter = reader.int32();
                    break;
                case /* rd.search.service.OrderCustomerContactsBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* string cursor */ 7:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 8:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 9:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter sms_consent_filter */ 10:
                    message.smsConsentFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_tag_ids */ 11:
                    message.customerTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerContactsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID customer_ids = 2; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter should_email_invoices_filter = 3; */
        if (message.shouldEmailInvoicesFilter !== 0)
            writer.tag(3, WireType.Varint).int32(message.shouldEmailInvoicesFilter);
        /* rd.search.service.BoolFilter should_email_statements_filter = 4; */
        if (message.shouldEmailStatementsFilter !== 0)
            writer.tag(4, WireType.Varint).int32(message.shouldEmailStatementsFilter);
        /* rd.search.service.OrderCustomerContactsBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* string cursor = 7; */
        if (message.cursor !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 8; */
        if (message.offset !== 0)
            writer.tag(8, WireType.Varint).int32(message.offset);
        /* int32 limit = 9; */
        if (message.limit !== 0)
            writer.tag(9, WireType.Varint).int32(message.limit);
        /* rd.search.service.BoolFilter sms_consent_filter = 10; */
        if (message.smsConsentFilter !== 0)
            writer.tag(10, WireType.Varint).int32(message.smsConsentFilter);
        /* repeated rd.proto.uuid.UUID customer_tag_ids = 11; */
        for (let i = 0; i < message.customerTagIds.length; i++)
            UUID.internalBinaryWrite(message.customerTagIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerContactsReq
 */
export const SearchCustomerContactsReq = new SearchCustomerContactsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerContactsRes$Type extends MessageType<SearchCustomerContactsRes> {
    constructor() {
        super("rd.search.service.SearchCustomerContactsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCustomerContactsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerContactsRes>): SearchCustomerContactsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerContactsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerContactsRes): SearchCustomerContactsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCustomerContactsRes.Result results */ 1:
                    message.results.push(SearchCustomerContactsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerContactsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCustomerContactsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCustomerContactsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerContactsRes
 */
export const SearchCustomerContactsRes = new SearchCustomerContactsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerContactsRes_Result$Type extends MessageType<SearchCustomerContactsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCustomerContactsRes.Result", [
            { no: 1, name: "customer", kind: "message", T: () => Customer },
            { no: 2, name: "contact", kind: "message", T: () => Contacts_Contact }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerContactsRes_Result>): SearchCustomerContactsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerContactsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerContactsRes_Result): SearchCustomerContactsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.customer.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.Contacts.Contact contact */ 2:
                    message.contact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.contact);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerContactsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.customer.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact contact = 2; */
        if (message.contact)
            Contacts_Contact.internalBinaryWrite(message.contact, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerContactsRes.Result
 */
export const SearchCustomerContactsRes_Result = new SearchCustomerContactsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomerContactsReq$Type extends MessageType<BulkExportCustomerContactsReq> {
    constructor() {
        super("rd.search.service.BulkExportCustomerContactsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "should_email_invoices_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 4, name: "should_email_statements_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCustomerContactsBy", OrderCustomerContactsBy, "ORDER_CUSTOMER_CONTACTS_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "sms_consent_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "customer_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomerContactsReq>): BulkExportCustomerContactsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.shouldEmailInvoicesFilter = 0;
        message.shouldEmailStatementsFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isTemplate = false;
        message.smsConsentFilter = 0;
        message.customerTagIds = [];
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomerContactsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomerContactsReq): BulkExportCustomerContactsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 2:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter should_email_invoices_filter */ 3:
                    message.shouldEmailInvoicesFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter should_email_statements_filter */ 4:
                    message.shouldEmailStatementsFilter = reader.int32();
                    break;
                case /* rd.search.service.OrderCustomerContactsBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* bool is_template */ 7:
                    message.isTemplate = reader.bool();
                    break;
                case /* rd.search.service.BoolFilter sms_consent_filter */ 8:
                    message.smsConsentFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_tag_ids */ 9:
                    message.customerTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomerContactsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID customer_ids = 2; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter should_email_invoices_filter = 3; */
        if (message.shouldEmailInvoicesFilter !== 0)
            writer.tag(3, WireType.Varint).int32(message.shouldEmailInvoicesFilter);
        /* rd.search.service.BoolFilter should_email_statements_filter = 4; */
        if (message.shouldEmailStatementsFilter !== 0)
            writer.tag(4, WireType.Varint).int32(message.shouldEmailStatementsFilter);
        /* rd.search.service.OrderCustomerContactsBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* bool is_template = 7; */
        if (message.isTemplate !== false)
            writer.tag(7, WireType.Varint).bool(message.isTemplate);
        /* rd.search.service.BoolFilter sms_consent_filter = 8; */
        if (message.smsConsentFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.smsConsentFilter);
        /* repeated rd.proto.uuid.UUID customer_tag_ids = 9; */
        for (let i = 0; i < message.customerTagIds.length; i++)
            UUID.internalBinaryWrite(message.customerTagIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomerContactsReq
 */
export const BulkExportCustomerContactsReq = new BulkExportCustomerContactsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomerContactsRes$Type extends MessageType<BulkExportCustomerContactsRes> {
    constructor() {
        super("rd.search.service.BulkExportCustomerContactsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomerContactsRes>): BulkExportCustomerContactsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomerContactsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomerContactsRes): BulkExportCustomerContactsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomerContactsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomerContactsRes
 */
export const BulkExportCustomerContactsRes = new BulkExportCustomerContactsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrdersReq$Type extends MessageType<SearchOrdersReq> {
    constructor() {
        super("rd.search.service.SearchOrdersReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "ordered_at_range", kind: "message", T: () => TimestampRange },
            { no: 4, name: "received_at_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "voided_at_range", kind: "message", T: () => TimestampRange },
            { no: 6, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Order.Status", Order_Status, "STATUS_"] },
            { no: 8, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "ordered_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "voided_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchOrdersReq>): SearchOrdersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.statuses = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.vendorIds = [];
        message.productIds = [];
        message.createdByIds = [];
        message.orderedByIds = [];
        message.voidedByIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchOrdersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrdersReq): SearchOrdersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange ordered_at_range */ 3:
                    message.orderedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.orderedAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange received_at_range */ 4:
                    message.receivedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.receivedAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange voided_at_range */ 5:
                    message.voidedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.voidedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 6:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Order.Status statuses */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* string cursor */ 8:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 9:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 10:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 11:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 12:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 13:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID ordered_by_ids */ 14:
                    message.orderedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID voided_by_ids */ 16:
                    message.voidedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrdersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange ordered_at_range = 3; */
        if (message.orderedAtRange)
            TimestampRange.internalBinaryWrite(message.orderedAtRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange received_at_range = 4; */
        if (message.receivedAtRange)
            TimestampRange.internalBinaryWrite(message.receivedAtRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange voided_at_range = 5; */
        if (message.voidedAtRange)
            TimestampRange.internalBinaryWrite(message.voidedAtRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 6; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Order.Status statuses = 7; */
        if (message.statuses.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* string cursor = 8; */
        if (message.cursor !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 9; */
        if (message.offset !== 0)
            writer.tag(9, WireType.Varint).int32(message.offset);
        /* int32 limit = 10; */
        if (message.limit !== 0)
            writer.tag(10, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID vendor_ids = 11; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 12; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID created_by_ids = 13; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID ordered_by_ids = 14; */
        for (let i = 0; i < message.orderedByIds.length; i++)
            UUID.internalBinaryWrite(message.orderedByIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID voided_by_ids = 16; */
        for (let i = 0; i < message.voidedByIds.length; i++)
            UUID.internalBinaryWrite(message.voidedByIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrdersReq
 */
export const SearchOrdersReq = new SearchOrdersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrdersRes$Type extends MessageType<SearchOrdersRes> {
    constructor() {
        super("rd.search.service.SearchOrdersRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchOrdersRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchOrdersRes>): SearchOrdersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchOrdersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrdersRes): SearchOrdersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchOrdersRes.Result results */ 1:
                    message.results.push(SearchOrdersRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrdersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchOrdersRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchOrdersRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrdersRes
 */
export const SearchOrdersRes = new SearchOrdersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrdersRes_Result$Type extends MessageType<SearchOrdersRes_Result> {
    constructor() {
        super("rd.search.service.SearchOrdersRes.Result", [
            { no: 1, name: "order", kind: "message", T: () => Order },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "location", kind: "message", T: () => Location },
            { no: 4, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 5, name: "matched_products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 6, name: "total", kind: "message", T: () => Money },
            { no: 7, name: "order_shipments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrderShipment }
        ]);
    }
    create(value?: PartialMessage<SearchOrdersRes_Result>): SearchOrdersRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        message.matchedProductsById = {};
        message.orderShipments = [];
        if (value !== undefined)
            reflectionMergePartial<SearchOrdersRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrdersRes_Result): SearchOrdersRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Order order */ 1:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.company.Location location */ 3:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 4:
                    this.binaryReadMap4(message.productsById, reader, options);
                    break;
                case /* map<string, rd.product.Product> matched_products_by_id */ 5:
                    this.binaryReadMap5(message.matchedProductsById, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 6:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* repeated rd.txn.OrderShipment order_shipments */ 7:
                    message.orderShipments.push(OrderShipment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SearchOrdersRes_Result["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchOrdersRes_Result["productsById"] | undefined, val: SearchOrdersRes_Result["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchOrdersRes.Result.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    private binaryReadMap5(map: SearchOrdersRes_Result["matchedProductsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchOrdersRes_Result["matchedProductsById"] | undefined, val: SearchOrdersRes_Result["matchedProductsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchOrdersRes.Result.matched_products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    internalBinaryWrite(message: SearchOrdersRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Order order = 1; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 3; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 4; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.product.Product> matched_products_by_id = 5; */
        for (let k of globalThis.Object.keys(message.matchedProductsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.matchedProductsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 6; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.OrderShipment order_shipments = 7; */
        for (let i = 0; i < message.orderShipments.length; i++)
            OrderShipment.internalBinaryWrite(message.orderShipments[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrdersRes.Result
 */
export const SearchOrdersRes_Result = new SearchOrdersRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsReq$Type extends MessageType<SearchOrderShipmentsReq> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "timestamp_range", kind: "message", T: () => TimestampRange },
            { no: 12, name: "status", kind: "enum", T: () => ["rd.txn.OrderShipment.Status", OrderShipment_Status, "STATUS_"] },
            { no: 13, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "received_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 17, name: "marked_paid_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "vouchered_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsReq>): SearchOrderShipmentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.status = 0;
        message.vendorIds = [];
        message.productIds = [];
        message.receivedByIds = [];
        message.markedPaidByIds = [];
        message.voucheredByIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsReq): SearchOrderShipmentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 3:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 4:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 5:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange timestamp_range */ 11:
                    message.timestampRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.timestampRange);
                    break;
                case /* rd.txn.OrderShipment.Status status */ 12:
                    message.status = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 13:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 14:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID received_by_ids */ 16:
                    message.receivedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID marked_paid_by_ids */ 17:
                    message.markedPaidByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vouchered_by_ids */ 18:
                    message.voucheredByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrderShipmentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID location_ids = 3; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 4; */
        if (message.cursor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 5; */
        if (message.offset !== 0)
            writer.tag(5, WireType.Varint).int32(message.offset);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* rd.proto.timestamprange.TimestampRange timestamp_range = 11; */
        if (message.timestampRange)
            TimestampRange.internalBinaryWrite(message.timestampRange, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.OrderShipment.Status status = 12; */
        if (message.status !== 0)
            writer.tag(12, WireType.Varint).int32(message.status);
        /* repeated rd.proto.uuid.UUID vendor_ids = 13; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 14; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID received_by_ids = 16; */
        for (let i = 0; i < message.receivedByIds.length; i++)
            UUID.internalBinaryWrite(message.receivedByIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID marked_paid_by_ids = 17; */
        for (let i = 0; i < message.markedPaidByIds.length; i++)
            UUID.internalBinaryWrite(message.markedPaidByIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vouchered_by_ids = 18; */
        for (let i = 0; i < message.voucheredByIds.length; i++)
            UUID.internalBinaryWrite(message.voucheredByIds[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsReq
 */
export const SearchOrderShipmentsReq = new SearchOrderShipmentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsRes$Type extends MessageType<SearchOrderShipmentsRes> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchOrderShipmentsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsRes>): SearchOrderShipmentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsRes): SearchOrderShipmentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchOrderShipmentsRes.Result results */ 1:
                    message.results.push(SearchOrderShipmentsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrderShipmentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchOrderShipmentsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchOrderShipmentsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsRes
 */
export const SearchOrderShipmentsRes = new SearchOrderShipmentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsRes_Result$Type extends MessageType<SearchOrderShipmentsRes_Result> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsRes.Result", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "location", kind: "message", T: () => Location },
            { no: 4, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 5, name: "matched_products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 6, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsRes_Result>): SearchOrderShipmentsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        message.matchedProductsById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsRes_Result): SearchOrderShipmentsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.company.Location location */ 3:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 4:
                    this.binaryReadMap4(message.productsById, reader, options);
                    break;
                case /* map<string, rd.product.Product> matched_products_by_id */ 5:
                    this.binaryReadMap5(message.matchedProductsById, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 6:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SearchOrderShipmentsRes_Result["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchOrderShipmentsRes_Result["productsById"] | undefined, val: SearchOrderShipmentsRes_Result["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchOrderShipmentsRes.Result.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    private binaryReadMap5(map: SearchOrderShipmentsRes_Result["matchedProductsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchOrderShipmentsRes_Result["matchedProductsById"] | undefined, val: SearchOrderShipmentsRes_Result["matchedProductsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchOrderShipmentsRes.Result.matched_products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    internalBinaryWrite(message: SearchOrderShipmentsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 3; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 4; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.product.Product> matched_products_by_id = 5; */
        for (let k of globalThis.Object.keys(message.matchedProductsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.matchedProductsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 6; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsRes.Result
 */
export const SearchOrderShipmentsRes_Result = new SearchOrderShipmentsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductsV2Req$Type extends MessageType<SearchProductsV2Req> {
    constructor() {
        super("rd.search.service.SearchProductsV2Req", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inv_sort_location_id", kind: "message", T: () => UUID },
            { no: 3, name: "current_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 5, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "additional_fee_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "is_tintable_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 10, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchProductsV2Req.OrderBy", SearchProductsV2Req_OrderBy, "ORDER_BY_"] },
            { no: 14, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 15, name: "tax_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.product.Product.TaxStatus", Product_TaxStatus, "TAX_STATUS_"] },
            { no: 16, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 17, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 19, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 20, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 21, name: "integrated_vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 22, name: "gift_card_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.giftcard.GiftCard.Type", GiftCard_Type, "TYPE_"] },
            { no: 23, name: "filter_no_department", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "filter_no_class", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "filter_no_fineline", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "is_ecomm_enabled_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 27, name: "is_in_stock_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 28, name: "is_non_stock_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 29, name: "is_special_orderable_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 30, name: "has_price_change_since_print_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 31, name: "is_bub_export_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 32, name: "kit_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.product.Product.KitType", Product_KitType, "KIT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchProductsV2Req>): SearchProductsV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.vendorIds = [];
        message.additionalFeeIdStrings = [];
        message.isActiveFilter = 0;
        message.isTintableFilter = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.taxStatuses = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.tagIds = [];
        message.productIds = [];
        message.integratedVendorIds = [];
        message.giftCardTypes = [];
        message.filterNoDepartment = false;
        message.filterNoClass = false;
        message.filterNoFineline = false;
        message.isEcommEnabledFilter = 0;
        message.isInStockFilter = 0;
        message.isNonStockFilter = 0;
        message.isSpecialOrderableFilter = 0;
        message.hasPriceChangeSincePrintFilter = 0;
        message.isBubExportFilter = 0;
        message.kitTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchProductsV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductsV2Req): SearchProductsV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID inv_sort_location_id */ 2:
                    message.invSortLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.invSortLocationId);
                    break;
                case /* rd.proto.uuid.UUID current_location_id */ 3:
                    message.currentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentLocationId);
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 5:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_id_strings */ 6:
                    message.additionalFeeIdStrings.push(reader.string());
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 7:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_tintable_filter */ 9:
                    message.isTintableFilter = reader.int32();
                    break;
                case /* string cursor */ 10:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 11:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 12:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchProductsV2Req.OrderBy order_by */ 13:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 14:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.product.Product.TaxStatus tax_statuses */ 15:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taxStatuses.push(reader.int32());
                    else
                        message.taxStatuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 16:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 17:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 18:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 19:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 20:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID integrated_vendor_ids */ 21:
                    message.integratedVendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.giftcard.GiftCard.Type gift_card_types */ 22:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.giftCardTypes.push(reader.int32());
                    else
                        message.giftCardTypes.push(reader.int32());
                    break;
                case /* bool filter_no_department */ 23:
                    message.filterNoDepartment = reader.bool();
                    break;
                case /* bool filter_no_class */ 24:
                    message.filterNoClass = reader.bool();
                    break;
                case /* bool filter_no_fineline */ 25:
                    message.filterNoFineline = reader.bool();
                    break;
                case /* rd.search.service.BoolFilter is_ecomm_enabled_filter */ 26:
                    message.isEcommEnabledFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_in_stock_filter */ 27:
                    message.isInStockFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_non_stock_filter */ 28:
                    message.isNonStockFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_special_orderable_filter */ 29:
                    message.isSpecialOrderableFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter has_price_change_since_print_filter */ 30:
                    message.hasPriceChangeSincePrintFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_bub_export_filter */ 31:
                    message.isBubExportFilter = reader.int32();
                    break;
                case /* repeated rd.product.Product.KitType kit_types */ 32:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.kitTypes.push(reader.int32());
                    else
                        message.kitTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchProductsV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID inv_sort_location_id = 2; */
        if (message.invSortLocationId)
            UUID.internalBinaryWrite(message.invSortLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_location_id = 3; */
        if (message.currentLocationId)
            UUID.internalBinaryWrite(message.currentLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 5; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_id_strings = 6; */
        for (let i = 0; i < message.additionalFeeIdStrings.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.additionalFeeIdStrings[i]);
        /* rd.search.service.BoolFilter is_active_filter = 7; */
        if (message.isActiveFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.BoolFilter is_tintable_filter = 9; */
        if (message.isTintableFilter !== 0)
            writer.tag(9, WireType.Varint).int32(message.isTintableFilter);
        /* string cursor = 10; */
        if (message.cursor !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 11; */
        if (message.offset !== 0)
            writer.tag(11, WireType.Varint).int32(message.offset);
        /* int32 limit = 12; */
        if (message.limit !== 0)
            writer.tag(12, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchProductsV2Req.OrderBy order_by = 13; */
        if (message.orderBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 14; */
        if (message.sortOrder !== 0)
            writer.tag(14, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.product.Product.TaxStatus tax_statuses = 15; */
        if (message.taxStatuses.length) {
            writer.tag(15, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taxStatuses.length; i++)
                writer.int32(message.taxStatuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID department_ids = 16; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 17; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 18; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 19; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 20; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID integrated_vendor_ids = 21; */
        for (let i = 0; i < message.integratedVendorIds.length; i++)
            UUID.internalBinaryWrite(message.integratedVendorIds[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.giftcard.GiftCard.Type gift_card_types = 22; */
        if (message.giftCardTypes.length) {
            writer.tag(22, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.giftCardTypes.length; i++)
                writer.int32(message.giftCardTypes[i]);
            writer.join();
        }
        /* bool filter_no_department = 23; */
        if (message.filterNoDepartment !== false)
            writer.tag(23, WireType.Varint).bool(message.filterNoDepartment);
        /* bool filter_no_class = 24; */
        if (message.filterNoClass !== false)
            writer.tag(24, WireType.Varint).bool(message.filterNoClass);
        /* bool filter_no_fineline = 25; */
        if (message.filterNoFineline !== false)
            writer.tag(25, WireType.Varint).bool(message.filterNoFineline);
        /* rd.search.service.BoolFilter is_ecomm_enabled_filter = 26; */
        if (message.isEcommEnabledFilter !== 0)
            writer.tag(26, WireType.Varint).int32(message.isEcommEnabledFilter);
        /* rd.search.service.BoolFilter is_in_stock_filter = 27; */
        if (message.isInStockFilter !== 0)
            writer.tag(27, WireType.Varint).int32(message.isInStockFilter);
        /* rd.search.service.BoolFilter is_non_stock_filter = 28; */
        if (message.isNonStockFilter !== 0)
            writer.tag(28, WireType.Varint).int32(message.isNonStockFilter);
        /* rd.search.service.BoolFilter is_special_orderable_filter = 29; */
        if (message.isSpecialOrderableFilter !== 0)
            writer.tag(29, WireType.Varint).int32(message.isSpecialOrderableFilter);
        /* rd.search.service.BoolFilter has_price_change_since_print_filter = 30; */
        if (message.hasPriceChangeSincePrintFilter !== 0)
            writer.tag(30, WireType.Varint).int32(message.hasPriceChangeSincePrintFilter);
        /* rd.search.service.BoolFilter is_bub_export_filter = 31; */
        if (message.isBubExportFilter !== 0)
            writer.tag(31, WireType.Varint).int32(message.isBubExportFilter);
        /* repeated rd.product.Product.KitType kit_types = 32; */
        if (message.kitTypes.length) {
            writer.tag(32, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.kitTypes.length; i++)
                writer.int32(message.kitTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductsV2Req
 */
export const SearchProductsV2Req = new SearchProductsV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductsV2Res$Type extends MessageType<SearchProductsV2Res> {
    constructor() {
        super("rd.search.service.SearchProductsV2Res", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchProductsV2Res_Result },
            { no: 2, name: "locations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Location } },
            { no: 3, name: "pricing_tiers", kind: "message", T: () => PricingTiers },
            { no: 4, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchProductsV2Res>): SearchProductsV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.locationsById = {};
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchProductsV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductsV2Res): SearchProductsV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchProductsV2Res.Result results */ 1:
                    message.results.push(SearchProductsV2Res_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.company.Location> locations_by_id */ 2:
                    this.binaryReadMap2(message.locationsById, reader, options);
                    break;
                case /* rd.company.PricingTiers pricing_tiers */ 3:
                    message.pricingTiers = PricingTiers.internalBinaryRead(reader, reader.uint32(), options, message.pricingTiers);
                    break;
                case /* string cursor */ 4:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SearchProductsV2Res["locationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchProductsV2Res["locationsById"] | undefined, val: SearchProductsV2Res["locationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Location.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchProductsV2Res.locations_by_id");
            }
        }
        map[key ?? ""] = val ?? Location.create();
    }
    internalBinaryWrite(message: SearchProductsV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchProductsV2Res.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchProductsV2Res_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.company.Location> locations_by_id = 2; */
        for (let k of globalThis.Object.keys(message.locationsById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Location.internalBinaryWrite(message.locationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.company.PricingTiers pricing_tiers = 3; */
        if (message.pricingTiers)
            PricingTiers.internalBinaryWrite(message.pricingTiers, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 4; */
        if (message.cursor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductsV2Res
 */
export const SearchProductsV2Res = new SearchProductsV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductsV2Res_Result$Type extends MessageType<SearchProductsV2Res_Result> {
    constructor() {
        super("rd.search.service.SearchProductsV2Res.Result", [
            { no: 1, name: "product", kind: "message", T: () => Product },
            { no: 2, name: "matched_price_product", kind: "message", T: () => Product },
            { no: 3, name: "matched_cost_product", kind: "message", T: () => Product },
            { no: 4, name: "inventories", kind: "message", T: () => Inventories },
            { no: 5, name: "primary_cost_vendor", kind: "message", T: () => Vendor },
            { no: 10, name: "analytics", kind: "message", T: () => ProductSalesAnalytics },
            { no: 11, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 12, name: "department", kind: "message", T: () => ProductCategory },
            { no: 13, name: "class", kind: "message", T: () => ProductCategory },
            { no: 14, name: "fineline", kind: "message", T: () => ProductCategory },
            { no: 15, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier },
            { no: 16, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tag },
            { no: 17, name: "margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 18, name: "vendor_skus", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VendorSKU },
            { no: 19, name: "delta_v2", kind: "message", T: () => Decimal },
            { no: 20, name: "image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "sale_form", kind: "message", T: () => SaleForm },
            { no: 22, name: "upcs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "additional_fees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdditionalFees_Fee },
            { no: 24, name: "tier_prices_by_region", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RegionTierPrices },
            { no: 25, name: "product_label", kind: "message", T: () => ProductLabel }
        ]);
    }
    create(value?: PartialMessage<SearchProductsV2Res_Result>): SearchProductsV2Res_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierPrices = [];
        message.tags = [];
        message.marginYtd = 0;
        message.vendorSkus = [];
        message.imageUrl = "";
        message.upcs = [];
        message.additionalFees = [];
        message.tierPricesByRegion = [];
        if (value !== undefined)
            reflectionMergePartial<SearchProductsV2Res_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductsV2Res_Result): SearchProductsV2Res_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.Product product */ 1:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.product.Product matched_price_product */ 2:
                    message.matchedPriceProduct = Product.internalBinaryRead(reader, reader.uint32(), options, message.matchedPriceProduct);
                    break;
                case /* rd.product.Product matched_cost_product */ 3:
                    message.matchedCostProduct = Product.internalBinaryRead(reader, reader.uint32(), options, message.matchedCostProduct);
                    break;
                case /* rd.product.Inventories inventories */ 4:
                    message.inventories = Inventories.internalBinaryRead(reader, reader.uint32(), options, message.inventories);
                    break;
                case /* rd.vendors.Vendor primary_cost_vendor */ 5:
                    message.primaryCostVendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.primaryCostVendor);
                    break;
                case /* rd.txn.ProductSalesAnalytics analytics */ 10:
                    message.analytics = ProductSalesAnalytics.internalBinaryRead(reader, reader.uint32(), options, message.analytics);
                    break;
                case /* rd.catalog.Product catalog_product */ 11:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* rd.company.ProductCategory department */ 12:
                    message.department = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* rd.company.ProductCategory class */ 13:
                    message.class = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.class);
                    break;
                case /* rd.company.ProductCategory fineline */ 14:
                    message.fineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.fineline);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 15:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.tag.Tag tags */ 16:
                    message.tags.push(Tag.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float margin_ytd */ 17:
                    message.marginYtd = reader.float();
                    break;
                case /* repeated rd.product.VendorSKU vendor_skus */ 18:
                    message.vendorSkus.push(VendorSKU.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.decimal.Decimal delta_v2 */ 19:
                    message.deltaV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.deltaV2);
                    break;
                case /* string image_url */ 20:
                    message.imageUrl = reader.string();
                    break;
                case /* rd.company.SaleForm sale_form */ 21:
                    message.saleForm = SaleForm.internalBinaryRead(reader, reader.uint32(), options, message.saleForm);
                    break;
                case /* repeated string upcs */ 22:
                    message.upcs.push(reader.string());
                    break;
                case /* repeated rd.company.AdditionalFees.Fee additional_fees */ 23:
                    message.additionalFees.push(AdditionalFees_Fee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.price.RegionTierPrices tier_prices_by_region */ 24:
                    message.tierPricesByRegion.push(RegionTierPrices.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.product.ProductLabel product_label */ 25:
                    message.productLabel = ProductLabel.internalBinaryRead(reader, reader.uint32(), options, message.productLabel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchProductsV2Res_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.Product product = 1; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product matched_price_product = 2; */
        if (message.matchedPriceProduct)
            Product.internalBinaryWrite(message.matchedPriceProduct, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product matched_cost_product = 3; */
        if (message.matchedCostProduct)
            Product.internalBinaryWrite(message.matchedCostProduct, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Inventories inventories = 4; */
        if (message.inventories)
            Inventories.internalBinaryWrite(message.inventories, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor primary_cost_vendor = 5; */
        if (message.primaryCostVendor)
            Vendor.internalBinaryWrite(message.primaryCostVendor, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.ProductSalesAnalytics analytics = 10; */
        if (message.analytics)
            ProductSalesAnalytics.internalBinaryWrite(message.analytics, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product catalog_product = 11; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory department = 12; */
        if (message.department)
            ProductCategory.internalBinaryWrite(message.department, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory class = 13; */
        if (message.class)
            ProductCategory.internalBinaryWrite(message.class, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory fineline = 14; */
        if (message.fineline)
            ProductCategory.internalBinaryWrite(message.fineline, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 15; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.tag.Tag tags = 16; */
        for (let i = 0; i < message.tags.length; i++)
            Tag.internalBinaryWrite(message.tags[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* float margin_ytd = 17; */
        if (message.marginYtd !== 0)
            writer.tag(17, WireType.Bit32).float(message.marginYtd);
        /* repeated rd.product.VendorSKU vendor_skus = 18; */
        for (let i = 0; i < message.vendorSkus.length; i++)
            VendorSKU.internalBinaryWrite(message.vendorSkus[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal delta_v2 = 19; */
        if (message.deltaV2)
            Decimal.internalBinaryWrite(message.deltaV2, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string image_url = 20; */
        if (message.imageUrl !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.imageUrl);
        /* rd.company.SaleForm sale_form = 21; */
        if (message.saleForm)
            SaleForm.internalBinaryWrite(message.saleForm, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated string upcs = 22; */
        for (let i = 0; i < message.upcs.length; i++)
            writer.tag(22, WireType.LengthDelimited).string(message.upcs[i]);
        /* repeated rd.company.AdditionalFees.Fee additional_fees = 23; */
        for (let i = 0; i < message.additionalFees.length; i++)
            AdditionalFees_Fee.internalBinaryWrite(message.additionalFees[i], writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.RegionTierPrices tier_prices_by_region = 24; */
        for (let i = 0; i < message.tierPricesByRegion.length; i++)
            RegionTierPrices.internalBinaryWrite(message.tierPricesByRegion[i], writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.ProductLabel product_label = 25; */
        if (message.productLabel)
            ProductLabel.internalBinaryWrite(message.productLabel, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductsV2Res.Result
 */
export const SearchProductsV2Res_Result = new SearchProductsV2Res_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportProductsReq$Type extends MessageType<BulkExportProductsReq> {
    constructor() {
        super("rd.search.service.BulkExportProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inv_sort_location_id", kind: "message", T: () => UUID },
            { no: 3, name: "current_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 5, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "additional_fee_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 8, name: "is_tintable_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchProductOrderBy", SearchProductOrderBy] },
            { no: 10, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 11, name: "tax_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.product.Product.TaxStatus", Product_TaxStatus, "TAX_STATUS_"] },
            { no: 16, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 19, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 20, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 21, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 22, name: "output_to_gcs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportProductsReq>): BulkExportProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.vendorIds = [];
        message.additionalFeeIdStrings = [];
        message.isActiveFilter = 0;
        message.isTintableFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.taxStatuses = [];
        message.isTemplate = false;
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.productIds = [];
        message.tagIds = [];
        message.outputToGcs = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportProductsReq): BulkExportProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID inv_sort_location_id */ 2:
                    message.invSortLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.invSortLocationId);
                    break;
                case /* rd.proto.uuid.UUID current_location_id */ 3:
                    message.currentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentLocationId);
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 5:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_id_strings */ 6:
                    message.additionalFeeIdStrings.push(reader.string());
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 7:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_tintable_filter */ 8:
                    message.isTintableFilter = reader.int32();
                    break;
                case /* rd.search.service.SearchProductOrderBy order_by */ 9:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 10:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.product.Product.TaxStatus tax_statuses */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taxStatuses.push(reader.int32());
                    else
                        message.taxStatuses.push(reader.int32());
                    break;
                case /* bool is_template */ 16:
                    message.isTemplate = reader.bool();
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 17:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 18:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 19:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 20:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 21:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool output_to_gcs */ 22:
                    message.outputToGcs = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID inv_sort_location_id = 2; */
        if (message.invSortLocationId)
            UUID.internalBinaryWrite(message.invSortLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_location_id = 3; */
        if (message.currentLocationId)
            UUID.internalBinaryWrite(message.currentLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 5; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_id_strings = 6; */
        for (let i = 0; i < message.additionalFeeIdStrings.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.additionalFeeIdStrings[i]);
        /* rd.search.service.BoolFilter is_active_filter = 7; */
        if (message.isActiveFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.BoolFilter is_tintable_filter = 8; */
        if (message.isTintableFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.isTintableFilter);
        /* rd.search.service.SearchProductOrderBy order_by = 9; */
        if (message.orderBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 10; */
        if (message.sortOrder !== 0)
            writer.tag(10, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.product.Product.TaxStatus tax_statuses = 11; */
        if (message.taxStatuses.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taxStatuses.length; i++)
                writer.int32(message.taxStatuses[i]);
            writer.join();
        }
        /* bool is_template = 16; */
        if (message.isTemplate !== false)
            writer.tag(16, WireType.Varint).bool(message.isTemplate);
        /* repeated rd.proto.uuid.UUID department_ids = 17; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 18; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 19; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 20; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 21; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* bool output_to_gcs = 22; */
        if (message.outputToGcs !== false)
            writer.tag(22, WireType.Varint).bool(message.outputToGcs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportProductsReq
 */
export const BulkExportProductsReq = new BulkExportProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportProductsRes$Type extends MessageType<BulkExportProductsRes> {
    constructor() {
        super("rd.search.service.BulkExportProductsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "gcs_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportProductsRes>): BulkExportProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        message.gcsUrl = "";
        if (value !== undefined)
            reflectionMergePartial<BulkExportProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportProductsRes): BulkExportProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                case /* string gcs_url */ 2:
                    message.gcsUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        /* string gcs_url = 2; */
        if (message.gcsUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.gcsUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportProductsRes
 */
export const BulkExportProductsRes = new BulkExportProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportProductLabelsReq$Type extends MessageType<BulkExportProductLabelsReq> {
    constructor() {
        super("rd.search.service.BulkExportProductLabelsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inv_sort_location_id", kind: "message", T: () => UUID },
            { no: 3, name: "current_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "additional_fee_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 7, name: "is_tintable_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 8, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchProductOrderBy", SearchProductOrderBy] },
            { no: 9, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 10, name: "tax_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.product.Product.TaxStatus", Product_TaxStatus, "TAX_STATUS_"] },
            { no: 11, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "template", kind: "enum", T: () => ["rd.product.LabelTemplate", LabelTemplate, "LABEL_TEMPLATE_"] },
            { no: 16, name: "rotation_degrees", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "label_design_id", kind: "message", T: () => UUID },
            { no: 21, name: "print_settings", kind: "message", T: () => CustomPrintSettings },
            { no: 22, name: "start_position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportProductLabelsReq>): BulkExportProductLabelsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.vendorIds = [];
        message.additionalFeeIdStrings = [];
        message.isActiveFilter = 0;
        message.isTintableFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.taxStatuses = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.tagIds = [];
        message.template = 0;
        message.rotationDegrees = 0;
        message.quantity = 0;
        message.startPosition = 0;
        if (value !== undefined)
            reflectionMergePartial<BulkExportProductLabelsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportProductLabelsReq): BulkExportProductLabelsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID inv_sort_location_id */ 2:
                    message.invSortLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.invSortLocationId);
                    break;
                case /* rd.proto.uuid.UUID current_location_id */ 3:
                    message.currentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentLocationId);
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 4:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_id_strings */ 5:
                    message.additionalFeeIdStrings.push(reader.string());
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 6:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_tintable_filter */ 7:
                    message.isTintableFilter = reader.int32();
                    break;
                case /* rd.search.service.SearchProductOrderBy order_by */ 8:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 9:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.product.Product.TaxStatus tax_statuses */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taxStatuses.push(reader.int32());
                    else
                        message.taxStatuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 11:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 12:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 13:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 14:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.product.LabelTemplate template */ 15:
                    message.template = reader.int32();
                    break;
                case /* int32 rotation_degrees */ 16:
                    message.rotationDegrees = reader.int32();
                    break;
                case /* int32 quantity */ 17:
                    message.quantity = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID label_design_id */ 18:
                    message.labelDesignId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.labelDesignId);
                    break;
                case /* rd.product.CustomPrintSettings print_settings */ 21:
                    message.printSettings = CustomPrintSettings.internalBinaryRead(reader, reader.uint32(), options, message.printSettings);
                    break;
                case /* int32 start_position */ 22:
                    message.startPosition = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportProductLabelsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID inv_sort_location_id = 2; */
        if (message.invSortLocationId)
            UUID.internalBinaryWrite(message.invSortLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_location_id = 3; */
        if (message.currentLocationId)
            UUID.internalBinaryWrite(message.currentLocationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 4; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_id_strings = 5; */
        for (let i = 0; i < message.additionalFeeIdStrings.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.additionalFeeIdStrings[i]);
        /* rd.search.service.BoolFilter is_active_filter = 6; */
        if (message.isActiveFilter !== 0)
            writer.tag(6, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.BoolFilter is_tintable_filter = 7; */
        if (message.isTintableFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isTintableFilter);
        /* rd.search.service.SearchProductOrderBy order_by = 8; */
        if (message.orderBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 9; */
        if (message.sortOrder !== 0)
            writer.tag(9, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.product.Product.TaxStatus tax_statuses = 10; */
        if (message.taxStatuses.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taxStatuses.length; i++)
                writer.int32(message.taxStatuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID department_ids = 11; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 12; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 13; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 14; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.LabelTemplate template = 15; */
        if (message.template !== 0)
            writer.tag(15, WireType.Varint).int32(message.template);
        /* int32 rotation_degrees = 16; */
        if (message.rotationDegrees !== 0)
            writer.tag(16, WireType.Varint).int32(message.rotationDegrees);
        /* int32 quantity = 17; */
        if (message.quantity !== 0)
            writer.tag(17, WireType.Varint).int32(message.quantity);
        /* rd.proto.uuid.UUID label_design_id = 18; */
        if (message.labelDesignId)
            UUID.internalBinaryWrite(message.labelDesignId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.CustomPrintSettings print_settings = 21; */
        if (message.printSettings)
            CustomPrintSettings.internalBinaryWrite(message.printSettings, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* int32 start_position = 22; */
        if (message.startPosition !== 0)
            writer.tag(22, WireType.Varint).int32(message.startPosition);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportProductLabelsReq
 */
export const BulkExportProductLabelsReq = new BulkExportProductLabelsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportProductLabelsRes$Type extends MessageType<BulkExportProductLabelsRes> {
    constructor() {
        super("rd.search.service.BulkExportProductLabelsRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportProductLabelsRes>): BulkExportProductLabelsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportProductLabelsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportProductLabelsRes): BulkExportProductLabelsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportProductLabelsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportProductLabelsRes
 */
export const BulkExportProductLabelsRes = new BulkExportProductLabelsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSalesV2Req$Type extends MessageType<SearchSalesV2Req> {
    constructor() {
        super("rd.search.service.SearchSalesV2Req", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "quoted_at_range", kind: "message", T: () => TimestampRange },
            { no: 4, name: "will_called_at_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "sold_at_range", kind: "message", T: () => TimestampRange },
            { no: 6, name: "voided_at_range", kind: "message", T: () => TimestampRange },
            { no: 7, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "quoted_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "will_called_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "sold_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "voided_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 15, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 19, name: "tint_color_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 20, name: "contains_non_taxable_products_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 22, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 23, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Type", Sale_Type, "TYPE_"] },
            { no: 25, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 26, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 27, name: "special_ordered_at_range", kind: "message", T: () => TimestampRange },
            { no: 28, name: "special_ordered_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 29, name: "fulfillment_location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 31, name: "close_out_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.CloseOutStatus", Sale_CloseOutStatus, "CLOSE_OUT_STATUS_"] },
            { no: 32, name: "sources", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Source", Sale_Source, "SOURCE_"] },
            { no: 33, name: "designated_clerk_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 34, name: "exclude_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 35, name: "is_staged_for_delivery", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchSalesV2Req>): SearchSalesV2Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.createdByIds = [];
        message.quotedByIds = [];
        message.willCalledByIds = [];
        message.soldByIds = [];
        message.voidedByIds = [];
        message.customerIds = [];
        message.locationIds = [];
        message.statuses = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.purchaseOrderIds = [];
        message.tintColorIds = [];
        message.containsNonTaxableProductsFilter = 0;
        message.jobIds = [];
        message.types = [];
        message.productIds = [];
        message.methodIds = [];
        message.specialOrderedByIds = [];
        message.fulfillmentLocationIds = [];
        message.closeOutStatuses = [];
        message.sources = [];
        message.designatedClerkIds = [];
        message.excludeStatuses = [];
        message.isStagedForDelivery = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchSalesV2Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSalesV2Req): SearchSalesV2Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange quoted_at_range */ 3:
                    message.quotedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.quotedAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange will_called_at_range */ 4:
                    message.willCalledAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.willCalledAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange sold_at_range */ 5:
                    message.soldAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.soldAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange voided_at_range */ 6:
                    message.voidedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.voidedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 7:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID quoted_by_ids */ 8:
                    message.quotedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID will_called_by_ids */ 9:
                    message.willCalledByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID sold_by_ids */ 10:
                    message.soldByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID voided_by_ids */ 11:
                    message.voidedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 12:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 13:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Sale.Status statuses */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* string cursor */ 15:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 16:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 17:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 18:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tint_color_ids */ 19:
                    message.tintColorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter contains_non_taxable_products_filter */ 20:
                    message.containsNonTaxableProductsFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 22:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Sale.Type types */ 23:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 25:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 26:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange special_ordered_at_range */ 27:
                    message.specialOrderedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.specialOrderedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID special_ordered_by_ids */ 28:
                    message.specialOrderedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fulfillment_location_ids */ 29:
                    message.fulfillmentLocationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Sale.CloseOutStatus close_out_statuses */ 31:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.closeOutStatuses.push(reader.int32());
                    else
                        message.closeOutStatuses.push(reader.int32());
                    break;
                case /* repeated rd.txn.Sale.Source sources */ 32:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sources.push(reader.int32());
                    else
                        message.sources.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID designated_clerk_ids */ 33:
                    message.designatedClerkIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Sale.Status exclude_statuses */ 34:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.excludeStatuses.push(reader.int32());
                    else
                        message.excludeStatuses.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter is_staged_for_delivery */ 35:
                    message.isStagedForDelivery = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSalesV2Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange quoted_at_range = 3; */
        if (message.quotedAtRange)
            TimestampRange.internalBinaryWrite(message.quotedAtRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange will_called_at_range = 4; */
        if (message.willCalledAtRange)
            TimestampRange.internalBinaryWrite(message.willCalledAtRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange sold_at_range = 5; */
        if (message.soldAtRange)
            TimestampRange.internalBinaryWrite(message.soldAtRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange voided_at_range = 6; */
        if (message.voidedAtRange)
            TimestampRange.internalBinaryWrite(message.voidedAtRange, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID created_by_ids = 7; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID quoted_by_ids = 8; */
        for (let i = 0; i < message.quotedByIds.length; i++)
            UUID.internalBinaryWrite(message.quotedByIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID will_called_by_ids = 9; */
        for (let i = 0; i < message.willCalledByIds.length; i++)
            UUID.internalBinaryWrite(message.willCalledByIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sold_by_ids = 10; */
        for (let i = 0; i < message.soldByIds.length; i++)
            UUID.internalBinaryWrite(message.soldByIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID voided_by_ids = 11; */
        for (let i = 0; i < message.voidedByIds.length; i++)
            UUID.internalBinaryWrite(message.voidedByIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 12; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 13; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale.Status statuses = 14; */
        if (message.statuses.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* string cursor = 15; */
        if (message.cursor !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 16; */
        if (message.offset !== 0)
            writer.tag(16, WireType.Varint).int32(message.offset);
        /* int32 limit = 17; */
        if (message.limit !== 0)
            writer.tag(17, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 18; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tint_color_ids = 19; */
        for (let i = 0; i < message.tintColorIds.length; i++)
            UUID.internalBinaryWrite(message.tintColorIds[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter contains_non_taxable_products_filter = 20; */
        if (message.containsNonTaxableProductsFilter !== 0)
            writer.tag(20, WireType.Varint).int32(message.containsNonTaxableProductsFilter);
        /* repeated rd.proto.uuid.UUID job_ids = 22; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale.Type types = 23; */
        if (message.types.length) {
            writer.tag(23, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID product_ids = 25; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID method_ids = 26; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange special_ordered_at_range = 27; */
        if (message.specialOrderedAtRange)
            TimestampRange.internalBinaryWrite(message.specialOrderedAtRange, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID special_ordered_by_ids = 28; */
        for (let i = 0; i < message.specialOrderedByIds.length; i++)
            UUID.internalBinaryWrite(message.specialOrderedByIds[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fulfillment_location_ids = 29; */
        for (let i = 0; i < message.fulfillmentLocationIds.length; i++)
            UUID.internalBinaryWrite(message.fulfillmentLocationIds[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale.CloseOutStatus close_out_statuses = 31; */
        if (message.closeOutStatuses.length) {
            writer.tag(31, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.closeOutStatuses.length; i++)
                writer.int32(message.closeOutStatuses[i]);
            writer.join();
        }
        /* repeated rd.txn.Sale.Source sources = 32; */
        if (message.sources.length) {
            writer.tag(32, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sources.length; i++)
                writer.int32(message.sources[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID designated_clerk_ids = 33; */
        for (let i = 0; i < message.designatedClerkIds.length; i++)
            UUID.internalBinaryWrite(message.designatedClerkIds[i], writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale.Status exclude_statuses = 34; */
        if (message.excludeStatuses.length) {
            writer.tag(34, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.excludeStatuses.length; i++)
                writer.int32(message.excludeStatuses[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter is_staged_for_delivery = 35; */
        if (message.isStagedForDelivery !== 0)
            writer.tag(35, WireType.Varint).int32(message.isStagedForDelivery);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSalesV2Req
 */
export const SearchSalesV2Req = new SearchSalesV2Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSalesV2Res$Type extends MessageType<SearchSalesV2Res> {
    constructor() {
        super("rd.search.service.SearchSalesV2Res", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchSalesV2Res_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchSalesV2Res>): SearchSalesV2Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSalesV2Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSalesV2Res): SearchSalesV2Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchSalesV2Res.Result results */ 1:
                    message.results.push(SearchSalesV2Res_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSalesV2Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchSalesV2Res.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchSalesV2Res_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSalesV2Res
 */
export const SearchSalesV2Res = new SearchSalesV2Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSalesV2Res_Result$Type extends MessageType<SearchSalesV2Res_Result> {
    constructor() {
        super("rd.search.service.SearchSalesV2Res.Result", [
            { no: 1, name: "sale", kind: "message", T: () => Sale },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "customer", kind: "message", T: () => Customer },
            { no: 4, name: "purchase_order", kind: "message", T: () => PurchaseOrder },
            { no: 6, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 8, name: "tint_colors_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TintColor } },
            { no: 9, name: "total", kind: "message", T: () => Money },
            { no: 10, name: "customer_contact", kind: "message", T: () => Contacts_Contact },
            { no: 12, name: "sale_products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct },
            { no: 15, name: "job", kind: "message", T: () => Customer },
            { no: 16, name: "returns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sale },
            { no: 17, name: "returned_from_sales_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale } },
            { no: 18, name: "returned_in_sales_by_sale_product_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SearchSalesV2Res_Result_ReturnedInSales } },
            { no: 19, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 20, name: "fulfillment_location", kind: "message", T: () => Location },
            { no: 21, name: "gift_cards_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => GiftCard } },
            { no: 22, name: "delivery_stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryStop }
        ]);
    }
    create(value?: PartialMessage<SearchSalesV2Res_Result>): SearchSalesV2Res_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        message.tintColorsById = {};
        message.saleProducts = [];
        message.returns = [];
        message.returnedFromSalesById = {};
        message.returnedInSalesBySaleProductId = {};
        message.giftCardsById = {};
        message.deliveryStops = [];
        if (value !== undefined)
            reflectionMergePartial<SearchSalesV2Res_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSalesV2Res_Result): SearchSalesV2Res_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Sale sale */ 1:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 3:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.PurchaseOrder purchase_order */ 4:
                    message.purchaseOrder = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options, message.purchaseOrder);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 6:
                    this.binaryReadMap6(message.productsById, reader, options);
                    break;
                case /* map<string, rd.tintcolor.TintColor> tint_colors_by_id */ 8:
                    this.binaryReadMap8(message.tintColorsById, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 9:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.customer.Contacts.Contact customer_contact */ 10:
                    message.customerContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.customerContact);
                    break;
                case /* repeated rd.txn.SaleProduct sale_products */ 12:
                    message.saleProducts.push(SaleProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.customer.Customer job */ 15:
                    message.job = Customer.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* repeated rd.txn.Sale returns */ 16:
                    message.returns.push(Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.txn.Sale> returned_from_sales_by_id */ 17:
                    this.binaryReadMap17(message.returnedFromSalesById, reader, options);
                    break;
                case /* map<string, rd.search.service.SearchSalesV2Res.Result.ReturnedInSales> returned_in_sales_by_sale_product_id */ 18:
                    this.binaryReadMap18(message.returnedInSalesBySaleProductId, reader, options);
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 19:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* rd.company.Location fulfillment_location */ 20:
                    message.fulfillmentLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocation);
                    break;
                case /* map<string, rd.giftcard.GiftCard> gift_cards_by_id */ 21:
                    this.binaryReadMap21(message.giftCardsById, reader, options);
                    break;
                case /* repeated rd.txn.DeliveryStop delivery_stops */ 22:
                    message.deliveryStops.push(DeliveryStop.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: SearchSalesV2Res_Result["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchSalesV2Res_Result["productsById"] | undefined, val: SearchSalesV2Res_Result["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchSalesV2Res.Result.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    private binaryReadMap8(map: SearchSalesV2Res_Result["tintColorsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchSalesV2Res_Result["tintColorsById"] | undefined, val: SearchSalesV2Res_Result["tintColorsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TintColor.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchSalesV2Res.Result.tint_colors_by_id");
            }
        }
        map[key ?? ""] = val ?? TintColor.create();
    }
    private binaryReadMap17(map: SearchSalesV2Res_Result["returnedFromSalesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchSalesV2Res_Result["returnedFromSalesById"] | undefined, val: SearchSalesV2Res_Result["returnedFromSalesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchSalesV2Res.Result.returned_from_sales_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale.create();
    }
    private binaryReadMap18(map: SearchSalesV2Res_Result["returnedInSalesBySaleProductId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchSalesV2Res_Result["returnedInSalesBySaleProductId"] | undefined, val: SearchSalesV2Res_Result["returnedInSalesBySaleProductId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SearchSalesV2Res_Result_ReturnedInSales.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchSalesV2Res.Result.returned_in_sales_by_sale_product_id");
            }
        }
        map[key ?? ""] = val ?? SearchSalesV2Res_Result_ReturnedInSales.create();
    }
    private binaryReadMap21(map: SearchSalesV2Res_Result["giftCardsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchSalesV2Res_Result["giftCardsById"] | undefined, val: SearchSalesV2Res_Result["giftCardsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = GiftCard.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchSalesV2Res.Result.gift_cards_by_id");
            }
        }
        map[key ?? ""] = val ?? GiftCard.create();
    }
    internalBinaryWrite(message: SearchSalesV2Res_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Sale sale = 1; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 3; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.PurchaseOrder purchase_order = 4; */
        if (message.purchaseOrder)
            PurchaseOrder.internalBinaryWrite(message.purchaseOrder, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 6; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.tintcolor.TintColor> tint_colors_by_id = 8; */
        for (let k of globalThis.Object.keys(message.tintColorsById)) {
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TintColor.internalBinaryWrite(message.tintColorsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 9; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact customer_contact = 10; */
        if (message.customerContact)
            Contacts_Contact.internalBinaryWrite(message.customerContact, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.SaleProduct sale_products = 12; */
        for (let i = 0; i < message.saleProducts.length; i++)
            SaleProduct.internalBinaryWrite(message.saleProducts[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer job = 15; */
        if (message.job)
            Customer.internalBinaryWrite(message.job, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale returns = 16; */
        for (let i = 0; i < message.returns.length; i++)
            Sale.internalBinaryWrite(message.returns[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale> returned_from_sales_by_id = 17; */
        for (let k of globalThis.Object.keys(message.returnedFromSalesById)) {
            writer.tag(17, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale.internalBinaryWrite(message.returnedFromSalesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.search.service.SearchSalesV2Res.Result.ReturnedInSales> returned_in_sales_by_sale_product_id = 18; */
        for (let k of globalThis.Object.keys(message.returnedInSalesBySaleProductId)) {
            writer.tag(18, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SearchSalesV2Res_Result_ReturnedInSales.internalBinaryWrite(message.returnedInSalesBySaleProductId[k], writer, options);
            writer.join().join();
        }
        /* rd.ledger.LedgerMethods ledger_methods = 19; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location fulfillment_location = 20; */
        if (message.fulfillmentLocation)
            Location.internalBinaryWrite(message.fulfillmentLocation, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.giftcard.GiftCard> gift_cards_by_id = 21; */
        for (let k of globalThis.Object.keys(message.giftCardsById)) {
            writer.tag(21, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            GiftCard.internalBinaryWrite(message.giftCardsById[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.txn.DeliveryStop delivery_stops = 22; */
        for (let i = 0; i < message.deliveryStops.length; i++)
            DeliveryStop.internalBinaryWrite(message.deliveryStops[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSalesV2Res.Result
 */
export const SearchSalesV2Res_Result = new SearchSalesV2Res_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSalesV2Res_Result_ReturnedInSales$Type extends MessageType<SearchSalesV2Res_Result_ReturnedInSales> {
    constructor() {
        super("rd.search.service.SearchSalesV2Res.Result.ReturnedInSales", [
            { no: 1, name: "sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<SearchSalesV2Res_Result_ReturnedInSales>): SearchSalesV2Res_Result_ReturnedInSales {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sales = [];
        if (value !== undefined)
            reflectionMergePartial<SearchSalesV2Res_Result_ReturnedInSales>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSalesV2Res_Result_ReturnedInSales): SearchSalesV2Res_Result_ReturnedInSales {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.Sale sales */ 1:
                    message.sales.push(Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSalesV2Res_Result_ReturnedInSales, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.Sale sales = 1; */
        for (let i = 0; i < message.sales.length; i++)
            Sale.internalBinaryWrite(message.sales[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSalesV2Res.Result.ReturnedInSales
 */
export const SearchSalesV2Res_Result_ReturnedInSales = new SearchSalesV2Res_Result_ReturnedInSales$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnsReq$Type extends MessageType<SearchReturnsReq> {
    constructor() {
        super("rd.search.service.SearchReturnsReq", []);
    }
    create(value?: PartialMessage<SearchReturnsReq>): SearchReturnsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReturnsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnsReq): SearchReturnsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnsReq
 */
export const SearchReturnsReq = new SearchReturnsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnsRes$Type extends MessageType<SearchReturnsRes> {
    constructor() {
        super("rd.search.service.SearchReturnsRes", []);
    }
    create(value?: PartialMessage<SearchReturnsRes>): SearchReturnsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReturnsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnsRes): SearchReturnsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnsRes
 */
export const SearchReturnsRes = new SearchReturnsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnsRes_Result$Type extends MessageType<SearchReturnsRes_Result> {
    constructor() {
        super("rd.search.service.SearchReturnsRes.Result", []);
    }
    create(value?: PartialMessage<SearchReturnsRes_Result>): SearchReturnsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReturnsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnsRes_Result): SearchReturnsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnsRes.Result
 */
export const SearchReturnsRes_Result = new SearchReturnsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOutstandingSalesReq$Type extends MessageType<SearchOutstandingSalesReq> {
    constructor() {
        super("rd.search.service.SearchOutstandingSalesReq", []);
    }
    create(value?: PartialMessage<SearchOutstandingSalesReq>): SearchOutstandingSalesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchOutstandingSalesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOutstandingSalesReq): SearchOutstandingSalesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOutstandingSalesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOutstandingSalesReq
 */
export const SearchOutstandingSalesReq = new SearchOutstandingSalesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOutstandingSalesRes$Type extends MessageType<SearchOutstandingSalesRes> {
    constructor() {
        super("rd.search.service.SearchOutstandingSalesRes", []);
    }
    create(value?: PartialMessage<SearchOutstandingSalesRes>): SearchOutstandingSalesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchOutstandingSalesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOutstandingSalesRes): SearchOutstandingSalesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOutstandingSalesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOutstandingSalesRes
 */
export const SearchOutstandingSalesRes = new SearchOutstandingSalesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOutstandingSalesRes_Result$Type extends MessageType<SearchOutstandingSalesRes_Result> {
    constructor() {
        super("rd.search.service.SearchOutstandingSalesRes.Result", []);
    }
    create(value?: PartialMessage<SearchOutstandingSalesRes_Result>): SearchOutstandingSalesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchOutstandingSalesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOutstandingSalesRes_Result): SearchOutstandingSalesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOutstandingSalesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOutstandingSalesRes.Result
 */
export const SearchOutstandingSalesRes_Result = new SearchOutstandingSalesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTintColorsReq$Type extends MessageType<SearchTintColorsReq> {
    constructor() {
        super("rd.search.service.SearchTintColorsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchTintColorsReq>): SearchTintColorsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<SearchTintColorsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTintColorsReq): SearchTintColorsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTintColorsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTintColorsReq
 */
export const SearchTintColorsReq = new SearchTintColorsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTintColorsRes$Type extends MessageType<SearchTintColorsRes> {
    constructor() {
        super("rd.search.service.SearchTintColorsRes", [
            { no: 2, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchTintColorsRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchTintColorsRes>): SearchTintColorsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchTintColorsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTintColorsRes): SearchTintColorsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchTintColorsRes.Result results */ 2:
                    message.results.push(SearchTintColorsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTintColorsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchTintColorsRes.Result results = 2; */
        for (let i = 0; i < message.results.length; i++)
            SearchTintColorsRes_Result.internalBinaryWrite(message.results[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTintColorsRes
 */
export const SearchTintColorsRes = new SearchTintColorsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTintColorsRes_Result$Type extends MessageType<SearchTintColorsRes_Result> {
    constructor() {
        super("rd.search.service.SearchTintColorsRes.Result", [
            { no: 1, name: "tint_color", kind: "message", T: () => TintColor }
        ]);
    }
    create(value?: PartialMessage<SearchTintColorsRes_Result>): SearchTintColorsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchTintColorsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTintColorsRes_Result): SearchTintColorsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.tintcolor.TintColor tint_color */ 1:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTintColorsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.tintcolor.TintColor tint_color = 1; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTintColorsRes.Result
 */
export const SearchTintColorsRes_Result = new SearchTintColorsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTransfersReq$Type extends MessageType<SearchTransfersReq> {
    constructor() {
        super("rd.search.service.SearchTransfersReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "sent_at_range", kind: "message", T: () => TimestampRange },
            { no: 4, name: "received_at_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "voided_at_range", kind: "message", T: () => TimestampRange },
            { no: 6, name: "from_location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "to_location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Transfer.Status", Transfer_Status, "STATUS_"] },
            { no: 9, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "requested_at_range", kind: "message", T: () => TimestampRange },
            { no: 13, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchTransfersReq>): SearchTransfersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.fromLocationIds = [];
        message.toLocationIds = [];
        message.statuses = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.productIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchTransfersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTransfersReq): SearchTransfersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange sent_at_range */ 3:
                    message.sentAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.sentAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange received_at_range */ 4:
                    message.receivedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.receivedAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange voided_at_range */ 5:
                    message.voidedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.voidedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID from_location_ids */ 6:
                    message.fromLocationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID to_location_ids */ 7:
                    message.toLocationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Transfer.Status statuses */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* string cursor */ 9:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 10:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 11:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange requested_at_range */ 12:
                    message.requestedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.requestedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 13:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTransfersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange sent_at_range = 3; */
        if (message.sentAtRange)
            TimestampRange.internalBinaryWrite(message.sentAtRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange received_at_range = 4; */
        if (message.receivedAtRange)
            TimestampRange.internalBinaryWrite(message.receivedAtRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange voided_at_range = 5; */
        if (message.voidedAtRange)
            TimestampRange.internalBinaryWrite(message.voidedAtRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID from_location_ids = 6; */
        for (let i = 0; i < message.fromLocationIds.length; i++)
            UUID.internalBinaryWrite(message.fromLocationIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID to_location_ids = 7; */
        for (let i = 0; i < message.toLocationIds.length; i++)
            UUID.internalBinaryWrite(message.toLocationIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Transfer.Status statuses = 8; */
        if (message.statuses.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* string cursor = 9; */
        if (message.cursor !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 10; */
        if (message.offset !== 0)
            writer.tag(10, WireType.Varint).int32(message.offset);
        /* int32 limit = 11; */
        if (message.limit !== 0)
            writer.tag(11, WireType.Varint).int32(message.limit);
        /* rd.proto.timestamprange.TimestampRange requested_at_range = 12; */
        if (message.requestedAtRange)
            TimestampRange.internalBinaryWrite(message.requestedAtRange, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 13; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTransfersReq
 */
export const SearchTransfersReq = new SearchTransfersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTransfersRes$Type extends MessageType<SearchTransfersRes> {
    constructor() {
        super("rd.search.service.SearchTransfersRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchTransfersRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchTransfersRes>): SearchTransfersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchTransfersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTransfersRes): SearchTransfersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchTransfersRes.Result results */ 1:
                    message.results.push(SearchTransfersRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTransfersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchTransfersRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchTransfersRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTransfersRes
 */
export const SearchTransfersRes = new SearchTransfersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTransfersRes_Result$Type extends MessageType<SearchTransfersRes_Result> {
    constructor() {
        super("rd.search.service.SearchTransfersRes.Result", [
            { no: 1, name: "transfer", kind: "message", T: () => Transfer },
            { no: 2, name: "from_location", kind: "message", T: () => Location },
            { no: 3, name: "to_location", kind: "message", T: () => Location },
            { no: 4, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 6, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchTransfersRes_Result>): SearchTransfersRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchTransfersRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTransfersRes_Result): SearchTransfersRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Transfer transfer */ 1:
                    message.transfer = Transfer.internalBinaryRead(reader, reader.uint32(), options, message.transfer);
                    break;
                case /* rd.company.Location from_location */ 2:
                    message.fromLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.fromLocation);
                    break;
                case /* rd.company.Location to_location */ 3:
                    message.toLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.toLocation);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 4:
                    this.binaryReadMap4(message.productsById, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 6:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: SearchTransfersRes_Result["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchTransfersRes_Result["productsById"] | undefined, val: SearchTransfersRes_Result["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchTransfersRes.Result.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    internalBinaryWrite(message: SearchTransfersRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Transfer transfer = 1; */
        if (message.transfer)
            Transfer.internalBinaryWrite(message.transfer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location from_location = 2; */
        if (message.fromLocation)
            Location.internalBinaryWrite(message.fromLocation, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location to_location = 3; */
        if (message.toLocation)
            Location.internalBinaryWrite(message.toLocation, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 4; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 6; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTransfersRes.Result
 */
export const SearchTransfersRes_Result = new SearchTransfersRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchVendorsReq$Type extends MessageType<SearchVendorsReq> {
    constructor() {
        super("rd.search.service.SearchVendorsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 3, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SearchVendorsReq>): SearchVendorsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.isActiveFilter = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchVendorsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchVendorsReq): SearchVendorsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 2:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* string cursor */ 3:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 4:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchVendorsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.search.service.BoolFilter is_active_filter = 2; */
        if (message.isActiveFilter !== 0)
            writer.tag(2, WireType.Varint).int32(message.isActiveFilter);
        /* string cursor = 3; */
        if (message.cursor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 4; */
        if (message.offset !== 0)
            writer.tag(4, WireType.Varint).int32(message.offset);
        /* int32 limit = 5; */
        if (message.limit !== 0)
            writer.tag(5, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchVendorsReq
 */
export const SearchVendorsReq = new SearchVendorsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchVendorsRes$Type extends MessageType<SearchVendorsRes> {
    constructor() {
        super("rd.search.service.SearchVendorsRes", [
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchVendorsRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchVendorsRes>): SearchVendorsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cursor = "";
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchVendorsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchVendorsRes): SearchVendorsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* repeated rd.search.service.SearchVendorsRes.Result results */ 3:
                    message.results.push(SearchVendorsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchVendorsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* repeated rd.search.service.SearchVendorsRes.Result results = 3; */
        for (let i = 0; i < message.results.length; i++)
            SearchVendorsRes_Result.internalBinaryWrite(message.results[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchVendorsRes
 */
export const SearchVendorsRes = new SearchVendorsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchVendorsRes_Result$Type extends MessageType<SearchVendorsRes_Result> {
    constructor() {
        super("rd.search.service.SearchVendorsRes.Result", [
            { no: 1, name: "vendor", kind: "message", T: () => Vendor }
        ]);
    }
    create(value?: PartialMessage<SearchVendorsRes_Result>): SearchVendorsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchVendorsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchVendorsRes_Result): SearchVendorsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.vendors.Vendor vendor */ 1:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchVendorsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.vendors.Vendor vendor = 1; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchVendorsRes.Result
 */
export const SearchVendorsRes_Result = new SearchVendorsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportVendorsReq$Type extends MessageType<BulkExportVendorsReq> {
    constructor() {
        super("rd.search.service.BulkExportVendorsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 3, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportVendorsReq>): BulkExportVendorsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.isActiveFilter = 0;
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportVendorsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportVendorsReq): BulkExportVendorsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 2:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* bool is_template */ 3:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportVendorsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.search.service.BoolFilter is_active_filter = 2; */
        if (message.isActiveFilter !== 0)
            writer.tag(2, WireType.Varint).int32(message.isActiveFilter);
        /* bool is_template = 3; */
        if (message.isTemplate !== false)
            writer.tag(3, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportVendorsReq
 */
export const BulkExportVendorsReq = new BulkExportVendorsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportVendorsRes$Type extends MessageType<BulkExportVendorsRes> {
    constructor() {
        super("rd.search.service.BulkExportVendorsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportVendorsRes>): BulkExportVendorsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportVendorsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportVendorsRes): BulkExportVendorsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportVendorsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportVendorsRes
 */
export const BulkExportVendorsRes = new BulkExportVendorsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportUnitsOfMeasureReq$Type extends MessageType<BulkExportUnitsOfMeasureReq> {
    constructor() {
        super("rd.search.service.BulkExportUnitsOfMeasureReq", [
            { no: 1, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 2, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportUnitsOfMeasureReq>): BulkExportUnitsOfMeasureReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActiveFilter = 0;
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportUnitsOfMeasureReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportUnitsOfMeasureReq): BulkExportUnitsOfMeasureReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.search.service.BoolFilter is_active_filter */ 1:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* bool is_template */ 2:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportUnitsOfMeasureReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.search.service.BoolFilter is_active_filter = 1; */
        if (message.isActiveFilter !== 0)
            writer.tag(1, WireType.Varint).int32(message.isActiveFilter);
        /* bool is_template = 2; */
        if (message.isTemplate !== false)
            writer.tag(2, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportUnitsOfMeasureReq
 */
export const BulkExportUnitsOfMeasureReq = new BulkExportUnitsOfMeasureReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportUnitsOfMeasureRes$Type extends MessageType<BulkExportUnitsOfMeasureRes> {
    constructor() {
        super("rd.search.service.BulkExportUnitsOfMeasureRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportUnitsOfMeasureRes>): BulkExportUnitsOfMeasureRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportUnitsOfMeasureRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportUnitsOfMeasureRes): BulkExportUnitsOfMeasureRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportUnitsOfMeasureRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportUnitsOfMeasureRes
 */
export const BulkExportUnitsOfMeasureRes = new BulkExportUnitsOfMeasureRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRecordReq$Type extends MessageType<UpdateRecordReq> {
    constructor() {
        super("rd.search.service.UpdateRecordReq", [
            { no: 6, name: "update", kind: "message", T: () => Update }
        ]);
    }
    create(value?: PartialMessage<UpdateRecordReq>): UpdateRecordReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateRecordReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateRecordReq): UpdateRecordReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.search.cache.Update update */ 6:
                    message.update = Update.internalBinaryRead(reader, reader.uint32(), options, message.update);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateRecordReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.search.cache.Update update = 6; */
        if (message.update)
            Update.internalBinaryWrite(message.update, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.UpdateRecordReq
 */
export const UpdateRecordReq = new UpdateRecordReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRecordRes$Type extends MessageType<UpdateRecordRes> {
    constructor() {
        super("rd.search.service.UpdateRecordRes", []);
    }
    create(value?: PartialMessage<UpdateRecordRes>): UpdateRecordRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateRecordRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateRecordRes): UpdateRecordRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateRecordRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.UpdateRecordRes
 */
export const UpdateRecordRes = new UpdateRecordRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReloadReq$Type extends MessageType<ReloadReq> {
    constructor() {
        super("rd.search.service.ReloadReq", [
            { no: 1, name: "company_id", kind: "message", T: () => UUID },
            { no: 2, name: "full_reload", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "table_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "clear_aux_tables", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "from_disk", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ReloadReq>): ReloadReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fullReload = false;
        message.tableNames = [];
        message.clearAuxTables = false;
        message.fromDisk = false;
        if (value !== undefined)
            reflectionMergePartial<ReloadReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReloadReq): ReloadReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID company_id */ 1:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* bool full_reload */ 2:
                    message.fullReload = reader.bool();
                    break;
                case /* repeated string table_names */ 3:
                    message.tableNames.push(reader.string());
                    break;
                case /* bool clear_aux_tables */ 4:
                    message.clearAuxTables = reader.bool();
                    break;
                case /* bool from_disk */ 5:
                    message.fromDisk = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReloadReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID company_id = 1; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool full_reload = 2; */
        if (message.fullReload !== false)
            writer.tag(2, WireType.Varint).bool(message.fullReload);
        /* repeated string table_names = 3; */
        for (let i = 0; i < message.tableNames.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.tableNames[i]);
        /* bool clear_aux_tables = 4; */
        if (message.clearAuxTables !== false)
            writer.tag(4, WireType.Varint).bool(message.clearAuxTables);
        /* bool from_disk = 5; */
        if (message.fromDisk !== false)
            writer.tag(5, WireType.Varint).bool(message.fromDisk);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.ReloadReq
 */
export const ReloadReq = new ReloadReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReloadRes$Type extends MessageType<ReloadRes> {
    constructor() {
        super("rd.search.service.ReloadRes", []);
    }
    create(value?: PartialMessage<ReloadRes>): ReloadRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReloadRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReloadRes): ReloadRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReloadRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.ReloadRes
 */
export const ReloadRes = new ReloadRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCashTransactionsReq$Type extends MessageType<SearchCashTransactionsReq> {
    constructor() {
        super("rd.search.service.SearchCashTransactionsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 4, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.SearchCashTransactionsReq.Type", SearchCashTransactionsReq_Type, "TYPE_"] },
            { no: 5, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "cash_register_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchCashTransactionsReq>): SearchCashTransactionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.types = [];
        message.createdByIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.cashRegisterIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCashTransactionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCashTransactionsReq): SearchCashTransactionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 2:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 3:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* repeated rd.search.service.SearchCashTransactionsReq.Type types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 5:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 6:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 7:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID cash_register_ids */ 9:
                    message.cashRegisterIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCashTransactionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID location_ids = 2; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange created_at_range = 3; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SearchCashTransactionsReq.Type types = 4; */
        if (message.types.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID created_by_ids = 5; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 6; */
        if (message.cursor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 7; */
        if (message.offset !== 0)
            writer.tag(7, WireType.Varint).int32(message.offset);
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID cash_register_ids = 9; */
        for (let i = 0; i < message.cashRegisterIds.length; i++)
            UUID.internalBinaryWrite(message.cashRegisterIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCashTransactionsReq
 */
export const SearchCashTransactionsReq = new SearchCashTransactionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCashTransactionsRes$Type extends MessageType<SearchCashTransactionsRes> {
    constructor() {
        super("rd.search.service.SearchCashTransactionsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCashTransactionsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCashTransactionsRes>): SearchCashTransactionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCashTransactionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCashTransactionsRes): SearchCashTransactionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCashTransactionsRes.Result results */ 1:
                    message.results.push(SearchCashTransactionsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCashTransactionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCashTransactionsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCashTransactionsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCashTransactionsRes
 */
export const SearchCashTransactionsRes = new SearchCashTransactionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCashTransactionsRes_Result$Type extends MessageType<SearchCashTransactionsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCashTransactionsRes.Result", [
            { no: 1, name: "ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 2, name: "sale", kind: "message", T: () => Sale },
            { no: 3, name: "bill_payment", kind: "message", T: () => BillPayment },
            { no: 4, name: "petty_cash", kind: "message", T: () => PettyCash },
            { no: 5, name: "close_out", kind: "message", T: () => CloseOut },
            { no: 7, name: "sale_return", kind: "message", T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<SearchCashTransactionsRes_Result>): SearchCashTransactionsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchCashTransactionsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCashTransactionsRes_Result): SearchCashTransactionsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry ledger_entry */ 1:
                    message.ledgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntry);
                    break;
                case /* rd.txn.Sale sale */ 2:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.txn.BillPayment bill_payment */ 3:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                case /* rd.txn.PettyCash petty_cash */ 4:
                    message.pettyCash = PettyCash.internalBinaryRead(reader, reader.uint32(), options, message.pettyCash);
                    break;
                case /* rd.txn.CloseOut close_out */ 5:
                    message.closeOut = CloseOut.internalBinaryRead(reader, reader.uint32(), options, message.closeOut);
                    break;
                case /* rd.txn.Sale sale_return */ 7:
                    message.saleReturn = Sale.internalBinaryRead(reader, reader.uint32(), options, message.saleReturn);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCashTransactionsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry ledger_entry = 1; */
        if (message.ledgerEntry)
            LedgerEntry.internalBinaryWrite(message.ledgerEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale sale = 2; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.BillPayment bill_payment = 3; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.PettyCash petty_cash = 4; */
        if (message.pettyCash)
            PettyCash.internalBinaryWrite(message.pettyCash, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CloseOut close_out = 5; */
        if (message.closeOut)
            CloseOut.internalBinaryWrite(message.closeOut, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale sale_return = 7; */
        if (message.saleReturn)
            Sale.internalBinaryWrite(message.saleReturn, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCashTransactionsRes.Result
 */
export const SearchCashTransactionsRes_Result = new SearchCashTransactionsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinancialTransactionsReq$Type extends MessageType<SearchFinancialTransactionsReq> {
    constructor() {
        super("rd.search.service.SearchFinancialTransactionsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.payments.FinancialTransaction.Type", FinancialTransaction_Type, "TYPE_"] },
            { no: 4, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.payments.FinancialTransaction.Status", FinancialTransaction_Status, "STATUS_"] },
            { no: 5, name: "range", kind: "message", T: () => TimestampRange },
            { no: 6, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "chart_of_account_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchFinancialTransactionsReq>): SearchFinancialTransactionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.vendorIds = [];
        message.types = [];
        message.statuses = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.chartOfAccountIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchFinancialTransactionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinancialTransactionsReq): SearchFinancialTransactionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 2:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.payments.FinancialTransaction.Type types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.payments.FinancialTransaction.Status statuses */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* rd.proto.timestamprange.TimestampRange range */ 5:
                    message.range = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.range);
                    break;
                case /* string cursor */ 6:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 7:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID chart_of_account_ids */ 9:
                    message.chartOfAccountIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinancialTransactionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID vendor_ids = 2; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.payments.FinancialTransaction.Type types = 3; */
        if (message.types.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.payments.FinancialTransaction.Status statuses = 4; */
        if (message.statuses.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* rd.proto.timestamprange.TimestampRange range = 5; */
        if (message.range)
            TimestampRange.internalBinaryWrite(message.range, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 6; */
        if (message.cursor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 7; */
        if (message.offset !== 0)
            writer.tag(7, WireType.Varint).int32(message.offset);
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID chart_of_account_ids = 9; */
        for (let i = 0; i < message.chartOfAccountIds.length; i++)
            UUID.internalBinaryWrite(message.chartOfAccountIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinancialTransactionsReq
 */
export const SearchFinancialTransactionsReq = new SearchFinancialTransactionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinancialTransactionsRes$Type extends MessageType<SearchFinancialTransactionsRes> {
    constructor() {
        super("rd.search.service.SearchFinancialTransactionsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchFinancialTransactionsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchFinancialTransactionsRes>): SearchFinancialTransactionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchFinancialTransactionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinancialTransactionsRes): SearchFinancialTransactionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchFinancialTransactionsRes.Result results */ 1:
                    message.results.push(SearchFinancialTransactionsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinancialTransactionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchFinancialTransactionsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchFinancialTransactionsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinancialTransactionsRes
 */
export const SearchFinancialTransactionsRes = new SearchFinancialTransactionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinancialTransactionsRes_Result$Type extends MessageType<SearchFinancialTransactionsRes_Result> {
    constructor() {
        super("rd.search.service.SearchFinancialTransactionsRes.Result", [
            { no: 1, name: "financial_transaction", kind: "message", T: () => FinancialTransaction },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 5, name: "accounts_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Account } },
            { no: 6, name: "order_shipment_data_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SearchFinancialTransactionsRes_Result_OrderShipmentData } },
            { no: 7, name: "location", kind: "message", T: () => Location }
        ]);
    }
    create(value?: PartialMessage<SearchFinancialTransactionsRes_Result>): SearchFinancialTransactionsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountsById = {};
        message.orderShipmentDataById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchFinancialTransactionsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinancialTransactionsRes_Result): SearchFinancialTransactionsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.payments.FinancialTransaction financial_transaction */ 1:
                    message.financialTransaction = FinancialTransaction.internalBinaryRead(reader, reader.uint32(), options, message.financialTransaction);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* map<string, rd.coa.Account> accounts_by_id */ 5:
                    this.binaryReadMap5(message.accountsById, reader, options);
                    break;
                case /* map<string, rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id */ 6:
                    this.binaryReadMap6(message.orderShipmentDataById, reader, options);
                    break;
                case /* rd.company.Location location */ 7:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: SearchFinancialTransactionsRes_Result["accountsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchFinancialTransactionsRes_Result["accountsById"] | undefined, val: SearchFinancialTransactionsRes_Result["accountsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Account.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchFinancialTransactionsRes.Result.accounts_by_id");
            }
        }
        map[key ?? ""] = val ?? Account.create();
    }
    private binaryReadMap6(map: SearchFinancialTransactionsRes_Result["orderShipmentDataById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchFinancialTransactionsRes_Result["orderShipmentDataById"] | undefined, val: SearchFinancialTransactionsRes_Result["orderShipmentDataById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SearchFinancialTransactionsRes_Result_OrderShipmentData.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchFinancialTransactionsRes.Result.order_shipment_data_by_id");
            }
        }
        map[key ?? ""] = val ?? SearchFinancialTransactionsRes_Result_OrderShipmentData.create();
    }
    internalBinaryWrite(message: SearchFinancialTransactionsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.payments.FinancialTransaction financial_transaction = 1; */
        if (message.financialTransaction)
            FinancialTransaction.internalBinaryWrite(message.financialTransaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.coa.Account> accounts_by_id = 5; */
        for (let k of globalThis.Object.keys(message.accountsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Account.internalBinaryWrite(message.accountsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id = 6; */
        for (let k of globalThis.Object.keys(message.orderShipmentDataById)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SearchFinancialTransactionsRes_Result_OrderShipmentData.internalBinaryWrite(message.orderShipmentDataById[k], writer, options);
            writer.join().join();
        }
        /* rd.company.Location location = 7; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinancialTransactionsRes.Result
 */
export const SearchFinancialTransactionsRes_Result = new SearchFinancialTransactionsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinancialTransactionsRes_Result_OrderShipmentData$Type extends MessageType<SearchFinancialTransactionsRes_Result_OrderShipmentData> {
    constructor() {
        super("rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchFinancialTransactionsRes_Result_OrderShipmentData>): SearchFinancialTransactionsRes_Result_OrderShipmentData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchFinancialTransactionsRes_Result_OrderShipmentData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinancialTransactionsRes_Result_OrderShipmentData): SearchFinancialTransactionsRes_Result_OrderShipmentData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinancialTransactionsRes_Result_OrderShipmentData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinancialTransactionsRes.Result.OrderShipmentData
 */
export const SearchFinancialTransactionsRes_Result_OrderShipmentData = new SearchFinancialTransactionsRes_Result_OrderShipmentData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryCountProductsReq$Type extends MessageType<SearchInventoryCountProductsReq> {
    constructor() {
        super("rd.search.service.SearchInventoryCountProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inventory_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "inventory_count_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "product_status", kind: "enum", T: () => ["rd.product.InventoryCountProduct.Status", InventoryCountProduct_Status], options: { "rd.validator.require": true } },
            { no: 5, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchInventoryCountProductsReq.OrderBy", SearchInventoryCountProductsReq_OrderBy, "ORDER_BY_"] },
            { no: 14, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryCountProductsReq>): SearchInventoryCountProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.productStatus = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryCountProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryCountProductsReq): SearchInventoryCountProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID inventory_location_id */ 2:
                    message.inventoryLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryLocationId);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 3:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* rd.product.InventoryCountProduct.Status product_status */ 4:
                    message.productStatus = reader.int32();
                    break;
                case /* string cursor */ 5:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 6:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 7:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchInventoryCountProductsReq.OrderBy order_by */ 13:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 14:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryCountProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID inventory_location_id = 2; */
        if (message.inventoryLocationId)
            UUID.internalBinaryWrite(message.inventoryLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 3; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.InventoryCountProduct.Status product_status = 4; */
        if (message.productStatus !== 0)
            writer.tag(4, WireType.Varint).int32(message.productStatus);
        /* string cursor = 5; */
        if (message.cursor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 6; */
        if (message.offset !== 0)
            writer.tag(6, WireType.Varint).int32(message.offset);
        /* int32 limit = 7; */
        if (message.limit !== 0)
            writer.tag(7, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchInventoryCountProductsReq.OrderBy order_by = 13; */
        if (message.orderBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 14; */
        if (message.sortOrder !== 0)
            writer.tag(14, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryCountProductsReq
 */
export const SearchInventoryCountProductsReq = new SearchInventoryCountProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryCountProductsRes$Type extends MessageType<SearchInventoryCountProductsRes> {
    constructor() {
        super("rd.search.service.SearchInventoryCountProductsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchInventoryCountProductsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryCountProductsRes>): SearchInventoryCountProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryCountProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryCountProductsRes): SearchInventoryCountProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchInventoryCountProductsRes.Result results */ 1:
                    message.results.push(SearchInventoryCountProductsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryCountProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchInventoryCountProductsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchInventoryCountProductsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryCountProductsRes
 */
export const SearchInventoryCountProductsRes = new SearchInventoryCountProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryCountProductsRes_Result$Type extends MessageType<SearchInventoryCountProductsRes_Result> {
    constructor() {
        super("rd.search.service.SearchInventoryCountProductsRes.Result", [
            { no: 1, name: "product", kind: "message", T: () => Product },
            { no: 5, name: "dollar_variance", kind: "message", T: () => Money },
            { no: 6, name: "on_hand_v2", kind: "message", T: () => Decimal },
            { no: 7, name: "counted_v2", kind: "message", T: () => Decimal },
            { no: 8, name: "variance_v2", kind: "message", T: () => Decimal },
            { no: 9, name: "inventory_count_product_id", kind: "message", T: () => UUID },
            { no: 10, name: "cost", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryCountProductsRes_Result>): SearchInventoryCountProductsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryCountProductsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryCountProductsRes_Result): SearchInventoryCountProductsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.Product product */ 1:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.proto.money.Money dollar_variance */ 5:
                    message.dollarVariance = Money.internalBinaryRead(reader, reader.uint32(), options, message.dollarVariance);
                    break;
                case /* rd.proto.decimal.Decimal on_hand_v2 */ 6:
                    message.onHandV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.onHandV2);
                    break;
                case /* rd.proto.decimal.Decimal counted_v2 */ 7:
                    message.countedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.countedV2);
                    break;
                case /* rd.proto.decimal.Decimal variance_v2 */ 8:
                    message.varianceV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.varianceV2);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_product_id */ 9:
                    message.inventoryCountProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountProductId);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 10:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryCountProductsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.Product product = 1; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money dollar_variance = 5; */
        if (message.dollarVariance)
            Money.internalBinaryWrite(message.dollarVariance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal on_hand_v2 = 6; */
        if (message.onHandV2)
            Decimal.internalBinaryWrite(message.onHandV2, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal counted_v2 = 7; */
        if (message.countedV2)
            Decimal.internalBinaryWrite(message.countedV2, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal variance_v2 = 8; */
        if (message.varianceV2)
            Decimal.internalBinaryWrite(message.varianceV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_product_id = 9; */
        if (message.inventoryCountProductId)
            UUID.internalBinaryWrite(message.inventoryCountProductId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 10; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryCountProductsRes.Result
 */
export const SearchInventoryCountProductsRes_Result = new SearchInventoryCountProductsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportInventoryCountProductsReq$Type extends MessageType<BulkExportInventoryCountProductsReq> {
    constructor() {
        super("rd.search.service.BulkExportInventoryCountProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "inventory_location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "inventory_count_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "product_status", kind: "enum", T: () => ["rd.product.InventoryCountProduct.Status", InventoryCountProduct_Status], options: { "rd.validator.require": true } },
            { no: 5, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "order_by", kind: "enum", T: () => ["rd.search.service.BulkExportInventoryCountProductsReq.OrderBy", BulkExportInventoryCountProductsReq_OrderBy, "ORDER_BY_"] },
            { no: 14, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<BulkExportInventoryCountProductsReq>): BulkExportInventoryCountProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.productStatus = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<BulkExportInventoryCountProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportInventoryCountProductsReq): BulkExportInventoryCountProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID inventory_location_id */ 2:
                    message.inventoryLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryLocationId);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 3:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* rd.product.InventoryCountProduct.Status product_status */ 4:
                    message.productStatus = reader.int32();
                    break;
                case /* string cursor */ 5:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 6:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 7:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.BulkExportInventoryCountProductsReq.OrderBy order_by */ 13:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 14:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportInventoryCountProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID inventory_location_id = 2; */
        if (message.inventoryLocationId)
            UUID.internalBinaryWrite(message.inventoryLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 3; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.InventoryCountProduct.Status product_status = 4; */
        if (message.productStatus !== 0)
            writer.tag(4, WireType.Varint).int32(message.productStatus);
        /* string cursor = 5; */
        if (message.cursor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 6; */
        if (message.offset !== 0)
            writer.tag(6, WireType.Varint).int32(message.offset);
        /* int32 limit = 7; */
        if (message.limit !== 0)
            writer.tag(7, WireType.Varint).int32(message.limit);
        /* rd.search.service.BulkExportInventoryCountProductsReq.OrderBy order_by = 13; */
        if (message.orderBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 14; */
        if (message.sortOrder !== 0)
            writer.tag(14, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportInventoryCountProductsReq
 */
export const BulkExportInventoryCountProductsReq = new BulkExportInventoryCountProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportInventoryCountProductsRes$Type extends MessageType<BulkExportInventoryCountProductsRes> {
    constructor() {
        super("rd.search.service.BulkExportInventoryCountProductsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportInventoryCountProductsRes>): BulkExportInventoryCountProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportInventoryCountProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportInventoryCountProductsRes): BulkExportInventoryCountProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportInventoryCountProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportInventoryCountProductsRes
 */
export const BulkExportInventoryCountProductsRes = new BulkExportInventoryCountProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExcludedInventoryCountProductsReq$Type extends MessageType<SearchExcludedInventoryCountProductsReq> {
    constructor() {
        super("rd.search.service.SearchExcludedInventoryCountProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "inventory_count_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "department_id", kind: "message", T: () => UUID },
            { no: 8, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 9, name: "class_id", kind: "message", T: () => UUID },
            { no: 10, name: "fineline_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchExcludedInventoryCountProductsReq>): SearchExcludedInventoryCountProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchExcludedInventoryCountProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExcludedInventoryCountProductsReq): SearchExcludedInventoryCountProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID inventory_count_id */ 3:
                    message.inventoryCountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCountId);
                    break;
                case /* string cursor */ 4:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 5:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID department_id */ 7:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 8:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.uuid.UUID class_id */ 9:
                    message.classId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.classId);
                    break;
                case /* rd.proto.uuid.UUID fineline_id */ 10:
                    message.finelineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.finelineId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExcludedInventoryCountProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID inventory_count_id = 3; */
        if (message.inventoryCountId)
            UUID.internalBinaryWrite(message.inventoryCountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 4; */
        if (message.cursor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 5; */
        if (message.offset !== 0)
            writer.tag(5, WireType.Varint).int32(message.offset);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* rd.proto.uuid.UUID department_id = 7; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 8; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID class_id = 9; */
        if (message.classId)
            UUID.internalBinaryWrite(message.classId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID fineline_id = 10; */
        if (message.finelineId)
            UUID.internalBinaryWrite(message.finelineId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExcludedInventoryCountProductsReq
 */
export const SearchExcludedInventoryCountProductsReq = new SearchExcludedInventoryCountProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExcludedInventoryCountProductsRes$Type extends MessageType<SearchExcludedInventoryCountProductsRes> {
    constructor() {
        super("rd.search.service.SearchExcludedInventoryCountProductsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchExcludedInventoryCountProductsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchExcludedInventoryCountProductsRes>): SearchExcludedInventoryCountProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchExcludedInventoryCountProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExcludedInventoryCountProductsRes): SearchExcludedInventoryCountProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchExcludedInventoryCountProductsRes.Result results */ 1:
                    message.results.push(SearchExcludedInventoryCountProductsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExcludedInventoryCountProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchExcludedInventoryCountProductsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchExcludedInventoryCountProductsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExcludedInventoryCountProductsRes
 */
export const SearchExcludedInventoryCountProductsRes = new SearchExcludedInventoryCountProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExcludedInventoryCountProductsRes_Result$Type extends MessageType<SearchExcludedInventoryCountProductsRes_Result> {
    constructor() {
        super("rd.search.service.SearchExcludedInventoryCountProductsRes.Result", [
            { no: 1, name: "product", kind: "message", T: () => Product },
            { no: 2, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier }
        ]);
    }
    create(value?: PartialMessage<SearchExcludedInventoryCountProductsRes_Result>): SearchExcludedInventoryCountProductsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<SearchExcludedInventoryCountProductsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExcludedInventoryCountProductsRes_Result): SearchExcludedInventoryCountProductsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.Product product */ 1:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 2:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExcludedInventoryCountProductsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.Product product = 1; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 2; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExcludedInventoryCountProductsRes.Result
 */
export const SearchExcludedInventoryCountProductsRes_Result = new SearchExcludedInventoryCountProductsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalTransactionsReq$Type extends MessageType<SearchExternalTransactionsReq> {
    constructor() {
        super("rd.search.service.SearchExternalTransactionsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transacted_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "chart_of_account_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.ExternalTransaction.Type", ExternalTransaction_Type, "TYPE_"] },
            { no: 8, name: "payment_methods", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.ExternalTransaction.PaymentMethod", ExternalTransaction_PaymentMethod, "PAYMENT_METHOD_"] },
            { no: 9, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "external_account_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchExternalTransactionsReq>): SearchExternalTransactionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.customerIds = [];
        message.vendorIds = [];
        message.chartOfAccountIds = [];
        message.types = [];
        message.paymentMethods = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchExternalTransactionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExternalTransactionsReq): SearchExternalTransactionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange transacted_at_range */ 2:
                    message.transactedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.transactedAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 3:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 4:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 5:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID chart_of_account_ids */ 6:
                    message.chartOfAccountIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.accounting.ExternalTransaction.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.accounting.ExternalTransaction.PaymentMethod payment_methods */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.paymentMethods.push(reader.int32());
                    else
                        message.paymentMethods.push(reader.int32());
                    break;
                case /* string cursor */ 9:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 10:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 11:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID external_account_id */ 12:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExternalTransactionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange transacted_at_range = 2; */
        if (message.transactedAtRange)
            TimestampRange.internalBinaryWrite(message.transactedAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 3; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 4; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 5; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID chart_of_account_ids = 6; */
        for (let i = 0; i < message.chartOfAccountIds.length; i++)
            UUID.internalBinaryWrite(message.chartOfAccountIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.ExternalTransaction.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.accounting.ExternalTransaction.PaymentMethod payment_methods = 8; */
        if (message.paymentMethods.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.paymentMethods.length; i++)
                writer.int32(message.paymentMethods[i]);
            writer.join();
        }
        /* string cursor = 9; */
        if (message.cursor !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 10; */
        if (message.offset !== 0)
            writer.tag(10, WireType.Varint).int32(message.offset);
        /* int32 limit = 11; */
        if (message.limit !== 0)
            writer.tag(11, WireType.Varint).int32(message.limit);
        /* rd.proto.uuid.UUID external_account_id = 12; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExternalTransactionsReq
 */
export const SearchExternalTransactionsReq = new SearchExternalTransactionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalTransactionsRes$Type extends MessageType<SearchExternalTransactionsRes> {
    constructor() {
        super("rd.search.service.SearchExternalTransactionsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchExternalTransactionsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchExternalTransactionsRes>): SearchExternalTransactionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchExternalTransactionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExternalTransactionsRes): SearchExternalTransactionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchExternalTransactionsRes.Result results */ 1:
                    message.results.push(SearchExternalTransactionsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExternalTransactionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchExternalTransactionsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchExternalTransactionsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExternalTransactionsRes
 */
export const SearchExternalTransactionsRes = new SearchExternalTransactionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalTransactionsRes_Result$Type extends MessageType<SearchExternalTransactionsRes_Result> {
    constructor() {
        super("rd.search.service.SearchExternalTransactionsRes.Result", [
            { no: 1, name: "external_transaction", kind: "message", T: () => ExternalTransaction },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "customer", kind: "message", T: () => Customer },
            { no: 4, name: "vendor", kind: "message", T: () => Vendor },
            { no: 7, name: "accounts_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Account } },
            { no: 8, name: "order_shipment_data_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SearchExternalTransactionsRes_Result_OrderShipmentData } },
            { no: 9, name: "external_account", kind: "message", T: () => ExternalAccount }
        ]);
    }
    create(value?: PartialMessage<SearchExternalTransactionsRes_Result>): SearchExternalTransactionsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountsById = {};
        message.orderShipmentDataById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchExternalTransactionsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExternalTransactionsRes_Result): SearchExternalTransactionsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.ExternalTransaction external_transaction */ 1:
                    message.externalTransaction = ExternalTransaction.internalBinaryRead(reader, reader.uint32(), options, message.externalTransaction);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 3:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.vendors.Vendor vendor */ 4:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* map<string, rd.coa.Account> accounts_by_id */ 7:
                    this.binaryReadMap7(message.accountsById, reader, options);
                    break;
                case /* map<string, rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id */ 8:
                    this.binaryReadMap8(message.orderShipmentDataById, reader, options);
                    break;
                case /* rd.accounting.ExternalAccount external_account */ 9:
                    message.externalAccount = ExternalAccount.internalBinaryRead(reader, reader.uint32(), options, message.externalAccount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: SearchExternalTransactionsRes_Result["accountsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchExternalTransactionsRes_Result["accountsById"] | undefined, val: SearchExternalTransactionsRes_Result["accountsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Account.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchExternalTransactionsRes.Result.accounts_by_id");
            }
        }
        map[key ?? ""] = val ?? Account.create();
    }
    private binaryReadMap8(map: SearchExternalTransactionsRes_Result["orderShipmentDataById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchExternalTransactionsRes_Result["orderShipmentDataById"] | undefined, val: SearchExternalTransactionsRes_Result["orderShipmentDataById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SearchExternalTransactionsRes_Result_OrderShipmentData.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchExternalTransactionsRes.Result.order_shipment_data_by_id");
            }
        }
        map[key ?? ""] = val ?? SearchExternalTransactionsRes_Result_OrderShipmentData.create();
    }
    internalBinaryWrite(message: SearchExternalTransactionsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.ExternalTransaction external_transaction = 1; */
        if (message.externalTransaction)
            ExternalTransaction.internalBinaryWrite(message.externalTransaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 3; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 4; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.coa.Account> accounts_by_id = 7; */
        for (let k of globalThis.Object.keys(message.accountsById)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Account.internalBinaryWrite(message.accountsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData> order_shipment_data_by_id = 8; */
        for (let k of globalThis.Object.keys(message.orderShipmentDataById)) {
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SearchExternalTransactionsRes_Result_OrderShipmentData.internalBinaryWrite(message.orderShipmentDataById[k], writer, options);
            writer.join().join();
        }
        /* rd.accounting.ExternalAccount external_account = 9; */
        if (message.externalAccount)
            ExternalAccount.internalBinaryWrite(message.externalAccount, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExternalTransactionsRes.Result
 */
export const SearchExternalTransactionsRes_Result = new SearchExternalTransactionsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExternalTransactionsRes_Result_OrderShipmentData$Type extends MessageType<SearchExternalTransactionsRes_Result_OrderShipmentData> {
    constructor() {
        super("rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchExternalTransactionsRes_Result_OrderShipmentData>): SearchExternalTransactionsRes_Result_OrderShipmentData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchExternalTransactionsRes_Result_OrderShipmentData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExternalTransactionsRes_Result_OrderShipmentData): SearchExternalTransactionsRes_Result_OrderShipmentData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExternalTransactionsRes_Result_OrderShipmentData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchExternalTransactionsRes.Result.OrderShipmentData
 */
export const SearchExternalTransactionsRes_Result_OrderShipmentData = new SearchExternalTransactionsRes_Result_OrderShipmentData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsForReconciliationReq$Type extends MessageType<SearchOrderShipmentsForReconciliationReq> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsForReconciliationReq", [
            { no: 1, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "transaction_id", kind: "message", T: () => UUID },
            { no: 6, name: "stripe_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsForReconciliationReq>): SearchOrderShipmentsForReconciliationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.query = "";
        message.stripeTransactionId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsForReconciliationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsForReconciliationReq): SearchOrderShipmentsForReconciliationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cursor */ 1:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 2:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID transaction_id */ 5:
                    message.transactionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.transactionId);
                    break;
                case /* string stripe_transaction_id */ 6:
                    message.stripeTransactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrderShipmentsForReconciliationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cursor = 1; */
        if (message.cursor !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 2; */
        if (message.offset !== 0)
            writer.tag(2, WireType.Varint).int32(message.offset);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID transaction_id = 5; */
        if (message.transactionId)
            UUID.internalBinaryWrite(message.transactionId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_transaction_id = 6; */
        if (message.stripeTransactionId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stripeTransactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsForReconciliationReq
 */
export const SearchOrderShipmentsForReconciliationReq = new SearchOrderShipmentsForReconciliationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsForReconciliationRes$Type extends MessageType<SearchOrderShipmentsForReconciliationRes> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsForReconciliationRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchOrderShipmentsForReconciliationRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsForReconciliationRes>): SearchOrderShipmentsForReconciliationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsForReconciliationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsForReconciliationRes): SearchOrderShipmentsForReconciliationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchOrderShipmentsForReconciliationRes.Result results */ 1:
                    message.results.push(SearchOrderShipmentsForReconciliationRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrderShipmentsForReconciliationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchOrderShipmentsForReconciliationRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchOrderShipmentsForReconciliationRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsForReconciliationRes
 */
export const SearchOrderShipmentsForReconciliationRes = new SearchOrderShipmentsForReconciliationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrderShipmentsForReconciliationRes_Result$Type extends MessageType<SearchOrderShipmentsForReconciliationRes_Result> {
    constructor() {
        super("rd.search.service.SearchOrderShipmentsForReconciliationRes.Result", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "vendor", kind: "message", T: () => Vendor },
            { no: 3, name: "total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchOrderShipmentsForReconciliationRes_Result>): SearchOrderShipmentsForReconciliationRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchOrderShipmentsForReconciliationRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrderShipmentsForReconciliationRes_Result): SearchOrderShipmentsForReconciliationRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.vendors.Vendor vendor */ 2:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrderShipmentsForReconciliationRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 2; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchOrderShipmentsForReconciliationRes.Result
 */
export const SearchOrderShipmentsForReconciliationRes_Result = new SearchOrderShipmentsForReconciliationRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryChangesReq$Type extends MessageType<SearchInventoryChangesReq> {
    constructor() {
        super("rd.search.service.SearchInventoryChangesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 4, name: "staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "range", kind: "message", T: () => TimestampRange },
            { no: 7, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "inventory_change_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.InventoryChangeType", InventoryChangeType, "INVENTORY_CHANGE_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryChangesReq>): SearchInventoryChangesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.staffIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.locationIds = [];
        message.inventoryChangeTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryChangesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryChangesReq): SearchInventoryChangesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* repeated rd.proto.uuid.UUID staff_ids */ 4:
                    message.staffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange range */ 6:
                    message.range = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.range);
                    break;
                case /* string cursor */ 7:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 8:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 9:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 10:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.search.service.InventoryChangeType inventory_change_types */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.inventoryChangeTypes.push(reader.int32());
                    else
                        message.inventoryChangeTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryChangesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID staff_ids = 4; */
        for (let i = 0; i < message.staffIds.length; i++)
            UUID.internalBinaryWrite(message.staffIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange range = 6; */
        if (message.range)
            TimestampRange.internalBinaryWrite(message.range, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 7; */
        if (message.cursor !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 8; */
        if (message.offset !== 0)
            writer.tag(8, WireType.Varint).int32(message.offset);
        /* int32 limit = 9; */
        if (message.limit !== 0)
            writer.tag(9, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID location_ids = 10; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.InventoryChangeType inventory_change_types = 11; */
        if (message.inventoryChangeTypes.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.inventoryChangeTypes.length; i++)
                writer.int32(message.inventoryChangeTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryChangesReq
 */
export const SearchInventoryChangesReq = new SearchInventoryChangesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryChangesRes$Type extends MessageType<SearchInventoryChangesRes> {
    constructor() {
        super("rd.search.service.SearchInventoryChangesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchInventoryChangesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryChangesRes>): SearchInventoryChangesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryChangesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryChangesRes): SearchInventoryChangesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchInventoryChangesRes.Result results */ 1:
                    message.results.push(SearchInventoryChangesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchInventoryChangesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchInventoryChangesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchInventoryChangesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryChangesRes
 */
export const SearchInventoryChangesRes = new SearchInventoryChangesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchInventoryChangesRes_Result$Type extends MessageType<SearchInventoryChangesRes_Result> {
    constructor() {
        super("rd.search.service.SearchInventoryChangesRes.Result", [
            { no: 2, name: "id", kind: "message", T: () => UUID },
            { no: 3, name: "txn_id", kind: "message", T: () => UUID },
            { no: 4, name: "txn_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 7, name: "location_id", kind: "message", T: () => UUID },
            { no: 8, name: "staff", kind: "message", T: () => User },
            { no: 9, name: "unit_cost", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "average_cost", kind: "message", T: () => FractionalMoney },
            { no: 11, name: "status_quantities", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 12, name: "status_deltas", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 13, name: "valuation", kind: "message", T: () => FractionalMoney },
            { no: 14, name: "ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 15, name: "unit_cost_delta", kind: "message", T: () => FractionalMoney },
            { no: 16, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 17, name: "tag", kind: "enum", T: () => ["rd.search.service.SearchInventoryChangesRes.TransactionTag", SearchInventoryChangesRes_TransactionTag, "TRANSACTION_TAG_"] },
            { no: 18, name: "status_quantities_v2", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Decimal } },
            { no: 19, name: "status_deltas_v2", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Decimal } },
            { no: 20, name: "inventory_change_type", kind: "enum", T: () => ["rd.search.service.InventoryChangeType", InventoryChangeType, "INVENTORY_CHANGE_TYPE_"] },
            { no: 21, name: "is_reversal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "location", kind: "message", T: () => Location }
        ]);
    }
    create(value?: PartialMessage<SearchInventoryChangesRes_Result>): SearchInventoryChangesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.txnIdentifier = "";
        message.statusQuantities = {};
        message.statusDeltas = {};
        message.tag = 0;
        message.statusQuantitiesV2 = {};
        message.statusDeltasV2 = {};
        message.inventoryChangeType = 0;
        message.isReversal = false;
        if (value !== undefined)
            reflectionMergePartial<SearchInventoryChangesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchInventoryChangesRes_Result): SearchInventoryChangesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID txn_id */ 3:
                    message.txnId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.txnId);
                    break;
                case /* string txn_identifier */ 4:
                    message.txnIdentifier = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 7:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.user.User staff */ 8:
                    message.staff = User.internalBinaryRead(reader, reader.uint32(), options, message.staff);
                    break;
                case /* rd.proto.money.FractionalMoney unit_cost */ 9:
                    message.unitCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitCost);
                    break;
                case /* rd.proto.money.FractionalMoney average_cost */ 10:
                    message.averageCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.averageCost);
                    break;
                case /* map<int32, int32> status_quantities = 11 [deprecated = true] */ 11:
                    this.binaryReadMap11(message.statusQuantities, reader, options);
                    break;
                case /* map<int32, int32> status_deltas = 12 [deprecated = true] */ 12:
                    this.binaryReadMap12(message.statusDeltas, reader, options);
                    break;
                case /* rd.proto.money.FractionalMoney valuation */ 13:
                    message.valuation = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.valuation);
                    break;
                case /* rd.ledger.LedgerEntry ledger_entry */ 14:
                    message.ledgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntry);
                    break;
                case /* rd.proto.money.FractionalMoney unit_cost_delta */ 15:
                    message.unitCostDelta = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitCostDelta);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 16:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* rd.search.service.SearchInventoryChangesRes.TransactionTag tag */ 17:
                    message.tag = reader.int32();
                    break;
                case /* map<int32, rd.proto.decimal.Decimal> status_quantities_v2 */ 18:
                    this.binaryReadMap18(message.statusQuantitiesV2, reader, options);
                    break;
                case /* map<int32, rd.proto.decimal.Decimal> status_deltas_v2 */ 19:
                    this.binaryReadMap19(message.statusDeltasV2, reader, options);
                    break;
                case /* rd.search.service.InventoryChangeType inventory_change_type */ 20:
                    message.inventoryChangeType = reader.int32();
                    break;
                case /* bool is_reversal */ 21:
                    message.isReversal = reader.bool();
                    break;
                case /* rd.company.Location location */ 22:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: SearchInventoryChangesRes_Result["statusQuantities"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchInventoryChangesRes_Result["statusQuantities"] | undefined, val: SearchInventoryChangesRes_Result["statusQuantities"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchInventoryChangesRes.Result.status_quantities");
            }
        }
        map[key ?? 0] = val ?? 0;
    }
    private binaryReadMap12(map: SearchInventoryChangesRes_Result["statusDeltas"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchInventoryChangesRes_Result["statusDeltas"] | undefined, val: SearchInventoryChangesRes_Result["statusDeltas"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchInventoryChangesRes.Result.status_deltas");
            }
        }
        map[key ?? 0] = val ?? 0;
    }
    private binaryReadMap18(map: SearchInventoryChangesRes_Result["statusQuantitiesV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchInventoryChangesRes_Result["statusQuantitiesV2"] | undefined, val: SearchInventoryChangesRes_Result["statusQuantitiesV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchInventoryChangesRes.Result.status_quantities_v2");
            }
        }
        map[key ?? 0] = val ?? Decimal.create();
    }
    private binaryReadMap19(map: SearchInventoryChangesRes_Result["statusDeltasV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchInventoryChangesRes_Result["statusDeltasV2"] | undefined, val: SearchInventoryChangesRes_Result["statusDeltasV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchInventoryChangesRes.Result.status_deltas_v2");
            }
        }
        map[key ?? 0] = val ?? Decimal.create();
    }
    internalBinaryWrite(message: SearchInventoryChangesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID txn_id = 3; */
        if (message.txnId)
            UUID.internalBinaryWrite(message.txnId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string txn_identifier = 4; */
        if (message.txnIdentifier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.txnIdentifier);
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 7; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User staff = 8; */
        if (message.staff)
            User.internalBinaryWrite(message.staff, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_cost = 9; */
        if (message.unitCost)
            FractionalMoney.internalBinaryWrite(message.unitCost, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney average_cost = 10; */
        if (message.averageCost)
            FractionalMoney.internalBinaryWrite(message.averageCost, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, int32> status_quantities = 11 [deprecated = true]; */
        for (let k of globalThis.Object.keys(message.statusQuantities))
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.Varint).int32(message.statusQuantities[k as any]).join();
        /* map<int32, int32> status_deltas = 12 [deprecated = true]; */
        for (let k of globalThis.Object.keys(message.statusDeltas))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.Varint).int32(message.statusDeltas[k as any]).join();
        /* rd.proto.money.FractionalMoney valuation = 13; */
        if (message.valuation)
            FractionalMoney.internalBinaryWrite(message.valuation, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry ledger_entry = 14; */
        if (message.ledgerEntry)
            LedgerEntry.internalBinaryWrite(message.ledgerEntry, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_cost_delta = 15; */
        if (message.unitCostDelta)
            FractionalMoney.internalBinaryWrite(message.unitCostDelta, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_id = 16; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchInventoryChangesRes.TransactionTag tag = 17; */
        if (message.tag !== 0)
            writer.tag(17, WireType.Varint).int32(message.tag);
        /* map<int32, rd.proto.decimal.Decimal> status_quantities_v2 = 18; */
        for (let k of globalThis.Object.keys(message.statusQuantitiesV2)) {
            writer.tag(18, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.statusQuantitiesV2[k as any], writer, options);
            writer.join().join();
        }
        /* map<int32, rd.proto.decimal.Decimal> status_deltas_v2 = 19; */
        for (let k of globalThis.Object.keys(message.statusDeltasV2)) {
            writer.tag(19, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.statusDeltasV2[k as any], writer, options);
            writer.join().join();
        }
        /* rd.search.service.InventoryChangeType inventory_change_type = 20; */
        if (message.inventoryChangeType !== 0)
            writer.tag(20, WireType.Varint).int32(message.inventoryChangeType);
        /* bool is_reversal = 21; */
        if (message.isReversal !== false)
            writer.tag(21, WireType.Varint).bool(message.isReversal);
        /* rd.company.Location location = 22; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchInventoryChangesRes.Result
 */
export const SearchInventoryChangesRes_Result = new SearchInventoryChangesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomPriceRulesReq$Type extends MessageType<SearchCustomPriceRulesReq> {
    constructor() {
        super("rd.search.service.SearchCustomPriceRulesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "sort_by", kind: "enum", T: () => ["rd.search.service.CustomPriceRuleSortBy", CustomPriceRuleSortBy, "CUSTOM_PRICE_RULE_SORT_BY_"] },
            { no: 11, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 12, name: "type", kind: "enum", T: () => ["rd.search.service.CustomPriceRuleType", CustomPriceRuleType, "CUSTOM_PRICE_RULE_TYPE_"] },
            { no: 13, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.CustomPriceRuleValidityFilter", CustomPriceRuleValidityFilter] },
            { no: 14, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 17, name: "product_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "customer_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchCustomPriceRulesReq>): SearchCustomPriceRulesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.customerIds = [];
        message.departmentIds = [];
        message.vendorIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.sortBy = 0;
        message.sortOrder = 0;
        message.type = 0;
        message.statuses = [];
        message.jobIds = [];
        message.locationIds = [];
        message.productIds = [];
        message.productTagIds = [];
        message.customerTagIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCustomPriceRulesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomPriceRulesReq): SearchCustomPriceRulesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 5:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 6:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 7:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 8:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 9:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.CustomPriceRuleSortBy sort_by */ 10:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 11:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.CustomPriceRuleType type */ 12:
                    message.type = reader.int32();
                    break;
                case /* repeated rd.search.service.CustomPriceRuleValidityFilter statuses */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 14:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 15:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 16:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_tag_ids */ 17:
                    message.productTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_tag_ids */ 18:
                    message.customerTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomPriceRulesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID customer_ids = 5; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 6; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 7; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 8; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 9; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.CustomPriceRuleSortBy sort_by = 10; */
        if (message.sortBy !== 0)
            writer.tag(10, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 11; */
        if (message.sortOrder !== 0)
            writer.tag(11, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.CustomPriceRuleType type = 12; */
        if (message.type !== 0)
            writer.tag(12, WireType.Varint).int32(message.type);
        /* repeated rd.search.service.CustomPriceRuleValidityFilter statuses = 13; */
        if (message.statuses.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID job_ids = 14; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 15; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 16; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_tag_ids = 17; */
        for (let i = 0; i < message.productTagIds.length; i++)
            UUID.internalBinaryWrite(message.productTagIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_tag_ids = 18; */
        for (let i = 0; i < message.customerTagIds.length; i++)
            UUID.internalBinaryWrite(message.customerTagIds[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomPriceRulesReq
 */
export const SearchCustomPriceRulesReq = new SearchCustomPriceRulesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomPriceRulesRes$Type extends MessageType<SearchCustomPriceRulesRes> {
    constructor() {
        super("rd.search.service.SearchCustomPriceRulesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCustomPriceRulesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCustomPriceRulesRes>): SearchCustomPriceRulesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCustomPriceRulesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomPriceRulesRes): SearchCustomPriceRulesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCustomPriceRulesRes.Result results */ 1:
                    message.results.push(SearchCustomPriceRulesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomPriceRulesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCustomPriceRulesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCustomPriceRulesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomPriceRulesRes
 */
export const SearchCustomPriceRulesRes = new SearchCustomPriceRulesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomPriceRulesRes_Result$Type extends MessageType<SearchCustomPriceRulesRes_Result> {
    constructor() {
        super("rd.search.service.SearchCustomPriceRulesRes.Result", [
            { no: 1, name: "custom", kind: "message", T: () => Custom },
            { no: 10, name: "product_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "customer", kind: "message", T: () => Customer },
            { no: 12, name: "vendor", kind: "message", T: () => Vendor },
            { no: 13, name: "department", kind: "message", T: () => ProductCategory },
            { no: 14, name: "class", kind: "message", T: () => ProductCategory },
            { no: 15, name: "fineline", kind: "message", T: () => ProductCategory },
            { no: 16, name: "product", kind: "message", T: () => Product },
            { no: 18, name: "product_vendor", kind: "message", T: () => Vendor },
            { no: 19, name: "job", kind: "message", T: () => Customer },
            { no: 20, name: "product_department", kind: "message", T: () => ProductCategory },
            { no: 21, name: "product_class", kind: "message", T: () => ProductCategory },
            { no: 22, name: "product_fineline", kind: "message", T: () => ProductCategory },
            { no: 23, name: "location", kind: "message", T: () => Location },
            { no: 24, name: "product_tag", kind: "message", T: () => Tag },
            { no: 25, name: "reference_tier", kind: "message", T: () => PricingTiers_Tier },
            { no: 26, name: "customer_tag", kind: "message", T: () => Tag },
            { no: 27, name: "computed_price", kind: "message", T: () => Money },
            { no: 28, name: "computed_margin_percent", kind: "message", T: () => Decimal },
            { no: 29, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier },
            { no: 30, name: "matched_cost_product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<SearchCustomPriceRulesRes_Result>): SearchCustomPriceRulesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productCount = 0;
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCustomPriceRulesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomPriceRulesRes_Result): SearchCustomPriceRulesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.price.Custom custom */ 1:
                    message.custom = Custom.internalBinaryRead(reader, reader.uint32(), options, message.custom);
                    break;
                case /* int32 product_count */ 10:
                    message.productCount = reader.int32();
                    break;
                case /* rd.customer.Customer customer */ 11:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.vendors.Vendor vendor */ 12:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.company.ProductCategory department */ 13:
                    message.department = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* rd.company.ProductCategory class */ 14:
                    message.class = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.class);
                    break;
                case /* rd.company.ProductCategory fineline */ 15:
                    message.fineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.fineline);
                    break;
                case /* rd.product.Product product */ 16:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.vendors.Vendor product_vendor */ 18:
                    message.productVendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.productVendor);
                    break;
                case /* rd.customer.Customer job */ 19:
                    message.job = Customer.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* rd.company.ProductCategory product_department */ 20:
                    message.productDepartment = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productDepartment);
                    break;
                case /* rd.company.ProductCategory product_class */ 21:
                    message.productClass = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productClass);
                    break;
                case /* rd.company.ProductCategory product_fineline */ 22:
                    message.productFineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productFineline);
                    break;
                case /* rd.company.Location location */ 23:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.tag.Tag product_tag */ 24:
                    message.productTag = Tag.internalBinaryRead(reader, reader.uint32(), options, message.productTag);
                    break;
                case /* rd.company.PricingTiers.Tier reference_tier */ 25:
                    message.referenceTier = PricingTiers_Tier.internalBinaryRead(reader, reader.uint32(), options, message.referenceTier);
                    break;
                case /* rd.tag.Tag customer_tag */ 26:
                    message.customerTag = Tag.internalBinaryRead(reader, reader.uint32(), options, message.customerTag);
                    break;
                case /* rd.proto.money.Money computed_price */ 27:
                    message.computedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.computedPrice);
                    break;
                case /* rd.proto.decimal.Decimal computed_margin_percent */ 28:
                    message.computedMarginPercent = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.computedMarginPercent);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 29:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.product.Product matched_cost_product */ 30:
                    message.matchedCostProduct = Product.internalBinaryRead(reader, reader.uint32(), options, message.matchedCostProduct);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomPriceRulesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.price.Custom custom = 1; */
        if (message.custom)
            Custom.internalBinaryWrite(message.custom, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 product_count = 10; */
        if (message.productCount !== 0)
            writer.tag(10, WireType.Varint).int32(message.productCount);
        /* rd.customer.Customer customer = 11; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 12; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory department = 13; */
        if (message.department)
            ProductCategory.internalBinaryWrite(message.department, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory class = 14; */
        if (message.class)
            ProductCategory.internalBinaryWrite(message.class, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory fineline = 15; */
        if (message.fineline)
            ProductCategory.internalBinaryWrite(message.fineline, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 16; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor product_vendor = 18; */
        if (message.productVendor)
            Vendor.internalBinaryWrite(message.productVendor, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer job = 19; */
        if (message.job)
            Customer.internalBinaryWrite(message.job, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_department = 20; */
        if (message.productDepartment)
            ProductCategory.internalBinaryWrite(message.productDepartment, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_class = 21; */
        if (message.productClass)
            ProductCategory.internalBinaryWrite(message.productClass, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_fineline = 22; */
        if (message.productFineline)
            ProductCategory.internalBinaryWrite(message.productFineline, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 23; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.tag.Tag product_tag = 24; */
        if (message.productTag)
            Tag.internalBinaryWrite(message.productTag, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingTiers.Tier reference_tier = 25; */
        if (message.referenceTier)
            PricingTiers_Tier.internalBinaryWrite(message.referenceTier, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.tag.Tag customer_tag = 26; */
        if (message.customerTag)
            Tag.internalBinaryWrite(message.customerTag, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money computed_price = 27; */
        if (message.computedPrice)
            Money.internalBinaryWrite(message.computedPrice, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal computed_margin_percent = 28; */
        if (message.computedMarginPercent)
            Decimal.internalBinaryWrite(message.computedMarginPercent, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 29; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product matched_cost_product = 30; */
        if (message.matchedCostProduct)
            Product.internalBinaryWrite(message.matchedCostProduct, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomPriceRulesRes.Result
 */
export const SearchCustomPriceRulesRes_Result = new SearchCustomPriceRulesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomPriceRulesReq$Type extends MessageType<BulkExportCustomPriceRulesReq> {
    constructor() {
        super("rd.search.service.BulkExportCustomPriceRulesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "sort_by", kind: "enum", T: () => ["rd.search.service.CustomPriceRuleSortBy", CustomPriceRuleSortBy, "CUSTOM_PRICE_RULE_SORT_BY_"] },
            { no: 8, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 9, name: "type", kind: "enum", T: () => ["rd.search.service.CustomPriceRuleType", CustomPriceRuleType, "CUSTOM_PRICE_RULE_TYPE_"] },
            { no: 10, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.CustomPriceRuleValidityFilter", CustomPriceRuleValidityFilter] },
            { no: 11, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "product_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "customer_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomPriceRulesReq>): BulkExportCustomPriceRulesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.departmentIds = [];
        message.vendorIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.sortBy = 0;
        message.sortOrder = 0;
        message.type = 0;
        message.statuses = [];
        message.jobIds = [];
        message.isTemplate = false;
        message.locationIds = [];
        message.productIds = [];
        message.productTagIds = [];
        message.customerTagIds = [];
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomPriceRulesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomPriceRulesReq): BulkExportCustomPriceRulesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 2:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 3:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 4:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 5:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 6:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.CustomPriceRuleSortBy sort_by */ 7:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.CustomPriceRuleType type */ 9:
                    message.type = reader.int32();
                    break;
                case /* repeated rd.search.service.CustomPriceRuleValidityFilter statuses */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 11:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_template */ 12:
                    message.isTemplate = reader.bool();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 13:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 14:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_tag_ids */ 15:
                    message.productTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_tag_ids */ 16:
                    message.customerTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomPriceRulesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID customer_ids = 2; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 3; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 4; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 5; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 6; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.CustomPriceRuleSortBy sort_by = 7; */
        if (message.sortBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.CustomPriceRuleType type = 9; */
        if (message.type !== 0)
            writer.tag(9, WireType.Varint).int32(message.type);
        /* repeated rd.search.service.CustomPriceRuleValidityFilter statuses = 10; */
        if (message.statuses.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID job_ids = 11; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool is_template = 12; */
        if (message.isTemplate !== false)
            writer.tag(12, WireType.Varint).bool(message.isTemplate);
        /* repeated rd.proto.uuid.UUID location_ids = 13; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 14; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_tag_ids = 15; */
        for (let i = 0; i < message.productTagIds.length; i++)
            UUID.internalBinaryWrite(message.productTagIds[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_tag_ids = 16; */
        for (let i = 0; i < message.customerTagIds.length; i++)
            UUID.internalBinaryWrite(message.customerTagIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomPriceRulesReq
 */
export const BulkExportCustomPriceRulesReq = new BulkExportCustomPriceRulesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportCustomPriceRulesRes$Type extends MessageType<BulkExportCustomPriceRulesRes> {
    constructor() {
        super("rd.search.service.BulkExportCustomPriceRulesRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportCustomPriceRulesRes>): BulkExportCustomPriceRulesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportCustomPriceRulesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportCustomPriceRulesRes): BulkExportCustomPriceRulesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportCustomPriceRulesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportCustomPriceRulesRes
 */
export const BulkExportCustomPriceRulesRes = new BulkExportCustomPriceRulesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceTierRulesReq$Type extends MessageType<SearchPriceTierRulesReq> {
    constructor() {
        super("rd.search.service.SearchPriceTierRulesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "pricing_tier_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "product_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "price_strategies", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.price.Rule.PriceStrategy", Rule_PriceStrategy, "PRICE_STRATEGY_"] },
            { no: 13, name: "pricing_region_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "current_pricing_region_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchPriceTierRulesReq>): SearchPriceTierRulesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.pricingTierIdString = "";
        message.vendorIds = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.productTagIds = [];
        message.productIds = [];
        message.priceStrategies = [];
        message.pricingRegionIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchPriceTierRulesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceTierRulesReq): SearchPriceTierRulesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* string pricing_tier_id_string */ 5:
                    message.pricingTierIdString = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 6:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 7:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 8:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 9:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_tag_ids */ 10:
                    message.productTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 11:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.price.Rule.PriceStrategy price_strategies */ 12:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.priceStrategies.push(reader.int32());
                    else
                        message.priceStrategies.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID pricing_region_ids */ 13:
                    message.pricingRegionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID current_pricing_region_id */ 14:
                    message.currentPricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentPricingRegionId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceTierRulesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* string pricing_tier_id_string = 5; */
        if (message.pricingTierIdString !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pricingTierIdString);
        /* repeated rd.proto.uuid.UUID vendor_ids = 6; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 7; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 8; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 9; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_tag_ids = 10; */
        for (let i = 0; i < message.productTagIds.length; i++)
            UUID.internalBinaryWrite(message.productTagIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 11; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Rule.PriceStrategy price_strategies = 12; */
        if (message.priceStrategies.length) {
            writer.tag(12, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.priceStrategies.length; i++)
                writer.int32(message.priceStrategies[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID pricing_region_ids = 13; */
        for (let i = 0; i < message.pricingRegionIds.length; i++)
            UUID.internalBinaryWrite(message.pricingRegionIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_pricing_region_id = 14; */
        if (message.currentPricingRegionId)
            UUID.internalBinaryWrite(message.currentPricingRegionId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceTierRulesReq
 */
export const SearchPriceTierRulesReq = new SearchPriceTierRulesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceTierRulesRes$Type extends MessageType<SearchPriceTierRulesRes> {
    constructor() {
        super("rd.search.service.SearchPriceTierRulesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchPriceTierRulesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchPriceTierRulesRes>): SearchPriceTierRulesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchPriceTierRulesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceTierRulesRes): SearchPriceTierRulesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchPriceTierRulesRes.Result results */ 1:
                    message.results.push(SearchPriceTierRulesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceTierRulesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchPriceTierRulesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchPriceTierRulesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceTierRulesRes
 */
export const SearchPriceTierRulesRes = new SearchPriceTierRulesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceTierRulesRes_Result$Type extends MessageType<SearchPriceTierRulesRes_Result> {
    constructor() {
        super("rd.search.service.SearchPriceTierRulesRes.Result", [
            { no: 1, name: "tier_rule", kind: "message", T: () => TierRule },
            { no: 2, name: "product_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "vendor", kind: "message", T: () => Vendor },
            { no: 4, name: "department", kind: "message", T: () => ProductCategory },
            { no: 5, name: "class", kind: "message", T: () => ProductCategory },
            { no: 6, name: "fineline", kind: "message", T: () => ProductCategory },
            { no: 7, name: "product", kind: "message", T: () => Product },
            { no: 17, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier },
            { no: 8, name: "product_tag", kind: "message", T: () => Tag },
            { no: 9, name: "pricing_region", kind: "message", T: () => PricingRegion }
        ]);
    }
    create(value?: PartialMessage<SearchPriceTierRulesRes_Result>): SearchPriceTierRulesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productCount = 0;
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<SearchPriceTierRulesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceTierRulesRes_Result): SearchPriceTierRulesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.price.TierRule tier_rule */ 1:
                    message.tierRule = TierRule.internalBinaryRead(reader, reader.uint32(), options, message.tierRule);
                    break;
                case /* int32 product_count */ 2:
                    message.productCount = reader.int32();
                    break;
                case /* rd.vendors.Vendor vendor */ 3:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.company.ProductCategory department */ 4:
                    message.department = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* rd.company.ProductCategory class */ 5:
                    message.class = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.class);
                    break;
                case /* rd.company.ProductCategory fineline */ 6:
                    message.fineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.fineline);
                    break;
                case /* rd.product.Product product */ 7:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 17:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.tag.Tag product_tag */ 8:
                    message.productTag = Tag.internalBinaryRead(reader, reader.uint32(), options, message.productTag);
                    break;
                case /* rd.company.PricingRegion pricing_region */ 9:
                    message.pricingRegion = PricingRegion.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegion);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceTierRulesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.price.TierRule tier_rule = 1; */
        if (message.tierRule)
            TierRule.internalBinaryWrite(message.tierRule, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 product_count = 2; */
        if (message.productCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.productCount);
        /* rd.vendors.Vendor vendor = 3; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory department = 4; */
        if (message.department)
            ProductCategory.internalBinaryWrite(message.department, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory class = 5; */
        if (message.class)
            ProductCategory.internalBinaryWrite(message.class, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory fineline = 6; */
        if (message.fineline)
            ProductCategory.internalBinaryWrite(message.fineline, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 7; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.tag.Tag product_tag = 8; */
        if (message.productTag)
            Tag.internalBinaryWrite(message.productTag, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingRegion pricing_region = 9; */
        if (message.pricingRegion)
            PricingRegion.internalBinaryWrite(message.pricingRegion, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 17; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceTierRulesRes.Result
 */
export const SearchPriceTierRulesRes_Result = new SearchPriceTierRulesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJobsReq$Type extends MessageType<SearchJobsReq> {
    constructor() {
        super("rd.search.service.SearchJobsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderJobsBy", OrderJobsBy, "ORDER_JOBS_BY_"] },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 8, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchJobsReq>): SearchJobsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isActiveFilter = 0;
        message.customerIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchJobsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJobsReq): SearchJobsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.OrderJobsBy order_by */ 6:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 8:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 9:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJobsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.OrderJobsBy order_by = 6; */
        if (message.orderBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.BoolFilter is_active_filter = 8; */
        if (message.isActiveFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.isActiveFilter);
        /* repeated rd.proto.uuid.UUID customer_ids = 9; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJobsReq
 */
export const SearchJobsReq = new SearchJobsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJobsRes$Type extends MessageType<SearchJobsRes> {
    constructor() {
        super("rd.search.service.SearchJobsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchJobsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchJobsRes>): SearchJobsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchJobsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJobsRes): SearchJobsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchJobsRes.Result results */ 1:
                    message.results.push(SearchJobsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJobsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchJobsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchJobsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJobsRes
 */
export const SearchJobsRes = new SearchJobsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJobsRes_Result$Type extends MessageType<SearchJobsRes_Result> {
    constructor() {
        super("rd.search.service.SearchJobsRes.Result", [
            { no: 1, name: "job", kind: "message", T: () => Customer },
            { no: 7, name: "total_balance", kind: "message", T: () => Money },
            { no: 8, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value?: PartialMessage<SearchJobsRes_Result>): SearchJobsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchJobsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJobsRes_Result): SearchJobsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.customer.Customer job */ 1:
                    message.job = Customer.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* rd.proto.money.Money total_balance */ 7:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                case /* rd.customer.Customer customer */ 8:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJobsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.customer.Customer job = 1; */
        if (message.job)
            Customer.internalBinaryWrite(message.job, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 7; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 8; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJobsRes.Result
 */
export const SearchJobsRes_Result = new SearchJobsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportJobsReq$Type extends MessageType<BulkExportJobsReq> {
    constructor() {
        super("rd.search.service.BulkExportJobsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderJobsBy", OrderJobsBy, "ORDER_JOBS_BY_"] },
            { no: 4, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 5, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 6, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportJobsReq>): BulkExportJobsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isActiveFilter = 0;
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportJobsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportJobsReq): BulkExportJobsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 2:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.OrderJobsBy order_by */ 3:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 5:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* bool is_template */ 6:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportJobsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID customer_ids = 2; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.OrderJobsBy order_by = 3; */
        if (message.orderBy !== 0)
            writer.tag(3, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.BoolFilter is_active_filter = 5; */
        if (message.isActiveFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActiveFilter);
        /* bool is_template = 6; */
        if (message.isTemplate !== false)
            writer.tag(6, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportJobsReq
 */
export const BulkExportJobsReq = new BulkExportJobsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportJobsRes$Type extends MessageType<BulkExportJobsRes> {
    constructor() {
        super("rd.search.service.BulkExportJobsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportJobsRes>): BulkExportJobsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportJobsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportJobsRes): BulkExportJobsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportJobsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportJobsRes
 */
export const BulkExportJobsRes = new BulkExportJobsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTagsReq$Type extends MessageType<SearchTagsReq> {
    constructor() {
        super("rd.search.service.SearchTagsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchTagsReq.OrderBy", SearchTagsReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.tag.Tag.Type", Tag_Type, "TYPE_"] },
            { no: 8, name: "colors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.tag.Tag.Color", Tag_Color, "COLOR_"] }
        ]);
    }
    create(value?: PartialMessage<SearchTagsReq>): SearchTagsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.colors = [];
        if (value !== undefined)
            reflectionMergePartial<SearchTagsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTagsReq): SearchTagsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchTagsReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.tag.Tag.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.tag.Tag.Color colors */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.colors.push(reader.int32());
                    else
                        message.colors.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTagsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchTagsReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.tag.Tag.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.tag.Tag.Color colors = 8; */
        if (message.colors.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.colors.length; i++)
                writer.int32(message.colors[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTagsReq
 */
export const SearchTagsReq = new SearchTagsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTagsRes$Type extends MessageType<SearchTagsRes> {
    constructor() {
        super("rd.search.service.SearchTagsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchTagsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchTagsRes>): SearchTagsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchTagsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTagsRes): SearchTagsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchTagsRes.Result results */ 1:
                    message.results.push(SearchTagsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTagsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchTagsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchTagsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTagsRes
 */
export const SearchTagsRes = new SearchTagsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTagsRes_Result$Type extends MessageType<SearchTagsRes_Result> {
    constructor() {
        super("rd.search.service.SearchTagsRes.Result", [
            { no: 1, name: "tag", kind: "message", T: () => Tag },
            { no: 2, name: "tagged_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SearchTagsRes_Result>): SearchTagsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taggedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchTagsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTagsRes_Result): SearchTagsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.tag.Tag tag */ 1:
                    message.tag = Tag.internalBinaryRead(reader, reader.uint32(), options, message.tag);
                    break;
                case /* int32 tagged_count */ 2:
                    message.taggedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTagsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.tag.Tag tag = 1; */
        if (message.tag)
            Tag.internalBinaryWrite(message.tag, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 tagged_count = 2; */
        if (message.taggedCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.taggedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTagsRes.Result
 */
export const SearchTagsRes_Result = new SearchTagsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStagedProductsToOrderReq$Type extends MessageType<SearchStagedProductsToOrderReq> {
    constructor() {
        super("rd.search.service.SearchStagedProductsToOrderReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 11, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 12, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchStagedProductsToOrderReq.OrderBy", SearchStagedProductsToOrderReq_OrderBy, "ORDER_BY_"] },
            { no: 13, name: "is_active_in_buyers_list_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchStagedProductsToOrderReq>): SearchStagedProductsToOrderReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.customerIds = [];
        message.jobIds = [];
        message.vendorIds = [];
        message.productIds = [];
        message.saleIds = [];
        message.sortOrder = 0;
        message.orderBy = 0;
        message.isActiveInBuyersListFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchStagedProductsToOrderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStagedProductsToOrderReq): SearchStagedProductsToOrderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 5:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 6:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 7:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 8:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 9:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 10:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* rd.search.service.SortOrder sort_order */ 11:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.SearchStagedProductsToOrderReq.OrderBy order_by */ 12:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_in_buyers_list_filter */ 13:
                    message.isActiveInBuyersListFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStagedProductsToOrderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID customer_ids = 5; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 6; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 7; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 8; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_ids = 9; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange created_at_range = 10; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SortOrder sort_order = 11; */
        if (message.sortOrder !== 0)
            writer.tag(11, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.SearchStagedProductsToOrderReq.OrderBy order_by = 12; */
        if (message.orderBy !== 0)
            writer.tag(12, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.BoolFilter is_active_in_buyers_list_filter = 13; */
        if (message.isActiveInBuyersListFilter !== 0)
            writer.tag(13, WireType.Varint).int32(message.isActiveInBuyersListFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStagedProductsToOrderReq
 */
export const SearchStagedProductsToOrderReq = new SearchStagedProductsToOrderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStagedProductsToOrderRes$Type extends MessageType<SearchStagedProductsToOrderRes> {
    constructor() {
        super("rd.search.service.SearchStagedProductsToOrderRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStagedProductsToOrderRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStagedProductsToOrderRes>): SearchStagedProductsToOrderRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStagedProductsToOrderRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStagedProductsToOrderRes): SearchStagedProductsToOrderRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchStagedProductsToOrderRes.Result results */ 1:
                    message.results.push(SearchStagedProductsToOrderRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStagedProductsToOrderRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchStagedProductsToOrderRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchStagedProductsToOrderRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStagedProductsToOrderRes
 */
export const SearchStagedProductsToOrderRes = new SearchStagedProductsToOrderRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStagedProductsToOrderRes_LinkedOrder$Type extends MessageType<SearchStagedProductsToOrderRes_LinkedOrder> {
    constructor() {
        super("rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStagedProductsToOrderRes_LinkedOrder>): SearchStagedProductsToOrderRes_LinkedOrder {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStagedProductsToOrderRes_LinkedOrder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStagedProductsToOrderRes_LinkedOrder): SearchStagedProductsToOrderRes_LinkedOrder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStagedProductsToOrderRes_LinkedOrder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder
 */
export const SearchStagedProductsToOrderRes_LinkedOrder = new SearchStagedProductsToOrderRes_LinkedOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStagedProductsToOrderRes_LinkedShipment$Type extends MessageType<SearchStagedProductsToOrderRes_LinkedShipment> {
    constructor() {
        super("rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStagedProductsToOrderRes_LinkedShipment>): SearchStagedProductsToOrderRes_LinkedShipment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStagedProductsToOrderRes_LinkedShipment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStagedProductsToOrderRes_LinkedShipment): SearchStagedProductsToOrderRes_LinkedShipment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStagedProductsToOrderRes_LinkedShipment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment
 */
export const SearchStagedProductsToOrderRes_LinkedShipment = new SearchStagedProductsToOrderRes_LinkedShipment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStagedProductsToOrderRes_Result$Type extends MessageType<SearchStagedProductsToOrderRes_Result> {
    constructor() {
        super("rd.search.service.SearchStagedProductsToOrderRes.Result", [
            { no: 4, name: "product", kind: "message", T: () => Product },
            { no: 8, name: "matched_price_product", kind: "message", T: () => Product },
            { no: 9, name: "matched_cost_product", kind: "message", T: () => Product },
            { no: 10, name: "inventories", kind: "message", T: () => Inventories },
            { no: 12, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 13, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier },
            { no: 14, name: "required_quantity", kind: "message", T: () => Decimal },
            { no: 15, name: "quantity_on_draft_order", kind: "message", T: () => Decimal },
            { no: 16, name: "quantity_on_order", kind: "message", T: () => Decimal },
            { no: 17, name: "quantity_received", kind: "message", T: () => Decimal },
            { no: 18, name: "remaining_quantity", kind: "message", T: () => Decimal },
            { no: 19, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 20, name: "is_active_in_buyers_list", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "product_id", kind: "message", T: () => UUID },
            { no: 22, name: "product_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "product_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "sale_id", kind: "message", T: () => UUID },
            { no: 26, name: "sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 28, name: "price", kind: "message", T: () => Money },
            { no: 29, name: "linked_orders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStagedProductsToOrderRes_LinkedOrder },
            { no: 30, name: "linked_shipments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStagedProductsToOrderRes_LinkedShipment },
            { no: 31, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 34, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 36, name: "price_fractional", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<SearchStagedProductsToOrderRes_Result>): SearchStagedProductsToOrderRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierPrices = [];
        message.isActiveInBuyersList = false;
        message.productIdentifier = "";
        message.productName = "";
        message.vendorName = "";
        message.saleIdentifier = "";
        message.linkedOrders = [];
        message.linkedShipments = [];
        message.customerName = "";
        message.jobName = "";
        message.notes = "";
        message.customFields = [];
        if (value !== undefined)
            reflectionMergePartial<SearchStagedProductsToOrderRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStagedProductsToOrderRes_Result): SearchStagedProductsToOrderRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.Product product */ 4:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.product.Product matched_price_product */ 8:
                    message.matchedPriceProduct = Product.internalBinaryRead(reader, reader.uint32(), options, message.matchedPriceProduct);
                    break;
                case /* rd.product.Product matched_cost_product */ 9:
                    message.matchedCostProduct = Product.internalBinaryRead(reader, reader.uint32(), options, message.matchedCostProduct);
                    break;
                case /* rd.product.Inventories inventories */ 10:
                    message.inventories = Inventories.internalBinaryRead(reader, reader.uint32(), options, message.inventories);
                    break;
                case /* rd.catalog.Product catalog_product */ 12:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 13:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.decimal.Decimal required_quantity */ 14:
                    message.requiredQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.requiredQuantity);
                    break;
                case /* rd.proto.decimal.Decimal quantity_on_draft_order */ 15:
                    message.quantityOnDraftOrder = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOnDraftOrder);
                    break;
                case /* rd.proto.decimal.Decimal quantity_on_order */ 16:
                    message.quantityOnOrder = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOnOrder);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received */ 17:
                    message.quantityReceived = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceived);
                    break;
                case /* rd.proto.decimal.Decimal remaining_quantity */ 18:
                    message.remainingQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.remainingQuantity);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 19:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* bool is_active_in_buyers_list */ 20:
                    message.isActiveInBuyersList = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 21:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* string product_identifier */ 22:
                    message.productIdentifier = reader.string();
                    break;
                case /* string product_name */ 23:
                    message.productName = reader.string();
                    break;
                case /* string vendor_name */ 24:
                    message.vendorName = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 25:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* string sale_identifier */ 26:
                    message.saleIdentifier = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 27:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.proto.money.Money price */ 28:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder linked_orders */ 29:
                    message.linkedOrders.push(SearchStagedProductsToOrderRes_LinkedOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment linked_shipments */ 30:
                    message.linkedShipments.push(SearchStagedProductsToOrderRes_LinkedShipment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string customer_name */ 31:
                    message.customerName = reader.string();
                    break;
                case /* string job_name */ 32:
                    message.jobName = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 33:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* string notes */ 34:
                    message.notes = reader.string();
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 35:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.FractionalMoney price_fractional */ 36:
                    message.priceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.priceFractional);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStagedProductsToOrderRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.Product product = 4; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product matched_price_product = 8; */
        if (message.matchedPriceProduct)
            Product.internalBinaryWrite(message.matchedPriceProduct, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product matched_cost_product = 9; */
        if (message.matchedCostProduct)
            Product.internalBinaryWrite(message.matchedCostProduct, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Inventories inventories = 10; */
        if (message.inventories)
            Inventories.internalBinaryWrite(message.inventories, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product catalog_product = 12; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 13; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal required_quantity = 14; */
        if (message.requiredQuantity)
            Decimal.internalBinaryWrite(message.requiredQuantity, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_on_draft_order = 15; */
        if (message.quantityOnDraftOrder)
            Decimal.internalBinaryWrite(message.quantityOnDraftOrder, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_on_order = 16; */
        if (message.quantityOnOrder)
            Decimal.internalBinaryWrite(message.quantityOnOrder, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received = 17; */
        if (message.quantityReceived)
            Decimal.internalBinaryWrite(message.quantityReceived, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal remaining_quantity = 18; */
        if (message.remainingQuantity)
            Decimal.internalBinaryWrite(message.remainingQuantity, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 19; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active_in_buyers_list = 20; */
        if (message.isActiveInBuyersList !== false)
            writer.tag(20, WireType.Varint).bool(message.isActiveInBuyersList);
        /* rd.proto.uuid.UUID product_id = 21; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* string product_identifier = 22; */
        if (message.productIdentifier !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.productIdentifier);
        /* string product_name = 23; */
        if (message.productName !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.productName);
        /* string vendor_name = 24; */
        if (message.vendorName !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.vendorName);
        /* rd.proto.uuid.UUID sale_id = 25; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* string sale_identifier = 26; */
        if (message.saleIdentifier !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.saleIdentifier);
        /* google.protobuf.Timestamp created_at = 27; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money price = 28; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedOrder linked_orders = 29; */
        for (let i = 0; i < message.linkedOrders.length; i++)
            SearchStagedProductsToOrderRes_LinkedOrder.internalBinaryWrite(message.linkedOrders[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SearchStagedProductsToOrderRes.LinkedShipment linked_shipments = 30; */
        for (let i = 0; i < message.linkedShipments.length; i++)
            SearchStagedProductsToOrderRes_LinkedShipment.internalBinaryWrite(message.linkedShipments[i], writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* string customer_name = 31; */
        if (message.customerName !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.customerName);
        /* string job_name = 32; */
        if (message.jobName !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.jobName);
        /* rd.proto.uuid.UUID sale_product_id = 33; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 34; */
        if (message.notes !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.notes);
        /* repeated rd.company.SaleForm.CustomField custom_fields = 35; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney price_fractional = 36; */
        if (message.priceFractional)
            FractionalMoney.internalBinaryWrite(message.priceFractional, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStagedProductsToOrderRes.Result
 */
export const SearchStagedProductsToOrderRes_Result = new SearchStagedProductsToOrderRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewGeneratedOrderProductsReq$Type extends MessageType<PreviewGeneratedOrderProductsReq> {
    constructor() {
        super("rd.search.service.PreviewGeneratedOrderProductsReq", [
            { no: 1, name: "mode", kind: "enum", T: () => ["rd.search.service.PreviewGeneratedOrderProductsReq.Mode", PreviewGeneratedOrderProductsReq_Mode, "MODE_"], options: { "rd.validator.require": true } },
            { no: 2, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 4, name: "weeks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "match_vendor_on_all_costs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "filters", kind: "message", T: () => OrderProductFilter }
        ]);
    }
    create(value?: PartialMessage<PreviewGeneratedOrderProductsReq>): PreviewGeneratedOrderProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mode = 0;
        message.weeks = 0;
        message.matchVendorOnAllCosts = false;
        if (value !== undefined)
            reflectionMergePartial<PreviewGeneratedOrderProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreviewGeneratedOrderProductsReq): PreviewGeneratedOrderProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.search.service.PreviewGeneratedOrderProductsReq.Mode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 2:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* int32 weeks */ 4:
                    message.weeks = reader.int32();
                    break;
                case /* bool match_vendor_on_all_costs */ 5:
                    message.matchVendorOnAllCosts = reader.bool();
                    break;
                case /* rd.txn.OrderProductFilter filters */ 6:
                    message.filters = OrderProductFilter.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreviewGeneratedOrderProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.search.service.PreviewGeneratedOrderProductsReq.Mode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* rd.proto.uuid.UUID vendor_id = 2; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 weeks = 4; */
        if (message.weeks !== 0)
            writer.tag(4, WireType.Varint).int32(message.weeks);
        /* bool match_vendor_on_all_costs = 5; */
        if (message.matchVendorOnAllCosts !== false)
            writer.tag(5, WireType.Varint).bool(message.matchVendorOnAllCosts);
        /* rd.txn.OrderProductFilter filters = 6; */
        if (message.filters)
            OrderProductFilter.internalBinaryWrite(message.filters, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PreviewGeneratedOrderProductsReq
 */
export const PreviewGeneratedOrderProductsReq = new PreviewGeneratedOrderProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewGeneratedOrderProductsRes$Type extends MessageType<PreviewGeneratedOrderProductsRes> {
    constructor() {
        super("rd.search.service.PreviewGeneratedOrderProductsRes", [
            { no: 1, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<PreviewGeneratedOrderProductsRes>): PreviewGeneratedOrderProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productIds = [];
        if (value !== undefined)
            reflectionMergePartial<PreviewGeneratedOrderProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreviewGeneratedOrderProductsRes): PreviewGeneratedOrderProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID product_ids */ 1:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreviewGeneratedOrderProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID product_ids = 1; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PreviewGeneratedOrderProductsRes
 */
export const PreviewGeneratedOrderProductsRes = new PreviewGeneratedOrderProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinanceChargesReq$Type extends MessageType<SearchFinanceChargesReq> {
    constructor() {
        super("rd.search.service.SearchFinanceChargesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SearchFinanceChargesReq>): SearchFinanceChargesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.customerIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchFinanceChargesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinanceChargesReq): SearchFinanceChargesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 2:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 3:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 4:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 5:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinanceChargesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.timestamprange.TimestampRange created_at_range = 2; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 3; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 4; */
        if (message.cursor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 5; */
        if (message.offset !== 0)
            writer.tag(5, WireType.Varint).int32(message.offset);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinanceChargesReq
 */
export const SearchFinanceChargesReq = new SearchFinanceChargesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinanceChargesRes$Type extends MessageType<SearchFinanceChargesRes> {
    constructor() {
        super("rd.search.service.SearchFinanceChargesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchFinanceChargesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchFinanceChargesRes>): SearchFinanceChargesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchFinanceChargesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinanceChargesRes): SearchFinanceChargesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchFinanceChargesRes.Result results */ 1:
                    message.results.push(SearchFinanceChargesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinanceChargesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchFinanceChargesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchFinanceChargesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinanceChargesRes
 */
export const SearchFinanceChargesRes = new SearchFinanceChargesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinanceChargesRes_OutstandingTransaction$Type extends MessageType<SearchFinanceChargesRes_OutstandingTransaction> {
    constructor() {
        super("rd.search.service.SearchFinanceChargesRes.OutstandingTransaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "type", kind: "enum", T: () => ["rd.search.service.SearchFinanceChargesRes.OutstandingTransaction.Type", SearchFinanceChargesRes_OutstandingTransaction_Type, "TYPE_"] },
            { no: 3, name: "sale", kind: "message", T: () => Sale },
            { no: 4, name: "finance_charge", kind: "message", T: () => LedgerEntry },
            { no: 5, name: "customer", kind: "message", T: () => Customer },
            { no: 6, name: "location", kind: "message", T: () => Location },
            { no: 7, name: "outstanding_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchFinanceChargesRes_OutstandingTransaction>): SearchFinanceChargesRes_OutstandingTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchFinanceChargesRes_OutstandingTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinanceChargesRes_OutstandingTransaction): SearchFinanceChargesRes_OutstandingTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.search.service.SearchFinanceChargesRes.OutstandingTransaction.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* rd.txn.Sale sale */ 3:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.ledger.LedgerEntry finance_charge */ 4:
                    message.financeCharge = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.financeCharge);
                    break;
                case /* rd.customer.Customer customer */ 5:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.company.Location location */ 6:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.proto.money.Money outstanding_balance */ 7:
                    message.outstandingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.outstandingBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchFinanceChargesRes_OutstandingTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchFinanceChargesRes.OutstandingTransaction.Type type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* rd.txn.Sale sale = 3; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry finance_charge = 4; */
        if (message.financeCharge)
            LedgerEntry.internalBinaryWrite(message.financeCharge, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 5; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 6; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money outstanding_balance = 7; */
        if (message.outstandingBalance)
            Money.internalBinaryWrite(message.outstandingBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinanceChargesRes.OutstandingTransaction
 */
export const SearchFinanceChargesRes_OutstandingTransaction = new SearchFinanceChargesRes_OutstandingTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchFinanceChargesRes_Result$Type extends MessageType<SearchFinanceChargesRes_Result> {
    constructor() {
        super("rd.search.service.SearchFinanceChargesRes.Result", [
            { no: 1, name: "finance_charge_ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 2, name: "customer", kind: "message", T: () => Customer },
            { no: 3, name: "outstanding_transactions_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SearchFinanceChargesRes_OutstandingTransaction } }
        ]);
    }
    create(value?: PartialMessage<SearchFinanceChargesRes_Result>): SearchFinanceChargesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outstandingTransactionsById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchFinanceChargesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchFinanceChargesRes_Result): SearchFinanceChargesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.ledger.LedgerEntry finance_charge_ledger_entry */ 1:
                    message.financeChargeLedgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.financeChargeLedgerEntry);
                    break;
                case /* rd.customer.Customer customer */ 2:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* map<string, rd.search.service.SearchFinanceChargesRes.OutstandingTransaction> outstanding_transactions_by_id */ 3:
                    this.binaryReadMap3(message.outstandingTransactionsById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SearchFinanceChargesRes_Result["outstandingTransactionsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchFinanceChargesRes_Result["outstandingTransactionsById"] | undefined, val: SearchFinanceChargesRes_Result["outstandingTransactionsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SearchFinanceChargesRes_OutstandingTransaction.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchFinanceChargesRes.Result.outstanding_transactions_by_id");
            }
        }
        map[key ?? ""] = val ?? SearchFinanceChargesRes_OutstandingTransaction.create();
    }
    internalBinaryWrite(message: SearchFinanceChargesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.ledger.LedgerEntry finance_charge_ledger_entry = 1; */
        if (message.financeChargeLedgerEntry)
            LedgerEntry.internalBinaryWrite(message.financeChargeLedgerEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 2; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.search.service.SearchFinanceChargesRes.OutstandingTransaction> outstanding_transactions_by_id = 3; */
        for (let k of globalThis.Object.keys(message.outstandingTransactionsById)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SearchFinanceChargesRes_OutstandingTransaction.internalBinaryWrite(message.outstandingTransactionsById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchFinanceChargesRes.Result
 */
export const SearchFinanceChargesRes_Result = new SearchFinanceChargesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementsReq$Type extends MessageType<SearchStatementsReq> {
    constructor() {
        super("rd.search.service.SearchStatementsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "finance_charge_settings_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "is_on_credit_hold_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 7, name: "financing_term_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "pricing_tier_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "rep_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 11, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "statement_run_id", kind: "message", T: () => UUID },
            { no: 13, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderStatementsBy", OrderStatementsBy, "ORDER_STATEMENTS_BY_"] },
            { no: 14, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 15, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.statement.Statement.Status", Statement_Status, "STATUS_"] },
            { no: 16, name: "isMailed", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 17, name: "autopay_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.statement.Statement.AutopayStatus", Statement_AutopayStatus, "AUTOPAY_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<SearchStatementsReq>): SearchStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.financeChargeSettingsIds = [];
        message.isOnCreditHoldFilter = 0;
        message.financingTermIdStrings = [];
        message.pricingTierIdStrings = [];
        message.repStaffIds = [];
        message.isActiveFilter = 0;
        message.tagIds = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        message.statuses = [];
        message.isMailed = 0;
        message.autopayStatuses = [];
        if (value !== undefined)
            reflectionMergePartial<SearchStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementsReq): SearchStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID finance_charge_settings_ids */ 5:
                    message.financeChargeSettingsIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_on_credit_hold_filter */ 6:
                    message.isOnCreditHoldFilter = reader.int32();
                    break;
                case /* repeated string financing_term_id_strings */ 7:
                    message.financingTermIdStrings.push(reader.string());
                    break;
                case /* repeated string pricing_tier_id_strings */ 8:
                    message.pricingTierIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID rep_staff_ids */ 9:
                    message.repStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 10:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 11:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 12:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* rd.search.service.OrderStatementsBy order_by */ 13:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 14:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.statement.Statement.Status statuses */ 15:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter isMailed */ 16:
                    message.isMailed = reader.int32();
                    break;
                case /* repeated rd.statement.Statement.AutopayStatus autopay_statuses */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.autopayStatuses.push(reader.int32());
                    else
                        message.autopayStatuses.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID finance_charge_settings_ids = 5; */
        for (let i = 0; i < message.financeChargeSettingsIds.length; i++)
            UUID.internalBinaryWrite(message.financeChargeSettingsIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_on_credit_hold_filter = 6; */
        if (message.isOnCreditHoldFilter !== 0)
            writer.tag(6, WireType.Varint).int32(message.isOnCreditHoldFilter);
        /* repeated string financing_term_id_strings = 7; */
        for (let i = 0; i < message.financingTermIdStrings.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.financingTermIdStrings[i]);
        /* repeated string pricing_tier_id_strings = 8; */
        for (let i = 0; i < message.pricingTierIdStrings.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.pricingTierIdStrings[i]);
        /* repeated rd.proto.uuid.UUID rep_staff_ids = 9; */
        for (let i = 0; i < message.repStaffIds.length; i++)
            UUID.internalBinaryWrite(message.repStaffIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_active_filter = 10; */
        if (message.isActiveFilter !== 0)
            writer.tag(10, WireType.Varint).int32(message.isActiveFilter);
        /* repeated rd.proto.uuid.UUID tag_ids = 11; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 12; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.OrderStatementsBy order_by = 13; */
        if (message.orderBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 14; */
        if (message.sortOrder !== 0)
            writer.tag(14, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.statement.Statement.Status statuses = 15; */
        if (message.statuses.length) {
            writer.tag(15, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter isMailed = 16; */
        if (message.isMailed !== 0)
            writer.tag(16, WireType.Varint).int32(message.isMailed);
        /* repeated rd.statement.Statement.AutopayStatus autopay_statuses = 17; */
        if (message.autopayStatuses.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.autopayStatuses.length; i++)
                writer.int32(message.autopayStatuses[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementsReq
 */
export const SearchStatementsReq = new SearchStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementsRes$Type extends MessageType<SearchStatementsRes> {
    constructor() {
        super("rd.search.service.SearchStatementsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStatementsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStatementsRes>): SearchStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementsRes): SearchStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchStatementsRes.Result results */ 1:
                    message.results.push(SearchStatementsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchStatementsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchStatementsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementsRes
 */
export const SearchStatementsRes = new SearchStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementsRes_Result$Type extends MessageType<SearchStatementsRes_Result> {
    constructor() {
        super("rd.search.service.SearchStatementsRes.Result", [
            { no: 1, name: "statement", kind: "message", T: () => Statement },
            { no: 2, name: "customer", kind: "message", T: () => Customer },
            { no: 3, name: "statement_period", kind: "message", T: () => TimestampRange },
            { no: 4, name: "sent_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "total_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchStatementsRes_Result>): SearchStatementsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchStatementsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementsRes_Result): SearchStatementsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.Statement statement */ 1:
                    message.statement = Statement.internalBinaryRead(reader, reader.uint32(), options, message.statement);
                    break;
                case /* rd.customer.Customer customer */ 2:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.proto.timestamprange.TimestampRange statement_period */ 3:
                    message.statementPeriod = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.statementPeriod);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 4:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                case /* rd.proto.money.Money total_balance */ 5:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.Statement statement = 1; */
        if (message.statement)
            Statement.internalBinaryWrite(message.statement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 2; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange statement_period = 3; */
        if (message.statementPeriod)
            TimestampRange.internalBinaryWrite(message.statementPeriod, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 4; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 5; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementsRes.Result
 */
export const SearchStatementsRes_Result = new SearchStatementsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementRunsReq$Type extends MessageType<SearchStatementRunsReq> {
    constructor() {
        super("rd.search.service.SearchStatementRunsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "run_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.statement.StatementRun.RunType", StatementRun_RunType, "RUN_TYPE_"] },
            { no: 6, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderStatementRunsBy", OrderStatementRunsBy, "ORDER_STATEMENT_RUNS_BY_"] },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchStatementRunsReq>): SearchStatementRunsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.runTypes = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchStatementRunsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementRunsReq): SearchStatementRunsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.statement.StatementRun.RunType run_types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.runTypes.push(reader.int32());
                    else
                        message.runTypes.push(reader.int32());
                    break;
                case /* rd.search.service.OrderStatementRunsBy order_by */ 6:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementRunsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.statement.StatementRun.RunType run_types = 5; */
        if (message.runTypes.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.runTypes.length; i++)
                writer.int32(message.runTypes[i]);
            writer.join();
        }
        /* rd.search.service.OrderStatementRunsBy order_by = 6; */
        if (message.orderBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementRunsReq
 */
export const SearchStatementRunsReq = new SearchStatementRunsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementRunsRes$Type extends MessageType<SearchStatementRunsRes> {
    constructor() {
        super("rd.search.service.SearchStatementRunsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStatementRunsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStatementRunsRes>): SearchStatementRunsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStatementRunsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementRunsRes): SearchStatementRunsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchStatementRunsRes.Result results */ 1:
                    message.results.push(SearchStatementRunsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementRunsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchStatementRunsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchStatementRunsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementRunsRes
 */
export const SearchStatementRunsRes = new SearchStatementRunsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStatementRunsRes_Result$Type extends MessageType<SearchStatementRunsRes_Result> {
    constructor() {
        super("rd.search.service.SearchStatementRunsRes.Result", [
            { no: 1, name: "statement_run", kind: "message", T: () => StatementRun },
            { no: 2, name: "sent_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "generated_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "statement_period", kind: "message", T: () => TimestampRange },
            { no: 5, name: "error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "initiated_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStatementRunsRes_Result>): SearchStatementRunsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.generatedCount = 0;
        message.errorCount = 0;
        message.initiatedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchStatementRunsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStatementRunsRes_Result): SearchStatementRunsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.StatementRun statement_run */ 1:
                    message.statementRun = StatementRun.internalBinaryRead(reader, reader.uint32(), options, message.statementRun);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 2:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                case /* int32 generated_count */ 3:
                    message.generatedCount = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange statement_period */ 4:
                    message.statementPeriod = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.statementPeriod);
                    break;
                case /* int32 error_count */ 5:
                    message.errorCount = reader.int32();
                    break;
                case /* int32 initiated_count */ 6:
                    message.initiatedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStatementRunsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.StatementRun statement_run = 1; */
        if (message.statementRun)
            StatementRun.internalBinaryWrite(message.statementRun, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 2; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 generated_count = 3; */
        if (message.generatedCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.generatedCount);
        /* rd.proto.timestamprange.TimestampRange statement_period = 4; */
        if (message.statementPeriod)
            TimestampRange.internalBinaryWrite(message.statementPeriod, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 error_count = 5; */
        if (message.errorCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.errorCount);
        /* int32 initiated_count = 6; */
        if (message.initiatedCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.initiatedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStatementRunsRes.Result
 */
export const SearchStatementRunsRes_Result = new SearchStatementRunsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerStatementsReq$Type extends MessageType<SearchCustomerStatementsReq> {
    constructor() {
        super("rd.search.service.SearchCustomerStatementsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 6, name: "run_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.statement.StatementRun.RunType", StatementRun_RunType, "RUN_TYPE_"] },
            { no: 7, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCustomerStatementsBy", OrderCustomerStatementsBy, "ORDER_CUSTOMER_STATEMENTS_BY_"] },
            { no: 8, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerStatementsReq>): SearchCustomerStatementsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.runTypes = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerStatementsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerStatementsReq): SearchCustomerStatementsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.statement.StatementRun.RunType run_types */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.runTypes.push(reader.int32());
                    else
                        message.runTypes.push(reader.int32());
                    break;
                case /* rd.search.service.OrderCustomerStatementsBy order_by */ 7:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerStatementsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.statement.StatementRun.RunType run_types = 6; */
        if (message.runTypes.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.runTypes.length; i++)
                writer.int32(message.runTypes[i]);
            writer.join();
        }
        /* rd.search.service.OrderCustomerStatementsBy order_by = 7; */
        if (message.orderBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerStatementsReq
 */
export const SearchCustomerStatementsReq = new SearchCustomerStatementsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerStatementsRes$Type extends MessageType<SearchCustomerStatementsRes> {
    constructor() {
        super("rd.search.service.SearchCustomerStatementsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCustomerStatementsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerStatementsRes>): SearchCustomerStatementsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerStatementsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerStatementsRes): SearchCustomerStatementsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCustomerStatementsRes.Result results */ 1:
                    message.results.push(SearchCustomerStatementsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerStatementsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCustomerStatementsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCustomerStatementsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerStatementsRes
 */
export const SearchCustomerStatementsRes = new SearchCustomerStatementsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCustomerStatementsRes_Result$Type extends MessageType<SearchCustomerStatementsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCustomerStatementsRes.Result", [
            { no: 1, name: "statement", kind: "message", T: () => Statement },
            { no: 2, name: "statement_run", kind: "message", T: () => StatementRun },
            { no: 3, name: "statement_period", kind: "message", T: () => TimestampRange },
            { no: 4, name: "total_balance", kind: "message", T: () => Money },
            { no: 5, name: "sent_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SearchCustomerStatementsRes_Result>): SearchCustomerStatementsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchCustomerStatementsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCustomerStatementsRes_Result): SearchCustomerStatementsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.statement.Statement statement */ 1:
                    message.statement = Statement.internalBinaryRead(reader, reader.uint32(), options, message.statement);
                    break;
                case /* rd.statement.StatementRun statement_run */ 2:
                    message.statementRun = StatementRun.internalBinaryRead(reader, reader.uint32(), options, message.statementRun);
                    break;
                case /* rd.proto.timestamprange.TimestampRange statement_period */ 3:
                    message.statementPeriod = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.statementPeriod);
                    break;
                case /* rd.proto.money.Money total_balance */ 4:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 5:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCustomerStatementsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.statement.Statement statement = 1; */
        if (message.statement)
            Statement.internalBinaryWrite(message.statement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.statement.StatementRun statement_run = 2; */
        if (message.statementRun)
            StatementRun.internalBinaryWrite(message.statementRun, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange statement_period = 3; */
        if (message.statementPeriod)
            TimestampRange.internalBinaryWrite(message.statementPeriod, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 4; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 5; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCustomerStatementsRes.Result
 */
export const SearchCustomerStatementsRes_Result = new SearchCustomerStatementsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnableSaleProductsReq$Type extends MessageType<SearchReturnableSaleProductsReq> {
    constructor() {
        super("rd.search.service.SearchReturnableSaleProductsReq", [
            { no: 1, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 6, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "sold_at_range", kind: "message", T: () => TimestampRange },
            { no: 8, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "customer_purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "clerk_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "tint_color_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "current_selected_sale_product_id", kind: "message", T: () => UUID },
            { no: 15, name: "selected_sale_product_ids_in_cart", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchReturnableSaleProductsReq>): SearchReturnableSaleProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.query = "";
        message.locationIds = [];
        message.customerPurchaseOrderIds = [];
        message.clerkIds = [];
        message.tintColorIds = [];
        message.jobIds = [];
        message.selectedSaleProductIdsInCart = [];
        message.methodIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReturnableSaleProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnableSaleProductsReq): SearchReturnableSaleProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cursor */ 1:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 2:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 5:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 6:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.timestamprange.TimestampRange sold_at_range */ 7:
                    message.soldAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.soldAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 8:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_purchase_order_ids */ 9:
                    message.customerPurchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID clerk_ids */ 10:
                    message.clerkIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tint_color_ids */ 12:
                    message.tintColorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 13:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID current_selected_sale_product_id */ 14:
                    message.currentSelectedSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentSelectedSaleProductId);
                    break;
                case /* repeated rd.proto.uuid.UUID selected_sale_product_ids_in_cart */ 15:
                    message.selectedSaleProductIdsInCart.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 16:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnableSaleProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cursor = 1; */
        if (message.cursor !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 2; */
        if (message.offset !== 0)
            writer.tag(2, WireType.Varint).int32(message.offset);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID product_id = 5; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 6; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange sold_at_range = 7; */
        if (message.soldAtRange)
            TimestampRange.internalBinaryWrite(message.soldAtRange, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 8; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_purchase_order_ids = 9; */
        for (let i = 0; i < message.customerPurchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.customerPurchaseOrderIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID clerk_ids = 10; */
        for (let i = 0; i < message.clerkIds.length; i++)
            UUID.internalBinaryWrite(message.clerkIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tint_color_ids = 12; */
        for (let i = 0; i < message.tintColorIds.length; i++)
            UUID.internalBinaryWrite(message.tintColorIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 13; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_selected_sale_product_id = 14; */
        if (message.currentSelectedSaleProductId)
            UUID.internalBinaryWrite(message.currentSelectedSaleProductId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID selected_sale_product_ids_in_cart = 15; */
        for (let i = 0; i < message.selectedSaleProductIdsInCart.length; i++)
            UUID.internalBinaryWrite(message.selectedSaleProductIdsInCart[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID method_ids = 16; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnableSaleProductsReq
 */
export const SearchReturnableSaleProductsReq = new SearchReturnableSaleProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnableSaleProductsRes$Type extends MessageType<SearchReturnableSaleProductsRes> {
    constructor() {
        super("rd.search.service.SearchReturnableSaleProductsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchReturnableSaleProductsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchReturnableSaleProductsRes>): SearchReturnableSaleProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchReturnableSaleProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnableSaleProductsRes): SearchReturnableSaleProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchReturnableSaleProductsRes.Result results */ 1:
                    message.results.push(SearchReturnableSaleProductsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnableSaleProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchReturnableSaleProductsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchReturnableSaleProductsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnableSaleProductsRes
 */
export const SearchReturnableSaleProductsRes = new SearchReturnableSaleProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReturnableSaleProductsRes_Result$Type extends MessageType<SearchReturnableSaleProductsRes_Result> {
    constructor() {
        super("rd.search.service.SearchReturnableSaleProductsRes.Result", [
            { no: 1, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 2, name: "sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sale_id", kind: "message", T: () => UUID },
            { no: 4, name: "sale_type", kind: "enum", T: () => ["rd.txn.Sale.Type", Sale_Type, "TYPE_"] },
            { no: 5, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "unit_price", kind: "message", T: () => Money },
            { no: 8, name: "clerk_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "tint_color", kind: "message", T: () => TintColor },
            { no: 12, name: "custom_tint_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "customer_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "customer_id", kind: "message", T: () => UUID },
            { no: 16, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "job_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "job_id", kind: "message", T: () => UUID },
            { no: 19, name: "location_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "location_id", kind: "message", T: () => UUID },
            { no: 21, name: "customer_purchase_order", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "quantity_remaining_v2", kind: "message", T: () => Decimal },
            { no: 23, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 24, name: "original_uom_id", kind: "message", T: () => UUID },
            { no: 25, name: "original_uom_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "original_conversion_factor", kind: "message", T: () => Decimal },
            { no: 27, name: "quantity_remaining_uom", kind: "message", T: () => Decimal },
            { no: 28, name: "unit_price_fractional", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<SearchReturnableSaleProductsRes_Result>): SearchReturnableSaleProductsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleIdentifier = "";
        message.saleType = 0;
        message.clerkName = "";
        message.saleNotes = "";
        message.customTintColor = "";
        message.customerName = "";
        message.customerIdentifier = "";
        message.jobName = "";
        message.jobIdentifier = "";
        message.locationPrefix = "";
        message.customerPurchaseOrder = "";
        message.originalUomCode = "";
        if (value !== undefined)
            reflectionMergePartial<SearchReturnableSaleProductsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReturnableSaleProductsRes_Result): SearchReturnableSaleProductsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_product_id */ 1:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* string sale_identifier */ 2:
                    message.saleIdentifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 3:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.txn.Sale.Type sale_type */ 4:
                    message.saleType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp sold_at */ 5:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* rd.proto.money.Money unit_price */ 7:
                    message.unitPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.unitPrice);
                    break;
                case /* string clerk_name */ 8:
                    message.clerkName = reader.string();
                    break;
                case /* string sale_notes */ 10:
                    message.saleNotes = reader.string();
                    break;
                case /* rd.tintcolor.TintColor tint_color */ 11:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                case /* string custom_tint_color */ 12:
                    message.customTintColor = reader.string();
                    break;
                case /* string customer_name */ 13:
                    message.customerName = reader.string();
                    break;
                case /* string customer_identifier */ 14:
                    message.customerIdentifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 15:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string job_name */ 16:
                    message.jobName = reader.string();
                    break;
                case /* string job_identifier */ 17:
                    message.jobIdentifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID job_id */ 18:
                    message.jobId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.jobId);
                    break;
                case /* string location_prefix */ 19:
                    message.locationPrefix = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 20:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string customer_purchase_order */ 21:
                    message.customerPurchaseOrder = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_remaining_v2 */ 22:
                    message.quantityRemainingV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityRemainingV2);
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 23:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* rd.proto.uuid.UUID original_uom_id */ 24:
                    message.originalUomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.originalUomId);
                    break;
                case /* string original_uom_code */ 25:
                    message.originalUomCode = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal original_conversion_factor */ 26:
                    message.originalConversionFactor = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.originalConversionFactor);
                    break;
                case /* rd.proto.decimal.Decimal quantity_remaining_uom */ 27:
                    message.quantityRemainingUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityRemainingUom);
                    break;
                case /* rd.proto.money.FractionalMoney unit_price_fractional */ 28:
                    message.unitPriceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitPriceFractional);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReturnableSaleProductsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_product_id = 1; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sale_identifier = 2; */
        if (message.saleIdentifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.saleIdentifier);
        /* rd.proto.uuid.UUID sale_id = 3; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.Type sale_type = 4; */
        if (message.saleType !== 0)
            writer.tag(4, WireType.Varint).int32(message.saleType);
        /* google.protobuf.Timestamp sold_at = 5; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money unit_price = 7; */
        if (message.unitPrice)
            Money.internalBinaryWrite(message.unitPrice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string clerk_name = 8; */
        if (message.clerkName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.clerkName);
        /* string sale_notes = 10; */
        if (message.saleNotes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.saleNotes);
        /* rd.tintcolor.TintColor tint_color = 11; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string custom_tint_color = 12; */
        if (message.customTintColor !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.customTintColor);
        /* string customer_name = 13; */
        if (message.customerName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.customerName);
        /* string customer_identifier = 14; */
        if (message.customerIdentifier !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.customerIdentifier);
        /* rd.proto.uuid.UUID customer_id = 15; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string job_name = 16; */
        if (message.jobName !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.jobName);
        /* string job_identifier = 17; */
        if (message.jobIdentifier !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.jobIdentifier);
        /* rd.proto.uuid.UUID job_id = 18; */
        if (message.jobId)
            UUID.internalBinaryWrite(message.jobId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* string location_prefix = 19; */
        if (message.locationPrefix !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.locationPrefix);
        /* rd.proto.uuid.UUID location_id = 20; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* string customer_purchase_order = 21; */
        if (message.customerPurchaseOrder !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.customerPurchaseOrder);
        /* rd.proto.decimal.Decimal quantity_remaining_v2 = 22; */
        if (message.quantityRemainingV2)
            Decimal.internalBinaryWrite(message.quantityRemainingV2, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerMethods ledger_methods = 23; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID original_uom_id = 24; */
        if (message.originalUomId)
            UUID.internalBinaryWrite(message.originalUomId, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* string original_uom_code = 25; */
        if (message.originalUomCode !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.originalUomCode);
        /* rd.proto.decimal.Decimal original_conversion_factor = 26; */
        if (message.originalConversionFactor)
            Decimal.internalBinaryWrite(message.originalConversionFactor, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_remaining_uom = 27; */
        if (message.quantityRemainingUom)
            Decimal.internalBinaryWrite(message.quantityRemainingUom, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney unit_price_fractional = 28; */
        if (message.unitPriceFractional)
            FractionalMoney.internalBinaryWrite(message.unitPriceFractional, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReturnableSaleProductsRes.Result
 */
export const SearchReturnableSaleProductsRes_Result = new SearchReturnableSaleProductsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCreditsReq$Type extends MessageType<SearchCreditsReq> {
    constructor() {
        super("rd.search.service.SearchCreditsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "date_range_filter", kind: "message", T: () => TimestampRange },
            { no: 6, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCreditsBy", OrderCreditsBy, "ORDER_CREDITS_BY_"] },
            { no: 8, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 9, name: "allocation_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.CreditAllocationStatus", CreditAllocationStatus, "CREDIT_ALLOCATION_STATUS_"] },
            { no: 10, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Transaction.Type", Receivable_Transaction_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchCreditsReq>): SearchCreditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.customerIds = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        message.allocationStatuses = [];
        message.transactionTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCreditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCreditsReq): SearchCreditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange date_range_filter */ 5:
                    message.dateRangeFilter = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRangeFilter);
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 6:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.OrderCreditsBy order_by */ 7:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.txn.CreditAllocationStatus allocation_statuses */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.allocationStatuses.push(reader.int32());
                    else
                        message.allocationStatuses.push(reader.int32());
                    break;
                case /* repeated rd.txn.Receivable.Transaction.Type transaction_types */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCreditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.proto.timestamprange.TimestampRange date_range_filter = 5; */
        if (message.dateRangeFilter)
            TimestampRange.internalBinaryWrite(message.dateRangeFilter, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 6; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.OrderCreditsBy order_by = 7; */
        if (message.orderBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.txn.CreditAllocationStatus allocation_statuses = 9; */
        if (message.allocationStatuses.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.allocationStatuses.length; i++)
                writer.int32(message.allocationStatuses[i]);
            writer.join();
        }
        /* repeated rd.txn.Receivable.Transaction.Type transaction_types = 10; */
        if (message.transactionTypes.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCreditsReq
 */
export const SearchCreditsReq = new SearchCreditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCreditsRes$Type extends MessageType<SearchCreditsRes> {
    constructor() {
        super("rd.search.service.SearchCreditsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCreditsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCreditsRes>): SearchCreditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCreditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCreditsRes): SearchCreditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCreditsRes.Result results */ 1:
                    message.results.push(SearchCreditsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCreditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCreditsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCreditsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCreditsRes
 */
export const SearchCreditsRes = new SearchCreditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCreditsRes_Result$Type extends MessageType<SearchCreditsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCreditsRes.Result", [
            { no: 5, name: "allocation_status", kind: "enum", T: () => ["rd.txn.CreditAllocationStatus", CreditAllocationStatus, "CREDIT_ALLOCATION_STATUS_"] },
            { no: 10, name: "receivable", kind: "message", T: () => Receivable }
        ]);
    }
    create(value?: PartialMessage<SearchCreditsRes_Result>): SearchCreditsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allocationStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchCreditsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCreditsRes_Result): SearchCreditsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.CreditAllocationStatus allocation_status */ 5:
                    message.allocationStatus = reader.int32();
                    break;
                case /* rd.txn.Receivable receivable */ 10:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCreditsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.CreditAllocationStatus allocation_status = 5; */
        if (message.allocationStatus !== 0)
            writer.tag(5, WireType.Varint).int32(message.allocationStatus);
        /* rd.txn.Receivable receivable = 10; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCreditsRes.Result
 */
export const SearchCreditsRes_Result = new SearchCreditsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAccountsReq$Type extends MessageType<SearchAccountsReq> {
    constructor() {
        super("rd.search.service.SearchAccountsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortAccountsBy", SortAccountsBy, "SORT_ACCOUNTS_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 8, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchAccountsReq>): SearchAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.isActiveFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAccountsReq): SearchAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SortAccountsBy sort_by */ 5:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.coa.Account.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 8:
                    message.isActiveFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SortAccountsBy sort_by = 5; */
        if (message.sortBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.coa.Account.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter is_active_filter = 8; */
        if (message.isActiveFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.isActiveFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchAccountsReq
 */
export const SearchAccountsReq = new SearchAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAccountsRes$Type extends MessageType<SearchAccountsRes> {
    constructor() {
        super("rd.search.service.SearchAccountsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchAccountsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAccountsRes>): SearchAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAccountsRes): SearchAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchAccountsRes.Result results */ 1:
                    message.results.push(SearchAccountsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchAccountsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchAccountsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchAccountsRes
 */
export const SearchAccountsRes = new SearchAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAccountsRes_Result$Type extends MessageType<SearchAccountsRes_Result> {
    constructor() {
        super("rd.search.service.SearchAccountsRes.Result", [
            { no: 1, name: "account", kind: "message", T: () => Account },
            { no: 2, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Mapping }
        ]);
    }
    create(value?: PartialMessage<SearchAccountsRes_Result>): SearchAccountsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mappings = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAccountsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAccountsRes_Result): SearchAccountsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.coa.Account account */ 1:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* repeated rd.coa.Mapping mappings */ 2:
                    message.mappings.push(Mapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAccountsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.coa.Account account = 1; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.coa.Mapping mappings = 2; */
        for (let i = 0; i < message.mappings.length; i++)
            Mapping.internalBinaryWrite(message.mappings[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchAccountsRes.Result
 */
export const SearchAccountsRes_Result = new SearchAccountsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportAccountsReq$Type extends MessageType<BulkExportAccountsReq> {
    constructor() {
        super("rd.search.service.BulkExportAccountsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortAccountsBy", SortAccountsBy, "SORT_ACCOUNTS_BY_"] },
            { no: 4, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 5, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 6, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<BulkExportAccountsReq>): BulkExportAccountsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.isTemplate = false;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.isActiveFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<BulkExportAccountsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportAccountsReq): BulkExportAccountsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* bool is_template */ 2:
                    message.isTemplate = reader.bool();
                    break;
                case /* rd.search.service.SortAccountsBy sort_by */ 3:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.coa.Account.Type types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 6:
                    message.isActiveFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportAccountsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* bool is_template = 2; */
        if (message.isTemplate !== false)
            writer.tag(2, WireType.Varint).bool(message.isTemplate);
        /* rd.search.service.SortAccountsBy sort_by = 3; */
        if (message.sortBy !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.coa.Account.Type types = 5; */
        if (message.types.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter is_active_filter = 6; */
        if (message.isActiveFilter !== 0)
            writer.tag(6, WireType.Varint).int32(message.isActiveFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportAccountsReq
 */
export const BulkExportAccountsReq = new BulkExportAccountsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportAccountsRes$Type extends MessageType<BulkExportAccountsRes> {
    constructor() {
        super("rd.search.service.BulkExportAccountsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportAccountsRes>): BulkExportAccountsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportAccountsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportAccountsRes): BulkExportAccountsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportAccountsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportAccountsRes
 */
export const BulkExportAccountsRes = new BulkExportAccountsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMappingsReq$Type extends MessageType<SearchMappingsReq> {
    constructor() {
        super("rd.search.service.SearchMappingsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortMappingsBy", SortMappingsBy, "SORT_MAPPINGS_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 8, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "account_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "control_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] },
            { no: 12, name: "tender_method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchMappingsReq>): SearchMappingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.locationIds = [];
        message.departmentIds = [];
        message.accountIds = [];
        message.controlAccounts = [];
        message.tenderMethodIds = [];
        message.additionalFeeIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchMappingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMappingsReq): SearchMappingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SortMappingsBy sort_by */ 5:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.coa.Account.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 8:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 9:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID account_ids */ 10:
                    message.accountIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.coa.InternalAccount control_accounts */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.controlAccounts.push(reader.int32());
                    else
                        message.controlAccounts.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID tender_method_ids */ 12:
                    message.tenderMethodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_ids */ 13:
                    message.additionalFeeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMappingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SortMappingsBy sort_by = 5; */
        if (message.sortBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.coa.Account.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID location_ids = 8; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 9; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID account_ids = 10; */
        for (let i = 0; i < message.accountIds.length; i++)
            UUID.internalBinaryWrite(message.accountIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.coa.InternalAccount control_accounts = 11; */
        if (message.controlAccounts.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.controlAccounts.length; i++)
                writer.int32(message.controlAccounts[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID tender_method_ids = 12; */
        for (let i = 0; i < message.tenderMethodIds.length; i++)
            UUID.internalBinaryWrite(message.tenderMethodIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_ids = 13; */
        for (let i = 0; i < message.additionalFeeIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.additionalFeeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchMappingsReq
 */
export const SearchMappingsReq = new SearchMappingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMappingsRes$Type extends MessageType<SearchMappingsRes> {
    constructor() {
        super("rd.search.service.SearchMappingsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchMappingsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchMappingsRes>): SearchMappingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchMappingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMappingsRes): SearchMappingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchMappingsRes.Result results */ 1:
                    message.results.push(SearchMappingsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMappingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchMappingsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchMappingsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchMappingsRes
 */
export const SearchMappingsRes = new SearchMappingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMappingsRes_Result$Type extends MessageType<SearchMappingsRes_Result> {
    constructor() {
        super("rd.search.service.SearchMappingsRes.Result", [
            { no: 1, name: "mapping", kind: "message", T: () => Mapping },
            { no: 2, name: "account", kind: "message", T: () => Account },
            { no: 3, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "account_type", kind: "enum", T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 6, name: "breakdown_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "control_account_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchMappingsRes_Result>): SearchMappingsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountType = 0;
        message.breakdownName = "";
        message.controlAccountDescription = "";
        if (value !== undefined)
            reflectionMergePartial<SearchMappingsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchMappingsRes_Result): SearchMappingsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.coa.Mapping mapping */ 1:
                    message.mapping = Mapping.internalBinaryRead(reader, reader.uint32(), options, message.mapping);
                    break;
                case /* rd.coa.Account account */ 2:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* rd.company.Location location */ 3:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.coa.Account.Type account_type */ 5:
                    message.accountType = reader.int32();
                    break;
                case /* string breakdown_name */ 6:
                    message.breakdownName = reader.string();
                    break;
                case /* string control_account_description */ 7:
                    message.controlAccountDescription = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchMappingsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.coa.Mapping mapping = 1; */
        if (message.mapping)
            Mapping.internalBinaryWrite(message.mapping, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account account = 2; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 3; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account.Type account_type = 5; */
        if (message.accountType !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountType);
        /* string breakdown_name = 6; */
        if (message.breakdownName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.breakdownName);
        /* string control_account_description = 7; */
        if (message.controlAccountDescription !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.controlAccountDescription);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchMappingsRes.Result
 */
export const SearchMappingsRes_Result = new SearchMappingsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportMappingsReq$Type extends MessageType<BulkExportMappingsReq> {
    constructor() {
        super("rd.search.service.BulkExportMappingsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortMappingsBy", SortMappingsBy, "SORT_MAPPINGS_BY_"] },
            { no: 4, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 5, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 6, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "account_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "control_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] }
        ]);
    }
    create(value?: PartialMessage<BulkExportMappingsReq>): BulkExportMappingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.isTemplate = false;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.locationIds = [];
        message.departmentIds = [];
        message.accountIds = [];
        message.controlAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<BulkExportMappingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportMappingsReq): BulkExportMappingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* bool is_template */ 2:
                    message.isTemplate = reader.bool();
                    break;
                case /* rd.search.service.SortMappingsBy sort_by */ 3:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.coa.Account.Type types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 6:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 7:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID account_ids */ 8:
                    message.accountIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.coa.InternalAccount control_accounts */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.controlAccounts.push(reader.int32());
                    else
                        message.controlAccounts.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportMappingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* bool is_template = 2; */
        if (message.isTemplate !== false)
            writer.tag(2, WireType.Varint).bool(message.isTemplate);
        /* rd.search.service.SortMappingsBy sort_by = 3; */
        if (message.sortBy !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.coa.Account.Type types = 5; */
        if (message.types.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID location_ids = 6; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 7; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID account_ids = 8; */
        for (let i = 0; i < message.accountIds.length; i++)
            UUID.internalBinaryWrite(message.accountIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.coa.InternalAccount control_accounts = 9; */
        if (message.controlAccounts.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.controlAccounts.length; i++)
                writer.int32(message.controlAccounts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportMappingsReq
 */
export const BulkExportMappingsReq = new BulkExportMappingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportMappingsRes$Type extends MessageType<BulkExportMappingsRes> {
    constructor() {
        super("rd.search.service.BulkExportMappingsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportMappingsRes>): BulkExportMappingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportMappingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportMappingsRes): BulkExportMappingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportMappingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportMappingsRes
 */
export const BulkExportMappingsRes = new BulkExportMappingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJournalEntriesReq$Type extends MessageType<SearchJournalEntriesReq> {
    constructor() {
        super("rd.search.service.SearchJournalEntriesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortJournalEntriesBy", SortJournalEntriesBy, "SORT_JOURNAL_ENTRIES_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.JournalEntry.Type", JournalEntry_Type, "TYPE_"] },
            { no: 8, name: "is_auto_generated_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "is_archived_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 10, name: "date_range_filter", kind: "message", T: () => TimestampRange },
            { no: 11, name: "exported_at_range_filter", kind: "message", T: () => TimestampRange },
            { no: 12, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchJournalEntriesReq>): SearchJournalEntriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.isAutoGeneratedFilter = 0;
        message.isArchivedFilter = 0;
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<SearchJournalEntriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJournalEntriesReq): SearchJournalEntriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SortJournalEntriesBy sort_by */ 5:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.accounting.JournalEntry.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter is_auto_generated_filter */ 8:
                    message.isAutoGeneratedFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_archived_filter */ 9:
                    message.isArchivedFilter = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange date_range_filter */ 10:
                    message.dateRangeFilter = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRangeFilter);
                    break;
                case /* rd.proto.timestamprange.TimestampRange exported_at_range_filter */ 11:
                    message.exportedAtRangeFilter = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.exportedAtRangeFilter);
                    break;
                case /* string client_time_zone */ 12:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJournalEntriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SortJournalEntriesBy sort_by = 5; */
        if (message.sortBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.accounting.JournalEntry.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter is_auto_generated_filter = 8; */
        if (message.isAutoGeneratedFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.isAutoGeneratedFilter);
        /* rd.search.service.BoolFilter is_archived_filter = 9; */
        if (message.isArchivedFilter !== 0)
            writer.tag(9, WireType.Varint).int32(message.isArchivedFilter);
        /* rd.proto.timestamprange.TimestampRange date_range_filter = 10; */
        if (message.dateRangeFilter)
            TimestampRange.internalBinaryWrite(message.dateRangeFilter, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange exported_at_range_filter = 11; */
        if (message.exportedAtRangeFilter)
            TimestampRange.internalBinaryWrite(message.exportedAtRangeFilter, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 12; */
        if (message.clientTimeZone !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJournalEntriesReq
 */
export const SearchJournalEntriesReq = new SearchJournalEntriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJournalEntriesRes$Type extends MessageType<SearchJournalEntriesRes> {
    constructor() {
        super("rd.search.service.SearchJournalEntriesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchJournalEntriesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchJournalEntriesRes>): SearchJournalEntriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchJournalEntriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJournalEntriesRes): SearchJournalEntriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchJournalEntriesRes.Result results */ 1:
                    message.results.push(SearchJournalEntriesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJournalEntriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchJournalEntriesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchJournalEntriesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJournalEntriesRes
 */
export const SearchJournalEntriesRes = new SearchJournalEntriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchJournalEntriesRes_Result$Type extends MessageType<SearchJournalEntriesRes_Result> {
    constructor() {
        super("rd.search.service.SearchJournalEntriesRes.Result", [
            { no: 1, name: "journal_entry", kind: "message", T: () => JournalEntry }
        ]);
    }
    create(value?: PartialMessage<SearchJournalEntriesRes_Result>): SearchJournalEntriesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchJournalEntriesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchJournalEntriesRes_Result): SearchJournalEntriesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.JournalEntry journal_entry */ 1:
                    message.journalEntry = JournalEntry.internalBinaryRead(reader, reader.uint32(), options, message.journalEntry);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchJournalEntriesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.JournalEntry journal_entry = 1; */
        if (message.journalEntry)
            JournalEntry.internalBinaryWrite(message.journalEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchJournalEntriesRes.Result
 */
export const SearchJournalEntriesRes_Result = new SearchJournalEntriesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManualJournalEntriesReq$Type extends MessageType<SearchManualJournalEntriesReq> {
    constructor() {
        super("rd.search.service.SearchManualJournalEntriesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortManualJournalEntriesBy", SortManualJournalEntriesBy, "SORT_MANUAL_JOURNAL_ENTRIES_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "accounted_at_range_filter", kind: "message", T: () => TimestampRange },
            { no: 8, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchManualJournalEntriesReq>): SearchManualJournalEntriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.clientTimeZone = "";
        message.locationIds = [];
        message.customerIds = [];
        message.vendorIds = [];
        message.productIds = [];
        message.isActiveFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchManualJournalEntriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManualJournalEntriesReq): SearchManualJournalEntriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SortManualJournalEntriesBy sort_by */ 5:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange accounted_at_range_filter */ 7:
                    message.accountedAtRangeFilter = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.accountedAtRangeFilter);
                    break;
                case /* string client_time_zone */ 8:
                    message.clientTimeZone = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 9:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 10:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 11:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 12:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 13:
                    message.isActiveFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManualJournalEntriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SortManualJournalEntriesBy sort_by = 5; */
        if (message.sortBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* rd.proto.timestamprange.TimestampRange accounted_at_range_filter = 7; */
        if (message.accountedAtRangeFilter)
            TimestampRange.internalBinaryWrite(message.accountedAtRangeFilter, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 8; */
        if (message.clientTimeZone !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.clientTimeZone);
        /* repeated rd.proto.uuid.UUID location_ids = 9; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 10; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 11; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 12; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_active_filter = 13; */
        if (message.isActiveFilter !== 0)
            writer.tag(13, WireType.Varint).int32(message.isActiveFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchManualJournalEntriesReq
 */
export const SearchManualJournalEntriesReq = new SearchManualJournalEntriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManualJournalEntriesRes$Type extends MessageType<SearchManualJournalEntriesRes> {
    constructor() {
        super("rd.search.service.SearchManualJournalEntriesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchManualJournalEntriesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchManualJournalEntriesRes>): SearchManualJournalEntriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchManualJournalEntriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManualJournalEntriesRes): SearchManualJournalEntriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchManualJournalEntriesRes.Result results */ 1:
                    message.results.push(SearchManualJournalEntriesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchManualJournalEntriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchManualJournalEntriesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchManualJournalEntriesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchManualJournalEntriesRes
 */
export const SearchManualJournalEntriesRes = new SearchManualJournalEntriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManualJournalEntriesRes_Result$Type extends MessageType<SearchManualJournalEntriesRes_Result> {
    constructor() {
        super("rd.search.service.SearchManualJournalEntriesRes.Result", [
            { no: 1, name: "manual_journal_entry", kind: "message", T: () => ManualJournalEntry },
            { no: 2, name: "line_entity_names_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<SearchManualJournalEntriesRes_Result>): SearchManualJournalEntriesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lineEntityNamesById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchManualJournalEntriesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchManualJournalEntriesRes_Result): SearchManualJournalEntriesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.manualjournalentry.ManualJournalEntry manual_journal_entry */ 1:
                    message.manualJournalEntry = ManualJournalEntry.internalBinaryRead(reader, reader.uint32(), options, message.manualJournalEntry);
                    break;
                case /* map<string, string> line_entity_names_by_id */ 2:
                    this.binaryReadMap2(message.lineEntityNamesById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: SearchManualJournalEntriesRes_Result["lineEntityNamesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchManualJournalEntriesRes_Result["lineEntityNamesById"] | undefined, val: SearchManualJournalEntriesRes_Result["lineEntityNamesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchManualJournalEntriesRes.Result.line_entity_names_by_id");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SearchManualJournalEntriesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.manualjournalentry.ManualJournalEntry manual_journal_entry = 1; */
        if (message.manualJournalEntry)
            ManualJournalEntry.internalBinaryWrite(message.manualJournalEntry, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> line_entity_names_by_id = 2; */
        for (let k of globalThis.Object.keys(message.lineEntityNamesById))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.lineEntityNamesById[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchManualJournalEntriesRes.Result
 */
export const SearchManualJournalEntriesRes_Result = new SearchManualJournalEntriesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSavedReportsReq$Type extends MessageType<SearchSavedReportsReq> {
    constructor() {
        super("rd.search.service.SearchSavedReportsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SortSavedReportsBy", SortSavedReportsBy, "SORT_SAVED_REPORTS_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "filter", kind: "message", T: () => SearchSavedReportsReq_Filter },
            { no: 8, name: "is_global_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 9, name: "is_accounting_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchSavedReportsReq>): SearchSavedReportsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.sortBy = 0;
        message.sortOrder = 0;
        message.isGlobalFilter = 0;
        message.isAccountingFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchSavedReportsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSavedReportsReq): SearchSavedReportsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SortSavedReportsBy sort_by */ 5:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.SearchSavedReportsReq.Filter filter */ 7:
                    message.filter = SearchSavedReportsReq_Filter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* rd.search.service.BoolFilter is_global_filter */ 8:
                    message.isGlobalFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_accounting_filter */ 9:
                    message.isAccountingFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSavedReportsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SortSavedReportsBy sort_by = 5; */
        if (message.sortBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.SearchSavedReportsReq.Filter filter = 7; */
        if (message.filter)
            SearchSavedReportsReq_Filter.internalBinaryWrite(message.filter, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_global_filter = 8; */
        if (message.isGlobalFilter !== 0)
            writer.tag(8, WireType.Varint).int32(message.isGlobalFilter);
        /* rd.search.service.BoolFilter is_accounting_filter = 9; */
        if (message.isAccountingFilter !== 0)
            writer.tag(9, WireType.Varint).int32(message.isAccountingFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSavedReportsReq
 */
export const SearchSavedReportsReq = new SearchSavedReportsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSavedReportsReq_Filter$Type extends MessageType<SearchSavedReportsReq_Filter> {
    constructor() {
        super("rd.search.service.SearchSavedReportsReq.Filter", [
            { no: 1, name: "base_data_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.BaseData", BaseData, "BASE_DATA_"] },
            { no: 2, name: "created_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "updated_by_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "created_at_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "updated_at_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<SearchSavedReportsReq_Filter>): SearchSavedReportsReq_Filter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseDataTypes = [];
        message.createdByIds = [];
        message.updatedByIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchSavedReportsReq_Filter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSavedReportsReq_Filter): SearchSavedReportsReq_Filter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.analyticsv2.reportbuilder.BaseData base_data_types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.baseDataTypes.push(reader.int32());
                    else
                        message.baseDataTypes.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID created_by_ids */ 2:
                    message.createdByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID updated_by_ids */ 3:
                    message.updatedByIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange created_at_range */ 4:
                    message.createdAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.createdAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange updated_at_range */ 5:
                    message.updatedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.updatedAtRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSavedReportsReq_Filter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.analyticsv2.reportbuilder.BaseData base_data_types = 1; */
        if (message.baseDataTypes.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.baseDataTypes.length; i++)
                writer.int32(message.baseDataTypes[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID created_by_ids = 2; */
        for (let i = 0; i < message.createdByIds.length; i++)
            UUID.internalBinaryWrite(message.createdByIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID updated_by_ids = 3; */
        for (let i = 0; i < message.updatedByIds.length; i++)
            UUID.internalBinaryWrite(message.updatedByIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange created_at_range = 4; */
        if (message.createdAtRange)
            TimestampRange.internalBinaryWrite(message.createdAtRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange updated_at_range = 5; */
        if (message.updatedAtRange)
            TimestampRange.internalBinaryWrite(message.updatedAtRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSavedReportsReq.Filter
 */
export const SearchSavedReportsReq_Filter = new SearchSavedReportsReq_Filter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSavedReportsRes$Type extends MessageType<SearchSavedReportsRes> {
    constructor() {
        super("rd.search.service.SearchSavedReportsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchSavedReportsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchSavedReportsRes>): SearchSavedReportsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSavedReportsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSavedReportsRes): SearchSavedReportsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchSavedReportsRes.Result results */ 1:
                    message.results.push(SearchSavedReportsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSavedReportsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchSavedReportsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchSavedReportsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSavedReportsRes
 */
export const SearchSavedReportsRes = new SearchSavedReportsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSavedReportsRes_Result$Type extends MessageType<SearchSavedReportsRes_Result> {
    constructor() {
        super("rd.search.service.SearchSavedReportsRes.Result", [
            { no: 1, name: "saved_report", kind: "message", T: () => SavedReport }
        ]);
    }
    create(value?: PartialMessage<SearchSavedReportsRes_Result>): SearchSavedReportsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchSavedReportsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSavedReportsRes_Result): SearchSavedReportsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.SavedReport saved_report */ 1:
                    message.savedReport = SavedReport.internalBinaryRead(reader, reader.uint32(), options, message.savedReport);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSavedReportsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.SavedReport saved_report = 1; */
        if (message.savedReport)
            SavedReport.internalBinaryWrite(message.savedReport, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSavedReportsRes.Result
 */
export const SearchSavedReportsRes_Result = new SearchSavedReportsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchSalesReq$Type extends MessageType<CxaSearchSalesReq> {
    constructor() {
        super("rd.search.service.CxaSearchSalesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 3, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 5, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Type", Sale_Type, "TYPE_"] },
            { no: 9, name: "sources", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Sale.Source", Sale_Source, "SOURCE_"] },
            { no: 10, name: "sold_at_range", kind: "message", T: () => TimestampRange },
            { no: 11, name: "tint_color_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "will_called_at_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<CxaSearchSalesReq>): CxaSearchSalesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.statuses = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.types = [];
        message.sources = [];
        message.tintColorIds = [];
        message.jobIds = [];
        message.productIds = [];
        message.methodIds = [];
        if (value !== undefined)
            reflectionMergePartial<CxaSearchSalesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchSalesReq): CxaSearchSalesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 3:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Sale.Status statuses */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* string cursor */ 5:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 6:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 7:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.txn.Sale.Type types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.txn.Sale.Source sources */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sources.push(reader.int32());
                    else
                        message.sources.push(reader.int32());
                    break;
                case /* rd.proto.timestamprange.TimestampRange sold_at_range */ 10:
                    message.soldAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.soldAtRange);
                    break;
                case /* repeated rd.proto.uuid.UUID tint_color_ids */ 11:
                    message.tintColorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 12:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 13:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 14:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange will_called_at_range */ 15:
                    message.willCalledAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.willCalledAtRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchSalesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID location_ids = 3; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Sale.Status statuses = 4; */
        if (message.statuses.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* string cursor = 5; */
        if (message.cursor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 6; */
        if (message.offset !== 0)
            writer.tag(6, WireType.Varint).int32(message.offset);
        /* int32 limit = 7; */
        if (message.limit !== 0)
            writer.tag(7, WireType.Varint).int32(message.limit);
        /* repeated rd.txn.Sale.Type types = 8; */
        if (message.types.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.txn.Sale.Source sources = 9; */
        if (message.sources.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sources.length; i++)
                writer.int32(message.sources[i]);
            writer.join();
        }
        /* rd.proto.timestamprange.TimestampRange sold_at_range = 10; */
        if (message.soldAtRange)
            TimestampRange.internalBinaryWrite(message.soldAtRange, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tint_color_ids = 11; */
        for (let i = 0; i < message.tintColorIds.length; i++)
            UUID.internalBinaryWrite(message.tintColorIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 12; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 13; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID method_ids = 14; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange will_called_at_range = 15; */
        if (message.willCalledAtRange)
            TimestampRange.internalBinaryWrite(message.willCalledAtRange, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchSalesReq
 */
export const CxaSearchSalesReq = new CxaSearchSalesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchSalesRes$Type extends MessageType<CxaSearchSalesRes> {
    constructor() {
        super("rd.search.service.CxaSearchSalesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CxaSearchSalesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchSalesRes>): CxaSearchSalesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchSalesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchSalesRes): CxaSearchSalesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.CxaSearchSalesRes.Result results */ 1:
                    message.results.push(CxaSearchSalesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchSalesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.CxaSearchSalesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CxaSearchSalesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchSalesRes
 */
export const CxaSearchSalesRes = new CxaSearchSalesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchSalesRes_Result$Type extends MessageType<CxaSearchSalesRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchSalesRes.Result", [
            { no: 1, name: "sale", kind: "message", T: () => Sale },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "purchase_order", kind: "message", T: () => PurchaseOrder },
            { no: 5, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Product } },
            { no: 7, name: "tint_colors_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TintColor } },
            { no: 8, name: "total", kind: "message", T: () => Money },
            { no: 10, name: "customer_contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "customer_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "ledger_methods", kind: "message", T: () => LedgerMethods }
        ]);
    }
    create(value?: PartialMessage<CxaSearchSalesRes_Result>): CxaSearchSalesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productsById = {};
        message.tintColorsById = {};
        message.customerContactName = "";
        message.customerIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchSalesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchSalesRes_Result): CxaSearchSalesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Sale sale */ 1:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.PurchaseOrder purchase_order */ 3:
                    message.purchaseOrder = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options, message.purchaseOrder);
                    break;
                case /* map<string, rd.product.Product> products_by_id */ 5:
                    this.binaryReadMap5(message.productsById, reader, options);
                    break;
                case /* map<string, rd.tintcolor.TintColor> tint_colors_by_id */ 7:
                    this.binaryReadMap7(message.tintColorsById, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 8:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string customer_contact_name */ 10:
                    message.customerContactName = reader.string();
                    break;
                case /* string customer_identifier */ 11:
                    message.customerIdentifier = reader.string();
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 12:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: CxaSearchSalesRes_Result["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CxaSearchSalesRes_Result["productsById"] | undefined, val: CxaSearchSalesRes_Result["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.CxaSearchSalesRes.Result.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Product.create();
    }
    private binaryReadMap7(map: CxaSearchSalesRes_Result["tintColorsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CxaSearchSalesRes_Result["tintColorsById"] | undefined, val: CxaSearchSalesRes_Result["tintColorsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TintColor.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.CxaSearchSalesRes.Result.tint_colors_by_id");
            }
        }
        map[key ?? ""] = val ?? TintColor.create();
    }
    internalBinaryWrite(message: CxaSearchSalesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Sale sale = 1; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.PurchaseOrder purchase_order = 3; */
        if (message.purchaseOrder)
            PurchaseOrder.internalBinaryWrite(message.purchaseOrder, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.product.Product> products_by_id = 5; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.tintcolor.TintColor> tint_colors_by_id = 7; */
        for (let k of globalThis.Object.keys(message.tintColorsById)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TintColor.internalBinaryWrite(message.tintColorsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 8; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_name = 10; */
        if (message.customerContactName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.customerContactName);
        /* string customer_identifier = 11; */
        if (message.customerIdentifier !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.customerIdentifier);
        /* rd.ledger.LedgerMethods ledger_methods = 12; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchSalesRes.Result
 */
export const CxaSearchSalesRes_Result = new CxaSearchSalesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchOutstandingSalesReq$Type extends MessageType<CxaSearchOutstandingSalesReq> {
    constructor() {
        super("rd.search.service.CxaSearchOutstandingSalesReq", []);
    }
    create(value?: PartialMessage<CxaSearchOutstandingSalesReq>): CxaSearchOutstandingSalesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchOutstandingSalesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchOutstandingSalesReq): CxaSearchOutstandingSalesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchOutstandingSalesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchOutstandingSalesReq
 */
export const CxaSearchOutstandingSalesReq = new CxaSearchOutstandingSalesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchOutstandingSalesRes$Type extends MessageType<CxaSearchOutstandingSalesRes> {
    constructor() {
        super("rd.search.service.CxaSearchOutstandingSalesRes", []);
    }
    create(value?: PartialMessage<CxaSearchOutstandingSalesRes>): CxaSearchOutstandingSalesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchOutstandingSalesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchOutstandingSalesRes): CxaSearchOutstandingSalesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchOutstandingSalesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchOutstandingSalesRes
 */
export const CxaSearchOutstandingSalesRes = new CxaSearchOutstandingSalesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchOutstandingSalesRes_Result$Type extends MessageType<CxaSearchOutstandingSalesRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchOutstandingSalesRes.Result", []);
    }
    create(value?: PartialMessage<CxaSearchOutstandingSalesRes_Result>): CxaSearchOutstandingSalesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchOutstandingSalesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchOutstandingSalesRes_Result): CxaSearchOutstandingSalesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchOutstandingSalesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchOutstandingSalesRes.Result
 */
export const CxaSearchOutstandingSalesRes_Result = new CxaSearchOutstandingSalesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReceivablesAgingReq$Type extends MessageType<CxaSearchReceivablesAgingReq> {
    constructor() {
        super("rd.search.service.CxaSearchReceivablesAgingReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "receivable_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Type", Receivable_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<CxaSearchReceivablesAgingReq>): CxaSearchReceivablesAgingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.receivableTypes = [];
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReceivablesAgingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReceivablesAgingReq): CxaSearchReceivablesAgingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.txn.Receivable.Type receivable_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.receivableTypes.push(reader.int32());
                    else
                        message.receivableTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReceivablesAgingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.txn.Receivable.Type receivable_types = 2; */
        if (message.receivableTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.receivableTypes.length; i++)
                writer.int32(message.receivableTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReceivablesAgingReq
 */
export const CxaSearchReceivablesAgingReq = new CxaSearchReceivablesAgingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReceivablesAgingRes$Type extends MessageType<CxaSearchReceivablesAgingRes> {
    constructor() {
        super("rd.search.service.CxaSearchReceivablesAgingRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CxaSearchReceivablesAgingRes_Result }
        ]);
    }
    create(value?: PartialMessage<CxaSearchReceivablesAgingRes>): CxaSearchReceivablesAgingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReceivablesAgingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReceivablesAgingRes): CxaSearchReceivablesAgingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.CxaSearchReceivablesAgingRes.Result results */ 1:
                    message.results.push(CxaSearchReceivablesAgingRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReceivablesAgingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.CxaSearchReceivablesAgingRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CxaSearchReceivablesAgingRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReceivablesAgingRes
 */
export const CxaSearchReceivablesAgingRes = new CxaSearchReceivablesAgingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReceivablesAgingRes_Result$Type extends MessageType<CxaSearchReceivablesAgingRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchReceivablesAgingRes.Result", [
            { no: 1, name: "receivable", kind: "message", T: () => Receivable }
        ]);
    }
    create(value?: PartialMessage<CxaSearchReceivablesAgingRes_Result>): CxaSearchReceivablesAgingRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReceivablesAgingRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReceivablesAgingRes_Result): CxaSearchReceivablesAgingRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 1:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReceivablesAgingRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 1; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReceivablesAgingRes.Result
 */
export const CxaSearchReceivablesAgingRes_Result = new CxaSearchReceivablesAgingRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReturnsReq$Type extends MessageType<CxaSearchReturnsReq> {
    constructor() {
        super("rd.search.service.CxaSearchReturnsReq", []);
    }
    create(value?: PartialMessage<CxaSearchReturnsReq>): CxaSearchReturnsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReturnsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReturnsReq): CxaSearchReturnsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReturnsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReturnsReq
 */
export const CxaSearchReturnsReq = new CxaSearchReturnsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReturnsRes$Type extends MessageType<CxaSearchReturnsRes> {
    constructor() {
        super("rd.search.service.CxaSearchReturnsRes", []);
    }
    create(value?: PartialMessage<CxaSearchReturnsRes>): CxaSearchReturnsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReturnsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReturnsRes): CxaSearchReturnsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReturnsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReturnsRes
 */
export const CxaSearchReturnsRes = new CxaSearchReturnsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchReturnsRes_Result$Type extends MessageType<CxaSearchReturnsRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchReturnsRes.Result", []);
    }
    create(value?: PartialMessage<CxaSearchReturnsRes_Result>): CxaSearchReturnsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchReturnsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchReturnsRes_Result): CxaSearchReturnsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchReturnsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchReturnsRes.Result
 */
export const CxaSearchReturnsRes_Result = new CxaSearchReturnsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchJobsReq$Type extends MessageType<CxaSearchJobsReq> {
    constructor() {
        super("rd.search.service.CxaSearchJobsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchJobsReq>): CxaSearchJobsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<CxaSearchJobsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchJobsReq): CxaSearchJobsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchJobsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchJobsReq
 */
export const CxaSearchJobsReq = new CxaSearchJobsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchJobsRes$Type extends MessageType<CxaSearchJobsRes> {
    constructor() {
        super("rd.search.service.CxaSearchJobsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CxaSearchJobsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchJobsRes>): CxaSearchJobsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchJobsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchJobsRes): CxaSearchJobsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.CxaSearchJobsRes.Result results */ 1:
                    message.results.push(CxaSearchJobsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchJobsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.CxaSearchJobsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CxaSearchJobsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchJobsRes
 */
export const CxaSearchJobsRes = new CxaSearchJobsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchJobsRes_Result$Type extends MessageType<CxaSearchJobsRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchJobsRes.Result", [
            { no: 1, name: "job", kind: "message", T: () => Customer },
            { no: 2, name: "total_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<CxaSearchJobsRes_Result>): CxaSearchJobsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchJobsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchJobsRes_Result): CxaSearchJobsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.customer.Customer job */ 1:
                    message.job = Customer.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* rd.proto.money.Money total_balance */ 2:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchJobsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.customer.Customer job = 1; */
        if (message.job)
            Customer.internalBinaryWrite(message.job, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 2; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchJobsRes.Result
 */
export const CxaSearchJobsRes_Result = new CxaSearchJobsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchProductsReq$Type extends MessageType<CxaSearchProductsReq> {
    constructor() {
        super("rd.search.service.CxaSearchProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 6, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "order_by", kind: "enum", T: () => ["rd.search.service.CxaSearchProductsReq.OrderBy", CxaSearchProductsReq_OrderBy, "ORDER_BY_"] },
            { no: 10, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 11, name: "is_in_stock_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<CxaSearchProductsReq>): CxaSearchProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isInStockFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<CxaSearchProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchProductsReq): CxaSearchProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 6:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 7:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 8:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.CxaSearchProductsReq.OrderBy order_by */ 9:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 10:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_in_stock_filter */ 11:
                    message.isInStockFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 6; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 7; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 8; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.CxaSearchProductsReq.OrderBy order_by = 9; */
        if (message.orderBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 10; */
        if (message.sortOrder !== 0)
            writer.tag(10, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.BoolFilter is_in_stock_filter = 11; */
        if (message.isInStockFilter !== 0)
            writer.tag(11, WireType.Varint).int32(message.isInStockFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchProductsReq
 */
export const CxaSearchProductsReq = new CxaSearchProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchProductsRes$Type extends MessageType<CxaSearchProductsRes> {
    constructor() {
        super("rd.search.service.CxaSearchProductsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CxaSearchProductsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchProductsRes>): CxaSearchProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchProductsRes): CxaSearchProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.CxaSearchProductsRes.Result results */ 1:
                    message.results.push(CxaSearchProductsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.CxaSearchProductsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CxaSearchProductsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchProductsRes
 */
export const CxaSearchProductsRes = new CxaSearchProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchProductsRes_Result$Type extends MessageType<CxaSearchProductsRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchProductsRes.Result", [
            { no: 1, name: "product", kind: "message", T: () => Product },
            { no: 2, name: "customer_price", kind: "message", T: () => Money },
            { no: 3, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 4, name: "on_hand_quantity", kind: "message", T: () => Decimal },
            { no: 5, name: "department", kind: "message", T: () => ProductCategory },
            { no: 6, name: "class", kind: "message", T: () => ProductCategory },
            { no: 7, name: "fineline", kind: "message", T: () => ProductCategory },
            { no: 8, name: "image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchProductsRes_Result>): CxaSearchProductsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.imageUrl = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchProductsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchProductsRes_Result): CxaSearchProductsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.product.Product product */ 1:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.proto.money.Money customer_price */ 2:
                    message.customerPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.customerPrice);
                    break;
                case /* rd.catalog.Product catalog_product */ 3:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* rd.proto.decimal.Decimal on_hand_quantity */ 4:
                    message.onHandQuantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.onHandQuantity);
                    break;
                case /* rd.company.ProductCategory department */ 5:
                    message.department = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* rd.company.ProductCategory class */ 6:
                    message.class = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.class);
                    break;
                case /* rd.company.ProductCategory fineline */ 7:
                    message.fineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.fineline);
                    break;
                case /* string image_url */ 8:
                    message.imageUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchProductsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.product.Product product = 1; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money customer_price = 2; */
        if (message.customerPrice)
            Money.internalBinaryWrite(message.customerPrice, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product catalog_product = 3; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal on_hand_quantity = 4; */
        if (message.onHandQuantity)
            Decimal.internalBinaryWrite(message.onHandQuantity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory department = 5; */
        if (message.department)
            ProductCategory.internalBinaryWrite(message.department, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory class = 6; */
        if (message.class)
            ProductCategory.internalBinaryWrite(message.class, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory fineline = 7; */
        if (message.fineline)
            ProductCategory.internalBinaryWrite(message.fineline, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string image_url = 8; */
        if (message.imageUrl !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.imageUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchProductsRes.Result
 */
export const CxaSearchProductsRes_Result = new CxaSearchProductsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchTintColorsReq$Type extends MessageType<CxaSearchTintColorsReq> {
    constructor() {
        super("rd.search.service.CxaSearchTintColorsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaSearchTintColorsReq>): CxaSearchTintColorsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<CxaSearchTintColorsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchTintColorsReq): CxaSearchTintColorsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchTintColorsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchTintColorsReq
 */
export const CxaSearchTintColorsReq = new CxaSearchTintColorsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchTintColorsRes$Type extends MessageType<CxaSearchTintColorsRes> {
    constructor() {
        super("rd.search.service.CxaSearchTintColorsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CxaSearchTintColorsRes_Result }
        ]);
    }
    create(value?: PartialMessage<CxaSearchTintColorsRes>): CxaSearchTintColorsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<CxaSearchTintColorsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchTintColorsRes): CxaSearchTintColorsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.CxaSearchTintColorsRes.Result results */ 1:
                    message.results.push(CxaSearchTintColorsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchTintColorsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.CxaSearchTintColorsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CxaSearchTintColorsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchTintColorsRes
 */
export const CxaSearchTintColorsRes = new CxaSearchTintColorsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaSearchTintColorsRes_Result$Type extends MessageType<CxaSearchTintColorsRes_Result> {
    constructor() {
        super("rd.search.service.CxaSearchTintColorsRes.Result", [
            { no: 1, name: "tint_color", kind: "message", T: () => TintColor }
        ]);
    }
    create(value?: PartialMessage<CxaSearchTintColorsRes_Result>): CxaSearchTintColorsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CxaSearchTintColorsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaSearchTintColorsRes_Result): CxaSearchTintColorsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.tintcolor.TintColor tint_color */ 1:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaSearchTintColorsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.tintcolor.TintColor tint_color = 1; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.CxaSearchTintColorsRes.Result
 */
export const CxaSearchTintColorsRes_Result = new CxaSearchTintColorsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterReq$Type extends MessageType<GetCashRegisterReq> {
    constructor() {
        super("rd.search.service.GetCashRegisterReq", []);
    }
    create(value?: PartialMessage<GetCashRegisterReq>): GetCashRegisterReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterReq): GetCashRegisterReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterReq
 */
export const GetCashRegisterReq = new GetCashRegisterReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterRes$Type extends MessageType<GetCashRegisterRes> {
    constructor() {
        super("rd.search.service.GetCashRegisterRes", []);
    }
    create(value?: PartialMessage<GetCashRegisterRes>): GetCashRegisterRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterRes): GetCashRegisterRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterRes
 */
export const GetCashRegisterRes = new GetCashRegisterRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterPDFReq$Type extends MessageType<GetCashRegisterPDFReq> {
    constructor() {
        super("rd.search.service.GetCashRegisterPDFReq", []);
    }
    create(value?: PartialMessage<GetCashRegisterPDFReq>): GetCashRegisterPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterPDFReq): GetCashRegisterPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterPDFReq
 */
export const GetCashRegisterPDFReq = new GetCashRegisterPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterPDFRes$Type extends MessageType<GetCashRegisterPDFRes> {
    constructor() {
        super("rd.search.service.GetCashRegisterPDFRes", []);
    }
    create(value?: PartialMessage<GetCashRegisterPDFRes>): GetCashRegisterPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterPDFRes): GetCashRegisterPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterPDFRes
 */
export const GetCashRegisterPDFRes = new GetCashRegisterPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterCSVReq$Type extends MessageType<GetCashRegisterCSVReq> {
    constructor() {
        super("rd.search.service.GetCashRegisterCSVReq", []);
    }
    create(value?: PartialMessage<GetCashRegisterCSVReq>): GetCashRegisterCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterCSVReq): GetCashRegisterCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterCSVReq
 */
export const GetCashRegisterCSVReq = new GetCashRegisterCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCashRegisterCSVRes$Type extends MessageType<GetCashRegisterCSVRes> {
    constructor() {
        super("rd.search.service.GetCashRegisterCSVRes", []);
    }
    create(value?: PartialMessage<GetCashRegisterCSVRes>): GetCashRegisterCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCashRegisterCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCashRegisterCSVRes): GetCashRegisterCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCashRegisterCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetCashRegisterCSVRes
 */
export const GetCashRegisterCSVRes = new GetCashRegisterCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesReq$Type extends MessageType<GetSalesReq> {
    constructor() {
        super("rd.search.service.GetSalesReq", []);
    }
    create(value?: PartialMessage<GetSalesReq>): GetSalesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesReq): GetSalesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesReq
 */
export const GetSalesReq = new GetSalesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesRes$Type extends MessageType<GetSalesRes> {
    constructor() {
        super("rd.search.service.GetSalesRes", []);
    }
    create(value?: PartialMessage<GetSalesRes>): GetSalesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesRes): GetSalesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesRes
 */
export const GetSalesRes = new GetSalesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesPDFReq$Type extends MessageType<GetSalesPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesPDFReq>): GetSalesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesPDFReq): GetSalesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesPDFReq
 */
export const GetSalesPDFReq = new GetSalesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesPDFRes$Type extends MessageType<GetSalesPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesPDFRes>): GetSalesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesPDFRes): GetSalesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesPDFRes
 */
export const GetSalesPDFRes = new GetSalesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesCSVReq$Type extends MessageType<GetSalesCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesCSVReq>): GetSalesCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesCSVReq): GetSalesCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesCSVReq
 */
export const GetSalesCSVReq = new GetSalesCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesCSVRes$Type extends MessageType<GetSalesCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesCSVRes>): GetSalesCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesCSVRes): GetSalesCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesCSVRes
 */
export const GetSalesCSVRes = new GetSalesCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsReq$Type extends MessageType<GetPaymentsReq> {
    constructor() {
        super("rd.search.service.GetPaymentsReq", []);
    }
    create(value?: PartialMessage<GetPaymentsReq>): GetPaymentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsReq): GetPaymentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsReq
 */
export const GetPaymentsReq = new GetPaymentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsRes$Type extends MessageType<GetPaymentsRes> {
    constructor() {
        super("rd.search.service.GetPaymentsRes", []);
    }
    create(value?: PartialMessage<GetPaymentsRes>): GetPaymentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsRes): GetPaymentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsRes
 */
export const GetPaymentsRes = new GetPaymentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsPDFReq$Type extends MessageType<GetPaymentsPDFReq> {
    constructor() {
        super("rd.search.service.GetPaymentsPDFReq", []);
    }
    create(value?: PartialMessage<GetPaymentsPDFReq>): GetPaymentsPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsPDFReq): GetPaymentsPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsPDFReq
 */
export const GetPaymentsPDFReq = new GetPaymentsPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsPDFRes$Type extends MessageType<GetPaymentsPDFRes> {
    constructor() {
        super("rd.search.service.GetPaymentsPDFRes", []);
    }
    create(value?: PartialMessage<GetPaymentsPDFRes>): GetPaymentsPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsPDFRes): GetPaymentsPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsPDFRes
 */
export const GetPaymentsPDFRes = new GetPaymentsPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsCSVReq$Type extends MessageType<GetPaymentsCSVReq> {
    constructor() {
        super("rd.search.service.GetPaymentsCSVReq", []);
    }
    create(value?: PartialMessage<GetPaymentsCSVReq>): GetPaymentsCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsCSVReq): GetPaymentsCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsCSVReq
 */
export const GetPaymentsCSVReq = new GetPaymentsCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentsCSVRes$Type extends MessageType<GetPaymentsCSVRes> {
    constructor() {
        super("rd.search.service.GetPaymentsCSVRes", []);
    }
    create(value?: PartialMessage<GetPaymentsCSVRes>): GetPaymentsCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPaymentsCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPaymentsCSVRes): GetPaymentsCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPaymentsCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPaymentsCSVRes
 */
export const GetPaymentsCSVRes = new GetPaymentsCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsReq$Type extends MessageType<GetSoldProductsReq> {
    constructor() {
        super("rd.search.service.GetSoldProductsReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.SoldProductsSortBy", SoldProductsSortBy, "SOLD_PRODUCTS_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetSoldProductsReq>): GetSoldProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsReq): GetSoldProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.SoldProductsSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.SoldProductsSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsReq
 */
export const GetSoldProductsReq = new GetSoldProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsRes$Type extends MessageType<GetSoldProductsRes> {
    constructor() {
        super("rd.search.service.GetSoldProductsRes", [
            { no: 1, name: "report", kind: "message", T: () => Report }
        ]);
    }
    create(value?: PartialMessage<GetSoldProductsRes>): GetSoldProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsRes): GetSoldProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analytics.Report report */ 1:
                    message.report = Report.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analytics.Report report = 1; */
        if (message.report)
            Report.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsRes
 */
export const GetSoldProductsRes = new GetSoldProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsPDFReq$Type extends MessageType<GetSoldProductsPDFReq> {
    constructor() {
        super("rd.search.service.GetSoldProductsPDFReq", []);
    }
    create(value?: PartialMessage<GetSoldProductsPDFReq>): GetSoldProductsPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsPDFReq): GetSoldProductsPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsPDFReq
 */
export const GetSoldProductsPDFReq = new GetSoldProductsPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsPDFRes$Type extends MessageType<GetSoldProductsPDFRes> {
    constructor() {
        super("rd.search.service.GetSoldProductsPDFRes", []);
    }
    create(value?: PartialMessage<GetSoldProductsPDFRes>): GetSoldProductsPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsPDFRes): GetSoldProductsPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsPDFRes
 */
export const GetSoldProductsPDFRes = new GetSoldProductsPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsCSVReq$Type extends MessageType<GetSoldProductsCSVReq> {
    constructor() {
        super("rd.search.service.GetSoldProductsCSVReq", []);
    }
    create(value?: PartialMessage<GetSoldProductsCSVReq>): GetSoldProductsCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsCSVReq): GetSoldProductsCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsCSVReq
 */
export const GetSoldProductsCSVReq = new GetSoldProductsCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSoldProductsCSVRes$Type extends MessageType<GetSoldProductsCSVRes> {
    constructor() {
        super("rd.search.service.GetSoldProductsCSVRes", []);
    }
    create(value?: PartialMessage<GetSoldProductsCSVRes>): GetSoldProductsCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSoldProductsCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSoldProductsCSVRes): GetSoldProductsCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSoldProductsCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSoldProductsCSVRes
 */
export const GetSoldProductsCSVRes = new GetSoldProductsCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerReq$Type extends MessageType<GetSalesByCustomerReq> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerReq", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerReq>): GetSalesByCustomerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerReq): GetSalesByCustomerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerReq
 */
export const GetSalesByCustomerReq = new GetSalesByCustomerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerRes$Type extends MessageType<GetSalesByCustomerRes> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerRes", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerRes>): GetSalesByCustomerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerRes): GetSalesByCustomerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerRes
 */
export const GetSalesByCustomerRes = new GetSalesByCustomerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerPDFReq$Type extends MessageType<GetSalesByCustomerPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerPDFReq>): GetSalesByCustomerPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerPDFReq): GetSalesByCustomerPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerPDFReq
 */
export const GetSalesByCustomerPDFReq = new GetSalesByCustomerPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerPDFRes$Type extends MessageType<GetSalesByCustomerPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerPDFRes>): GetSalesByCustomerPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerPDFRes): GetSalesByCustomerPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerPDFRes
 */
export const GetSalesByCustomerPDFRes = new GetSalesByCustomerPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerCSVReq$Type extends MessageType<GetSalesByCustomerCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerCSVReq>): GetSalesByCustomerCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerCSVReq): GetSalesByCustomerCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerCSVReq
 */
export const GetSalesByCustomerCSVReq = new GetSalesByCustomerCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByCustomerCSVRes$Type extends MessageType<GetSalesByCustomerCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesByCustomerCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesByCustomerCSVRes>): GetSalesByCustomerCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByCustomerCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByCustomerCSVRes): GetSalesByCustomerCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByCustomerCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByCustomerCSVRes
 */
export const GetSalesByCustomerCSVRes = new GetSalesByCustomerCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobReq$Type extends MessageType<GetSalesByJobReq> {
    constructor() {
        super("rd.search.service.GetSalesByJobReq", []);
    }
    create(value?: PartialMessage<GetSalesByJobReq>): GetSalesByJobReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobReq): GetSalesByJobReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobReq
 */
export const GetSalesByJobReq = new GetSalesByJobReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobRes$Type extends MessageType<GetSalesByJobRes> {
    constructor() {
        super("rd.search.service.GetSalesByJobRes", []);
    }
    create(value?: PartialMessage<GetSalesByJobRes>): GetSalesByJobRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobRes): GetSalesByJobRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobRes
 */
export const GetSalesByJobRes = new GetSalesByJobRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobPDFReq$Type extends MessageType<GetSalesByJobPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesByJobPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesByJobPDFReq>): GetSalesByJobPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobPDFReq): GetSalesByJobPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobPDFReq
 */
export const GetSalesByJobPDFReq = new GetSalesByJobPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobPDFRes$Type extends MessageType<GetSalesByJobPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesByJobPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesByJobPDFRes>): GetSalesByJobPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobPDFRes): GetSalesByJobPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobPDFRes
 */
export const GetSalesByJobPDFRes = new GetSalesByJobPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobCSVReq$Type extends MessageType<GetSalesByJobCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesByJobCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesByJobCSVReq>): GetSalesByJobCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobCSVReq): GetSalesByJobCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobCSVReq
 */
export const GetSalesByJobCSVReq = new GetSalesByJobCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByJobCSVRes$Type extends MessageType<GetSalesByJobCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesByJobCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesByJobCSVRes>): GetSalesByJobCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByJobCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByJobCSVRes): GetSalesByJobCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByJobCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByJobCSVRes
 */
export const GetSalesByJobCSVRes = new GetSalesByJobCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductReq$Type extends MessageType<GetSalesByProductReq> {
    constructor() {
        super("rd.search.service.GetSalesByProductReq", []);
    }
    create(value?: PartialMessage<GetSalesByProductReq>): GetSalesByProductReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductReq): GetSalesByProductReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductReq
 */
export const GetSalesByProductReq = new GetSalesByProductReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductRes$Type extends MessageType<GetSalesByProductRes> {
    constructor() {
        super("rd.search.service.GetSalesByProductRes", []);
    }
    create(value?: PartialMessage<GetSalesByProductRes>): GetSalesByProductRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductRes): GetSalesByProductRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductRes
 */
export const GetSalesByProductRes = new GetSalesByProductRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductPDFReq$Type extends MessageType<GetSalesByProductPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesByProductPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesByProductPDFReq>): GetSalesByProductPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductPDFReq): GetSalesByProductPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductPDFReq
 */
export const GetSalesByProductPDFReq = new GetSalesByProductPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductPDFRes$Type extends MessageType<GetSalesByProductPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesByProductPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesByProductPDFRes>): GetSalesByProductPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductPDFRes): GetSalesByProductPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductPDFRes
 */
export const GetSalesByProductPDFRes = new GetSalesByProductPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductCSVReq$Type extends MessageType<GetSalesByProductCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesByProductCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesByProductCSVReq>): GetSalesByProductCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductCSVReq): GetSalesByProductCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductCSVReq
 */
export const GetSalesByProductCSVReq = new GetSalesByProductCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByProductCSVRes$Type extends MessageType<GetSalesByProductCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesByProductCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesByProductCSVRes>): GetSalesByProductCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByProductCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByProductCSVRes): GetSalesByProductCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByProductCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByProductCSVRes
 */
export const GetSalesByProductCSVRes = new GetSalesByProductCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationReq$Type extends MessageType<GetSalesByLocationReq> {
    constructor() {
        super("rd.search.service.GetSalesByLocationReq", []);
    }
    create(value?: PartialMessage<GetSalesByLocationReq>): GetSalesByLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationReq): GetSalesByLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationReq
 */
export const GetSalesByLocationReq = new GetSalesByLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationRes$Type extends MessageType<GetSalesByLocationRes> {
    constructor() {
        super("rd.search.service.GetSalesByLocationRes", []);
    }
    create(value?: PartialMessage<GetSalesByLocationRes>): GetSalesByLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationRes): GetSalesByLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationRes
 */
export const GetSalesByLocationRes = new GetSalesByLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationPDFReq$Type extends MessageType<GetSalesByLocationPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesByLocationPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesByLocationPDFReq>): GetSalesByLocationPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationPDFReq): GetSalesByLocationPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationPDFReq
 */
export const GetSalesByLocationPDFReq = new GetSalesByLocationPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationPDFRes$Type extends MessageType<GetSalesByLocationPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesByLocationPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesByLocationPDFRes>): GetSalesByLocationPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationPDFRes): GetSalesByLocationPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationPDFRes
 */
export const GetSalesByLocationPDFRes = new GetSalesByLocationPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationCSVReq$Type extends MessageType<GetSalesByLocationCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesByLocationCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesByLocationCSVReq>): GetSalesByLocationCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationCSVReq): GetSalesByLocationCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationCSVReq
 */
export const GetSalesByLocationCSVReq = new GetSalesByLocationCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByLocationCSVRes$Type extends MessageType<GetSalesByLocationCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesByLocationCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesByLocationCSVRes>): GetSalesByLocationCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByLocationCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByLocationCSVRes): GetSalesByLocationCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByLocationCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByLocationCSVRes
 */
export const GetSalesByLocationCSVRes = new GetSalesByLocationCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepReq$Type extends MessageType<GetSalesByRepReq> {
    constructor() {
        super("rd.search.service.GetSalesByRepReq", []);
    }
    create(value?: PartialMessage<GetSalesByRepReq>): GetSalesByRepReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepReq): GetSalesByRepReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepReq
 */
export const GetSalesByRepReq = new GetSalesByRepReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepRes$Type extends MessageType<GetSalesByRepRes> {
    constructor() {
        super("rd.search.service.GetSalesByRepRes", []);
    }
    create(value?: PartialMessage<GetSalesByRepRes>): GetSalesByRepRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepRes): GetSalesByRepRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepRes
 */
export const GetSalesByRepRes = new GetSalesByRepRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepPDFReq$Type extends MessageType<GetSalesByRepPDFReq> {
    constructor() {
        super("rd.search.service.GetSalesByRepPDFReq", []);
    }
    create(value?: PartialMessage<GetSalesByRepPDFReq>): GetSalesByRepPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepPDFReq): GetSalesByRepPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepPDFReq
 */
export const GetSalesByRepPDFReq = new GetSalesByRepPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepPDFRes$Type extends MessageType<GetSalesByRepPDFRes> {
    constructor() {
        super("rd.search.service.GetSalesByRepPDFRes", []);
    }
    create(value?: PartialMessage<GetSalesByRepPDFRes>): GetSalesByRepPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepPDFRes): GetSalesByRepPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepPDFRes
 */
export const GetSalesByRepPDFRes = new GetSalesByRepPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepCSVReq$Type extends MessageType<GetSalesByRepCSVReq> {
    constructor() {
        super("rd.search.service.GetSalesByRepCSVReq", []);
    }
    create(value?: PartialMessage<GetSalesByRepCSVReq>): GetSalesByRepCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepCSVReq): GetSalesByRepCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepCSVReq
 */
export const GetSalesByRepCSVReq = new GetSalesByRepCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSalesByRepCSVRes$Type extends MessageType<GetSalesByRepCSVRes> {
    constructor() {
        super("rd.search.service.GetSalesByRepCSVRes", []);
    }
    create(value?: PartialMessage<GetSalesByRepCSVRes>): GetSalesByRepCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSalesByRepCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSalesByRepCSVRes): GetSalesByRepCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSalesByRepCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetSalesByRepCSVRes
 */
export const GetSalesByRepCSVRes = new GetSalesByRepCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsReq$Type extends MessageType<GetPriceEditsReq> {
    constructor() {
        super("rd.search.service.GetPriceEditsReq", []);
    }
    create(value?: PartialMessage<GetPriceEditsReq>): GetPriceEditsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsReq): GetPriceEditsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsReq
 */
export const GetPriceEditsReq = new GetPriceEditsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsRes$Type extends MessageType<GetPriceEditsRes> {
    constructor() {
        super("rd.search.service.GetPriceEditsRes", []);
    }
    create(value?: PartialMessage<GetPriceEditsRes>): GetPriceEditsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsRes): GetPriceEditsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsRes
 */
export const GetPriceEditsRes = new GetPriceEditsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsPDFReq$Type extends MessageType<GetPriceEditsPDFReq> {
    constructor() {
        super("rd.search.service.GetPriceEditsPDFReq", []);
    }
    create(value?: PartialMessage<GetPriceEditsPDFReq>): GetPriceEditsPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsPDFReq): GetPriceEditsPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsPDFReq
 */
export const GetPriceEditsPDFReq = new GetPriceEditsPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsPDFRes$Type extends MessageType<GetPriceEditsPDFRes> {
    constructor() {
        super("rd.search.service.GetPriceEditsPDFRes", []);
    }
    create(value?: PartialMessage<GetPriceEditsPDFRes>): GetPriceEditsPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsPDFRes): GetPriceEditsPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsPDFRes
 */
export const GetPriceEditsPDFRes = new GetPriceEditsPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsCSVReq$Type extends MessageType<GetPriceEditsCSVReq> {
    constructor() {
        super("rd.search.service.GetPriceEditsCSVReq", []);
    }
    create(value?: PartialMessage<GetPriceEditsCSVReq>): GetPriceEditsCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsCSVReq): GetPriceEditsCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsCSVReq
 */
export const GetPriceEditsCSVReq = new GetPriceEditsCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPriceEditsCSVRes$Type extends MessageType<GetPriceEditsCSVRes> {
    constructor() {
        super("rd.search.service.GetPriceEditsCSVRes", []);
    }
    create(value?: PartialMessage<GetPriceEditsCSVRes>): GetPriceEditsCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPriceEditsCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPriceEditsCSVRes): GetPriceEditsCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPriceEditsCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPriceEditsCSVRes
 */
export const GetPriceEditsCSVRes = new GetPriceEditsCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfitAndLossReq$Type extends MessageType<GetProfitAndLossReq> {
    constructor() {
        super("rd.search.service.GetProfitAndLossReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetProfitAndLossReq>): GetProfitAndLossReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetProfitAndLossReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfitAndLossReq): GetProfitAndLossReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfitAndLossReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetProfitAndLossReq
 */
export const GetProfitAndLossReq = new GetProfitAndLossReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfitAndLossRes$Type extends MessageType<GetProfitAndLossRes> {
    constructor() {
        super("rd.search.service.GetProfitAndLossRes", [
            { no: 1, name: "profit_and_loss", kind: "message", T: () => ProfitAndLoss }
        ]);
    }
    create(value?: PartialMessage<GetProfitAndLossRes>): GetProfitAndLossRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetProfitAndLossRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfitAndLossRes): GetProfitAndLossRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.ProfitAndLoss profit_and_loss */ 1:
                    message.profitAndLoss = ProfitAndLoss.internalBinaryRead(reader, reader.uint32(), options, message.profitAndLoss);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfitAndLossRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.ProfitAndLoss profit_and_loss = 1; */
        if (message.profitAndLoss)
            ProfitAndLoss.internalBinaryWrite(message.profitAndLoss, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetProfitAndLossRes
 */
export const GetProfitAndLossRes = new GetProfitAndLossRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfitAndLossPDFReq$Type extends MessageType<GetProfitAndLossPDFReq> {
    constructor() {
        super("rd.search.service.GetProfitAndLossPDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "hide_product_categories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetProfitAndLossPDFReq>): GetProfitAndLossPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hideProductCategories = false;
        if (value !== undefined)
            reflectionMergePartial<GetProfitAndLossPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfitAndLossPDFReq): GetProfitAndLossPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* bool hide_product_categories */ 2:
                    message.hideProductCategories = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfitAndLossPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool hide_product_categories = 2; */
        if (message.hideProductCategories !== false)
            writer.tag(2, WireType.Varint).bool(message.hideProductCategories);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetProfitAndLossPDFReq
 */
export const GetProfitAndLossPDFReq = new GetProfitAndLossPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfitAndLossPDFRes$Type extends MessageType<GetProfitAndLossPDFRes> {
    constructor() {
        super("rd.search.service.GetProfitAndLossPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetProfitAndLossPDFRes>): GetProfitAndLossPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetProfitAndLossPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfitAndLossPDFRes): GetProfitAndLossPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfitAndLossPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetProfitAndLossPDFRes
 */
export const GetProfitAndLossPDFRes = new GetProfitAndLossPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedReq$Type extends MessageType<GetNewAccountsOpenedReq> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedReq", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedReq>): GetNewAccountsOpenedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedReq): GetNewAccountsOpenedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedReq
 */
export const GetNewAccountsOpenedReq = new GetNewAccountsOpenedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedRes$Type extends MessageType<GetNewAccountsOpenedRes> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedRes", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedRes>): GetNewAccountsOpenedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedRes): GetNewAccountsOpenedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedRes
 */
export const GetNewAccountsOpenedRes = new GetNewAccountsOpenedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedPDFReq$Type extends MessageType<GetNewAccountsOpenedPDFReq> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedPDFReq", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedPDFReq>): GetNewAccountsOpenedPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedPDFReq): GetNewAccountsOpenedPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedPDFReq
 */
export const GetNewAccountsOpenedPDFReq = new GetNewAccountsOpenedPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedPDFRes$Type extends MessageType<GetNewAccountsOpenedPDFRes> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedPDFRes", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedPDFRes>): GetNewAccountsOpenedPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedPDFRes): GetNewAccountsOpenedPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedPDFRes
 */
export const GetNewAccountsOpenedPDFRes = new GetNewAccountsOpenedPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedCSVReq$Type extends MessageType<GetNewAccountsOpenedCSVReq> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedCSVReq", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedCSVReq>): GetNewAccountsOpenedCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedCSVReq): GetNewAccountsOpenedCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedCSVReq
 */
export const GetNewAccountsOpenedCSVReq = new GetNewAccountsOpenedCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNewAccountsOpenedCSVRes$Type extends MessageType<GetNewAccountsOpenedCSVRes> {
    constructor() {
        super("rd.search.service.GetNewAccountsOpenedCSVRes", []);
    }
    create(value?: PartialMessage<GetNewAccountsOpenedCSVRes>): GetNewAccountsOpenedCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNewAccountsOpenedCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNewAccountsOpenedCSVRes): GetNewAccountsOpenedCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNewAccountsOpenedCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetNewAccountsOpenedCSVRes
 */
export const GetNewAccountsOpenedCSVRes = new GetNewAccountsOpenedCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailReq$Type extends MessageType<GetAgingDetailReq> {
    constructor() {
        super("rd.search.service.GetAgingDetailReq", []);
    }
    create(value?: PartialMessage<GetAgingDetailReq>): GetAgingDetailReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailReq): GetAgingDetailReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailReq
 */
export const GetAgingDetailReq = new GetAgingDetailReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailRes$Type extends MessageType<GetAgingDetailRes> {
    constructor() {
        super("rd.search.service.GetAgingDetailRes", []);
    }
    create(value?: PartialMessage<GetAgingDetailRes>): GetAgingDetailRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailRes): GetAgingDetailRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailRes
 */
export const GetAgingDetailRes = new GetAgingDetailRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailPDFReq$Type extends MessageType<GetAgingDetailPDFReq> {
    constructor() {
        super("rd.search.service.GetAgingDetailPDFReq", []);
    }
    create(value?: PartialMessage<GetAgingDetailPDFReq>): GetAgingDetailPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailPDFReq): GetAgingDetailPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailPDFReq
 */
export const GetAgingDetailPDFReq = new GetAgingDetailPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailPDFRes$Type extends MessageType<GetAgingDetailPDFRes> {
    constructor() {
        super("rd.search.service.GetAgingDetailPDFRes", []);
    }
    create(value?: PartialMessage<GetAgingDetailPDFRes>): GetAgingDetailPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailPDFRes): GetAgingDetailPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailPDFRes
 */
export const GetAgingDetailPDFRes = new GetAgingDetailPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailCSVReq$Type extends MessageType<GetAgingDetailCSVReq> {
    constructor() {
        super("rd.search.service.GetAgingDetailCSVReq", []);
    }
    create(value?: PartialMessage<GetAgingDetailCSVReq>): GetAgingDetailCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailCSVReq): GetAgingDetailCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailCSVReq
 */
export const GetAgingDetailCSVReq = new GetAgingDetailCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingDetailCSVRes$Type extends MessageType<GetAgingDetailCSVRes> {
    constructor() {
        super("rd.search.service.GetAgingDetailCSVRes", []);
    }
    create(value?: PartialMessage<GetAgingDetailCSVRes>): GetAgingDetailCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingDetailCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingDetailCSVRes): GetAgingDetailCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingDetailCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingDetailCSVRes
 */
export const GetAgingDetailCSVRes = new GetAgingDetailCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalReq$Type extends MessageType<GetPurchaseJournalReq> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PurchaseJournalSortBy", PurchaseJournalSortBy, "PURCHASE_JOURNAL_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalReq>): GetPurchaseJournalReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalReq): GetPurchaseJournalReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PurchaseJournalSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PurchaseJournalSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalReq
 */
export const GetPurchaseJournalReq = new GetPurchaseJournalReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalRes$Type extends MessageType<GetPurchaseJournalRes> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalRes", [
            { no: 1, name: "report", kind: "message", T: () => Report }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalRes>): GetPurchaseJournalRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalRes): GetPurchaseJournalRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analytics.Report report */ 1:
                    message.report = Report.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analytics.Report report = 1; */
        if (message.report)
            Report.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalRes
 */
export const GetPurchaseJournalRes = new GetPurchaseJournalRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalPDFReq$Type extends MessageType<GetPurchaseJournalPDFReq> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalPDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PurchaseJournalSortBy", PurchaseJournalSortBy, "PURCHASE_JOURNAL_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalPDFReq>): GetPurchaseJournalPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalPDFReq): GetPurchaseJournalPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PurchaseJournalSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PurchaseJournalSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalPDFReq
 */
export const GetPurchaseJournalPDFReq = new GetPurchaseJournalPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalPDFRes$Type extends MessageType<GetPurchaseJournalPDFRes> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalPDFRes>): GetPurchaseJournalPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalPDFRes): GetPurchaseJournalPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalPDFRes
 */
export const GetPurchaseJournalPDFRes = new GetPurchaseJournalPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalCSVReq$Type extends MessageType<GetPurchaseJournalCSVReq> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalCSVReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PurchaseJournalSortBy", PurchaseJournalSortBy, "PURCHASE_JOURNAL_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalCSVReq>): GetPurchaseJournalCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalCSVReq): GetPurchaseJournalCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PurchaseJournalSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PurchaseJournalSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalCSVReq
 */
export const GetPurchaseJournalCSVReq = new GetPurchaseJournalCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPurchaseJournalCSVRes$Type extends MessageType<GetPurchaseJournalCSVRes> {
    constructor() {
        super("rd.search.service.GetPurchaseJournalCSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPurchaseJournalCSVRes>): GetPurchaseJournalCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPurchaseJournalCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPurchaseJournalCSVRes): GetPurchaseJournalCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPurchaseJournalCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPurchaseJournalCSVRes
 */
export const GetPurchaseJournalCSVRes = new GetPurchaseJournalCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsReq$Type extends MessageType<GetAccountPaymentAdjustmentsReq> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsReq", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsReq>): GetAccountPaymentAdjustmentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsReq): GetAccountPaymentAdjustmentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsReq
 */
export const GetAccountPaymentAdjustmentsReq = new GetAccountPaymentAdjustmentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsRes$Type extends MessageType<GetAccountPaymentAdjustmentsRes> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsRes", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsRes>): GetAccountPaymentAdjustmentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsRes): GetAccountPaymentAdjustmentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsRes
 */
export const GetAccountPaymentAdjustmentsRes = new GetAccountPaymentAdjustmentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsPDFReq$Type extends MessageType<GetAccountPaymentAdjustmentsPDFReq> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsPDFReq", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsPDFReq>): GetAccountPaymentAdjustmentsPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsPDFReq): GetAccountPaymentAdjustmentsPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsPDFReq
 */
export const GetAccountPaymentAdjustmentsPDFReq = new GetAccountPaymentAdjustmentsPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsPDFRes$Type extends MessageType<GetAccountPaymentAdjustmentsPDFRes> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsPDFRes", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsPDFRes>): GetAccountPaymentAdjustmentsPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsPDFRes): GetAccountPaymentAdjustmentsPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsPDFRes
 */
export const GetAccountPaymentAdjustmentsPDFRes = new GetAccountPaymentAdjustmentsPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsCSVReq$Type extends MessageType<GetAccountPaymentAdjustmentsCSVReq> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsCSVReq", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsCSVReq>): GetAccountPaymentAdjustmentsCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsCSVReq): GetAccountPaymentAdjustmentsCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsCSVReq
 */
export const GetAccountPaymentAdjustmentsCSVReq = new GetAccountPaymentAdjustmentsCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPaymentAdjustmentsCSVRes$Type extends MessageType<GetAccountPaymentAdjustmentsCSVRes> {
    constructor() {
        super("rd.search.service.GetAccountPaymentAdjustmentsCSVRes", []);
    }
    create(value?: PartialMessage<GetAccountPaymentAdjustmentsCSVRes>): GetAccountPaymentAdjustmentsCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountPaymentAdjustmentsCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPaymentAdjustmentsCSVRes): GetAccountPaymentAdjustmentsCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPaymentAdjustmentsCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAccountPaymentAdjustmentsCSVRes
 */
export const GetAccountPaymentAdjustmentsCSVRes = new GetAccountPaymentAdjustmentsCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesReq$Type extends MessageType<GetAdditionalFeesReq> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesReq", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesReq>): GetAdditionalFeesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesReq): GetAdditionalFeesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesReq
 */
export const GetAdditionalFeesReq = new GetAdditionalFeesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesRes$Type extends MessageType<GetAdditionalFeesRes> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesRes", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesRes>): GetAdditionalFeesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesRes): GetAdditionalFeesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesRes
 */
export const GetAdditionalFeesRes = new GetAdditionalFeesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesPDFReq$Type extends MessageType<GetAdditionalFeesPDFReq> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesPDFReq", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesPDFReq>): GetAdditionalFeesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesPDFReq): GetAdditionalFeesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesPDFReq
 */
export const GetAdditionalFeesPDFReq = new GetAdditionalFeesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesPDFRes$Type extends MessageType<GetAdditionalFeesPDFRes> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesPDFRes", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesPDFRes>): GetAdditionalFeesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesPDFRes): GetAdditionalFeesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesPDFRes
 */
export const GetAdditionalFeesPDFRes = new GetAdditionalFeesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesCSVReq$Type extends MessageType<GetAdditionalFeesCSVReq> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesCSVReq", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesCSVReq>): GetAdditionalFeesCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesCSVReq): GetAdditionalFeesCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesCSVReq
 */
export const GetAdditionalFeesCSVReq = new GetAdditionalFeesCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAdditionalFeesCSVRes$Type extends MessageType<GetAdditionalFeesCSVRes> {
    constructor() {
        super("rd.search.service.GetAdditionalFeesCSVRes", []);
    }
    create(value?: PartialMessage<GetAdditionalFeesCSVRes>): GetAdditionalFeesCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAdditionalFeesCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAdditionalFeesCSVRes): GetAdditionalFeesCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAdditionalFeesCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAdditionalFeesCSVRes
 */
export const GetAdditionalFeesCSVRes = new GetAdditionalFeesCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobReq$Type extends MessageType<GetAgingByJobReq> {
    constructor() {
        super("rd.search.service.GetAgingByJobReq", []);
    }
    create(value?: PartialMessage<GetAgingByJobReq>): GetAgingByJobReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobReq): GetAgingByJobReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobReq
 */
export const GetAgingByJobReq = new GetAgingByJobReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobRes$Type extends MessageType<GetAgingByJobRes> {
    constructor() {
        super("rd.search.service.GetAgingByJobRes", []);
    }
    create(value?: PartialMessage<GetAgingByJobRes>): GetAgingByJobRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobRes): GetAgingByJobRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobRes
 */
export const GetAgingByJobRes = new GetAgingByJobRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobPDFReq$Type extends MessageType<GetAgingByJobPDFReq> {
    constructor() {
        super("rd.search.service.GetAgingByJobPDFReq", []);
    }
    create(value?: PartialMessage<GetAgingByJobPDFReq>): GetAgingByJobPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobPDFReq): GetAgingByJobPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobPDFReq
 */
export const GetAgingByJobPDFReq = new GetAgingByJobPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobPDFRes$Type extends MessageType<GetAgingByJobPDFRes> {
    constructor() {
        super("rd.search.service.GetAgingByJobPDFRes", []);
    }
    create(value?: PartialMessage<GetAgingByJobPDFRes>): GetAgingByJobPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobPDFRes): GetAgingByJobPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobPDFRes
 */
export const GetAgingByJobPDFRes = new GetAgingByJobPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobCSVReq$Type extends MessageType<GetAgingByJobCSVReq> {
    constructor() {
        super("rd.search.service.GetAgingByJobCSVReq", []);
    }
    create(value?: PartialMessage<GetAgingByJobCSVReq>): GetAgingByJobCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobCSVReq): GetAgingByJobCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobCSVReq
 */
export const GetAgingByJobCSVReq = new GetAgingByJobCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgingByJobCSVRes$Type extends MessageType<GetAgingByJobCSVRes> {
    constructor() {
        super("rd.search.service.GetAgingByJobCSVRes", []);
    }
    create(value?: PartialMessage<GetAgingByJobCSVRes>): GetAgingByJobCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAgingByJobCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAgingByJobCSVRes): GetAgingByJobCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAgingByJobCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetAgingByJobCSVRes
 */
export const GetAgingByJobCSVRes = new GetAgingByJobCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentReq$Type extends MessageType<GetInventoryByDepartmentReq> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentReq", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentReq>): GetInventoryByDepartmentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentReq): GetInventoryByDepartmentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentReq
 */
export const GetInventoryByDepartmentReq = new GetInventoryByDepartmentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentRes$Type extends MessageType<GetInventoryByDepartmentRes> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentRes", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentRes>): GetInventoryByDepartmentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentRes): GetInventoryByDepartmentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentRes
 */
export const GetInventoryByDepartmentRes = new GetInventoryByDepartmentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentPDFReq$Type extends MessageType<GetInventoryByDepartmentPDFReq> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentPDFReq", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentPDFReq>): GetInventoryByDepartmentPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentPDFReq): GetInventoryByDepartmentPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentPDFReq
 */
export const GetInventoryByDepartmentPDFReq = new GetInventoryByDepartmentPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentPDFRes$Type extends MessageType<GetInventoryByDepartmentPDFRes> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentPDFRes", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentPDFRes>): GetInventoryByDepartmentPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentPDFRes): GetInventoryByDepartmentPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentPDFRes
 */
export const GetInventoryByDepartmentPDFRes = new GetInventoryByDepartmentPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentCSVReq$Type extends MessageType<GetInventoryByDepartmentCSVReq> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentCSVReq", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentCSVReq>): GetInventoryByDepartmentCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentCSVReq): GetInventoryByDepartmentCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentCSVReq
 */
export const GetInventoryByDepartmentCSVReq = new GetInventoryByDepartmentCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByDepartmentCSVRes$Type extends MessageType<GetInventoryByDepartmentCSVRes> {
    constructor() {
        super("rd.search.service.GetInventoryByDepartmentCSVRes", []);
    }
    create(value?: PartialMessage<GetInventoryByDepartmentCSVRes>): GetInventoryByDepartmentCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByDepartmentCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByDepartmentCSVRes): GetInventoryByDepartmentCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByDepartmentCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByDepartmentCSVRes
 */
export const GetInventoryByDepartmentCSVRes = new GetInventoryByDepartmentCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductReq$Type extends MessageType<GetInventoryByProductReq> {
    constructor() {
        super("rd.search.service.GetInventoryByProductReq", []);
    }
    create(value?: PartialMessage<GetInventoryByProductReq>): GetInventoryByProductReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductReq): GetInventoryByProductReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductReq
 */
export const GetInventoryByProductReq = new GetInventoryByProductReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductRes$Type extends MessageType<GetInventoryByProductRes> {
    constructor() {
        super("rd.search.service.GetInventoryByProductRes", []);
    }
    create(value?: PartialMessage<GetInventoryByProductRes>): GetInventoryByProductRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductRes): GetInventoryByProductRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductRes
 */
export const GetInventoryByProductRes = new GetInventoryByProductRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductPDFReq$Type extends MessageType<GetInventoryByProductPDFReq> {
    constructor() {
        super("rd.search.service.GetInventoryByProductPDFReq", []);
    }
    create(value?: PartialMessage<GetInventoryByProductPDFReq>): GetInventoryByProductPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductPDFReq): GetInventoryByProductPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductPDFReq
 */
export const GetInventoryByProductPDFReq = new GetInventoryByProductPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductPDFRes$Type extends MessageType<GetInventoryByProductPDFRes> {
    constructor() {
        super("rd.search.service.GetInventoryByProductPDFRes", []);
    }
    create(value?: PartialMessage<GetInventoryByProductPDFRes>): GetInventoryByProductPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductPDFRes): GetInventoryByProductPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductPDFRes
 */
export const GetInventoryByProductPDFRes = new GetInventoryByProductPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductCSVReq$Type extends MessageType<GetInventoryByProductCSVReq> {
    constructor() {
        super("rd.search.service.GetInventoryByProductCSVReq", []);
    }
    create(value?: PartialMessage<GetInventoryByProductCSVReq>): GetInventoryByProductCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductCSVReq): GetInventoryByProductCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductCSVReq
 */
export const GetInventoryByProductCSVReq = new GetInventoryByProductCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInventoryByProductCSVRes$Type extends MessageType<GetInventoryByProductCSVRes> {
    constructor() {
        super("rd.search.service.GetInventoryByProductCSVRes", []);
    }
    create(value?: PartialMessage<GetInventoryByProductCSVRes>): GetInventoryByProductCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInventoryByProductCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInventoryByProductCSVRes): GetInventoryByProductCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInventoryByProductCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInventoryByProductCSVRes
 */
export const GetInventoryByProductCSVRes = new GetInventoryByProductCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesReq$Type extends MessageType<GetTransferDiscrepanciesReq> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesReq", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesReq>): GetTransferDiscrepanciesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesReq): GetTransferDiscrepanciesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesReq
 */
export const GetTransferDiscrepanciesReq = new GetTransferDiscrepanciesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesRes$Type extends MessageType<GetTransferDiscrepanciesRes> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesRes", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesRes>): GetTransferDiscrepanciesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesRes): GetTransferDiscrepanciesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesRes
 */
export const GetTransferDiscrepanciesRes = new GetTransferDiscrepanciesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesPDFReq$Type extends MessageType<GetTransferDiscrepanciesPDFReq> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesPDFReq", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesPDFReq>): GetTransferDiscrepanciesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesPDFReq): GetTransferDiscrepanciesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesPDFReq
 */
export const GetTransferDiscrepanciesPDFReq = new GetTransferDiscrepanciesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesPDFRes$Type extends MessageType<GetTransferDiscrepanciesPDFRes> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesPDFRes", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesPDFRes>): GetTransferDiscrepanciesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesPDFRes): GetTransferDiscrepanciesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesPDFRes
 */
export const GetTransferDiscrepanciesPDFRes = new GetTransferDiscrepanciesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesCSVReq$Type extends MessageType<GetTransferDiscrepanciesCSVReq> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesCSVReq", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesCSVReq>): GetTransferDiscrepanciesCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesCSVReq): GetTransferDiscrepanciesCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesCSVReq
 */
export const GetTransferDiscrepanciesCSVReq = new GetTransferDiscrepanciesCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTransferDiscrepanciesCSVRes$Type extends MessageType<GetTransferDiscrepanciesCSVRes> {
    constructor() {
        super("rd.search.service.GetTransferDiscrepanciesCSVRes", []);
    }
    create(value?: PartialMessage<GetTransferDiscrepanciesCSVRes>): GetTransferDiscrepanciesCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTransferDiscrepanciesCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTransferDiscrepanciesCSVRes): GetTransferDiscrepanciesCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTransferDiscrepanciesCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTransferDiscrepanciesCSVRes
 */
export const GetTransferDiscrepanciesCSVRes = new GetTransferDiscrepanciesCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffReq$Type extends MessageType<GetInteractionsByStaffReq> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffReq", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffReq>): GetInteractionsByStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffReq): GetInteractionsByStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffReq
 */
export const GetInteractionsByStaffReq = new GetInteractionsByStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffRes$Type extends MessageType<GetInteractionsByStaffRes> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffRes", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffRes>): GetInteractionsByStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffRes): GetInteractionsByStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffRes
 */
export const GetInteractionsByStaffRes = new GetInteractionsByStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffPDFReq$Type extends MessageType<GetInteractionsByStaffPDFReq> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffPDFReq", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffPDFReq>): GetInteractionsByStaffPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffPDFReq): GetInteractionsByStaffPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffPDFReq
 */
export const GetInteractionsByStaffPDFReq = new GetInteractionsByStaffPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffPDFRes$Type extends MessageType<GetInteractionsByStaffPDFRes> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffPDFRes", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffPDFRes>): GetInteractionsByStaffPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffPDFRes): GetInteractionsByStaffPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffPDFRes
 */
export const GetInteractionsByStaffPDFRes = new GetInteractionsByStaffPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffCSVReq$Type extends MessageType<GetInteractionsByStaffCSVReq> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffCSVReq", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffCSVReq>): GetInteractionsByStaffCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffCSVReq): GetInteractionsByStaffCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffCSVReq
 */
export const GetInteractionsByStaffCSVReq = new GetInteractionsByStaffCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsByStaffCSVRes$Type extends MessageType<GetInteractionsByStaffCSVRes> {
    constructor() {
        super("rd.search.service.GetInteractionsByStaffCSVRes", []);
    }
    create(value?: PartialMessage<GetInteractionsByStaffCSVRes>): GetInteractionsByStaffCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsByStaffCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsByStaffCSVRes): GetInteractionsByStaffCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsByStaffCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsByStaffCSVRes
 */
export const GetInteractionsByStaffCSVRes = new GetInteractionsByStaffCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsReq$Type extends MessageType<GetInteractionsReq> {
    constructor() {
        super("rd.search.service.GetInteractionsReq", []);
    }
    create(value?: PartialMessage<GetInteractionsReq>): GetInteractionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsReq): GetInteractionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsReq
 */
export const GetInteractionsReq = new GetInteractionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsRes$Type extends MessageType<GetInteractionsRes> {
    constructor() {
        super("rd.search.service.GetInteractionsRes", []);
    }
    create(value?: PartialMessage<GetInteractionsRes>): GetInteractionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsRes): GetInteractionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsRes
 */
export const GetInteractionsRes = new GetInteractionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsPDFReq$Type extends MessageType<GetInteractionsPDFReq> {
    constructor() {
        super("rd.search.service.GetInteractionsPDFReq", []);
    }
    create(value?: PartialMessage<GetInteractionsPDFReq>): GetInteractionsPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsPDFReq): GetInteractionsPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsPDFReq
 */
export const GetInteractionsPDFReq = new GetInteractionsPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsPDFRes$Type extends MessageType<GetInteractionsPDFRes> {
    constructor() {
        super("rd.search.service.GetInteractionsPDFRes", []);
    }
    create(value?: PartialMessage<GetInteractionsPDFRes>): GetInteractionsPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsPDFRes): GetInteractionsPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsPDFRes
 */
export const GetInteractionsPDFRes = new GetInteractionsPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsCSVReq$Type extends MessageType<GetInteractionsCSVReq> {
    constructor() {
        super("rd.search.service.GetInteractionsCSVReq", []);
    }
    create(value?: PartialMessage<GetInteractionsCSVReq>): GetInteractionsCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsCSVReq): GetInteractionsCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsCSVReq
 */
export const GetInteractionsCSVReq = new GetInteractionsCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInteractionsCSVRes$Type extends MessageType<GetInteractionsCSVRes> {
    constructor() {
        super("rd.search.service.GetInteractionsCSVRes", []);
    }
    create(value?: PartialMessage<GetInteractionsCSVRes>): GetInteractionsCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInteractionsCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInteractionsCSVRes): GetInteractionsCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInteractionsCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetInteractionsCSVRes
 */
export const GetInteractionsCSVRes = new GetInteractionsCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesReq$Type extends MessageType<GetFinanceChargesReq> {
    constructor() {
        super("rd.search.service.GetFinanceChargesReq", []);
    }
    create(value?: PartialMessage<GetFinanceChargesReq>): GetFinanceChargesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesReq): GetFinanceChargesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesReq
 */
export const GetFinanceChargesReq = new GetFinanceChargesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesRes$Type extends MessageType<GetFinanceChargesRes> {
    constructor() {
        super("rd.search.service.GetFinanceChargesRes", []);
    }
    create(value?: PartialMessage<GetFinanceChargesRes>): GetFinanceChargesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesRes): GetFinanceChargesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesRes
 */
export const GetFinanceChargesRes = new GetFinanceChargesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesPDFReq$Type extends MessageType<GetFinanceChargesPDFReq> {
    constructor() {
        super("rd.search.service.GetFinanceChargesPDFReq", []);
    }
    create(value?: PartialMessage<GetFinanceChargesPDFReq>): GetFinanceChargesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesPDFReq): GetFinanceChargesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesPDFReq
 */
export const GetFinanceChargesPDFReq = new GetFinanceChargesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesPDFRes$Type extends MessageType<GetFinanceChargesPDFRes> {
    constructor() {
        super("rd.search.service.GetFinanceChargesPDFRes", []);
    }
    create(value?: PartialMessage<GetFinanceChargesPDFRes>): GetFinanceChargesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesPDFRes): GetFinanceChargesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesPDFRes
 */
export const GetFinanceChargesPDFRes = new GetFinanceChargesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesCSVReq$Type extends MessageType<GetFinanceChargesCSVReq> {
    constructor() {
        super("rd.search.service.GetFinanceChargesCSVReq", []);
    }
    create(value?: PartialMessage<GetFinanceChargesCSVReq>): GetFinanceChargesCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesCSVReq): GetFinanceChargesCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesCSVReq
 */
export const GetFinanceChargesCSVReq = new GetFinanceChargesCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargesCSVRes$Type extends MessageType<GetFinanceChargesCSVRes> {
    constructor() {
        super("rd.search.service.GetFinanceChargesCSVRes", []);
    }
    create(value?: PartialMessage<GetFinanceChargesCSVRes>): GetFinanceChargesCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargesCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargesCSVRes): GetFinanceChargesCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargesCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetFinanceChargesCSVRes
 */
export const GetFinanceChargesCSVRes = new GetFinanceChargesCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportBuilderReq$Type extends MessageType<GetReportBuilderReq> {
    constructor() {
        super("rd.search.service.GetReportBuilderReq", [
            { no: 1, name: "params", kind: "message", T: () => ReportParams },
            { no: 2, name: "to_csv", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "params_v2", kind: "message", T: () => ReportParamsV2 },
            { no: 4, name: "to_pdf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "saved_report_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetReportBuilderReq>): GetReportBuilderReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toCsv = false;
        message.toPdf = false;
        message.savedReportName = "";
        if (value !== undefined)
            reflectionMergePartial<GetReportBuilderReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportBuilderReq): GetReportBuilderReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.ReportParams params */ 1:
                    message.params = ReportParams.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                case /* bool to_csv */ 2:
                    message.toCsv = reader.bool();
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2 params_v2 */ 3:
                    message.paramsV2 = ReportParamsV2.internalBinaryRead(reader, reader.uint32(), options, message.paramsV2);
                    break;
                case /* bool to_pdf */ 4:
                    message.toPdf = reader.bool();
                    break;
                case /* string saved_report_name */ 5:
                    message.savedReportName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportBuilderReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.ReportParams params = 1; */
        if (message.params)
            ReportParams.internalBinaryWrite(message.params, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool to_csv = 2; */
        if (message.toCsv !== false)
            writer.tag(2, WireType.Varint).bool(message.toCsv);
        /* rd.analyticsv2.reportbuilder.ReportParamsV2 params_v2 = 3; */
        if (message.paramsV2)
            ReportParamsV2.internalBinaryWrite(message.paramsV2, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool to_pdf = 4; */
        if (message.toPdf !== false)
            writer.tag(4, WireType.Varint).bool(message.toPdf);
        /* string saved_report_name = 5; */
        if (message.savedReportName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.savedReportName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetReportBuilderReq
 */
export const GetReportBuilderReq = new GetReportBuilderReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportBuilderRes$Type extends MessageType<GetReportBuilderRes> {
    constructor() {
        super("rd.search.service.GetReportBuilderRes", [
            { no: 1, name: "report", kind: "message", T: () => Report$ },
            { no: 2, name: "compare_report", kind: "message", T: () => Report$ },
            { no: 3, name: "csv_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetReportBuilderRes>): GetReportBuilderRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.csvUrl = "";
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetReportBuilderRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportBuilderRes): GetReportBuilderRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.Report report */ 1:
                    message.report = Report$.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                case /* rd.analyticsv2.reportbuilder.Report compare_report */ 2:
                    message.compareReport = Report$.internalBinaryRead(reader, reader.uint32(), options, message.compareReport);
                    break;
                case /* string csv_url */ 3:
                    message.csvUrl = reader.string();
                    break;
                case /* bytes pdf_bytes */ 4:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportBuilderRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.Report report = 1; */
        if (message.report)
            Report$.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.Report compare_report = 2; */
        if (message.compareReport)
            Report$.internalBinaryWrite(message.compareReport, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string csv_url = 3; */
        if (message.csvUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.csvUrl);
        /* bytes pdf_bytes = 4; */
        if (message.pdfBytes.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetReportBuilderRes
 */
export const GetReportBuilderRes = new GetReportBuilderRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportBuilderConfigReq$Type extends MessageType<GetReportBuilderConfigReq> {
    constructor() {
        super("rd.search.service.GetReportBuilderConfigReq", [
            { no: 1, name: "show_admin_base_datas", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetReportBuilderConfigReq>): GetReportBuilderConfigReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.showAdminBaseDatas = false;
        if (value !== undefined)
            reflectionMergePartial<GetReportBuilderConfigReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportBuilderConfigReq): GetReportBuilderConfigReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool show_admin_base_datas */ 1:
                    message.showAdminBaseDatas = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportBuilderConfigReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool show_admin_base_datas = 1; */
        if (message.showAdminBaseDatas !== false)
            writer.tag(1, WireType.Varint).bool(message.showAdminBaseDatas);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetReportBuilderConfigReq
 */
export const GetReportBuilderConfigReq = new GetReportBuilderConfigReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportBuilderConfigRes$Type extends MessageType<GetReportBuilderConfigRes> {
    constructor() {
        super("rd.search.service.GetReportBuilderConfigRes", [
            { no: 1, name: "mappings_by_base_data", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => GetReportBuilderConfigRes_Mapping } },
            { no: 2, name: "group_names", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "base_data_names", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<GetReportBuilderConfigRes>): GetReportBuilderConfigRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mappingsByBaseData = {};
        message.groupNames = {};
        message.baseDataNames = {};
        if (value !== undefined)
            reflectionMergePartial<GetReportBuilderConfigRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportBuilderConfigRes): GetReportBuilderConfigRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int32, rd.search.service.GetReportBuilderConfigRes.Mapping> mappings_by_base_data */ 1:
                    this.binaryReadMap1(message.mappingsByBaseData, reader, options);
                    break;
                case /* map<int32, string> group_names */ 2:
                    this.binaryReadMap2(message.groupNames, reader, options);
                    break;
                case /* map<int32, string> base_data_names */ 3:
                    this.binaryReadMap3(message.baseDataNames, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: GetReportBuilderConfigRes["mappingsByBaseData"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetReportBuilderConfigRes["mappingsByBaseData"] | undefined, val: GetReportBuilderConfigRes["mappingsByBaseData"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = GetReportBuilderConfigRes_Mapping.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.GetReportBuilderConfigRes.mappings_by_base_data");
            }
        }
        map[key ?? 0] = val ?? GetReportBuilderConfigRes_Mapping.create();
    }
    private binaryReadMap2(map: GetReportBuilderConfigRes["groupNames"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetReportBuilderConfigRes["groupNames"] | undefined, val: GetReportBuilderConfigRes["groupNames"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.GetReportBuilderConfigRes.group_names");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    private binaryReadMap3(map: GetReportBuilderConfigRes["baseDataNames"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetReportBuilderConfigRes["baseDataNames"] | undefined, val: GetReportBuilderConfigRes["baseDataNames"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.GetReportBuilderConfigRes.base_data_names");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    internalBinaryWrite(message: GetReportBuilderConfigRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int32, rd.search.service.GetReportBuilderConfigRes.Mapping> mappings_by_base_data = 1; */
        for (let k of globalThis.Object.keys(message.mappingsByBaseData)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            GetReportBuilderConfigRes_Mapping.internalBinaryWrite(message.mappingsByBaseData[k as any], writer, options);
            writer.join().join();
        }
        /* map<int32, string> group_names = 2; */
        for (let k of globalThis.Object.keys(message.groupNames))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.groupNames[k as any]).join();
        /* map<int32, string> base_data_names = 3; */
        for (let k of globalThis.Object.keys(message.baseDataNames))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.baseDataNames[k as any]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetReportBuilderConfigRes
 */
export const GetReportBuilderConfigRes = new GetReportBuilderConfigRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportBuilderConfigRes_Mapping$Type extends MessageType<GetReportBuilderConfigRes_Mapping> {
    constructor() {
        super("rd.search.service.GetReportBuilderConfigRes.Mapping", [
            { no: 1, name: "base_data", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.BaseData", BaseData, "BASE_DATA_"] },
            { no: 3, name: "filters", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.Filter.Attribute", Filter_Attribute, "ATTRIBUTE_"] },
            { no: 7, name: "default_params", kind: "message", T: () => ReportParamsV2 },
            { no: 8, name: "is_single_date", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "all_columns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ColumnOption },
            { no: 10, name: "label_columns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ColumnOption },
            { no: 11, name: "metric_columns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ColumnOption }
        ]);
    }
    create(value?: PartialMessage<GetReportBuilderConfigRes_Mapping>): GetReportBuilderConfigRes_Mapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseData = 0;
        message.filters = [];
        message.isSingleDate = false;
        message.allColumns = [];
        message.labelColumns = [];
        message.metricColumns = [];
        if (value !== undefined)
            reflectionMergePartial<GetReportBuilderConfigRes_Mapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportBuilderConfigRes_Mapping): GetReportBuilderConfigRes_Mapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.BaseData base_data */ 1:
                    message.baseData = reader.int32();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Filter.Attribute filters */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filters.push(reader.int32());
                    else
                        message.filters.push(reader.int32());
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2 default_params */ 7:
                    message.defaultParams = ReportParamsV2.internalBinaryRead(reader, reader.uint32(), options, message.defaultParams);
                    break;
                case /* bool is_single_date */ 8:
                    message.isSingleDate = reader.bool();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ColumnOption all_columns */ 9:
                    message.allColumns.push(ColumnOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ColumnOption label_columns */ 10:
                    message.labelColumns.push(ColumnOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ColumnOption metric_columns */ 11:
                    message.metricColumns.push(ColumnOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportBuilderConfigRes_Mapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.BaseData base_data = 1; */
        if (message.baseData !== 0)
            writer.tag(1, WireType.Varint).int32(message.baseData);
        /* repeated rd.analyticsv2.reportbuilder.Filter.Attribute filters = 3; */
        if (message.filters.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filters.length; i++)
                writer.int32(message.filters[i]);
            writer.join();
        }
        /* rd.analyticsv2.reportbuilder.ReportParamsV2 default_params = 7; */
        if (message.defaultParams)
            ReportParamsV2.internalBinaryWrite(message.defaultParams, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_single_date = 8; */
        if (message.isSingleDate !== false)
            writer.tag(8, WireType.Varint).bool(message.isSingleDate);
        /* repeated rd.analyticsv2.reportbuilder.ColumnOption all_columns = 9; */
        for (let i = 0; i < message.allColumns.length; i++)
            ColumnOption.internalBinaryWrite(message.allColumns[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.ColumnOption label_columns = 10; */
        for (let i = 0; i < message.labelColumns.length; i++)
            ColumnOption.internalBinaryWrite(message.labelColumns[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.ColumnOption metric_columns = 11; */
        for (let i = 0; i < message.metricColumns.length; i++)
            ColumnOption.internalBinaryWrite(message.metricColumns[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetReportBuilderConfigRes.Mapping
 */
export const GetReportBuilderConfigRes_Mapping = new GetReportBuilderConfigRes_Mapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshSearchalyticsCacheReq$Type extends MessageType<RefreshSearchalyticsCacheReq> {
    constructor() {
        super("rd.search.service.RefreshSearchalyticsCacheReq", []);
    }
    create(value?: PartialMessage<RefreshSearchalyticsCacheReq>): RefreshSearchalyticsCacheReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RefreshSearchalyticsCacheReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshSearchalyticsCacheReq): RefreshSearchalyticsCacheReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshSearchalyticsCacheReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.RefreshSearchalyticsCacheReq
 */
export const RefreshSearchalyticsCacheReq = new RefreshSearchalyticsCacheReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshSearchalyticsCacheRes$Type extends MessageType<RefreshSearchalyticsCacheRes> {
    constructor() {
        super("rd.search.service.RefreshSearchalyticsCacheRes", []);
    }
    create(value?: PartialMessage<RefreshSearchalyticsCacheRes>): RefreshSearchalyticsCacheRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RefreshSearchalyticsCacheRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshSearchalyticsCacheRes): RefreshSearchalyticsCacheRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshSearchalyticsCacheRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.RefreshSearchalyticsCacheRes
 */
export const RefreshSearchalyticsCacheRes = new RefreshSearchalyticsCacheRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveriesReq$Type extends MessageType<SearchDeliveriesReq> {
    constructor() {
        super("rd.search.service.SearchDeliveriesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Delivery.Status", Delivery_Status, "STATUS_"] },
            { no: 3, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "departure_time_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "assigned_to_staff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 12, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchDeliveriesReq.OrderBy", SearchDeliveriesReq_OrderBy, "ORDER_BY_"] }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveriesReq>): SearchDeliveriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.statuses = [];
        message.locationIds = [];
        message.assignedToStaffIds = [];
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.customerIds = [];
        message.saleIds = [];
        message.sortOrder = 0;
        message.orderBy = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveriesReq): SearchDeliveriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.txn.Delivery.Status statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 3:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange departure_time_range */ 4:
                    message.departureTimeRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.departureTimeRange);
                    break;
                case /* repeated rd.proto.uuid.UUID assigned_to_staff_ids */ 5:
                    message.assignedToStaffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 6:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 7:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 8:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 9:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 10:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.SortOrder sort_order */ 11:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.SearchDeliveriesReq.OrderBy order_by */ 12:
                    message.orderBy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.txn.Delivery.Status statuses = 2; */
        if (message.statuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID location_ids = 3; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange departure_time_range = 4; */
        if (message.departureTimeRange)
            TimestampRange.internalBinaryWrite(message.departureTimeRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID assigned_to_staff_ids = 5; */
        for (let i = 0; i < message.assignedToStaffIds.length; i++)
            UUID.internalBinaryWrite(message.assignedToStaffIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 6; */
        if (message.cursor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 7; */
        if (message.offset !== 0)
            writer.tag(7, WireType.Varint).int32(message.offset);
        /* int32 limit = 8; */
        if (message.limit !== 0)
            writer.tag(8, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID customer_ids = 9; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_ids = 10; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SortOrder sort_order = 11; */
        if (message.sortOrder !== 0)
            writer.tag(11, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.SearchDeliveriesReq.OrderBy order_by = 12; */
        if (message.orderBy !== 0)
            writer.tag(12, WireType.Varint).int32(message.orderBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveriesReq
 */
export const SearchDeliveriesReq = new SearchDeliveriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveriesRes$Type extends MessageType<SearchDeliveriesRes> {
    constructor() {
        super("rd.search.service.SearchDeliveriesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchDeliveriesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveriesRes>): SearchDeliveriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveriesRes): SearchDeliveriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchDeliveriesRes.Result results */ 1:
                    message.results.push(SearchDeliveriesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchDeliveriesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchDeliveriesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveriesRes
 */
export const SearchDeliveriesRes = new SearchDeliveriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveriesRes_Result$Type extends MessageType<SearchDeliveriesRes_Result> {
    constructor() {
        super("rd.search.service.SearchDeliveriesRes.Result", [
            { no: 1, name: "delivery", kind: "message", T: () => Delivery },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "transactions_by_stop_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => SearchDeliveriesRes_Result_StopTransactions } },
            { no: 4, name: "assigned_to", kind: "message", T: () => Staff }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveriesRes_Result>): SearchDeliveriesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionsByStopId = {};
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveriesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveriesRes_Result): SearchDeliveriesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Delivery delivery */ 1:
                    message.delivery = Delivery.internalBinaryRead(reader, reader.uint32(), options, message.delivery);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* map<string, rd.search.service.SearchDeliveriesRes.Result.StopTransactions> transactions_by_stop_id */ 3:
                    this.binaryReadMap3(message.transactionsByStopId, reader, options);
                    break;
                case /* rd.company.Staff assigned_to */ 4:
                    message.assignedTo = Staff.internalBinaryRead(reader, reader.uint32(), options, message.assignedTo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SearchDeliveriesRes_Result["transactionsByStopId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchDeliveriesRes_Result["transactionsByStopId"] | undefined, val: SearchDeliveriesRes_Result["transactionsByStopId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = SearchDeliveriesRes_Result_StopTransactions.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchDeliveriesRes.Result.transactions_by_stop_id");
            }
        }
        map[key ?? ""] = val ?? SearchDeliveriesRes_Result_StopTransactions.create();
    }
    internalBinaryWrite(message: SearchDeliveriesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Delivery delivery = 1; */
        if (message.delivery)
            Delivery.internalBinaryWrite(message.delivery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.search.service.SearchDeliveriesRes.Result.StopTransactions> transactions_by_stop_id = 3; */
        for (let k of globalThis.Object.keys(message.transactionsByStopId)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            SearchDeliveriesRes_Result_StopTransactions.internalBinaryWrite(message.transactionsByStopId[k], writer, options);
            writer.join().join();
        }
        /* rd.company.Staff assigned_to = 4; */
        if (message.assignedTo)
            Staff.internalBinaryWrite(message.assignedTo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveriesRes.Result
 */
export const SearchDeliveriesRes_Result = new SearchDeliveriesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveriesRes_Result_StopTransaction$Type extends MessageType<SearchDeliveriesRes_Result_StopTransaction> {
    constructor() {
        super("rd.search.service.SearchDeliveriesRes.Result.StopTransaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "item_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 5, name: "total", kind: "message", T: () => Money },
            { no: 6, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveriesRes_Result_StopTransaction>): SearchDeliveriesRes_Result_StopTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.itemCount = 0;
        message.status = 0;
        message.customerName = "";
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveriesRes_Result_StopTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveriesRes_Result_StopTransaction): SearchDeliveriesRes_Result_StopTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* int32 item_count */ 3:
                    message.itemCount = reader.int32();
                    break;
                case /* rd.txn.Sale.Status status */ 4:
                    message.status = reader.int32();
                    break;
                case /* rd.proto.money.Money total */ 5:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string customer_name */ 6:
                    message.customerName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveriesRes_Result_StopTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* int32 item_count = 3; */
        if (message.itemCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.itemCount);
        /* rd.txn.Sale.Status status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* rd.proto.money.Money total = 5; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string customer_name = 6; */
        if (message.customerName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.customerName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveriesRes.Result.StopTransaction
 */
export const SearchDeliveriesRes_Result_StopTransaction = new SearchDeliveriesRes_Result_StopTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveriesRes_Result_StopTransactions$Type extends MessageType<SearchDeliveriesRes_Result_StopTransactions> {
    constructor() {
        super("rd.search.service.SearchDeliveriesRes.Result.StopTransactions", [
            { no: 1, name: "transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchDeliveriesRes_Result_StopTransaction },
            { no: 2, name: "stop", kind: "message", T: () => DeliveryStop }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveriesRes_Result_StopTransactions>): SearchDeliveriesRes_Result_StopTransactions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactions = [];
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveriesRes_Result_StopTransactions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveriesRes_Result_StopTransactions): SearchDeliveriesRes_Result_StopTransactions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchDeliveriesRes.Result.StopTransaction transactions */ 1:
                    message.transactions.push(SearchDeliveriesRes_Result_StopTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.DeliveryStop stop */ 2:
                    message.stop = DeliveryStop.internalBinaryRead(reader, reader.uint32(), options, message.stop);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveriesRes_Result_StopTransactions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchDeliveriesRes.Result.StopTransaction transactions = 1; */
        for (let i = 0; i < message.transactions.length; i++)
            SearchDeliveriesRes_Result_StopTransaction.internalBinaryWrite(message.transactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryStop stop = 2; */
        if (message.stop)
            DeliveryStop.internalBinaryWrite(message.stop, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveriesRes.Result.StopTransactions
 */
export const SearchDeliveriesRes_Result_StopTransactions = new SearchDeliveriesRes_Result_StopTransactions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveryStopsReq$Type extends MessageType<SearchDeliveryStopsReq> {
    constructor() {
        super("rd.search.service.SearchDeliveryStopsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.DeliveryStop.Status", DeliveryStop_Status, "STATUS_"] },
            { no: 3, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "requested_date_range", kind: "message", T: () => TimestampRange },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 8, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchDeliveryStopsReq.OrderBy", SearchDeliveryStopsReq_OrderBy, "ORDER_BY_"] },
            { no: 9, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveryStopsReq>): SearchDeliveryStopsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.statuses = [];
        message.locationIds = [];
        message.customerIds = [];
        message.saleIds = [];
        message.sortOrder = 0;
        message.orderBy = 0;
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveryStopsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveryStopsReq): SearchDeliveryStopsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.txn.DeliveryStop.Status statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 3:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 4:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 5:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange requested_date_range */ 6:
                    message.requestedDateRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.requestedDateRange);
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.SearchDeliveryStopsReq.OrderBy order_by */ 8:
                    message.orderBy = reader.int32();
                    break;
                case /* string cursor */ 9:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 10:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 11:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveryStopsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.txn.DeliveryStop.Status statuses = 2; */
        if (message.statuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID location_ids = 3; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 4; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_ids = 5; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange requested_date_range = 6; */
        if (message.requestedDateRange)
            TimestampRange.internalBinaryWrite(message.requestedDateRange, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.SearchDeliveryStopsReq.OrderBy order_by = 8; */
        if (message.orderBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.orderBy);
        /* string cursor = 9; */
        if (message.cursor !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 10; */
        if (message.offset !== 0)
            writer.tag(10, WireType.Varint).int32(message.offset);
        /* int32 limit = 11; */
        if (message.limit !== 0)
            writer.tag(11, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveryStopsReq
 */
export const SearchDeliveryStopsReq = new SearchDeliveryStopsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveryStopsRes$Type extends MessageType<SearchDeliveryStopsRes> {
    constructor() {
        super("rd.search.service.SearchDeliveryStopsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchDeliveryStopsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveryStopsRes>): SearchDeliveryStopsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveryStopsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveryStopsRes): SearchDeliveryStopsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchDeliveryStopsRes.Result results */ 1:
                    message.results.push(SearchDeliveryStopsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveryStopsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchDeliveryStopsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchDeliveryStopsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveryStopsRes
 */
export const SearchDeliveryStopsRes = new SearchDeliveryStopsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveryStopsRes_Result$Type extends MessageType<SearchDeliveryStopsRes_Result> {
    constructor() {
        super("rd.search.service.SearchDeliveryStopsRes.Result", [
            { no: 1, name: "stop", kind: "message", T: () => DeliveryStop },
            { no: 2, name: "dispatch_location", kind: "message", T: () => Location },
            { no: 3, name: "transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchDeliveryStopsRes_Result_Transaction },
            { no: 4, name: "linked_delivery", kind: "message", T: () => SearchDeliveryStopsRes_Result_LinkedDelivery }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveryStopsRes_Result>): SearchDeliveryStopsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactions = [];
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveryStopsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveryStopsRes_Result): SearchDeliveryStopsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.DeliveryStop stop */ 1:
                    message.stop = DeliveryStop.internalBinaryRead(reader, reader.uint32(), options, message.stop);
                    break;
                case /* rd.company.Location dispatch_location */ 2:
                    message.dispatchLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.dispatchLocation);
                    break;
                case /* repeated rd.search.service.SearchDeliveryStopsRes.Result.Transaction transactions */ 3:
                    message.transactions.push(SearchDeliveryStopsRes_Result_Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery linked_delivery */ 4:
                    message.linkedDelivery = SearchDeliveryStopsRes_Result_LinkedDelivery.internalBinaryRead(reader, reader.uint32(), options, message.linkedDelivery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveryStopsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.DeliveryStop stop = 1; */
        if (message.stop)
            DeliveryStop.internalBinaryWrite(message.stop, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location dispatch_location = 2; */
        if (message.dispatchLocation)
            Location.internalBinaryWrite(message.dispatchLocation, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SearchDeliveryStopsRes.Result.Transaction transactions = 3; */
        for (let i = 0; i < message.transactions.length; i++)
            SearchDeliveryStopsRes_Result_Transaction.internalBinaryWrite(message.transactions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery linked_delivery = 4; */
        if (message.linkedDelivery)
            SearchDeliveryStopsRes_Result_LinkedDelivery.internalBinaryWrite(message.linkedDelivery, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveryStopsRes.Result
 */
export const SearchDeliveryStopsRes_Result = new SearchDeliveryStopsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveryStopsRes_Result_Transaction$Type extends MessageType<SearchDeliveryStopsRes_Result_Transaction> {
    constructor() {
        super("rd.search.service.SearchDeliveryStopsRes.Result.Transaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "item_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 5, name: "total", kind: "message", T: () => Money },
            { no: 6, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveryStopsRes_Result_Transaction>): SearchDeliveryStopsRes_Result_Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.itemCount = 0;
        message.status = 0;
        message.customerName = "";
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveryStopsRes_Result_Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveryStopsRes_Result_Transaction): SearchDeliveryStopsRes_Result_Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* int32 item_count */ 3:
                    message.itemCount = reader.int32();
                    break;
                case /* rd.txn.Sale.Status status */ 4:
                    message.status = reader.int32();
                    break;
                case /* rd.proto.money.Money total */ 5:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string customer_name */ 6:
                    message.customerName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveryStopsRes_Result_Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* int32 item_count = 3; */
        if (message.itemCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.itemCount);
        /* rd.txn.Sale.Status status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* rd.proto.money.Money total = 5; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string customer_name = 6; */
        if (message.customerName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.customerName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveryStopsRes.Result.Transaction
 */
export const SearchDeliveryStopsRes_Result_Transaction = new SearchDeliveryStopsRes_Result_Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchDeliveryStopsRes_Result_LinkedDelivery$Type extends MessageType<SearchDeliveryStopsRes_Result_LinkedDelivery> {
    constructor() {
        super("rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["rd.txn.Delivery.Status", Delivery_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<SearchDeliveryStopsRes_Result_LinkedDelivery>): SearchDeliveryStopsRes_Result_LinkedDelivery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchDeliveryStopsRes_Result_LinkedDelivery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchDeliveryStopsRes_Result_LinkedDelivery): SearchDeliveryStopsRes_Result_LinkedDelivery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Delivery.Status status */ 3:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchDeliveryStopsRes_Result_LinkedDelivery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Delivery.Status status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchDeliveryStopsRes.Result.LinkedDelivery
 */
export const SearchDeliveryStopsRes_Result_LinkedDelivery = new SearchDeliveryStopsRes_Result_LinkedDelivery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchLocationsReq$Type extends MessageType<SearchLocationsReq> {
    constructor() {
        super("rd.search.service.SearchLocationsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchLocationsReq>): SearchLocationsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.isActiveFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchLocationsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchLocationsReq): SearchLocationsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 5:
                    message.isActiveFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchLocationsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.BoolFilter is_active_filter = 5; */
        if (message.isActiveFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActiveFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchLocationsReq
 */
export const SearchLocationsReq = new SearchLocationsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchLocationsRes$Type extends MessageType<SearchLocationsRes> {
    constructor() {
        super("rd.search.service.SearchLocationsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchLocationsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchLocationsRes>): SearchLocationsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchLocationsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchLocationsRes): SearchLocationsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchLocationsRes.Result results */ 1:
                    message.results.push(SearchLocationsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchLocationsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchLocationsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchLocationsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchLocationsRes
 */
export const SearchLocationsRes = new SearchLocationsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchLocationsRes_Result$Type extends MessageType<SearchLocationsRes_Result> {
    constructor() {
        super("rd.search.service.SearchLocationsRes.Result", [
            { no: 1, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "tax_rates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxRate },
            { no: 4, name: "pricing_region", kind: "message", T: () => PricingRegion }
        ]);
    }
    create(value?: PartialMessage<SearchLocationsRes_Result>): SearchLocationsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRates = [];
        if (value !== undefined)
            reflectionMergePartial<SearchLocationsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchLocationsRes_Result): SearchLocationsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Location location */ 1:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* repeated rd.company.TaxRate tax_rates */ 3:
                    message.taxRates.push(TaxRate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.company.PricingRegion pricing_region */ 4:
                    message.pricingRegion = PricingRegion.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegion);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchLocationsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Location location = 1; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.TaxRate tax_rates = 3; */
        for (let i = 0; i < message.taxRates.length; i++)
            TaxRate.internalBinaryWrite(message.taxRates[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingRegion pricing_region = 4; */
        if (message.pricingRegion)
            PricingRegion.internalBinaryWrite(message.pricingRegion, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchLocationsRes.Result
 */
export const SearchLocationsRes_Result = new SearchLocationsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductCategoriesReq$Type extends MessageType<SearchProductCategoriesReq> {
    constructor() {
        super("rd.search.service.SearchProductCategoriesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.ProductCategory.Type", ProductCategory_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchProductCategoriesReq>): SearchProductCategoriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.types = [];
        if (value !== undefined)
            reflectionMergePartial<SearchProductCategoriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductCategoriesReq): SearchProductCategoriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.company.ProductCategory.Type types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchProductCategoriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.company.ProductCategory.Type types = 5; */
        if (message.types.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductCategoriesReq
 */
export const SearchProductCategoriesReq = new SearchProductCategoriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductCategoriesRes$Type extends MessageType<SearchProductCategoriesRes> {
    constructor() {
        super("rd.search.service.SearchProductCategoriesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchProductCategoriesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchProductCategoriesRes>): SearchProductCategoriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchProductCategoriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductCategoriesRes): SearchProductCategoriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchProductCategoriesRes.Result results */ 1:
                    message.results.push(SearchProductCategoriesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchProductCategoriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchProductCategoriesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchProductCategoriesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductCategoriesRes
 */
export const SearchProductCategoriesRes = new SearchProductCategoriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProductCategoriesRes_Result$Type extends MessageType<SearchProductCategoriesRes_Result> {
    constructor() {
        super("rd.search.service.SearchProductCategoriesRes.Result", [
            { no: 1, name: "product_category", kind: "message", T: () => ProductCategory }
        ]);
    }
    create(value?: PartialMessage<SearchProductCategoriesRes_Result>): SearchProductCategoriesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchProductCategoriesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchProductCategoriesRes_Result): SearchProductCategoriesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.ProductCategory product_category */ 1:
                    message.productCategory = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productCategory);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchProductCategoriesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.ProductCategory product_category = 1; */
        if (message.productCategory)
            ProductCategory.internalBinaryWrite(message.productCategory, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchProductCategoriesRes.Result
 */
export const SearchProductCategoriesRes_Result = new SearchProductCategoriesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStaffsReq$Type extends MessageType<SearchStaffsReq> {
    constructor() {
        super("rd.search.service.SearchStaffsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 6, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchStaffsReq.OrderBy", SearchStaffsReq_OrderBy, "ORDER_BY_"] },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchStaffsReq>): SearchStaffsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.isActiveFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchStaffsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStaffsReq): SearchStaffsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 5:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* rd.search.service.SearchStaffsReq.OrderBy order_by */ 6:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStaffsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.BoolFilter is_active_filter = 5; */
        if (message.isActiveFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActiveFilter);
        /* rd.search.service.SearchStaffsReq.OrderBy order_by = 6; */
        if (message.orderBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStaffsReq
 */
export const SearchStaffsReq = new SearchStaffsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStaffsRes$Type extends MessageType<SearchStaffsRes> {
    constructor() {
        super("rd.search.service.SearchStaffsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchStaffsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "permissionIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStaffsRes>): SearchStaffsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        message.permissionIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchStaffsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStaffsRes): SearchStaffsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchStaffsRes.Result results */ 1:
                    message.results.push(SearchStaffsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* repeated string permissionIds */ 3:
                    message.permissionIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStaffsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchStaffsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchStaffsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* repeated string permissionIds = 3; */
        for (let i = 0; i < message.permissionIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.permissionIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStaffsRes
 */
export const SearchStaffsRes = new SearchStaffsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStaffsRes_Result$Type extends MessageType<SearchStaffsRes_Result> {
    constructor() {
        super("rd.search.service.SearchStaffsRes.Result", [
            { no: 1, name: "staff", kind: "message", T: () => Staff }
        ]);
    }
    create(value?: PartialMessage<SearchStaffsRes_Result>): SearchStaffsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchStaffsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStaffsRes_Result): SearchStaffsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Staff staff */ 1:
                    message.staff = Staff.internalBinaryRead(reader, reader.uint32(), options, message.staff);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStaffsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Staff staff = 1; */
        if (message.staff)
            Staff.internalBinaryWrite(message.staff, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchStaffsRes.Result
 */
export const SearchStaffsRes_Result = new SearchStaffsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesReq$Type extends MessageType<GetTaxesReq> {
    constructor() {
        super("rd.search.service.GetTaxesReq", []);
    }
    create(value?: PartialMessage<GetTaxesReq>): GetTaxesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesReq): GetTaxesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesReq
 */
export const GetTaxesReq = new GetTaxesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesRes$Type extends MessageType<GetTaxesRes> {
    constructor() {
        super("rd.search.service.GetTaxesRes", []);
    }
    create(value?: PartialMessage<GetTaxesRes>): GetTaxesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesRes): GetTaxesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesRes
 */
export const GetTaxesRes = new GetTaxesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesPDFReq$Type extends MessageType<GetTaxesPDFReq> {
    constructor() {
        super("rd.search.service.GetTaxesPDFReq", []);
    }
    create(value?: PartialMessage<GetTaxesPDFReq>): GetTaxesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesPDFReq): GetTaxesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesPDFReq
 */
export const GetTaxesPDFReq = new GetTaxesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesPDFRes$Type extends MessageType<GetTaxesPDFRes> {
    constructor() {
        super("rd.search.service.GetTaxesPDFRes", []);
    }
    create(value?: PartialMessage<GetTaxesPDFRes>): GetTaxesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesPDFRes): GetTaxesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesPDFRes
 */
export const GetTaxesPDFRes = new GetTaxesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesCSVReq$Type extends MessageType<GetTaxesCSVReq> {
    constructor() {
        super("rd.search.service.GetTaxesCSVReq", []);
    }
    create(value?: PartialMessage<GetTaxesCSVReq>): GetTaxesCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesCSVReq): GetTaxesCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesCSVReq
 */
export const GetTaxesCSVReq = new GetTaxesCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesCSVRes$Type extends MessageType<GetTaxesCSVRes> {
    constructor() {
        super("rd.search.service.GetTaxesCSVRes", []);
    }
    create(value?: PartialMessage<GetTaxesCSVRes>): GetTaxesCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesCSVRes): GetTaxesCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesCSVRes
 */
export const GetTaxesCSVRes = new GetTaxesCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRateReq$Type extends MessageType<GetTaxesByTaxRateReq> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRateReq", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRateReq>): GetTaxesByTaxRateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRateReq): GetTaxesByTaxRateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRateReq
 */
export const GetTaxesByTaxRateReq = new GetTaxesByTaxRateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRateRes$Type extends MessageType<GetTaxesByTaxRateRes> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRateRes", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRateRes>): GetTaxesByTaxRateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRateRes): GetTaxesByTaxRateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRateRes
 */
export const GetTaxesByTaxRateRes = new GetTaxesByTaxRateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRatePDFReq$Type extends MessageType<GetTaxesByTaxRatePDFReq> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRatePDFReq", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRatePDFReq>): GetTaxesByTaxRatePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRatePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRatePDFReq): GetTaxesByTaxRatePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRatePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRatePDFReq
 */
export const GetTaxesByTaxRatePDFReq = new GetTaxesByTaxRatePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRatePDFRes$Type extends MessageType<GetTaxesByTaxRatePDFRes> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRatePDFRes", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRatePDFRes>): GetTaxesByTaxRatePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRatePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRatePDFRes): GetTaxesByTaxRatePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRatePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRatePDFRes
 */
export const GetTaxesByTaxRatePDFRes = new GetTaxesByTaxRatePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRateCSVReq$Type extends MessageType<GetTaxesByTaxRateCSVReq> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRateCSVReq", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRateCSVReq>): GetTaxesByTaxRateCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRateCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRateCSVReq): GetTaxesByTaxRateCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRateCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRateCSVReq
 */
export const GetTaxesByTaxRateCSVReq = new GetTaxesByTaxRateCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByTaxRateCSVRes$Type extends MessageType<GetTaxesByTaxRateCSVRes> {
    constructor() {
        super("rd.search.service.GetTaxesByTaxRateCSVRes", []);
    }
    create(value?: PartialMessage<GetTaxesByTaxRateCSVRes>): GetTaxesByTaxRateCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByTaxRateCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByTaxRateCSVRes): GetTaxesByTaxRateCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByTaxRateCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByTaxRateCSVRes
 */
export const GetTaxesByTaxRateCSVRes = new GetTaxesByTaxRateCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationReq$Type extends MessageType<GetTaxesByAccountingLocationReq> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationReq", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationReq>): GetTaxesByAccountingLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationReq): GetTaxesByAccountingLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationReq
 */
export const GetTaxesByAccountingLocationReq = new GetTaxesByAccountingLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationRes$Type extends MessageType<GetTaxesByAccountingLocationRes> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationRes", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationRes>): GetTaxesByAccountingLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationRes): GetTaxesByAccountingLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationRes
 */
export const GetTaxesByAccountingLocationRes = new GetTaxesByAccountingLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationPDFReq$Type extends MessageType<GetTaxesByAccountingLocationPDFReq> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationPDFReq", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationPDFReq>): GetTaxesByAccountingLocationPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationPDFReq): GetTaxesByAccountingLocationPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationPDFReq
 */
export const GetTaxesByAccountingLocationPDFReq = new GetTaxesByAccountingLocationPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationPDFRes$Type extends MessageType<GetTaxesByAccountingLocationPDFRes> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationPDFRes", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationPDFRes>): GetTaxesByAccountingLocationPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationPDFRes): GetTaxesByAccountingLocationPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationPDFRes
 */
export const GetTaxesByAccountingLocationPDFRes = new GetTaxesByAccountingLocationPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationCSVReq$Type extends MessageType<GetTaxesByAccountingLocationCSVReq> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationCSVReq", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationCSVReq>): GetTaxesByAccountingLocationCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationCSVReq): GetTaxesByAccountingLocationCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationCSVReq
 */
export const GetTaxesByAccountingLocationCSVReq = new GetTaxesByAccountingLocationCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaxesByAccountingLocationCSVRes$Type extends MessageType<GetTaxesByAccountingLocationCSVRes> {
    constructor() {
        super("rd.search.service.GetTaxesByAccountingLocationCSVRes", []);
    }
    create(value?: PartialMessage<GetTaxesByAccountingLocationCSVRes>): GetTaxesByAccountingLocationCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTaxesByAccountingLocationCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTaxesByAccountingLocationCSVRes): GetTaxesByAccountingLocationCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTaxesByAccountingLocationCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetTaxesByAccountingLocationCSVRes
 */
export const GetTaxesByAccountingLocationCSVRes = new GetTaxesByAccountingLocationCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchNotifDeliveriesReq$Type extends MessageType<SearchNotifDeliveriesReq> {
    constructor() {
        super("rd.search.service.SearchNotifDeliveriesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_read_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 6, name: "is_archived_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 7, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderNotificationsBy", OrderNotificationsBy, "ORDER_NOTIFICATIONS_BY_"] },
            { no: 8, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 9, name: "sink_filter", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.notif.Sink", Sink, "SINK_"] },
            { no: 10, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<SearchNotifDeliveriesReq>): SearchNotifDeliveriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.isReadFilter = 0;
        message.isArchivedFilter = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.sinkFilter = [];
        if (value !== undefined)
            reflectionMergePartial<SearchNotifDeliveriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchNotifDeliveriesReq): SearchNotifDeliveriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_read_filter */ 5:
                    message.isReadFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_archived_filter */ 6:
                    message.isArchivedFilter = reader.int32();
                    break;
                case /* rd.search.service.OrderNotificationsBy order_by */ 7:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.notif.Sink sink_filter */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sinkFilter.push(reader.int32());
                    else
                        message.sinkFilter.push(reader.int32());
                    break;
                case /* rd.proto.uuid.UUID location_id */ 10:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchNotifDeliveriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.BoolFilter is_read_filter = 5; */
        if (message.isReadFilter !== 0)
            writer.tag(5, WireType.Varint).int32(message.isReadFilter);
        /* rd.search.service.BoolFilter is_archived_filter = 6; */
        if (message.isArchivedFilter !== 0)
            writer.tag(6, WireType.Varint).int32(message.isArchivedFilter);
        /* rd.search.service.OrderNotificationsBy order_by = 7; */
        if (message.orderBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.notif.Sink sink_filter = 9; */
        if (message.sinkFilter.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sinkFilter.length; i++)
                writer.int32(message.sinkFilter[i]);
            writer.join();
        }
        /* rd.proto.uuid.UUID location_id = 10; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchNotifDeliveriesReq
 */
export const SearchNotifDeliveriesReq = new SearchNotifDeliveriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchNotifDeliveriesRes$Type extends MessageType<SearchNotifDeliveriesRes> {
    constructor() {
        super("rd.search.service.SearchNotifDeliveriesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchNotifDeliveriesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchNotifDeliveriesRes>): SearchNotifDeliveriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchNotifDeliveriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchNotifDeliveriesRes): SearchNotifDeliveriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchNotifDeliveriesRes.Result results */ 1:
                    message.results.push(SearchNotifDeliveriesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchNotifDeliveriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchNotifDeliveriesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchNotifDeliveriesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchNotifDeliveriesRes
 */
export const SearchNotifDeliveriesRes = new SearchNotifDeliveriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchNotifDeliveriesRes_Result$Type extends MessageType<SearchNotifDeliveriesRes_Result> {
    constructor() {
        super("rd.search.service.SearchNotifDeliveriesRes.Result", [
            { no: 1, name: "delivery", kind: "message", T: () => Delivery$ }
        ]);
    }
    create(value?: PartialMessage<SearchNotifDeliveriesRes_Result>): SearchNotifDeliveriesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchNotifDeliveriesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchNotifDeliveriesRes_Result): SearchNotifDeliveriesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.notif.Delivery delivery */ 1:
                    message.delivery = Delivery$.internalBinaryRead(reader, reader.uint32(), options, message.delivery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchNotifDeliveriesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.notif.Delivery delivery = 1; */
        if (message.delivery)
            Delivery$.internalBinaryWrite(message.delivery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchNotifDeliveriesRes.Result
 */
export const SearchNotifDeliveriesRes_Result = new SearchNotifDeliveriesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDateReq$Type extends MessageType<GetPayoutsByPayoutDateReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDateReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDateReq>): GetPayoutsByPayoutDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDateReq): GetPayoutsByPayoutDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDateReq
 */
export const GetPayoutsByPayoutDateReq = new GetPayoutsByPayoutDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDateRes$Type extends MessageType<GetPayoutsByPayoutDateRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDateRes", [
            { no: 1, name: "report", kind: "message", T: () => Report }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDateRes>): GetPayoutsByPayoutDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDateRes): GetPayoutsByPayoutDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analytics.Report report */ 1:
                    message.report = Report.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analytics.Report report = 1; */
        if (message.report)
            Report.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDateRes
 */
export const GetPayoutsByPayoutDateRes = new GetPayoutsByPayoutDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDatePDFReq$Type extends MessageType<GetPayoutsByPayoutDatePDFReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDatePDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDatePDFReq>): GetPayoutsByPayoutDatePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDatePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDatePDFReq): GetPayoutsByPayoutDatePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDatePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDatePDFReq
 */
export const GetPayoutsByPayoutDatePDFReq = new GetPayoutsByPayoutDatePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDatePDFRes$Type extends MessageType<GetPayoutsByPayoutDatePDFRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDatePDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDatePDFRes>): GetPayoutsByPayoutDatePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDatePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDatePDFRes): GetPayoutsByPayoutDatePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDatePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDatePDFRes
 */
export const GetPayoutsByPayoutDatePDFRes = new GetPayoutsByPayoutDatePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDateCSVReq$Type extends MessageType<GetPayoutsByPayoutDateCSVReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDateCSVReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDateCSVReq>): GetPayoutsByPayoutDateCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDateCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDateCSVReq): GetPayoutsByPayoutDateCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDateCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDateCSVReq
 */
export const GetPayoutsByPayoutDateCSVReq = new GetPayoutsByPayoutDateCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByPayoutDateCSVRes$Type extends MessageType<GetPayoutsByPayoutDateCSVRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByPayoutDateCSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByPayoutDateCSVRes>): GetPayoutsByPayoutDateCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByPayoutDateCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByPayoutDateCSVRes): GetPayoutsByPayoutDateCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByPayoutDateCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByPayoutDateCSVRes
 */
export const GetPayoutsByPayoutDateCSVRes = new GetPayoutsByPayoutDateCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDateReq$Type extends MessageType<GetPayoutsByTransactionDateReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDateReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDateReq>): GetPayoutsByTransactionDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDateReq): GetPayoutsByTransactionDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDateReq
 */
export const GetPayoutsByTransactionDateReq = new GetPayoutsByTransactionDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDateRes$Type extends MessageType<GetPayoutsByTransactionDateRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDateRes", [
            { no: 1, name: "report", kind: "message", T: () => Report }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDateRes>): GetPayoutsByTransactionDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDateRes): GetPayoutsByTransactionDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analytics.Report report */ 1:
                    message.report = Report.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analytics.Report report = 1; */
        if (message.report)
            Report.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDateRes
 */
export const GetPayoutsByTransactionDateRes = new GetPayoutsByTransactionDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDatePDFReq$Type extends MessageType<GetPayoutsByTransactionDatePDFReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDatePDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDatePDFReq>): GetPayoutsByTransactionDatePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDatePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDatePDFReq): GetPayoutsByTransactionDatePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDatePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDatePDFReq
 */
export const GetPayoutsByTransactionDatePDFReq = new GetPayoutsByTransactionDatePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDatePDFRes$Type extends MessageType<GetPayoutsByTransactionDatePDFRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDatePDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDatePDFRes>): GetPayoutsByTransactionDatePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDatePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDatePDFRes): GetPayoutsByTransactionDatePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDatePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDatePDFRes
 */
export const GetPayoutsByTransactionDatePDFRes = new GetPayoutsByTransactionDatePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDateCSVReq$Type extends MessageType<GetPayoutsByTransactionDateCSVReq> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDateCSVReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.analyticsv2.PayoutTxnSortBy", PayoutTxnSortBy, "PAYOUT_TXN_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDateCSVReq>): GetPayoutsByTransactionDateCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDateCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDateCSVReq): GetPayoutsByTransactionDateCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.analyticsv2.PayoutTxnSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDateCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.PayoutTxnSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDateCSVReq
 */
export const GetPayoutsByTransactionDateCSVReq = new GetPayoutsByTransactionDateCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBalanceSheetReq$Type extends MessageType<GetBalanceSheetReq> {
    constructor() {
        super("rd.search.service.GetBalanceSheetReq", [
            { no: 1, name: "asOf", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 2, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetBalanceSheetReq>): GetBalanceSheetReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<GetBalanceSheetReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBalanceSheetReq): GetBalanceSheetReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp asOf */ 1:
                    message.asOf = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.asOf);
                    break;
                case /* string client_time_zone */ 2:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBalanceSheetReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp asOf = 1; */
        if (message.asOf)
            Timestamp.internalBinaryWrite(message.asOf, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 2; */
        if (message.clientTimeZone !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetBalanceSheetReq
 */
export const GetBalanceSheetReq = new GetBalanceSheetReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBalanceSheetRes$Type extends MessageType<GetBalanceSheetRes> {
    constructor() {
        super("rd.search.service.GetBalanceSheetRes", [
            { no: 1, name: "balance_sheet", kind: "message", T: () => BalanceSheet }
        ]);
    }
    create(value?: PartialMessage<GetBalanceSheetRes>): GetBalanceSheetRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetBalanceSheetRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBalanceSheetRes): GetBalanceSheetRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.BalanceSheet balance_sheet */ 1:
                    message.balanceSheet = BalanceSheet.internalBinaryRead(reader, reader.uint32(), options, message.balanceSheet);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBalanceSheetRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.BalanceSheet balance_sheet = 1; */
        if (message.balanceSheet)
            BalanceSheet.internalBinaryWrite(message.balanceSheet, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetBalanceSheetRes
 */
export const GetBalanceSheetRes = new GetBalanceSheetRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIncomeStatementReq$Type extends MessageType<GetIncomeStatementReq> {
    constructor() {
        super("rd.search.service.GetIncomeStatementReq", [
            { no: 1, name: "timestamp_range", kind: "message", T: () => TimestampRange, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIncomeStatementReq>): GetIncomeStatementReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<GetIncomeStatementReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIncomeStatementReq): GetIncomeStatementReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.timestamprange.TimestampRange timestamp_range */ 1:
                    message.timestampRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.timestampRange);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIncomeStatementReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.timestamprange.TimestampRange timestamp_range = 1; */
        if (message.timestampRange)
            TimestampRange.internalBinaryWrite(message.timestampRange, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetIncomeStatementReq
 */
export const GetIncomeStatementReq = new GetIncomeStatementReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIncomeStatementRes$Type extends MessageType<GetIncomeStatementRes> {
    constructor() {
        super("rd.search.service.GetIncomeStatementRes", [
            { no: 1, name: "income_statement", kind: "message", T: () => IncomeStatement }
        ]);
    }
    create(value?: PartialMessage<GetIncomeStatementRes>): GetIncomeStatementRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIncomeStatementRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIncomeStatementRes): GetIncomeStatementRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.IncomeStatement income_statement */ 1:
                    message.incomeStatement = IncomeStatement.internalBinaryRead(reader, reader.uint32(), options, message.incomeStatement);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIncomeStatementRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.IncomeStatement income_statement = 1; */
        if (message.incomeStatement)
            IncomeStatement.internalBinaryWrite(message.incomeStatement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetIncomeStatementRes
 */
export const GetIncomeStatementRes = new GetIncomeStatementRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesReq$Type extends MessageType<GetJournalEntriesReq> {
    constructor() {
        super("rd.search.service.GetJournalEntriesReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "is_internal_transactions_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesReq>): GetJournalEntriesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isInternalTransactionsOnly = false;
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesReq): GetJournalEntriesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* bool is_internal_transactions_only */ 2:
                    message.isInternalTransactionsOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_internal_transactions_only = 2; */
        if (message.isInternalTransactionsOnly !== false)
            writer.tag(2, WireType.Varint).bool(message.isInternalTransactionsOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesReq
 */
export const GetJournalEntriesReq = new GetJournalEntriesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesRes$Type extends MessageType<GetJournalEntriesRes> {
    constructor() {
        super("rd.search.service.GetJournalEntriesRes", [
            { no: 1, name: "journal_entries", kind: "message", T: () => JournalEntries }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesRes>): GetJournalEntriesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesRes): GetJournalEntriesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.accounting.JournalEntries journal_entries */ 1:
                    message.journalEntries = JournalEntries.internalBinaryRead(reader, reader.uint32(), options, message.journalEntries);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.accounting.JournalEntries journal_entries = 1; */
        if (message.journalEntries)
            JournalEntries.internalBinaryWrite(message.journalEntries, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesRes
 */
export const GetJournalEntriesRes = new GetJournalEntriesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesPDFReq$Type extends MessageType<GetJournalEntriesPDFReq> {
    constructor() {
        super("rd.search.service.GetJournalEntriesPDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "is_internal_transactions_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesPDFReq>): GetJournalEntriesPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isInternalTransactionsOnly = false;
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesPDFReq): GetJournalEntriesPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* bool is_internal_transactions_only */ 2:
                    message.isInternalTransactionsOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_internal_transactions_only = 2; */
        if (message.isInternalTransactionsOnly !== false)
            writer.tag(2, WireType.Varint).bool(message.isInternalTransactionsOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesPDFReq
 */
export const GetJournalEntriesPDFReq = new GetJournalEntriesPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesPDFRes$Type extends MessageType<GetJournalEntriesPDFRes> {
    constructor() {
        super("rd.search.service.GetJournalEntriesPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesPDFRes>): GetJournalEntriesPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesPDFRes): GetJournalEntriesPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesPDFRes
 */
export const GetJournalEntriesPDFRes = new GetJournalEntriesPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesIIFReq$Type extends MessageType<GetJournalEntriesIIFReq> {
    constructor() {
        super("rd.search.service.GetJournalEntriesIIFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "is_internal_transactions_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesIIFReq>): GetJournalEntriesIIFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isInternalTransactionsOnly = false;
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesIIFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesIIFReq): GetJournalEntriesIIFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* bool is_internal_transactions_only */ 2:
                    message.isInternalTransactionsOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesIIFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_internal_transactions_only = 2; */
        if (message.isInternalTransactionsOnly !== false)
            writer.tag(2, WireType.Varint).bool(message.isInternalTransactionsOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesIIFReq
 */
export const GetJournalEntriesIIFReq = new GetJournalEntriesIIFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJournalEntriesIIFRes$Type extends MessageType<GetJournalEntriesIIFRes> {
    constructor() {
        super("rd.search.service.GetJournalEntriesIIFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetJournalEntriesIIFRes>): GetJournalEntriesIIFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetJournalEntriesIIFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetJournalEntriesIIFRes): GetJournalEntriesIIFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetJournalEntriesIIFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetJournalEntriesIIFRes
 */
export const GetJournalEntriesIIFRes = new GetJournalEntriesIIFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPayoutsByTransactionDateCSVRes$Type extends MessageType<GetPayoutsByTransactionDateCSVRes> {
    constructor() {
        super("rd.search.service.GetPayoutsByTransactionDateCSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetPayoutsByTransactionDateCSVRes>): GetPayoutsByTransactionDateCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetPayoutsByTransactionDateCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPayoutsByTransactionDateCSVRes): GetPayoutsByTransactionDateCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPayoutsByTransactionDateCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetPayoutsByTransactionDateCSVRes
 */
export const GetPayoutsByTransactionDateCSVRes = new GetPayoutsByTransactionDateCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerReq$Type extends MessageType<GetGeneralLedgerReq> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.accounting.GeneralLedgerSortBy", GeneralLedgerSortBy, "GENERAL_LEDGER_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] },
            { no: 4, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.TransactionType", TransactionType, "TRANSACTION_TYPE_"] },
            { no: 5, name: "control_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerReq>): GetGeneralLedgerReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        message.transactionTypes = [];
        message.controlAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerReq): GetGeneralLedgerReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.accounting.GeneralLedgerSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.accounting.TransactionType transaction_types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                case /* repeated rd.coa.InternalAccount control_accounts */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.controlAccounts.push(reader.int32());
                    else
                        message.controlAccounts.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.GeneralLedgerSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.accounting.TransactionType transaction_types = 4; */
        if (message.transactionTypes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        /* repeated rd.coa.InternalAccount control_accounts = 5; */
        if (message.controlAccounts.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.controlAccounts.length; i++)
                writer.int32(message.controlAccounts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerReq
 */
export const GetGeneralLedgerReq = new GetGeneralLedgerReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerRes$Type extends MessageType<GetGeneralLedgerRes> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerRes", [
            { no: 1, name: "report", kind: "message", T: () => Report }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerRes>): GetGeneralLedgerRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerRes): GetGeneralLedgerRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analytics.Report report */ 1:
                    message.report = Report.internalBinaryRead(reader, reader.uint32(), options, message.report);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analytics.Report report = 1; */
        if (message.report)
            Report.internalBinaryWrite(message.report, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerRes
 */
export const GetGeneralLedgerRes = new GetGeneralLedgerRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerPDFReq$Type extends MessageType<GetGeneralLedgerPDFReq> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerPDFReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.accounting.GeneralLedgerSortBy", GeneralLedgerSortBy, "GENERAL_LEDGER_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] },
            { no: 4, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.TransactionType", TransactionType, "TRANSACTION_TYPE_"] },
            { no: 5, name: "control_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerPDFReq>): GetGeneralLedgerPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        message.transactionTypes = [];
        message.controlAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerPDFReq): GetGeneralLedgerPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.accounting.GeneralLedgerSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.accounting.TransactionType transaction_types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                case /* repeated rd.coa.InternalAccount control_accounts */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.controlAccounts.push(reader.int32());
                    else
                        message.controlAccounts.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.GeneralLedgerSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.accounting.TransactionType transaction_types = 4; */
        if (message.transactionTypes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        /* repeated rd.coa.InternalAccount control_accounts = 5; */
        if (message.controlAccounts.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.controlAccounts.length; i++)
                writer.int32(message.controlAccounts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerPDFReq
 */
export const GetGeneralLedgerPDFReq = new GetGeneralLedgerPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerPDFRes$Type extends MessageType<GetGeneralLedgerPDFRes> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerPDFRes>): GetGeneralLedgerPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerPDFRes): GetGeneralLedgerPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerPDFRes
 */
export const GetGeneralLedgerPDFRes = new GetGeneralLedgerPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerCSVReq$Type extends MessageType<GetGeneralLedgerCSVReq> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerCSVReq", [
            { no: 1, name: "filters", kind: "message", T: () => Filters, options: { "rd.validator.require": true } },
            { no: 2, name: "sort_by", kind: "enum", T: () => ["rd.accounting.GeneralLedgerSortBy", GeneralLedgerSortBy, "GENERAL_LEDGER_SORT_BY_"] },
            { no: 3, name: "sort_order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder$, "SORT_ORDER_"] },
            { no: 4, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.accounting.TransactionType", TransactionType, "TRANSACTION_TYPE_"] },
            { no: 5, name: "control_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerCSVReq>): GetGeneralLedgerCSVReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sortBy = 0;
        message.sortOrder = 0;
        message.transactionTypes = [];
        message.controlAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerCSVReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerCSVReq): GetGeneralLedgerCSVReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.Filters filters */ 1:
                    message.filters = Filters.internalBinaryRead(reader, reader.uint32(), options, message.filters);
                    break;
                case /* rd.accounting.GeneralLedgerSortBy sort_by */ 2:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.analyticsv2.SortOrder sort_order */ 3:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.accounting.TransactionType transaction_types */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                case /* repeated rd.coa.InternalAccount control_accounts */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.controlAccounts.push(reader.int32());
                    else
                        message.controlAccounts.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerCSVReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.Filters filters = 1; */
        if (message.filters)
            Filters.internalBinaryWrite(message.filters, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.GeneralLedgerSortBy sort_by = 2; */
        if (message.sortBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.sortBy);
        /* rd.analyticsv2.SortOrder sort_order = 3; */
        if (message.sortOrder !== 0)
            writer.tag(3, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.accounting.TransactionType transaction_types = 4; */
        if (message.transactionTypes.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        /* repeated rd.coa.InternalAccount control_accounts = 5; */
        if (message.controlAccounts.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.controlAccounts.length; i++)
                writer.int32(message.controlAccounts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerCSVReq
 */
export const GetGeneralLedgerCSVReq = new GetGeneralLedgerCSVReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGeneralLedgerCSVRes$Type extends MessageType<GetGeneralLedgerCSVRes> {
    constructor() {
        super("rd.search.service.GetGeneralLedgerCSVRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetGeneralLedgerCSVRes>): GetGeneralLedgerCSVRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetGeneralLedgerCSVRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGeneralLedgerCSVRes): GetGeneralLedgerCSVRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGeneralLedgerCSVRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.GetGeneralLedgerCSVRes
 */
export const GetGeneralLedgerCSVRes = new GetGeneralLedgerCSVRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTenderMethodsReq$Type extends MessageType<SearchTenderMethodsReq> {
    constructor() {
        super("rd.search.service.SearchTenderMethodsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "exclude_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] },
            { no: 6, name: "include_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchTenderMethodsReq>): SearchTenderMethodsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.excludeTypes = [];
        message.includeTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchTenderMethodsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTenderMethodsReq): SearchTenderMethodsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.company.tender.Method.Type exclude_types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.excludeTypes.push(reader.int32());
                    else
                        message.excludeTypes.push(reader.int32());
                    break;
                case /* repeated rd.company.tender.Method.Type include_types */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.includeTypes.push(reader.int32());
                    else
                        message.includeTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTenderMethodsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.company.tender.Method.Type exclude_types = 5; */
        if (message.excludeTypes.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.excludeTypes.length; i++)
                writer.int32(message.excludeTypes[i]);
            writer.join();
        }
        /* repeated rd.company.tender.Method.Type include_types = 6; */
        if (message.includeTypes.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.includeTypes.length; i++)
                writer.int32(message.includeTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTenderMethodsReq
 */
export const SearchTenderMethodsReq = new SearchTenderMethodsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTenderMethodsRes$Type extends MessageType<SearchTenderMethodsRes> {
    constructor() {
        super("rd.search.service.SearchTenderMethodsRes", [
            { no: 1, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchTenderMethodsRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchTenderMethodsRes>): SearchTenderMethodsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cursor = "";
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchTenderMethodsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTenderMethodsRes): SearchTenderMethodsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cursor */ 1:
                    message.cursor = reader.string();
                    break;
                case /* repeated rd.search.service.SearchTenderMethodsRes.Result results */ 2:
                    message.results.push(SearchTenderMethodsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTenderMethodsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cursor = 1; */
        if (message.cursor !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cursor);
        /* repeated rd.search.service.SearchTenderMethodsRes.Result results = 2; */
        for (let i = 0; i < message.results.length; i++)
            SearchTenderMethodsRes_Result.internalBinaryWrite(message.results[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTenderMethodsRes
 */
export const SearchTenderMethodsRes = new SearchTenderMethodsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTenderMethodsRes_Result$Type extends MessageType<SearchTenderMethodsRes_Result> {
    constructor() {
        super("rd.search.service.SearchTenderMethodsRes.Result", [
            { no: 1, name: "method", kind: "message", T: () => Method }
        ]);
    }
    create(value?: PartialMessage<SearchTenderMethodsRes_Result>): SearchTenderMethodsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchTenderMethodsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTenderMethodsRes_Result): SearchTenderMethodsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.tender.Method method */ 1:
                    message.method = Method.internalBinaryRead(reader, reader.uint32(), options, message.method);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTenderMethodsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.tender.Method method = 1; */
        if (message.method)
            Method.internalBinaryWrite(message.method, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchTenderMethodsRes.Result
 */
export const SearchTenderMethodsRes_Result = new SearchTenderMethodsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesHistoryReq$Type extends MessageType<SearchReceivablesHistoryReq> {
    constructor() {
        super("rd.search.service.SearchReceivablesHistoryReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Transaction.Type", Receivable_Transaction_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesHistoryReq>): SearchReceivablesHistoryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.purchaseOrderIds = [];
        message.transactionTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesHistoryReq): SearchReceivablesHistoryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 7:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Receivable.Transaction.Type transaction_types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 7; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Receivable.Transaction.Type transaction_types = 8; */
        if (message.transactionTypes.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesHistoryReq
 */
export const SearchReceivablesHistoryReq = new SearchReceivablesHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesHistoryRes$Type extends MessageType<SearchReceivablesHistoryRes> {
    constructor() {
        super("rd.search.service.SearchReceivablesHistoryRes", [
            { no: 1, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchReceivablesHistoryRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesHistoryRes>): SearchReceivablesHistoryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cursor = "";
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesHistoryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesHistoryRes): SearchReceivablesHistoryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cursor */ 1:
                    message.cursor = reader.string();
                    break;
                case /* repeated rd.search.service.SearchReceivablesHistoryRes.Result results */ 2:
                    message.results.push(SearchReceivablesHistoryRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesHistoryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cursor = 1; */
        if (message.cursor !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cursor);
        /* repeated rd.search.service.SearchReceivablesHistoryRes.Result results = 2; */
        for (let i = 0; i < message.results.length; i++)
            SearchReceivablesHistoryRes_Result.internalBinaryWrite(message.results[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesHistoryRes
 */
export const SearchReceivablesHistoryRes = new SearchReceivablesHistoryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesHistoryRes_Result$Type extends MessageType<SearchReceivablesHistoryRes_Result> {
    constructor() {
        super("rd.search.service.SearchReceivablesHistoryRes.Result", [
            { no: 14, name: "receivable", kind: "message", T: () => Receivable }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesHistoryRes_Result>): SearchReceivablesHistoryRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesHistoryRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesHistoryRes_Result): SearchReceivablesHistoryRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 14:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesHistoryRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 14; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesHistoryRes.Result
 */
export const SearchReceivablesHistoryRes_Result = new SearchReceivablesHistoryRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceChangesReq$Type extends MessageType<SearchPriceChangesReq> {
    constructor() {
        super("rd.search.service.SearchPriceChangesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchPriceChangesReq.OrderBy", SearchPriceChangesReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "additional_fee_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 12, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 15, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 17, name: "integration_vendors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 18, name: "is_promotional", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 19, name: "sale_codes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "order_id", kind: "message", T: () => UUID },
            { no: 21, name: "order_shipment_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchPriceChangesReq>): SearchPriceChangesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.vendorIds = [];
        message.additionalFeeIdStrings = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.tagIds = [];
        message.productIds = [];
        message.integrationVendors = [];
        message.isPromotional = 0;
        message.saleCodes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchPriceChangesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceChangesReq): SearchPriceChangesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchPriceChangesReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 7:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_id_strings */ 8:
                    message.additionalFeeIdStrings.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 11:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 12:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 13:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 14:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 15:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors */ 17:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.integrationVendors.push(reader.int32());
                    else
                        message.integrationVendors.push(reader.int32());
                    break;
                case /* rd.search.service.BoolFilter is_promotional */ 18:
                    message.isPromotional = reader.int32();
                    break;
                case /* repeated string sale_codes */ 19:
                    message.saleCodes.push(reader.string());
                    break;
                case /* rd.proto.uuid.UUID order_id */ 20:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 21:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceChangesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchPriceChangesReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.proto.uuid.UUID vendor_ids = 7; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_id_strings = 8; */
        for (let i = 0; i < message.additionalFeeIdStrings.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.additionalFeeIdStrings[i]);
        /* repeated rd.proto.uuid.UUID department_ids = 11; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 12; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 13; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 14; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID product_ids = 15; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 17; */
        if (message.integrationVendors.length) {
            writer.tag(17, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.integrationVendors.length; i++)
                writer.int32(message.integrationVendors[i]);
            writer.join();
        }
        /* rd.search.service.BoolFilter is_promotional = 18; */
        if (message.isPromotional !== 0)
            writer.tag(18, WireType.Varint).int32(message.isPromotional);
        /* repeated string sale_codes = 19; */
        for (let i = 0; i < message.saleCodes.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.saleCodes[i]);
        /* rd.proto.uuid.UUID order_id = 20; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 21; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceChangesReq
 */
export const SearchPriceChangesReq = new SearchPriceChangesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceChangesRes$Type extends MessageType<SearchPriceChangesRes> {
    constructor() {
        super("rd.search.service.SearchPriceChangesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchPriceChangesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchPriceChangesRes>): SearchPriceChangesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchPriceChangesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceChangesRes): SearchPriceChangesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchPriceChangesRes.Result results */ 1:
                    message.results.push(SearchPriceChangesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceChangesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchPriceChangesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchPriceChangesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceChangesRes
 */
export const SearchPriceChangesRes = new SearchPriceChangesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPriceChangesRes_Result$Type extends MessageType<SearchPriceChangesRes_Result> {
    constructor() {
        super("rd.search.service.SearchPriceChangesRes.Result", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "product", kind: "message", T: () => Product },
            { no: 3, name: "old_price", kind: "message", T: () => Money },
            { no: 4, name: "new_price", kind: "message", T: () => Money },
            { no: 5, name: "old_cost", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "new_cost", kind: "message", T: () => FractionalMoney },
            { no: 7, name: "vendor", kind: "message", T: () => Vendor },
            { no: 8, name: "effective_date", kind: "message", T: () => Timestamp },
            { no: 9, name: "standard_cost", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "price_change", kind: "message", T: () => PriceChange },
            { no: 11, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 12, name: "base_uom_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchPriceChangesRes_Result>): SearchPriceChangesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseUomLabel = "";
        if (value !== undefined)
            reflectionMergePartial<SearchPriceChangesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPriceChangesRes_Result): SearchPriceChangesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.product.Product product */ 2:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.proto.money.Money old_price */ 3:
                    message.oldPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.oldPrice);
                    break;
                case /* rd.proto.money.Money new_price */ 4:
                    message.newPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.newPrice);
                    break;
                case /* rd.proto.money.FractionalMoney old_cost */ 5:
                    message.oldCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.oldCost);
                    break;
                case /* rd.proto.money.FractionalMoney new_cost */ 6:
                    message.newCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.newCost);
                    break;
                case /* rd.vendors.Vendor vendor */ 7:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* google.protobuf.Timestamp effective_date */ 8:
                    message.effectiveDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.effectiveDate);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost */ 9:
                    message.standardCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCost);
                    break;
                case /* rd.integrations.PriceChange price_change */ 10:
                    message.priceChange = PriceChange.internalBinaryRead(reader, reader.uint32(), options, message.priceChange);
                    break;
                case /* rd.catalog.Product catalog_product */ 11:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* string base_uom_label */ 12:
                    message.baseUomLabel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPriceChangesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 2; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money old_price = 3; */
        if (message.oldPrice)
            Money.internalBinaryWrite(message.oldPrice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money new_price = 4; */
        if (message.newPrice)
            Money.internalBinaryWrite(message.newPrice, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney old_cost = 5; */
        if (message.oldCost)
            FractionalMoney.internalBinaryWrite(message.oldCost, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney new_cost = 6; */
        if (message.newCost)
            FractionalMoney.internalBinaryWrite(message.newCost, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 7; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp effective_date = 8; */
        if (message.effectiveDate)
            Timestamp.internalBinaryWrite(message.effectiveDate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost = 9; */
        if (message.standardCost)
            FractionalMoney.internalBinaryWrite(message.standardCost, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.PriceChange price_change = 10; */
        if (message.priceChange)
            PriceChange.internalBinaryWrite(message.priceChange, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product catalog_product = 11; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string base_uom_label = 12; */
        if (message.baseUomLabel !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.baseUomLabel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchPriceChangesRes.Result
 */
export const SearchPriceChangesRes_Result = new SearchPriceChangesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReceivablesHistoryReq$Type extends MessageType<PrintReceivablesHistoryReq> {
    constructor() {
        super("rd.search.service.PrintReceivablesHistoryReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "transaction_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Transaction.Type", Receivable_Transaction_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<PrintReceivablesHistoryReq>): PrintReceivablesHistoryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.purchaseOrderIds = [];
        message.transactionTypes = [];
        if (value !== undefined)
            reflectionMergePartial<PrintReceivablesHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReceivablesHistoryReq): PrintReceivablesHistoryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 7:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Receivable.Transaction.Type transaction_types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionTypes.push(reader.int32());
                    else
                        message.transactionTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReceivablesHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 7; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Receivable.Transaction.Type transaction_types = 8; */
        if (message.transactionTypes.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionTypes.length; i++)
                writer.int32(message.transactionTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PrintReceivablesHistoryReq
 */
export const PrintReceivablesHistoryReq = new PrintReceivablesHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReceivablesHistoryRes$Type extends MessageType<PrintReceivablesHistoryRes> {
    constructor() {
        super("rd.search.service.PrintReceivablesHistoryRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<PrintReceivablesHistoryRes>): PrintReceivablesHistoryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<PrintReceivablesHistoryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReceivablesHistoryRes): PrintReceivablesHistoryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReceivablesHistoryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PrintReceivablesHistoryRes
 */
export const PrintReceivablesHistoryRes = new PrintReceivablesHistoryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesAgingReq$Type extends MessageType<SearchReceivablesAgingReq> {
    constructor() {
        super("rd.search.service.SearchReceivablesAgingReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 4, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchReceivablesAgingReq.OrderBy", SearchReceivablesAgingReq_OrderBy] },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 8, name: "receivable_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Type", Receivable_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesAgingReq>): SearchReceivablesAgingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.jobIds = [];
        message.purchaseOrderIds = [];
        message.orderBy = 0;
        message.sortOrder = 0;
        message.receivableTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesAgingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesAgingReq): SearchReceivablesAgingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 4:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 5:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.SearchReceivablesAgingReq.OrderBy order_by */ 6:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.txn.Receivable.Type receivable_types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.receivableTypes.push(reader.int32());
                    else
                        message.receivableTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesAgingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 4; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 5; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchReceivablesAgingReq.OrderBy order_by = 6; */
        if (message.orderBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.txn.Receivable.Type receivable_types = 8; */
        if (message.receivableTypes.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.receivableTypes.length; i++)
                writer.int32(message.receivableTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesAgingReq
 */
export const SearchReceivablesAgingReq = new SearchReceivablesAgingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesAgingRes$Type extends MessageType<SearchReceivablesAgingRes> {
    constructor() {
        super("rd.search.service.SearchReceivablesAgingRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchReceivablesAgingRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesAgingRes>): SearchReceivablesAgingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesAgingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesAgingRes): SearchReceivablesAgingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchReceivablesAgingRes.Result results */ 1:
                    message.results.push(SearchReceivablesAgingRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesAgingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchReceivablesAgingRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchReceivablesAgingRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesAgingRes
 */
export const SearchReceivablesAgingRes = new SearchReceivablesAgingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReceivablesAgingRes_Result$Type extends MessageType<SearchReceivablesAgingRes_Result> {
    constructor() {
        super("rd.search.service.SearchReceivablesAgingRes.Result", [
            { no: 13, name: "receivable", kind: "message", T: () => Receivable },
            { no: 14, name: "statement_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchReceivablesAgingRes_Result>): SearchReceivablesAgingRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReceivablesAgingRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReceivablesAgingRes_Result): SearchReceivablesAgingRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 13:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                case /* rd.proto.money.Money statement_balance */ 14:
                    message.statementBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.statementBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReceivablesAgingRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 13; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money statement_balance = 14; */
        if (message.statementBalance)
            Money.internalBinaryWrite(message.statementBalance, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReceivablesAgingRes.Result
 */
export const SearchReceivablesAgingRes_Result = new SearchReceivablesAgingRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReceivablesAgingReq$Type extends MessageType<PrintReceivablesAgingReq> {
    constructor() {
        super("rd.search.service.PrintReceivablesAgingReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 4, name: "purchase_order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "job_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "receivable_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Type", Receivable_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<PrintReceivablesAgingReq>): PrintReceivablesAgingReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.purchaseOrderIds = [];
        message.jobIds = [];
        message.receivableTypes = [];
        if (value !== undefined)
            reflectionMergePartial<PrintReceivablesAgingReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReceivablesAgingReq): PrintReceivablesAgingReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* repeated rd.proto.uuid.UUID purchase_order_ids */ 4:
                    message.purchaseOrderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID job_ids */ 5:
                    message.jobIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.Receivable.Type receivable_types */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.receivableTypes.push(reader.int32());
                    else
                        message.receivableTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReceivablesAgingReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID purchase_order_ids = 4; */
        for (let i = 0; i < message.purchaseOrderIds.length; i++)
            UUID.internalBinaryWrite(message.purchaseOrderIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID job_ids = 5; */
        for (let i = 0; i < message.jobIds.length; i++)
            UUID.internalBinaryWrite(message.jobIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Receivable.Type receivable_types = 6; */
        if (message.receivableTypes.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.receivableTypes.length; i++)
                writer.int32(message.receivableTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PrintReceivablesAgingReq
 */
export const PrintReceivablesAgingReq = new PrintReceivablesAgingReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PrintReceivablesAgingRes$Type extends MessageType<PrintReceivablesAgingRes> {
    constructor() {
        super("rd.search.service.PrintReceivablesAgingRes", [
            { no: 1, name: "pdf_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<PrintReceivablesAgingRes>): PrintReceivablesAgingRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pdfBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<PrintReceivablesAgingRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PrintReceivablesAgingRes): PrintReceivablesAgingRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pdf_bytes */ 1:
                    message.pdfBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PrintReceivablesAgingRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pdf_bytes = 1; */
        if (message.pdfBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pdfBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PrintReceivablesAgingRes
 */
export const PrintReceivablesAgingRes = new PrintReceivablesAgingRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReallocationReceivablesReq$Type extends MessageType<SearchReallocationReceivablesReq> {
    constructor() {
        super("rd.search.service.SearchReallocationReceivablesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bill_payment_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "receivable_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.txn.Receivable.Type", Receivable_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SearchReallocationReceivablesReq>): SearchReallocationReceivablesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.receivableTypes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReallocationReceivablesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReallocationReceivablesReq): SearchReallocationReceivablesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 2:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                case /* repeated rd.txn.Receivable.Type receivable_types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.receivableTypes.push(reader.int32());
                    else
                        message.receivableTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReallocationReceivablesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.proto.uuid.UUID bill_payment_id = 2; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Receivable.Type receivable_types = 3; */
        if (message.receivableTypes.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.receivableTypes.length; i++)
                writer.int32(message.receivableTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReallocationReceivablesReq
 */
export const SearchReallocationReceivablesReq = new SearchReallocationReceivablesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReallocationReceivablesRes$Type extends MessageType<SearchReallocationReceivablesRes> {
    constructor() {
        super("rd.search.service.SearchReallocationReceivablesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchReallocationReceivablesRes_Result }
        ]);
    }
    create(value?: PartialMessage<SearchReallocationReceivablesRes>): SearchReallocationReceivablesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<SearchReallocationReceivablesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReallocationReceivablesRes): SearchReallocationReceivablesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchReallocationReceivablesRes.Result results */ 1:
                    message.results.push(SearchReallocationReceivablesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReallocationReceivablesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchReallocationReceivablesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchReallocationReceivablesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReallocationReceivablesRes
 */
export const SearchReallocationReceivablesRes = new SearchReallocationReceivablesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReallocationReceivablesRes_Result$Type extends MessageType<SearchReallocationReceivablesRes_Result> {
    constructor() {
        super("rd.search.service.SearchReallocationReceivablesRes.Result", [
            { no: 1, name: "receivable", kind: "message", T: () => Receivable },
            { no: 2, name: "original_allocation", kind: "message", T: () => SearchReallocationReceivablesRes_Result_OriginalAllocation },
            { no: 3, name: "adjusted_balance", kind: "message", T: () => SearchReallocationReceivablesRes_Result_AdjustedBalance }
        ]);
    }
    create(value?: PartialMessage<SearchReallocationReceivablesRes_Result>): SearchReallocationReceivablesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReallocationReceivablesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReallocationReceivablesRes_Result): SearchReallocationReceivablesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 1:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                case /* rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation original_allocation */ 2:
                    message.originalAllocation = SearchReallocationReceivablesRes_Result_OriginalAllocation.internalBinaryRead(reader, reader.uint32(), options, message.originalAllocation);
                    break;
                case /* rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance adjusted_balance */ 3:
                    message.adjustedBalance = SearchReallocationReceivablesRes_Result_AdjustedBalance.internalBinaryRead(reader, reader.uint32(), options, message.adjustedBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReallocationReceivablesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 1; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation original_allocation = 2; */
        if (message.originalAllocation)
            SearchReallocationReceivablesRes_Result_OriginalAllocation.internalBinaryWrite(message.originalAllocation, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance adjusted_balance = 3; */
        if (message.adjustedBalance)
            SearchReallocationReceivablesRes_Result_AdjustedBalance.internalBinaryWrite(message.adjustedBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReallocationReceivablesRes.Result
 */
export const SearchReallocationReceivablesRes_Result = new SearchReallocationReceivablesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReallocationReceivablesRes_Result_OriginalAllocation$Type extends MessageType<SearchReallocationReceivablesRes_Result_OriginalAllocation> {
    constructor() {
        super("rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation", [
            { no: 1, name: "allocation", kind: "message", T: () => Money },
            { no: 2, name: "discount", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SearchReallocationReceivablesRes_Result_OriginalAllocation>): SearchReallocationReceivablesRes_Result_OriginalAllocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReallocationReceivablesRes_Result_OriginalAllocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReallocationReceivablesRes_Result_OriginalAllocation): SearchReallocationReceivablesRes_Result_OriginalAllocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money allocation */ 1:
                    message.allocation = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocation);
                    break;
                case /* rd.proto.money.Money discount */ 2:
                    message.discount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReallocationReceivablesRes_Result_OriginalAllocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money allocation = 1; */
        if (message.allocation)
            Money.internalBinaryWrite(message.allocation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount = 2; */
        if (message.discount)
            Money.internalBinaryWrite(message.discount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReallocationReceivablesRes.Result.OriginalAllocation
 */
export const SearchReallocationReceivablesRes_Result_OriginalAllocation = new SearchReallocationReceivablesRes_Result_OriginalAllocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchReallocationReceivablesRes_Result_AdjustedBalance$Type extends MessageType<SearchReallocationReceivablesRes_Result_AdjustedBalance> {
    constructor() {
        super("rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance", [
            { no: 1, name: "balance", kind: "message", T: () => Money },
            { no: 2, name: "potential_discount", kind: "message", T: () => Money },
            { no: 3, name: "potential_discount_expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SearchReallocationReceivablesRes_Result_AdjustedBalance>): SearchReallocationReceivablesRes_Result_AdjustedBalance {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchReallocationReceivablesRes_Result_AdjustedBalance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchReallocationReceivablesRes_Result_AdjustedBalance): SearchReallocationReceivablesRes_Result_AdjustedBalance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money balance */ 1:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                case /* rd.proto.money.Money potential_discount */ 2:
                    message.potentialDiscount = Money.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscount);
                    break;
                case /* google.protobuf.Timestamp potential_discount_expires_at */ 3:
                    message.potentialDiscountExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscountExpiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchReallocationReceivablesRes_Result_AdjustedBalance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money balance = 1; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money potential_discount = 2; */
        if (message.potentialDiscount)
            Money.internalBinaryWrite(message.potentialDiscount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp potential_discount_expires_at = 3; */
        if (message.potentialDiscountExpiresAt)
            Timestamp.internalBinaryWrite(message.potentialDiscountExpiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchReallocationReceivablesRes.Result.AdjustedBalance
 */
export const SearchReallocationReceivablesRes_Result_AdjustedBalance = new SearchReallocationReceivablesRes_Result_AdjustedBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OmniSearchReq$Type extends MessageType<OmniSearchReq> {
    constructor() {
        super("rd.search.service.OmniSearchReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "include_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.OmniSearchRes.Result.Type", OmniSearchRes_Result_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<OmniSearchReq>): OmniSearchReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.includeTypes = [];
        if (value !== undefined)
            reflectionMergePartial<OmniSearchReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OmniSearchReq): OmniSearchReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.search.service.OmniSearchRes.Result.Type include_types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.includeTypes.push(reader.int32());
                    else
                        message.includeTypes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OmniSearchReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.search.service.OmniSearchRes.Result.Type include_types = 5; */
        if (message.includeTypes.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.includeTypes.length; i++)
                writer.int32(message.includeTypes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.OmniSearchReq
 */
export const OmniSearchReq = new OmniSearchReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OmniSearchRes$Type extends MessageType<OmniSearchRes> {
    constructor() {
        super("rd.search.service.OmniSearchRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OmniSearchRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OmniSearchRes>): OmniSearchRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<OmniSearchRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OmniSearchRes): OmniSearchRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.OmniSearchRes.Result results */ 1:
                    message.results.push(OmniSearchRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OmniSearchRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.OmniSearchRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            OmniSearchRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.OmniSearchRes
 */
export const OmniSearchRes = new OmniSearchRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OmniSearchRes_Result$Type extends MessageType<OmniSearchRes_Result> {
    constructor() {
        super("rd.search.service.OmniSearchRes.Result", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.search.service.OmniSearchRes.Result.Type", OmniSearchRes_Result_Type, "TYPE_"] },
            { no: 2, name: "customer", kind: "message", T: () => Customer },
            { no: 3, name: "product", kind: "message", T: () => Product },
            { no: 4, name: "sale", kind: "message", T: () => Sale },
            { no: 5, name: "vendor", kind: "message", T: () => Vendor },
            { no: 6, name: "order", kind: "message", T: () => Order },
            { no: 7, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 8, name: "transfer", kind: "message", T: () => Transfer },
            { no: 9, name: "bill_payment", kind: "message", T: () => BillPayment },
            { no: 10, name: "saved_report", kind: "message", T: () => SavedReport },
            { no: 11, name: "staff", kind: "message", T: () => Staff },
            { no: 12, name: "location", kind: "message", T: () => Location },
            { no: 13, name: "finance_charge", kind: "message", T: () => LedgerEntry },
            { no: 14, name: "close_out", kind: "message", T: () => CloseOut },
            { no: 15, name: "petty_cash", kind: "message", T: () => PettyCash },
            { no: 16, name: "inventory_count", kind: "message", T: () => InventoryCount },
            { no: 17, name: "delivery", kind: "message", T: () => Delivery }
        ]);
    }
    create(value?: PartialMessage<OmniSearchRes_Result>): OmniSearchRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<OmniSearchRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OmniSearchRes_Result): OmniSearchRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.search.service.OmniSearchRes.Result.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.customer.Customer customer */ 2:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.product.Product product */ 3:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.txn.Sale sale */ 4:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.vendors.Vendor vendor */ 5:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.txn.Order order */ 6:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* rd.txn.OrderShipment order_shipment */ 7:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.txn.Transfer transfer */ 8:
                    message.transfer = Transfer.internalBinaryRead(reader, reader.uint32(), options, message.transfer);
                    break;
                case /* rd.txn.BillPayment bill_payment */ 9:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                case /* rd.analyticsv2.reportbuilder.SavedReport saved_report */ 10:
                    message.savedReport = SavedReport.internalBinaryRead(reader, reader.uint32(), options, message.savedReport);
                    break;
                case /* rd.company.Staff staff */ 11:
                    message.staff = Staff.internalBinaryRead(reader, reader.uint32(), options, message.staff);
                    break;
                case /* rd.company.Location location */ 12:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.ledger.LedgerEntry finance_charge */ 13:
                    message.financeCharge = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.financeCharge);
                    break;
                case /* rd.txn.CloseOut close_out */ 14:
                    message.closeOut = CloseOut.internalBinaryRead(reader, reader.uint32(), options, message.closeOut);
                    break;
                case /* rd.txn.PettyCash petty_cash */ 15:
                    message.pettyCash = PettyCash.internalBinaryRead(reader, reader.uint32(), options, message.pettyCash);
                    break;
                case /* rd.product.InventoryCount inventory_count */ 16:
                    message.inventoryCount = InventoryCount.internalBinaryRead(reader, reader.uint32(), options, message.inventoryCount);
                    break;
                case /* rd.txn.Delivery delivery */ 17:
                    message.delivery = Delivery.internalBinaryRead(reader, reader.uint32(), options, message.delivery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OmniSearchRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.search.service.OmniSearchRes.Result.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.customer.Customer customer = 2; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 3; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale sale = 4; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 5; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Order order = 6; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.OrderShipment order_shipment = 7; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Transfer transfer = 8; */
        if (message.transfer)
            Transfer.internalBinaryWrite(message.transfer, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.BillPayment bill_payment = 9; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.SavedReport saved_report = 10; */
        if (message.savedReport)
            SavedReport.internalBinaryWrite(message.savedReport, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Staff staff = 11; */
        if (message.staff)
            Staff.internalBinaryWrite(message.staff, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 12; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry finance_charge = 13; */
        if (message.financeCharge)
            LedgerEntry.internalBinaryWrite(message.financeCharge, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CloseOut close_out = 14; */
        if (message.closeOut)
            CloseOut.internalBinaryWrite(message.closeOut, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.PettyCash petty_cash = 15; */
        if (message.pettyCash)
            PettyCash.internalBinaryWrite(message.pettyCash, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.InventoryCount inventory_count = 16; */
        if (message.inventoryCount)
            InventoryCount.internalBinaryWrite(message.inventoryCount, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Delivery delivery = 17; */
        if (message.delivery)
            Delivery.internalBinaryWrite(message.delivery, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.OmniSearchRes.Result
 */
export const OmniSearchRes_Result = new OmniSearchRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogSKUsReq$Type extends MessageType<SearchCatalogSKUsReq> {
    constructor() {
        super("rd.search.service.SearchCatalogSKUsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "order_by", kind: "enum", T: () => ["rd.search.service.OrderCatalogSKUsBy", OrderCatalogSKUsBy] },
            { no: 7, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 8, name: "integration_vendors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 9, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "current_location_id", kind: "message", T: () => UUID },
            { no: 11, name: "discontinued_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 13, name: "origins", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.catalog.SKU.Origin", SKU_Origin, "ORIGIN_"] },
            { no: 14, name: "identifiers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogSKUsReq>): SearchCatalogSKUsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.integrationVendors = [];
        message.locationIds = [];
        message.discontinuedFilter = 0;
        message.origins = [];
        message.identifiers = [];
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogSKUsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogSKUsReq): SearchCatalogSKUsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.OrderCatalogSKUsBy order_by */ 6:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.integrationVendors.push(reader.int32());
                    else
                        message.integrationVendors.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 9:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID current_location_id */ 10:
                    message.currentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentLocationId);
                    break;
                case /* rd.search.service.BoolFilter discontinued_filter */ 11:
                    message.discontinuedFilter = reader.int32();
                    break;
                case /* repeated rd.catalog.SKU.Origin origins */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.origins.push(reader.int32());
                    else
                        message.origins.push(reader.int32());
                    break;
                case /* repeated string identifiers */ 14:
                    message.identifiers.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogSKUsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.OrderCatalogSKUsBy order_by = 6; */
        if (message.orderBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 8; */
        if (message.integrationVendors.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.integrationVendors.length; i++)
                writer.int32(message.integrationVendors[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID location_ids = 9; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID current_location_id = 10; */
        if (message.currentLocationId)
            UUID.internalBinaryWrite(message.currentLocationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter discontinued_filter = 11; */
        if (message.discontinuedFilter !== 0)
            writer.tag(11, WireType.Varint).int32(message.discontinuedFilter);
        /* repeated rd.catalog.SKU.Origin origins = 13; */
        if (message.origins.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.origins.length; i++)
                writer.int32(message.origins[i]);
            writer.join();
        }
        /* repeated string identifiers = 14; */
        for (let i = 0; i < message.identifiers.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.identifiers[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogSKUsReq
 */
export const SearchCatalogSKUsReq = new SearchCatalogSKUsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogSKUsRes$Type extends MessageType<SearchCatalogSKUsRes> {
    constructor() {
        super("rd.search.service.SearchCatalogSKUsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCatalogSKUsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogSKUsRes>): SearchCatalogSKUsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogSKUsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogSKUsRes): SearchCatalogSKUsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCatalogSKUsRes.Result results */ 1:
                    message.results.push(SearchCatalogSKUsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogSKUsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCatalogSKUsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCatalogSKUsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogSKUsRes
 */
export const SearchCatalogSKUsRes = new SearchCatalogSKUsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogSKUsRes_Result$Type extends MessageType<SearchCatalogSKUsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCatalogSKUsRes.Result", [
            { no: 1, name: "sku", kind: "message", T: () => SKU },
            { no: 2, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 3, name: "linked_product_id", kind: "message", T: () => UUID },
            { no: 4, name: "computed_info", kind: "message", T: () => ComputedSKUInfo },
            { no: 5, name: "vendor", kind: "message", T: () => Vendor },
            { no: 6, name: "linked_product_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogSKUsRes_Result>): SearchCatalogSKUsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.linkedProductIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogSKUsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogSKUsRes_Result): SearchCatalogSKUsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.catalog.SKU sku */ 1:
                    message.sku = SKU.internalBinaryRead(reader, reader.uint32(), options, message.sku);
                    break;
                case /* rd.catalog.Product catalog_product */ 2:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* rd.proto.uuid.UUID linked_product_id */ 3:
                    message.linkedProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.linkedProductId);
                    break;
                case /* rd.catalog.ComputedSKUInfo computed_info */ 4:
                    message.computedInfo = ComputedSKUInfo.internalBinaryRead(reader, reader.uint32(), options, message.computedInfo);
                    break;
                case /* rd.vendors.Vendor vendor */ 5:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* string linked_product_identifier */ 6:
                    message.linkedProductIdentifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogSKUsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.catalog.SKU sku = 1; */
        if (message.sku)
            SKU.internalBinaryWrite(message.sku, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.Product catalog_product = 2; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID linked_product_id = 3; */
        if (message.linkedProductId)
            UUID.internalBinaryWrite(message.linkedProductId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.catalog.ComputedSKUInfo computed_info = 4; */
        if (message.computedInfo)
            ComputedSKUInfo.internalBinaryWrite(message.computedInfo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 5; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string linked_product_identifier = 6; */
        if (message.linkedProductIdentifier !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.linkedProductIdentifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogSKUsRes.Result
 */
export const SearchCatalogSKUsRes_Result = new SearchCatalogSKUsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogProductsReq$Type extends MessageType<SearchCatalogProductsReq> {
    constructor() {
        super("rd.search.service.SearchCatalogProductsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogProductsReq>): SearchCatalogProductsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.upc = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogProductsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogProductsReq): SearchCatalogProductsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* string upc */ 5:
                    message.upc = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogProductsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* string upc = 5; */
        if (message.upc !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.upc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogProductsReq
 */
export const SearchCatalogProductsReq = new SearchCatalogProductsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogProductsRes$Type extends MessageType<SearchCatalogProductsRes> {
    constructor() {
        super("rd.search.service.SearchCatalogProductsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchCatalogProductsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogProductsRes>): SearchCatalogProductsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogProductsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogProductsRes): SearchCatalogProductsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchCatalogProductsRes.Result results */ 1:
                    message.results.push(SearchCatalogProductsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogProductsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchCatalogProductsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchCatalogProductsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogProductsRes
 */
export const SearchCatalogProductsRes = new SearchCatalogProductsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCatalogProductsRes_Result$Type extends MessageType<SearchCatalogProductsRes_Result> {
    constructor() {
        super("rd.search.service.SearchCatalogProductsRes.Result", [
            { no: 1, name: "catalog_product", kind: "message", T: () => Product$ },
            { no: 2, name: "linked_product_id", kind: "message", T: () => UUID },
            { no: 3, name: "linked_product_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCatalogProductsRes_Result>): SearchCatalogProductsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.linkedProductIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCatalogProductsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCatalogProductsRes_Result): SearchCatalogProductsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.catalog.Product catalog_product */ 1:
                    message.catalogProduct = Product$.internalBinaryRead(reader, reader.uint32(), options, message.catalogProduct);
                    break;
                case /* rd.proto.uuid.UUID linked_product_id */ 2:
                    message.linkedProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.linkedProductId);
                    break;
                case /* string linked_product_identifier */ 3:
                    message.linkedProductIdentifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCatalogProductsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.catalog.Product catalog_product = 1; */
        if (message.catalogProduct)
            Product$.internalBinaryWrite(message.catalogProduct, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID linked_product_id = 2; */
        if (message.linkedProductId)
            UUID.internalBinaryWrite(message.linkedProductId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string linked_product_identifier = 3; */
        if (message.linkedProductIdentifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.linkedProductIdentifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchCatalogProductsRes.Result
 */
export const SearchCatalogProductsRes_Result = new SearchCatalogProductsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatThreadsReq$Type extends MessageType<SearchChatThreadsReq> {
    constructor() {
        super("rd.search.service.SearchChatThreadsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchChatThreadsReq.OrderBy", SearchChatThreadsReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "attached_to_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "customer_tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "is_read_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 12, name: "is_unknown_contact_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 13, name: "last_activity_at_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<SearchChatThreadsReq>): SearchChatThreadsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.locationIds = [];
        message.customerIds = [];
        message.attachedToIds = [];
        message.customerTagIds = [];
        message.isReadFilter = 0;
        message.isUnknownContactFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchChatThreadsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatThreadsReq): SearchChatThreadsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchChatThreadsReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 7:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 8:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string attached_to_ids */ 9:
                    message.attachedToIds.push(reader.string());
                    break;
                case /* repeated rd.proto.uuid.UUID customer_tag_ids */ 10:
                    message.customerTagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_read_filter */ 11:
                    message.isReadFilter = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_unknown_contact_filter */ 12:
                    message.isUnknownContactFilter = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange last_activity_at_range */ 13:
                    message.lastActivityAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.lastActivityAtRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchChatThreadsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchChatThreadsReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.proto.uuid.UUID location_ids = 7; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 8; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string attached_to_ids = 9; */
        for (let i = 0; i < message.attachedToIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.attachedToIds[i]);
        /* repeated rd.proto.uuid.UUID customer_tag_ids = 10; */
        for (let i = 0; i < message.customerTagIds.length; i++)
            UUID.internalBinaryWrite(message.customerTagIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_read_filter = 11; */
        if (message.isReadFilter !== 0)
            writer.tag(11, WireType.Varint).int32(message.isReadFilter);
        /* rd.search.service.BoolFilter is_unknown_contact_filter = 12; */
        if (message.isUnknownContactFilter !== 0)
            writer.tag(12, WireType.Varint).int32(message.isUnknownContactFilter);
        /* rd.proto.timestamprange.TimestampRange last_activity_at_range = 13; */
        if (message.lastActivityAtRange)
            TimestampRange.internalBinaryWrite(message.lastActivityAtRange, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatThreadsReq
 */
export const SearchChatThreadsReq = new SearchChatThreadsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatThreadsRes$Type extends MessageType<SearchChatThreadsRes> {
    constructor() {
        super("rd.search.service.SearchChatThreadsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchChatThreadsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchChatThreadsRes>): SearchChatThreadsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchChatThreadsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatThreadsRes): SearchChatThreadsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchChatThreadsRes.Result results */ 1:
                    message.results.push(SearchChatThreadsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchChatThreadsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchChatThreadsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchChatThreadsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatThreadsRes
 */
export const SearchChatThreadsRes = new SearchChatThreadsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatThreadsRes_Result$Type extends MessageType<SearchChatThreadsRes_Result> {
    constructor() {
        super("rd.search.service.SearchChatThreadsRes.Result", [
            { no: 1, name: "thread", kind: "message", T: () => Thread },
            { no: 2, name: "latest_message", kind: "message", T: () => Message },
            { no: 3, name: "customer_contact", kind: "message", T: () => Contacts_Contact }
        ]);
    }
    create(value?: PartialMessage<SearchChatThreadsRes_Result>): SearchChatThreadsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchChatThreadsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatThreadsRes_Result): SearchChatThreadsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.chat.Thread thread */ 1:
                    message.thread = Thread.internalBinaryRead(reader, reader.uint32(), options, message.thread);
                    break;
                case /* rd.chat.Message latest_message */ 2:
                    message.latestMessage = Message.internalBinaryRead(reader, reader.uint32(), options, message.latestMessage);
                    break;
                case /* rd.customer.Contacts.Contact customer_contact */ 3:
                    message.customerContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.customerContact);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchChatThreadsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.chat.Thread thread = 1; */
        if (message.thread)
            Thread.internalBinaryWrite(message.thread, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.chat.Message latest_message = 2; */
        if (message.latestMessage)
            Message.internalBinaryWrite(message.latestMessage, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact customer_contact = 3; */
        if (message.customerContact)
            Contacts_Contact.internalBinaryWrite(message.customerContact, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatThreadsRes.Result
 */
export const SearchChatThreadsRes_Result = new SearchChatThreadsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatMessagesReq$Type extends MessageType<SearchChatMessagesReq> {
    constructor() {
        super("rd.search.service.SearchChatMessagesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchChatMessagesReq.OrderBy", SearchChatMessagesReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "thread_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchChatMessagesReq>): SearchChatMessagesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.threadIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchChatMessagesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatMessagesReq): SearchChatMessagesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchChatMessagesReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID thread_ids */ 7:
                    message.threadIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchChatMessagesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchChatMessagesReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.proto.uuid.UUID thread_ids = 7; */
        for (let i = 0; i < message.threadIds.length; i++)
            UUID.internalBinaryWrite(message.threadIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatMessagesReq
 */
export const SearchChatMessagesReq = new SearchChatMessagesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatMessagesRes$Type extends MessageType<SearchChatMessagesRes> {
    constructor() {
        super("rd.search.service.SearchChatMessagesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchChatMessagesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "threads_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Thread } },
            { no: 4, name: "customer_contacts_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Contacts_Contact } }
        ]);
    }
    create(value?: PartialMessage<SearchChatMessagesRes>): SearchChatMessagesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        message.threadsById = {};
        message.customerContactsById = {};
        if (value !== undefined)
            reflectionMergePartial<SearchChatMessagesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatMessagesRes): SearchChatMessagesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchChatMessagesRes.Result results */ 1:
                    message.results.push(SearchChatMessagesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* map<string, rd.chat.Thread> threads_by_id */ 3:
                    this.binaryReadMap3(message.threadsById, reader, options);
                    break;
                case /* map<string, rd.customer.Contacts.Contact> customer_contacts_by_id */ 4:
                    this.binaryReadMap4(message.customerContactsById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SearchChatMessagesRes["threadsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchChatMessagesRes["threadsById"] | undefined, val: SearchChatMessagesRes["threadsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Thread.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchChatMessagesRes.threads_by_id");
            }
        }
        map[key ?? ""] = val ?? Thread.create();
    }
    private binaryReadMap4(map: SearchChatMessagesRes["customerContactsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SearchChatMessagesRes["customerContactsById"] | undefined, val: SearchChatMessagesRes["customerContactsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.search.service.SearchChatMessagesRes.customer_contacts_by_id");
            }
        }
        map[key ?? ""] = val ?? Contacts_Contact.create();
    }
    internalBinaryWrite(message: SearchChatMessagesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchChatMessagesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchChatMessagesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* map<string, rd.chat.Thread> threads_by_id = 3; */
        for (let k of globalThis.Object.keys(message.threadsById)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Thread.internalBinaryWrite(message.threadsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.customer.Contacts.Contact> customer_contacts_by_id = 4; */
        for (let k of globalThis.Object.keys(message.customerContactsById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Contacts_Contact.internalBinaryWrite(message.customerContactsById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatMessagesRes
 */
export const SearchChatMessagesRes = new SearchChatMessagesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchChatMessagesRes_Result$Type extends MessageType<SearchChatMessagesRes_Result> {
    constructor() {
        super("rd.search.service.SearchChatMessagesRes.Result", [
            { no: 1, name: "message", kind: "message", T: () => Message }
        ]);
    }
    create(value?: PartialMessage<SearchChatMessagesRes_Result>): SearchChatMessagesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchChatMessagesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchChatMessagesRes_Result): SearchChatMessagesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.chat.Message message */ 1:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchChatMessagesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.chat.Message message = 1; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchChatMessagesRes.Result
 */
export const SearchChatMessagesRes_Result = new SearchChatMessagesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRoutinesReq$Type extends MessageType<SearchRoutinesReq> {
    constructor() {
        super("rd.search.service.SearchRoutinesReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchRoutinesReq.OrderBy", SearchRoutinesReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 8, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.llm.Routine.Type", Routine_Type, "TYPE_"] },
            { no: 9, name: "scheduled_run_time_range", kind: "message", T: () => TimestampRange },
            { no: 10, name: "last_run_at_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<SearchRoutinesReq>): SearchRoutinesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.isActiveFilter = 0;
        message.types = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRoutinesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRoutinesReq): SearchRoutinesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchRoutinesReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 7:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* repeated rd.llm.Routine.Type types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* rd.proto.timestamprange.TimestampRange scheduled_run_time_range */ 9:
                    message.scheduledRunTimeRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.scheduledRunTimeRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange last_run_at_range */ 10:
                    message.lastRunAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.lastRunAtRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRoutinesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchRoutinesReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* rd.search.service.BoolFilter is_active_filter = 7; */
        if (message.isActiveFilter !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActiveFilter);
        /* repeated rd.llm.Routine.Type types = 8; */
        if (message.types.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* rd.proto.timestamprange.TimestampRange scheduled_run_time_range = 9; */
        if (message.scheduledRunTimeRange)
            TimestampRange.internalBinaryWrite(message.scheduledRunTimeRange, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange last_run_at_range = 10; */
        if (message.lastRunAtRange)
            TimestampRange.internalBinaryWrite(message.lastRunAtRange, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRoutinesReq
 */
export const SearchRoutinesReq = new SearchRoutinesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRoutinesRes$Type extends MessageType<SearchRoutinesRes> {
    constructor() {
        super("rd.search.service.SearchRoutinesRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchRoutinesRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRoutinesRes>): SearchRoutinesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRoutinesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRoutinesRes): SearchRoutinesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchRoutinesRes.Result results */ 1:
                    message.results.push(SearchRoutinesRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRoutinesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchRoutinesRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchRoutinesRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRoutinesRes
 */
export const SearchRoutinesRes = new SearchRoutinesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRoutinesRes_Result$Type extends MessageType<SearchRoutinesRes_Result> {
    constructor() {
        super("rd.search.service.SearchRoutinesRes.Result", [
            { no: 1, name: "routine", kind: "message", T: () => Routine }
        ]);
    }
    create(value?: PartialMessage<SearchRoutinesRes_Result>): SearchRoutinesRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchRoutinesRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRoutinesRes_Result): SearchRoutinesRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.llm.Routine routine */ 1:
                    message.routine = Routine.internalBinaryRead(reader, reader.uint32(), options, message.routine);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRoutinesRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.llm.Routine routine = 1; */
        if (message.routine)
            Routine.internalBinaryWrite(message.routine, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchRoutinesRes.Result
 */
export const SearchRoutinesRes_Result = new SearchRoutinesRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchConversationsReq$Type extends MessageType<SearchConversationsReq> {
    constructor() {
        super("rd.search.service.SearchConversationsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "order_by", kind: "enum", T: () => ["rd.search.service.SearchConversationsReq.OrderBy", SearchConversationsReq_OrderBy, "ORDER_BY_"] },
            { no: 6, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 7, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.llm.Conversation.Type", Conversation_Type, "TYPE_"] },
            { no: 8, name: "routine_id", kind: "message", T: () => UUID },
            { no: 9, name: "user_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "is_read_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchConversationsReq>): SearchConversationsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.orderBy = 0;
        message.sortOrder = 0;
        message.types = [];
        message.userIds = [];
        message.isReadFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchConversationsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchConversationsReq): SearchConversationsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* rd.search.service.SearchConversationsReq.OrderBy order_by */ 5:
                    message.orderBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.llm.Conversation.Type types */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* rd.proto.uuid.UUID routine_id */ 8:
                    message.routineId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.routineId);
                    break;
                case /* repeated rd.proto.uuid.UUID user_ids */ 9:
                    message.userIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.search.service.BoolFilter is_read_filter */ 10:
                    message.isReadFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchConversationsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* rd.search.service.SearchConversationsReq.OrderBy order_by = 5; */
        if (message.orderBy !== 0)
            writer.tag(5, WireType.Varint).int32(message.orderBy);
        /* rd.search.service.SortOrder sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.llm.Conversation.Type types = 7; */
        if (message.types.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* rd.proto.uuid.UUID routine_id = 8; */
        if (message.routineId)
            UUID.internalBinaryWrite(message.routineId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID user_ids = 9; */
        for (let i = 0; i < message.userIds.length; i++)
            UUID.internalBinaryWrite(message.userIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.search.service.BoolFilter is_read_filter = 10; */
        if (message.isReadFilter !== 0)
            writer.tag(10, WireType.Varint).int32(message.isReadFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchConversationsReq
 */
export const SearchConversationsReq = new SearchConversationsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchConversationsRes$Type extends MessageType<SearchConversationsRes> {
    constructor() {
        super("rd.search.service.SearchConversationsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchConversationsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchConversationsRes>): SearchConversationsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchConversationsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchConversationsRes): SearchConversationsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchConversationsRes.Result results */ 1:
                    message.results.push(SearchConversationsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchConversationsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchConversationsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchConversationsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchConversationsRes
 */
export const SearchConversationsRes = new SearchConversationsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchConversationsRes_Result$Type extends MessageType<SearchConversationsRes_Result> {
    constructor() {
        super("rd.search.service.SearchConversationsRes.Result", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_message_preview", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "staff_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "enum", T: () => ["rd.llm.Conversation.Status", Conversation_Status, "STATUS_"] },
            { no: 8, name: "last_human_message_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SearchConversationsRes_Result>): SearchConversationsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.lastMessagePreview = "";
        message.staffName = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchConversationsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchConversationsRes_Result): SearchConversationsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string last_message_preview */ 4:
                    message.lastMessagePreview = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string staff_name */ 6:
                    message.staffName = reader.string();
                    break;
                case /* rd.llm.Conversation.Status status */ 7:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp last_human_message_at */ 8:
                    message.lastHumanMessageAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastHumanMessageAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchConversationsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string last_message_preview = 4; */
        if (message.lastMessagePreview !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastMessagePreview);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string staff_name = 6; */
        if (message.staffName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.staffName);
        /* rd.llm.Conversation.Status status = 7; */
        if (message.status !== 0)
            writer.tag(7, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp last_human_message_at = 8; */
        if (message.lastHumanMessageAt)
            Timestamp.internalBinaryWrite(message.lastHumanMessageAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchConversationsRes.Result
 */
export const SearchConversationsRes_Result = new SearchConversationsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PollForNewChatMessagesReq$Type extends MessageType<PollForNewChatMessagesReq> {
    constructor() {
        super("rd.search.service.PollForNewChatMessagesReq", [
            { no: 1, name: "thread_id", kind: "message", T: () => UUID },
            { no: 2, name: "latest_message_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<PollForNewChatMessagesReq>): PollForNewChatMessagesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PollForNewChatMessagesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PollForNewChatMessagesReq): PollForNewChatMessagesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID thread_id */ 1:
                    message.threadId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.threadId);
                    break;
                case /* rd.proto.uuid.UUID latest_message_id */ 2:
                    message.latestMessageId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.latestMessageId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PollForNewChatMessagesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID thread_id = 1; */
        if (message.threadId)
            UUID.internalBinaryWrite(message.threadId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID latest_message_id = 2; */
        if (message.latestMessageId)
            UUID.internalBinaryWrite(message.latestMessageId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PollForNewChatMessagesReq
 */
export const PollForNewChatMessagesReq = new PollForNewChatMessagesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PollForNewChatMessagesRes$Type extends MessageType<PollForNewChatMessagesRes> {
    constructor() {
        super("rd.search.service.PollForNewChatMessagesRes", [
            { no: 1, name: "has_new_messages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PollForNewChatMessagesRes>): PollForNewChatMessagesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasNewMessages = false;
        if (value !== undefined)
            reflectionMergePartial<PollForNewChatMessagesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PollForNewChatMessagesRes): PollForNewChatMessagesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_new_messages */ 1:
                    message.hasNewMessages = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PollForNewChatMessagesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_new_messages = 1; */
        if (message.hasNewMessages !== false)
            writer.tag(1, WireType.Varint).bool(message.hasNewMessages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PollForNewChatMessagesRes
 */
export const PollForNewChatMessagesRes = new PollForNewChatMessagesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PollForUnreadChatThreadsReq$Type extends MessageType<PollForUnreadChatThreadsReq> {
    constructor() {
        super("rd.search.service.PollForUnreadChatThreadsReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<PollForUnreadChatThreadsReq>): PollForUnreadChatThreadsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PollForUnreadChatThreadsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PollForUnreadChatThreadsReq): PollForUnreadChatThreadsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PollForUnreadChatThreadsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PollForUnreadChatThreadsReq
 */
export const PollForUnreadChatThreadsReq = new PollForUnreadChatThreadsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PollForUnreadChatThreadsRes$Type extends MessageType<PollForUnreadChatThreadsRes> {
    constructor() {
        super("rd.search.service.PollForUnreadChatThreadsRes", [
            { no: 1, name: "num_unread_threads", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PollForUnreadChatThreadsRes>): PollForUnreadChatThreadsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numUnreadThreads = 0;
        if (value !== undefined)
            reflectionMergePartial<PollForUnreadChatThreadsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PollForUnreadChatThreadsRes): PollForUnreadChatThreadsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 num_unread_threads */ 1:
                    message.numUnreadThreads = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PollForUnreadChatThreadsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 num_unread_threads = 1; */
        if (message.numUnreadThreads !== 0)
            writer.tag(1, WireType.Varint).int32(message.numUnreadThreads);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.PollForUnreadChatThreadsRes
 */
export const PollForUnreadChatThreadsRes = new PollForUnreadChatThreadsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGiftCardsReq$Type extends MessageType<SearchGiftCardsReq> {
    constructor() {
        super("rd.search.service.SearchGiftCardsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "activated_at_range", kind: "message", T: () => TimestampRange },
            { no: 7, name: "deactivated_at_range", kind: "message", T: () => TimestampRange },
            { no: 8, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.giftcard.GiftCard.Status", GiftCard_Status, "STATUS_"] },
            { no: 9, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SearchGiftCardsReq.GiftCardSortBy", SearchGiftCardsReq_GiftCardSortBy, "GIFT_CARD_SORT_BY_"] },
            { no: 10, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<SearchGiftCardsReq>): SearchGiftCardsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.productIds = [];
        message.statuses = [];
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchGiftCardsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGiftCardsReq): SearchGiftCardsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID product_ids */ 5:
                    message.productIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange activated_at_range */ 6:
                    message.activatedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.activatedAtRange);
                    break;
                case /* rd.proto.timestamprange.TimestampRange deactivated_at_range */ 7:
                    message.deactivatedAtRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.deactivatedAtRange);
                    break;
                case /* repeated rd.giftcard.GiftCard.Status statuses */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* rd.search.service.SearchGiftCardsReq.GiftCardSortBy sort_by */ 9:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 10:
                    message.sortOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGiftCardsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID product_ids = 5; */
        for (let i = 0; i < message.productIds.length; i++)
            UUID.internalBinaryWrite(message.productIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange activated_at_range = 6; */
        if (message.activatedAtRange)
            TimestampRange.internalBinaryWrite(message.activatedAtRange, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange deactivated_at_range = 7; */
        if (message.deactivatedAtRange)
            TimestampRange.internalBinaryWrite(message.deactivatedAtRange, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.giftcard.GiftCard.Status statuses = 8; */
        if (message.statuses.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* rd.search.service.SearchGiftCardsReq.GiftCardSortBy sort_by = 9; */
        if (message.sortBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 10; */
        if (message.sortOrder !== 0)
            writer.tag(10, WireType.Varint).int32(message.sortOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchGiftCardsReq
 */
export const SearchGiftCardsReq = new SearchGiftCardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGiftCardsRes$Type extends MessageType<SearchGiftCardsRes> {
    constructor() {
        super("rd.search.service.SearchGiftCardsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchGiftCardsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchGiftCardsRes>): SearchGiftCardsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchGiftCardsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGiftCardsRes): SearchGiftCardsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchGiftCardsRes.Result results */ 1:
                    message.results.push(SearchGiftCardsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGiftCardsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchGiftCardsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchGiftCardsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchGiftCardsRes
 */
export const SearchGiftCardsRes = new SearchGiftCardsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGiftCardsRes_Result$Type extends MessageType<SearchGiftCardsRes_Result> {
    constructor() {
        super("rd.search.service.SearchGiftCardsRes.Result", [
            { no: 1, name: "gift_card", kind: "message", T: () => GiftCard },
            { no: 2, name: "gift_card_balance", kind: "message", T: () => GiftCardBalance },
            { no: 3, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<SearchGiftCardsRes_Result>): SearchGiftCardsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchGiftCardsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGiftCardsRes_Result): SearchGiftCardsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.giftcard.GiftCard gift_card */ 1:
                    message.giftCard = GiftCard.internalBinaryRead(reader, reader.uint32(), options, message.giftCard);
                    break;
                case /* rd.giftcard.GiftCardBalance gift_card_balance */ 2:
                    message.giftCardBalance = GiftCardBalance.internalBinaryRead(reader, reader.uint32(), options, message.giftCardBalance);
                    break;
                case /* rd.product.Product product */ 3:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGiftCardsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.giftcard.GiftCard gift_card = 1; */
        if (message.giftCard)
            GiftCard.internalBinaryWrite(message.giftCard, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCardBalance gift_card_balance = 2; */
        if (message.giftCardBalance)
            GiftCardBalance.internalBinaryWrite(message.giftCardBalance, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 3; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchGiftCardsRes.Result
 */
export const SearchGiftCardsRes_Result = new SearchGiftCardsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSpiffsReq$Type extends MessageType<SearchSpiffsReq> {
    constructor() {
        super("rd.search.service.SearchSpiffsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 8, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 9, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.SpiffValidityFilter", SpiffValidityFilter, "SPIFF_VALIDITY_FILTER_"] },
            { no: 11, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SpiffSortBy", SpiffSortBy, "SPIFF_SORT_BY_"] },
            { no: 12, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 13, name: "current_pricing_region_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<SearchSpiffsReq>): SearchSpiffsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.cursor = "";
        message.offset = 0;
        message.limit = 0;
        message.locationIds = [];
        message.vendorIds = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.statuses = [];
        message.sortBy = 0;
        message.sortOrder = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchSpiffsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSpiffsReq): SearchSpiffsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                case /* int32 offset */ 3:
                    message.offset = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 5:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 6:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 7:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 8:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 9:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.search.service.SpiffValidityFilter statuses */ 10:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* rd.search.service.SpiffSortBy sort_by */ 11:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 12:
                    message.sortOrder = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID current_pricing_region_id */ 13:
                    message.currentPricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.currentPricingRegionId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSpiffsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        /* int32 offset = 3; */
        if (message.offset !== 0)
            writer.tag(3, WireType.Varint).int32(message.offset);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* repeated rd.proto.uuid.UUID location_ids = 5; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 6; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 7; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 8; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 9; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SpiffValidityFilter statuses = 10; */
        if (message.statuses.length) {
            writer.tag(10, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* rd.search.service.SpiffSortBy sort_by = 11; */
        if (message.sortBy !== 0)
            writer.tag(11, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 12; */
        if (message.sortOrder !== 0)
            writer.tag(12, WireType.Varint).int32(message.sortOrder);
        /* rd.proto.uuid.UUID current_pricing_region_id = 13; */
        if (message.currentPricingRegionId)
            UUID.internalBinaryWrite(message.currentPricingRegionId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSpiffsReq
 */
export const SearchSpiffsReq = new SearchSpiffsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSpiffsRes$Type extends MessageType<SearchSpiffsRes> {
    constructor() {
        super("rd.search.service.SearchSpiffsRes", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SearchSpiffsRes_Result },
            { no: 2, name: "cursor", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchSpiffsRes>): SearchSpiffsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.cursor = "";
        if (value !== undefined)
            reflectionMergePartial<SearchSpiffsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSpiffsRes): SearchSpiffsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.search.service.SearchSpiffsRes.Result results */ 1:
                    message.results.push(SearchSpiffsRes_Result.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cursor */ 2:
                    message.cursor = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSpiffsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.search.service.SearchSpiffsRes.Result results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SearchSpiffsRes_Result.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string cursor = 2; */
        if (message.cursor !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cursor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSpiffsRes
 */
export const SearchSpiffsRes = new SearchSpiffsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSpiffsRes_Result$Type extends MessageType<SearchSpiffsRes_Result> {
    constructor() {
        super("rd.search.service.SearchSpiffsRes.Result", [
            { no: 1, name: "spiff", kind: "message", T: () => Spiff },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "vendor", kind: "message", T: () => Vendor },
            { no: 4, name: "department", kind: "message", T: () => ProductCategory },
            { no: 5, name: "class", kind: "message", T: () => ProductCategory },
            { no: 6, name: "fineline", kind: "message", T: () => ProductCategory },
            { no: 7, name: "product", kind: "message", T: () => Product },
            { no: 8, name: "product_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "product_vendor", kind: "message", T: () => Vendor },
            { no: 10, name: "product_department", kind: "message", T: () => ProductCategory },
            { no: 11, name: "product_class", kind: "message", T: () => ProductCategory },
            { no: 12, name: "product_fineline", kind: "message", T: () => ProductCategory },
            { no: 13, name: "uom", kind: "message", T: () => UnitOfMeasure },
            { no: 14, name: "tier_prices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tier }
        ]);
    }
    create(value?: PartialMessage<SearchSpiffsRes_Result>): SearchSpiffsRes_Result {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.productCount = 0;
        message.tierPrices = [];
        if (value !== undefined)
            reflectionMergePartial<SearchSpiffsRes_Result>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchSpiffsRes_Result): SearchSpiffsRes_Result {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.spiff.Spiff spiff */ 1:
                    message.spiff = Spiff.internalBinaryRead(reader, reader.uint32(), options, message.spiff);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.vendors.Vendor vendor */ 3:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.company.ProductCategory department */ 4:
                    message.department = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* rd.company.ProductCategory class */ 5:
                    message.class = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.class);
                    break;
                case /* rd.company.ProductCategory fineline */ 6:
                    message.fineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.fineline);
                    break;
                case /* rd.product.Product product */ 7:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* int32 product_count */ 8:
                    message.productCount = reader.int32();
                    break;
                case /* rd.vendors.Vendor product_vendor */ 9:
                    message.productVendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.productVendor);
                    break;
                case /* rd.company.ProductCategory product_department */ 10:
                    message.productDepartment = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productDepartment);
                    break;
                case /* rd.company.ProductCategory product_class */ 11:
                    message.productClass = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productClass);
                    break;
                case /* rd.company.ProductCategory product_fineline */ 12:
                    message.productFineline = ProductCategory.internalBinaryRead(reader, reader.uint32(), options, message.productFineline);
                    break;
                case /* rd.company.UnitOfMeasure uom */ 13:
                    message.uom = UnitOfMeasure.internalBinaryRead(reader, reader.uint32(), options, message.uom);
                    break;
                case /* repeated rd.price.Tier tier_prices */ 14:
                    message.tierPrices.push(Tier.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchSpiffsRes_Result, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.spiff.Spiff spiff = 1; */
        if (message.spiff)
            Spiff.internalBinaryWrite(message.spiff, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 3; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory department = 4; */
        if (message.department)
            ProductCategory.internalBinaryWrite(message.department, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory class = 5; */
        if (message.class)
            ProductCategory.internalBinaryWrite(message.class, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory fineline = 6; */
        if (message.fineline)
            ProductCategory.internalBinaryWrite(message.fineline, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 7; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 product_count = 8; */
        if (message.productCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.productCount);
        /* rd.vendors.Vendor product_vendor = 9; */
        if (message.productVendor)
            Vendor.internalBinaryWrite(message.productVendor, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_department = 10; */
        if (message.productDepartment)
            ProductCategory.internalBinaryWrite(message.productDepartment, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_class = 11; */
        if (message.productClass)
            ProductCategory.internalBinaryWrite(message.productClass, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.ProductCategory product_fineline = 12; */
        if (message.productFineline)
            ProductCategory.internalBinaryWrite(message.productFineline, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.UnitOfMeasure uom = 13; */
        if (message.uom)
            UnitOfMeasure.internalBinaryWrite(message.uom, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.price.Tier tier_prices = 14; */
        for (let i = 0; i < message.tierPrices.length; i++)
            Tier.internalBinaryWrite(message.tierPrices[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchSpiffsRes.Result
 */
export const SearchSpiffsRes_Result = new SearchSpiffsRes_Result$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportSpiffsReq$Type extends MessageType<BulkExportSpiffsReq> {
    constructor() {
        super("rd.search.service.BulkExportSpiffsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "vendor_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.search.service.SpiffValidityFilter", SpiffValidityFilter, "SPIFF_VALIDITY_FILTER_"] },
            { no: 8, name: "sort_by", kind: "enum", T: () => ["rd.search.service.SpiffSortBy", SpiffSortBy, "SPIFF_SORT_BY_"] },
            { no: 9, name: "sort_order", kind: "enum", T: () => ["rd.search.service.SortOrder", SortOrder, "SORT_ORDER_"] },
            { no: 10, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportSpiffsReq>): BulkExportSpiffsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.locationIds = [];
        message.vendorIds = [];
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.statuses = [];
        message.sortBy = 0;
        message.sortOrder = 0;
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportSpiffsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportSpiffsReq): BulkExportSpiffsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 2:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID vendor_ids */ 3:
                    message.vendorIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 4:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 5:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 6:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.search.service.SpiffValidityFilter statuses */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* rd.search.service.SpiffSortBy sort_by */ 8:
                    message.sortBy = reader.int32();
                    break;
                case /* rd.search.service.SortOrder sort_order */ 9:
                    message.sortOrder = reader.int32();
                    break;
                case /* bool is_template */ 10:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportSpiffsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.proto.uuid.UUID location_ids = 2; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID vendor_ids = 3; */
        for (let i = 0; i < message.vendorIds.length; i++)
            UUID.internalBinaryWrite(message.vendorIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 4; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 5; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 6; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.search.service.SpiffValidityFilter statuses = 7; */
        if (message.statuses.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* rd.search.service.SpiffSortBy sort_by = 8; */
        if (message.sortBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortBy);
        /* rd.search.service.SortOrder sort_order = 9; */
        if (message.sortOrder !== 0)
            writer.tag(9, WireType.Varint).int32(message.sortOrder);
        /* bool is_template = 10; */
        if (message.isTemplate !== false)
            writer.tag(10, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportSpiffsReq
 */
export const BulkExportSpiffsReq = new BulkExportSpiffsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportSpiffsRes$Type extends MessageType<BulkExportSpiffsRes> {
    constructor() {
        super("rd.search.service.BulkExportSpiffsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportSpiffsRes>): BulkExportSpiffsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportSpiffsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportSpiffsRes): BulkExportSpiffsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportSpiffsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportSpiffsRes
 */
export const BulkExportSpiffsRes = new BulkExportSpiffsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportStaffReq$Type extends MessageType<BulkExportStaffReq> {
    constructor() {
        super("rd.search.service.BulkExportStaffReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_active_filter", kind: "enum", T: () => ["rd.search.service.BoolFilter", BoolFilter, "BOOL_FILTER_"] },
            { no: 3, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportStaffReq>): BulkExportStaffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.isActiveFilter = 0;
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportStaffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportStaffReq): BulkExportStaffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* rd.search.service.BoolFilter is_active_filter */ 2:
                    message.isActiveFilter = reader.int32();
                    break;
                case /* bool is_template */ 3:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportStaffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* rd.search.service.BoolFilter is_active_filter = 2; */
        if (message.isActiveFilter !== 0)
            writer.tag(2, WireType.Varint).int32(message.isActiveFilter);
        /* bool is_template = 3; */
        if (message.isTemplate !== false)
            writer.tag(3, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportStaffReq
 */
export const BulkExportStaffReq = new BulkExportStaffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportStaffRes$Type extends MessageType<BulkExportStaffRes> {
    constructor() {
        super("rd.search.service.BulkExportStaffRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportStaffRes>): BulkExportStaffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportStaffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportStaffRes): BulkExportStaffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportStaffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportStaffRes
 */
export const BulkExportStaffRes = new BulkExportStaffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportDepartmentsReq$Type extends MessageType<BulkExportDepartmentsReq> {
    constructor() {
        super("rd.search.service.BulkExportDepartmentsReq", [
            { no: 1, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportDepartmentsReq>): BulkExportDepartmentsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportDepartmentsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportDepartmentsReq): BulkExportDepartmentsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_template */ 1:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportDepartmentsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_template = 1; */
        if (message.isTemplate !== false)
            writer.tag(1, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportDepartmentsReq
 */
export const BulkExportDepartmentsReq = new BulkExportDepartmentsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportDepartmentsRes$Type extends MessageType<BulkExportDepartmentsRes> {
    constructor() {
        super("rd.search.service.BulkExportDepartmentsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportDepartmentsRes>): BulkExportDepartmentsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportDepartmentsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportDepartmentsRes): BulkExportDepartmentsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportDepartmentsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportDepartmentsRes
 */
export const BulkExportDepartmentsRes = new BulkExportDepartmentsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportClassesReq$Type extends MessageType<BulkExportClassesReq> {
    constructor() {
        super("rd.search.service.BulkExportClassesReq", [
            { no: 1, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportClassesReq>): BulkExportClassesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportClassesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportClassesReq): BulkExportClassesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_template */ 1:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportClassesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_template = 1; */
        if (message.isTemplate !== false)
            writer.tag(1, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportClassesReq
 */
export const BulkExportClassesReq = new BulkExportClassesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportClassesRes$Type extends MessageType<BulkExportClassesRes> {
    constructor() {
        super("rd.search.service.BulkExportClassesRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportClassesRes>): BulkExportClassesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportClassesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportClassesRes): BulkExportClassesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportClassesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportClassesRes
 */
export const BulkExportClassesRes = new BulkExportClassesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportFinelineReq$Type extends MessageType<BulkExportFinelineReq> {
    constructor() {
        super("rd.search.service.BulkExportFinelineReq", [
            { no: 1, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportFinelineReq>): BulkExportFinelineReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportFinelineReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportFinelineReq): BulkExportFinelineReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_template */ 1:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportFinelineReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_template = 1; */
        if (message.isTemplate !== false)
            writer.tag(1, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportFinelineReq
 */
export const BulkExportFinelineReq = new BulkExportFinelineReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportFinelineRes$Type extends MessageType<BulkExportFinelineRes> {
    constructor() {
        super("rd.search.service.BulkExportFinelineRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportFinelineRes>): BulkExportFinelineRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportFinelineRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportFinelineRes): BulkExportFinelineRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportFinelineRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportFinelineRes
 */
export const BulkExportFinelineRes = new BulkExportFinelineRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportTagsReq$Type extends MessageType<BulkExportTagsReq> {
    constructor() {
        super("rd.search.service.BulkExportTagsReq", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.tag.Tag.Type", Tag_Type, "TYPE_"] },
            { no: 3, name: "colors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.tag.Tag.Color", Tag_Color, "COLOR_"] },
            { no: 4, name: "is_template", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportTagsReq>): BulkExportTagsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.types = [];
        message.colors = [];
        message.isTemplate = false;
        if (value !== undefined)
            reflectionMergePartial<BulkExportTagsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportTagsReq): BulkExportTagsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated rd.tag.Tag.Type types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.types.push(reader.int32());
                    else
                        message.types.push(reader.int32());
                    break;
                case /* repeated rd.tag.Tag.Color colors */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.colors.push(reader.int32());
                    else
                        message.colors.push(reader.int32());
                    break;
                case /* bool is_template */ 4:
                    message.isTemplate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportTagsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated rd.tag.Tag.Type types = 2; */
        if (message.types.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.types.length; i++)
                writer.int32(message.types[i]);
            writer.join();
        }
        /* repeated rd.tag.Tag.Color colors = 3; */
        if (message.colors.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.colors.length; i++)
                writer.int32(message.colors[i]);
            writer.join();
        }
        /* bool is_template = 4; */
        if (message.isTemplate !== false)
            writer.tag(4, WireType.Varint).bool(message.isTemplate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportTagsReq
 */
export const BulkExportTagsReq = new BulkExportTagsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkExportTagsRes$Type extends MessageType<BulkExportTagsRes> {
    constructor() {
        super("rd.search.service.BulkExportTagsRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkExportTagsRes>): BulkExportTagsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkExportTagsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkExportTagsRes): BulkExportTagsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkExportTagsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.BulkExportTagsRes
 */
export const BulkExportTagsRes = new BulkExportTagsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIntegrationVendorsWithCatalogsReq$Type extends MessageType<ListIntegrationVendorsWithCatalogsReq> {
    constructor() {
        super("rd.search.service.ListIntegrationVendorsWithCatalogsReq", []);
    }
    create(value?: PartialMessage<ListIntegrationVendorsWithCatalogsReq>): ListIntegrationVendorsWithCatalogsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListIntegrationVendorsWithCatalogsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListIntegrationVendorsWithCatalogsReq): ListIntegrationVendorsWithCatalogsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListIntegrationVendorsWithCatalogsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.ListIntegrationVendorsWithCatalogsReq
 */
export const ListIntegrationVendorsWithCatalogsReq = new ListIntegrationVendorsWithCatalogsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIntegrationVendorsWithCatalogsRes$Type extends MessageType<ListIntegrationVendorsWithCatalogsRes> {
    constructor() {
        super("rd.search.service.ListIntegrationVendorsWithCatalogsRes", [
            { no: 1, name: "integration_vendors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<ListIntegrationVendorsWithCatalogsRes>): ListIntegrationVendorsWithCatalogsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendors = [];
        if (value !== undefined)
            reflectionMergePartial<ListIntegrationVendorsWithCatalogsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListIntegrationVendorsWithCatalogsRes): ListIntegrationVendorsWithCatalogsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.integrationVendors.push(reader.int32());
                    else
                        message.integrationVendors.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListIntegrationVendorsWithCatalogsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 1; */
        if (message.integrationVendors.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.integrationVendors.length; i++)
                writer.int32(message.integrationVendors[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.ListIntegrationVendorsWithCatalogsRes
 */
export const ListIntegrationVendorsWithCatalogsRes = new ListIntegrationVendorsWithCatalogsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchListPromotionalSaleCodesReq$Type extends MessageType<SearchListPromotionalSaleCodesReq> {
    constructor() {
        super("rd.search.service.SearchListPromotionalSaleCodesReq", []);
    }
    create(value?: PartialMessage<SearchListPromotionalSaleCodesReq>): SearchListPromotionalSaleCodesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchListPromotionalSaleCodesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchListPromotionalSaleCodesReq): SearchListPromotionalSaleCodesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchListPromotionalSaleCodesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchListPromotionalSaleCodesReq
 */
export const SearchListPromotionalSaleCodesReq = new SearchListPromotionalSaleCodesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchListPromotionalSaleCodesRes$Type extends MessageType<SearchListPromotionalSaleCodesRes> {
    constructor() {
        super("rd.search.service.SearchListPromotionalSaleCodesRes", [
            { no: 1, name: "sale_codes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchListPromotionalSaleCodesRes>): SearchListPromotionalSaleCodesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleCodes = [];
        if (value !== undefined)
            reflectionMergePartial<SearchListPromotionalSaleCodesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchListPromotionalSaleCodesRes): SearchListPromotionalSaleCodesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string sale_codes */ 1:
                    message.saleCodes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchListPromotionalSaleCodesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string sale_codes = 1; */
        for (let i = 0; i < message.saleCodes.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.saleCodes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.search.service.SearchListPromotionalSaleCodesRes
 */
export const SearchListPromotionalSaleCodesRes = new SearchListPromotionalSaleCodesRes$Type();
/**
 * @generated ServiceType for protobuf service rd.search.service.SearchService
 */
export const SearchService = new ServiceType("rd.search.service.SearchService", [
    { name: "SearchBillPayments", options: {}, I: SearchBillPaymentsReq, O: SearchBillPaymentsRes },
    { name: "SearchRefundedBillPayments", options: {}, I: SearchRefundedBillPaymentsReq, O: SearchRefundedBillPaymentsRes },
    { name: "SearchCustomersV2", options: {}, I: SearchCustomersV2Req, O: SearchCustomersV2Res },
    { name: "SearchCustomerContacts", options: {}, I: SearchCustomerContactsReq, O: SearchCustomerContactsRes },
    { name: "SearchExternalTransactions", options: {}, I: SearchExternalTransactionsReq, O: SearchExternalTransactionsRes },
    { name: "SearchInventoryCountProducts", options: {}, I: SearchInventoryCountProductsReq, O: SearchInventoryCountProductsRes },
    { name: "SearchExcludedInventoryCountProducts", options: {}, I: SearchExcludedInventoryCountProductsReq, O: SearchExcludedInventoryCountProductsRes },
    { name: "SearchDeliveries", options: {}, I: SearchDeliveriesReq, O: SearchDeliveriesRes },
    { name: "SearchDeliveryStops", options: {}, I: SearchDeliveryStopsReq, O: SearchDeliveryStopsRes },
    { name: "SearchLocations", options: {}, I: SearchLocationsReq, O: SearchLocationsRes },
    { name: "SearchOrders", options: {}, I: SearchOrdersReq, O: SearchOrdersRes },
    { name: "SearchOrderShipments", options: {}, I: SearchOrderShipmentsReq, O: SearchOrderShipmentsRes },
    { name: "SearchProductsV2", options: {}, I: SearchProductsV2Req, O: SearchProductsV2Res },
    { name: "SearchProductCategories", options: {}, I: SearchProductCategoriesReq, O: SearchProductCategoriesRes },
    { name: "SearchSalesV2", options: {}, I: SearchSalesV2Req, O: SearchSalesV2Res },
    { name: "SearchStaffs", options: {}, I: SearchStaffsReq, O: SearchStaffsRes },
    { name: "SearchReturns", options: {}, I: SearchReturnsReq, O: SearchReturnsRes },
    { name: "SearchOutstandingSales", options: {}, I: SearchOutstandingSalesReq, O: SearchOutstandingSalesRes },
    { name: "SearchTintColors", options: {}, I: SearchTintColorsReq, O: SearchTintColorsRes },
    { name: "SearchTransfers", options: {}, I: SearchTransfersReq, O: SearchTransfersRes },
    { name: "SearchVendors", options: {}, I: SearchVendorsReq, O: SearchVendorsRes },
    { name: "SearchCashTransactions", options: {}, I: SearchCashTransactionsReq, O: SearchCashTransactionsRes },
    { name: "SearchNotifDeliveries", options: {}, I: SearchNotifDeliveriesReq, O: SearchNotifDeliveriesRes },
    { name: "SearchFinancialTransactions", options: {}, I: SearchFinancialTransactionsReq, O: SearchFinancialTransactionsRes },
    { name: "UpdateRecord", options: {}, I: UpdateRecordReq, O: UpdateRecordRes },
    { name: "Reload", options: {}, I: ReloadReq, O: ReloadRes },
    { name: "SearchOrderShipmentsForReconciliation", options: {}, I: SearchOrderShipmentsForReconciliationReq, O: SearchOrderShipmentsForReconciliationRes },
    { name: "SearchInventoryChanges", options: {}, I: SearchInventoryChangesReq, O: SearchInventoryChangesRes },
    { name: "SearchCustomPriceRules", options: {}, I: SearchCustomPriceRulesReq, O: SearchCustomPriceRulesRes },
    { name: "SearchPriceTierRules", options: {}, I: SearchPriceTierRulesReq, O: SearchPriceTierRulesRes },
    { name: "SearchJobs", options: {}, I: SearchJobsReq, O: SearchJobsRes },
    { name: "SearchTags", options: {}, I: SearchTagsReq, O: SearchTagsRes },
    { name: "SearchStagedProductsToOrder", options: {}, I: SearchStagedProductsToOrderReq, O: SearchStagedProductsToOrderRes },
    { name: "PreviewGeneratedOrderProducts", options: {}, I: PreviewGeneratedOrderProductsReq, O: PreviewGeneratedOrderProductsRes },
    { name: "SearchFinanceCharges", options: {}, I: SearchFinanceChargesReq, O: SearchFinanceChargesRes },
    { name: "SearchStatements", options: {}, I: SearchStatementsReq, O: SearchStatementsRes },
    { name: "SearchStatementRuns", options: {}, I: SearchStatementRunsReq, O: SearchStatementRunsRes },
    { name: "SearchCustomerStatements", options: {}, I: SearchCustomerStatementsReq, O: SearchCustomerStatementsRes },
    { name: "SearchReturnableSaleProducts", options: {}, I: SearchReturnableSaleProductsReq, O: SearchReturnableSaleProductsRes },
    { name: "SearchCredits", options: {}, I: SearchCreditsReq, O: SearchCreditsRes },
    { name: "SearchAccounts", options: {}, I: SearchAccountsReq, O: SearchAccountsRes },
    { name: "SearchMappings", options: {}, I: SearchMappingsReq, O: SearchMappingsRes },
    { name: "SearchJournalEntries", options: {}, I: SearchJournalEntriesReq, O: SearchJournalEntriesRes },
    { name: "SearchManualJournalEntries", options: {}, I: SearchManualJournalEntriesReq, O: SearchManualJournalEntriesRes },
    { name: "SearchSavedReports", options: {}, I: SearchSavedReportsReq, O: SearchSavedReportsRes },
    { name: "SearchTenderMethods", options: {}, I: SearchTenderMethodsReq, O: SearchTenderMethodsRes },
    { name: "SearchReceivablesHistory", options: {}, I: SearchReceivablesHistoryReq, O: SearchReceivablesHistoryRes },
    { name: "SearchPriceChanges", options: {}, I: SearchPriceChangesReq, O: SearchPriceChangesRes },
    { name: "PrintReceivablesHistory", options: {}, I: PrintReceivablesHistoryReq, O: PrintReceivablesHistoryRes },
    { name: "SearchReceivablesAging", options: {}, I: SearchReceivablesAgingReq, O: SearchReceivablesAgingRes },
    { name: "PrintReceivablesAging", options: {}, I: PrintReceivablesAgingReq, O: PrintReceivablesAgingRes },
    { name: "SearchReallocationReceivables", options: {}, I: SearchReallocationReceivablesReq, O: SearchReallocationReceivablesRes },
    { name: "OmniSearch", options: {}, I: OmniSearchReq, O: OmniSearchRes },
    { name: "SearchChatThreads", options: {}, I: SearchChatThreadsReq, O: SearchChatThreadsRes },
    { name: "SearchChatMessages", options: {}, I: SearchChatMessagesReq, O: SearchChatMessagesRes },
    { name: "PollForNewChatMessages", options: {}, I: PollForNewChatMessagesReq, O: PollForNewChatMessagesRes },
    { name: "PollForUnreadChatThreads", options: {}, I: PollForUnreadChatThreadsReq, O: PollForUnreadChatThreadsRes },
    { name: "SearchCatalogSKUs", options: {}, I: SearchCatalogSKUsReq, O: SearchCatalogSKUsRes },
    { name: "ListIntegrationVendorsWithCatalogs", options: {}, I: ListIntegrationVendorsWithCatalogsReq, O: ListIntegrationVendorsWithCatalogsRes },
    { name: "SearchCatalogProducts", options: {}, I: SearchCatalogProductsReq, O: SearchCatalogProductsRes },
    { name: "SearchGiftCards", options: {}, I: SearchGiftCardsReq, O: SearchGiftCardsRes },
    { name: "SearchSpiffs", options: {}, I: SearchSpiffsReq, O: SearchSpiffsRes },
    { name: "SearchRoutines", options: {}, I: SearchRoutinesReq, O: SearchRoutinesRes },
    { name: "SearchConversations", options: {}, I: SearchConversationsReq, O: SearchConversationsRes },
    { name: "SearchListPromotionalSaleCodes", options: {}, I: SearchListPromotionalSaleCodesReq, O: SearchListPromotionalSaleCodesRes }
]);
/**
 * @generated ServiceType for protobuf service rd.search.service.BulkService
 */
export const BulkService = new ServiceType("rd.search.service.BulkService", [
    { name: "BulkExportCustomers", options: {}, I: BulkExportCustomersReq, O: BulkExportCustomersRes },
    { name: "BulkExportJobs", options: {}, I: BulkExportJobsReq, O: BulkExportJobsRes },
    { name: "BulkExportCustomerContacts", options: {}, I: BulkExportCustomerContactsReq, O: BulkExportCustomerContactsRes },
    { name: "BulkExportProducts", options: {}, I: BulkExportProductsReq, O: BulkExportProductsRes },
    { name: "BulkExportProductLabels", options: {}, I: BulkExportProductLabelsReq, O: BulkExportProductLabelsRes },
    { name: "BulkExportVendors", options: {}, I: BulkExportVendorsReq, O: BulkExportVendorsRes },
    { name: "BulkExportUnitsOfMeasure", options: {}, I: BulkExportUnitsOfMeasureReq, O: BulkExportUnitsOfMeasureRes },
    { name: "BulkExportInventoryCountProducts", options: {}, I: BulkExportInventoryCountProductsReq, O: BulkExportInventoryCountProductsRes },
    { name: "BulkExportCustomPriceRules", options: {}, I: BulkExportCustomPriceRulesReq, O: BulkExportCustomPriceRulesRes },
    { name: "BulkExportMappings", options: {}, I: BulkExportMappingsReq, O: BulkExportMappingsRes },
    { name: "BulkExportAccounts", options: {}, I: BulkExportAccountsReq, O: BulkExportAccountsRes },
    { name: "BulkExportSpiffs", options: {}, I: BulkExportSpiffsReq, O: BulkExportSpiffsRes },
    { name: "BulkExportStaff", options: {}, I: BulkExportStaffReq, O: BulkExportStaffRes },
    { name: "BulkExportDepartments", options: {}, I: BulkExportDepartmentsReq, O: BulkExportDepartmentsRes },
    { name: "BulkExportClasses", options: {}, I: BulkExportClassesReq, O: BulkExportClassesRes },
    { name: "BulkExportFinelines", options: {}, I: BulkExportFinelineReq, O: BulkExportFinelineRes },
    { name: "BulkExportTags", options: {}, I: BulkExportTagsReq, O: BulkExportTagsRes }
]);
/**
 * @generated ServiceType for protobuf service rd.search.service.SearchalyticsService
 */
export const SearchalyticsService = new ServiceType("rd.search.service.SearchalyticsService", [
    { name: "GetProfitAndLoss", options: {}, I: GetProfitAndLossReq, O: GetProfitAndLossRes },
    { name: "GetProfitAndLossPDF", options: {}, I: GetProfitAndLossPDFReq, O: GetProfitAndLossPDFRes },
    { name: "GetPurchaseJournal", options: {}, I: GetPurchaseJournalReq, O: GetPurchaseJournalRes },
    { name: "GetPurchaseJournalPDF", options: {}, I: GetPurchaseJournalPDFReq, O: GetPurchaseJournalPDFRes },
    { name: "GetPurchaseJournalCSV", options: {}, I: GetPurchaseJournalCSVReq, O: GetPurchaseJournalCSVRes },
    { name: "GetReportBuilder", options: {}, I: GetReportBuilderReq, O: GetReportBuilderRes },
    { name: "GetReportBuilderConfig", options: {}, I: GetReportBuilderConfigReq, O: GetReportBuilderConfigRes },
    { name: "RefreshSearchalyticsCache", options: {}, I: RefreshSearchalyticsCacheReq, O: RefreshSearchalyticsCacheRes },
    { name: "GetPayoutsByPayoutDate", options: {}, I: GetPayoutsByPayoutDateReq, O: GetPayoutsByPayoutDateRes },
    { name: "GetPayoutsByPayoutDatePDF", options: {}, I: GetPayoutsByPayoutDatePDFReq, O: GetPayoutsByPayoutDatePDFRes },
    { name: "GetPayoutsByPayoutDateCSV", options: {}, I: GetPayoutsByPayoutDateCSVReq, O: GetPayoutsByPayoutDateCSVRes },
    { name: "GetPayoutsByTransactionDate", options: {}, I: GetPayoutsByTransactionDateReq, O: GetPayoutsByTransactionDateRes },
    { name: "GetPayoutsByTransactionDatePDF", options: {}, I: GetPayoutsByTransactionDatePDFReq, O: GetPayoutsByTransactionDatePDFRes },
    { name: "GetBalanceSheet", options: {}, I: GetBalanceSheetReq, O: GetBalanceSheetRes },
    { name: "GetIncomeStatement", options: {}, I: GetIncomeStatementReq, O: GetIncomeStatementRes },
    { name: "GetJournalEntries", options: {}, I: GetJournalEntriesReq, O: GetJournalEntriesRes },
    { name: "GetJournalEntriesPDF", options: {}, I: GetJournalEntriesPDFReq, O: GetJournalEntriesPDFRes },
    { name: "GetJournalEntriesIIF", options: {}, I: GetJournalEntriesIIFReq, O: GetJournalEntriesIIFRes },
    { name: "GetPayoutsByTransactionDateCSV", options: {}, I: GetPayoutsByTransactionDateCSVReq, O: GetPayoutsByTransactionDateCSVRes },
    { name: "GetGeneralLedger", options: {}, I: GetGeneralLedgerReq, O: GetGeneralLedgerRes },
    { name: "GetGeneralLedgerPDF", options: {}, I: GetGeneralLedgerPDFReq, O: GetGeneralLedgerPDFRes },
    { name: "GetGeneralLedgerCSV", options: {}, I: GetGeneralLedgerCSVReq, O: GetGeneralLedgerCSVRes }
]);
/**
 * @generated ServiceType for protobuf service rd.search.service.CxaSearchService
 */
export const CxaSearchService = new ServiceType("rd.search.service.CxaSearchService", [
    { name: "CxaSearchSales", options: {}, I: CxaSearchSalesReq, O: CxaSearchSalesRes },
    { name: "CxaSearchOutstandingSales", options: {}, I: CxaSearchOutstandingSalesReq, O: CxaSearchOutstandingSalesRes },
    { name: "CxaSearchReceivablesAging", options: {}, I: CxaSearchReceivablesAgingReq, O: CxaSearchReceivablesAgingRes },
    { name: "CxaSearchReturns", options: {}, I: CxaSearchReturnsReq, O: CxaSearchReturnsRes },
    { name: "CxaSearchJobs", options: {}, I: CxaSearchJobsReq, O: CxaSearchJobsRes },
    { name: "CxaSearchProducts", options: {}, I: CxaSearchProductsReq, O: CxaSearchProductsRes },
    { name: "CxaSearchTintColors", options: {}, I: CxaSearchTintColorsReq, O: CxaSearchTintColorsRes }
]);
